/** Generate by swagger-axios-codegen */
// @ts-nocheck
/* eslint-disable */

/** Generate by swagger-axios-codegen */
/* eslint-disable */
// @ts-nocheck
import axiosStatic from 'axios';
import type { AxiosInstance, AxiosRequestConfig } from 'axios';

export interface IRequestOptions extends AxiosRequestConfig {
  /**
   * show loading status
   */
  loading?: boolean;
  /**
   * display error message
   */
  showError?: boolean;
  /**
   * indicates whether Authorization credentials are required for the request
   * @default true
   */
  withAuthorization?: boolean;
}

export interface IRequestConfig {
  method?: any;
  headers?: any;
  url?: any;
  data?: any;
  params?: any;
}

// Add options interface
export interface ServiceOptions {
  axios?: AxiosInstance;
  /** only in axios interceptor config*/
  loading: boolean;
  showError: boolean;
}

// Add default options
export const serviceOptions: ServiceOptions = {};

// Instance selector
export function axios(configs: IRequestConfig, resolve: (p: any) => void, reject: (p: any) => void): Promise<any> {
  if (serviceOptions.axios) {
    return serviceOptions.axios
      .request(configs)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  } else {
    throw new Error('please inject yourself instance like axios  ');
  }
}

export function getConfigs(method: string, contentType: string, url: string, options: any): IRequestConfig {
  const configs: IRequestConfig = {
    loading: serviceOptions.loading,
    showError: serviceOptions.showError,
    ...options,
    method,
    url
  };
  configs.headers = {
    ...options.headers,
    'Content-Type': contentType
  };
  return configs;
}

export const basePath = '';

export interface IList<T> extends Array<T> {}
export interface List<T> extends Array<T> {}
export interface IDictionary<TValue> {
  [key: string]: TValue;
}
export interface Dictionary<TValue> extends IDictionary<TValue> {}

export interface IListResult<T> {
  items?: T[];
}

export class ListResultDto<T> implements IListResult<T> {
  items?: T[];
}

export interface IPagedResult<T> extends IListResult<T> {
  totalCount?: number;
  items?: T[];
}

export class PagedResultDto<T = any> implements IPagedResult<T> {
  totalCount?: number;
  items?: T[];
}

// customer definition
// empty

export class DataAccessPolicyControllerService {
  /**
   * getFilterListByType
   */
  static getFilterListByTypeUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** name */
      name?: string;
      /** type */
      type: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PairModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/access_policies/filter';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { accountId: params['accountId'], name: params['name'], type: params['type'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Data Access Policy Migration API
   */
  static migrateAccessPolicyUsingPost(
    params: {
      /** migrateDataAccessPolicyModel */
      migrateDataAccessPolicyModel: MigrateDataAccessPolicyModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/migrate_access_policies';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['migrateDataAccessPolicyModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Data Access Policy Migration API
   */
  static promoteAccessPolicyUsingPost(
    params: {
      /** migrateDataAccessPolicyModel */
      migrateDataAccessPolicyModel: PromoteDataAccessPolicyModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/promote_access_policies';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['migrateDataAccessPolicyModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * listAccessPolicies
   */
  static listAccessPoliciesUsingGet1(
    params: {
      /** accountId */
      accountId: string;
      /** databaseName */
      databaseName?: string[];
      /** databaseObjectNames */
      databaseObjectNames?: string;
      /** datasourcePolicyNames */
      datasourcePolicyNames?: string[];
      /** objectNames */
      objectNames?: string;
      /** page_no */
      pageNo?: number;
      /** page_size */
      pageSize?: number;
      /** policyName */
      policyName?: string[];
      /** policyType */
      policyType?: string[];
      /** principals */
      principals?: string[];
      /** roleName */
      roleName?: string;
      /** rootPolicyCreatedBy */
      rootPolicyCreatedBy?: string[];
      /** schemaName */
      schemaName?: string;
      /** sort_by */
      sortBy?: string;
      /** sort_order */
      sortOrder?: string;
      /** status */
      status?: string[];
      /** tableName */
      tableName?: string;
      /** templateName */
      templateName?: string;
      /** version */
      version?: number;
      /** viewName */
      viewName?: string;
      /** workspace */
      workspace?: string[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxPaginatedResponseModel_DataAccessPolicyWithoutUDFModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/access_policies';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        databaseName: params['databaseName'],
        databaseObjectNames: params['databaseObjectNames'],
        datasourcePolicyNames: params['datasourcePolicyNames'],
        objectNames: params['objectNames'],
        page_no: params['pageNo'],
        page_size: params['pageSize'],
        policyName: params['policyName'],
        policyType: params['policyType'],
        principals: params['principals'],
        roleName: params['roleName'],
        rootPolicyCreatedBy: params['rootPolicyCreatedBy'],
        schemaName: params['schemaName'],
        sort_by: params['sortBy'],
        sort_order: params['sortOrder'],
        status: params['status'],
        tableName: params['tableName'],
        templateName: params['templateName'],
        version: params['version'],
        viewName: params['viewName'],
        workspace: params['workspace']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * createAccessPolicy
   */
  static createAccessPolicyUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** dataAccessPolicyModel */
      dataAccessPolicyModel: DataAccessPolicyModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/access_policies';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['dataAccessPolicyModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get ABAC TAG RLS policies with their names and IDs
   */
  static getAbacTagRlsPoliciesUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** policySecuredObjectsReportModel */
      policySecuredObjectsReportModel: PolicySecuredObjectsReportModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/access_policies/abac_tag_rls_policies';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['policySecuredObjectsReportModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get policy IDs and names by account ID and policy type
   */
  static getPoliciesByAccountAndTypeUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** policyType */
      policyType: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<object[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/access_policies/by_policy_type';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { policyType: params['policyType'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getImpactedObject
   */
  static getImpactedObjectUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** dataAccessPolicyModel */
      dataAccessPolicyModel: DataAccessPolicyModel;
      /** policyId */
      policyId?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DataAccessPolicyImpactedObjectResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/access_policies/impacted_objects';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { policyId: params['policyId'] };

      let data = params['dataAccessPolicyModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getAccessPolicyByPolicyName
   */
  static getAccessPolicyByPolicyNameUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** policyName */
      policyName: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/access_policies/name/{policyName}';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{policyName}', params['policyName'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * publishedPolicyList
   */
  static publishedPolicyListUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** limit */
      limit?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/access_policies/published_policy';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { limit: params['limit'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get RBAC TAG policies with their names and impacted objects
   */
  static getRbacTagPoliciesWithImpactedObjectsUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** policySecuredObjectsReportModel */
      policySecuredObjectsReportModel: PolicySecuredObjectsReportModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<object[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/access_policies/rbac_tag_policies_with_objects';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['policySecuredObjectsReportModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getReviewAndPublishablePolicies
   */
  static getReviewAndPublishablePoliciesUsingGet(
    params: {
      /** accountId */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/access_policies/review_publish_policies';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * syncDataAccessPolicyForCICD
   */
  static syncDataAccessPolicyForCicdUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** ignoreSyncDatabases */
      ignoreSyncDatabases?: boolean;
      /** syncPolicyObjectNames */
      syncPolicyObjectNames: SyncPolicyObjectModel[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/access_policies/sync';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { ignoreSyncDatabases: params['ignoreSyncDatabases'] };

      let data = params['syncPolicyObjectNames'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * scanDataAccessPolicyByTagNames
   */
  static scanDataAccessPolicyByTagNamesUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** tagObjAuditList */
      tagObjAuditList: TagObjectAuditModel[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/access_policies/sync/fetch_tag_policies';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['tagObjAuditList'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * scanDataAccessPolicyByObjectNames
   */
  static scanDataAccessPolicyByObjectNamesUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** ignoreSyncDatabases */
      ignoreSyncDatabases?: boolean;
      /** objectNames */
      objectNames: any | null[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/access_policies/sync/object_policy';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { ignoreSyncDatabases: params['ignoreSyncDatabases'] };

      let data = params['objectNames'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getPolicyImpactedObjectsByPolicyIds
   */
  static getPolicyImpactedObjectsByPolicyIdsUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** policyIds */
      policyIds: any | null[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/access_policies/sync/policy_impacted_objects';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['policyIds'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get redeployable tag data access policy
   */
  static getTagAccessPolicyToSyncUsingGet(
    params: {
      /** accountId */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DataAccessPolicy[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/access_policies/sync/tags';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * triggerPolicySyncForAccount
   */
  static triggerPolicySyncForAccountUsingPost(
    params: {
      /** accountId */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/access_policies/triggerPolicySync';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getAccessPolicy
   */
  static getAccessPolicyUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/access_policies/{id}';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * updateAccessPolicy
   */
  static updateAccessPolicyUsingPut(
    params: {
      /** accountId */
      accountId: string;
      /** dataAccessPolicyModel */
      dataAccessPolicyModel: DataAccessPolicyModel;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/access_policies/{id}';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['dataAccessPolicyModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * deleteAccessPolicy
   */
  static deleteAccessPolicyUsingDelete(
    params: {
      /** accountId */
      accountId: string;
      /** consent */
      consent?: boolean;
      /** id */
      id: string;
      /** includeViewAccessGrants */
      includeViewAccessGrants?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/access_policies/{id}';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { consent: params['consent'], includeViewAccessGrants: params['includeViewAccessGrants'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get delegated object list for policy creator
   */
  static getDelegatedDatabaseSchemaListForCreatedByUserUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/access_policies/{id}/delegated_objects';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * deployDataPlaneUDF
   */
  static deployDataPlaneUdfUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** id */
      id: string;
      /** statusModel */
      statusModel: StatusModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/access_policies/{id}/deploy_policy';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['statusModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * putdeployDataPlaneUDF
   */
  static putdeployDataPlaneUdfUsingPut(
    params: {
      /** accountId */
      accountId: string;
      /** id */
      id: string;
      /** statusModel */
      statusModel: StatusModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/access_policies/{id}/deploy_policy';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['statusModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * disableAccessPolicy
   */
  static disableAccessPolicyUsingDelete(
    params: {
      /** accountId */
      accountId: string;
      /** consent */
      consent?: boolean;
      /** id */
      id: string;
      /** includeViewAccessGrants */
      includeViewAccessGrants?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/access_policies/{id}/disable';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { consent: params['consent'], includeViewAccessGrants: params['includeViewAccessGrants'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * discardDraftAccessPolicy
   */
  static discardDraftAccessPolicyUsingDelete(
    params: {
      /** accountId */
      accountId: string;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/access_policies/{id}/discardDraft';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * publishPolicy
   */
  static publishPolicyUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** connectionDetail */
      connectionDetail: RedshiftJDBCConnectionDetail;
      /** deltaDeploy */
      deltaDeploy?: boolean;
      /** id */
      id: string;
      /** includeViewAccessGrants */
      includeViewAccessGrants?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/access_policies/{id}/publish_policy';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = {
        deltaDeploy: params['deltaDeploy'],
        includeViewAccessGrants: params['includeViewAccessGrants']
      };

      let data = params['connectionDetail'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Rename deployed policies with their names and description
   */
  static renameAccessPolicyUsingPut(
    params: {
      /** accountId */
      accountId: string;
      /** id */
      id: string;
      /** renamePolicy */
      renamePolicy: RenamePolicyModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/access_policies/{id}/rename_policy';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['renamePolicy'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * reviewPolicy
   */
  static reviewPolicyUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** deltaDeploy */
      deltaDeploy?: boolean;
      /** id */
      id: string;
      /** includeViewAccessGrants */
      includeViewAccessGrants?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/access_policies/{id}/review_policy';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = {
        deltaDeploy: params['deltaDeploy'],
        includeViewAccessGrants: params['includeViewAccessGrants']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * reviewPublishPolicy
   */
  static reviewPublishPolicyUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** id */
      id: string;
      /** includeViewAccessGrants */
      includeViewAccessGrants?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/access_policies/{id}/review_publish_policy';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { includeViewAccessGrants: params['includeViewAccessGrants'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * syncReviewDataAccessPolicyByTagNames
   */
  static syncReviewDataAccessPolicyByTagNamesUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** id */
      id: string;
      /** isOnDemandSync */
      isOnDemandSync?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/access_policies/{id}/sync/review_abac_policy';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { isOnDemandSync: params['isOnDemandSync'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * syncDataAccessPolicyByTagNames
   */
  static syncDataAccessPolicyByTagNamesUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/access_policies/{id}/sync/tag_policy';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getAccessPolicyHistory
   */
  static getAccessPolicyHistoryUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** id */
      id: string;
      /** policy_status */
      policyStatus?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TenantAuditLogs[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/access_policies/{id}/view_history';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { policy_status: params['policyStatus'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Redeploy data access policy using policy name
   */
  static redeployPolicyByNameUsingPut(
    params: {
      /** accountId */
      accountId: string;
      /** policyName */
      policyName: string;
      /** sla */
      sla?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/access_policies/{policyName}/redeploy_policy';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{policyName}', params['policyName'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);
      configs.params = { sla: params['sla'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Sync policy secured objects from Snowflake for given policy IDs
   */
  static syncPolicySecuredObjectsUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** policyIds */
      policyIds: any | null[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/data_access_policies/sync_policy_secured_objects';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['policyIds'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getRoleTemplates
   */
  static getRoleTemplatesUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** dataAccessPolicyId */
      dataAccessPolicyId?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DataAccessPolicyRoleTemplate[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/role_templates';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { dataAccessPolicyId: params['dataAccessPolicyId'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * validateUdfTableDependencies
   */
  static validateUdfTableDependenciesUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** policyId */
      policyId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/accounts/{accountId}/policies/validate-udf-dependencies';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { policyId: params['policyId'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * validateUdfTableDependenciesForDraftPolicy
   */
  static validateUdfTableDependenciesForDraftPolicyUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** policyModel */
      policyModel: DataAccessPolicyModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/accounts/{accountId}/policies/validate-udf-dependencies';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['policyModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getObjectPrivilege
   */
  static getObjectPrivilegeUsingGet(
    params: {
      /** accountId */
      accountId?: string;
      /** catalog */
      catalog?: string[];
      /** isDomainPolicy */
      isDomainPolicy?: boolean;
      /** objectType */
      objectType?: string;
      /** type */
      type?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ObjectPrivilege[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/object_privileges';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        accountId: params['accountId'],
        catalog: params['catalog'],
        isDomainPolicy: params['isDomainPolicy'],
        objectType: params['objectType'],
        type: params['type']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * listObjectType
   */
  static listObjectTypeUsingGet(
    params: {
      /** accountType */
      accountType?: string;
      /** feature */
      feature?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ObjectType[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/object_type';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { accountType: params['accountType'], feature: params['feature'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getSearchParameters
   */
  static getSearchParametersUsingGet(
    params: {
      /** category */
      category: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/policies/search_parameters/{category}';
      url = url.replace('{category}', params['category'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class AccessPolicyUserDefinedFunctionControllerService {
  /**
   * Get all user defined functions metadata from RDS based on tenant
   */
  static getAllUserDefinedFunctionMetadataUsingGet(
    params: {
      /** accountIds */
      accountIds?: string[];
      /** databaseNames */
      databaseNames?: string[];
      /** dataSourceTypes */
      dataSourceTypes?: string[];
      /** dataType */
      dataType?: string;
      /** functionNames */
      functionNames?: string[];
      /** isConditionBuilder */
      isConditionBuilder?: boolean;
      /** isSystemFunction */
      isSystemFunction?: boolean;
      /** operator */
      operator?: string;
      /** page_no */
      pageNo?: number;
      /** page_size */
      pageSize?: number;
      /** schemaNames */
      schemaNames?: string[];
      /** search */
      search?: string;
      /** sort_by */
      sortBy?: string;
      /** sort_order */
      sortOrder?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxPaginatedResponseModel_AccessPolicyUserDefinedFunctionModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/access_policy/functions';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        accountIds: params['accountIds'],
        databaseNames: params['databaseNames'],
        dataSourceTypes: params['dataSourceTypes'],
        dataType: params['dataType'],
        functionNames: params['functionNames'],
        isConditionBuilder: params['isConditionBuilder'],
        isSystemFunction: params['isSystemFunction'],
        operator: params['operator'],
        page_no: params['pageNo'],
        page_size: params['pageSize'],
        schemaNames: params['schemaNames'],
        search: params['search'],
        sort_by: params['sortBy'],
        sort_order: params['sortOrder']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Store user defined function metadata in RDS
   */
  static createUserDefinedFunctionMetadataUsingPost(
    params: {
      /** udfModel */
      udfModel: AccessPolicyUserDefinedFunctionModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/access_policy/functions';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['udfModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get user defined function filter data based on type
   */
  static getListByFilterTypeUsingGet(
    params: {
      /** accountId */
      accountId?: string;
      /** databases */
      databases?: string[];
      /** isSystemFunction */
      isSystemFunction?: boolean;
      /** schemas */
      schemas?: string[];
      /** type */
      type: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PairModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/access_policy/functions/filter';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        accountId: params['accountId'],
        databases: params['databases'],
        isSystemFunction: params['isSystemFunction'],
        schemas: params['schemas'],
        type: params['type']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get user defined function from RDS by ID
   */
  static getUserDefinedFunctionMetadataByIdUsingGet(
    params: {
      /** Function metadata ID */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AccessPolicyUserDefinedFunctionModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/access_policy/functions/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Update user defined function metadata
   */
  static updateUserDefinedFunctionMetadataUsingPut(
    params: {
      /** id */
      id: string;
      /** udfModel */
      udfModel: AccessPolicyUserDefinedFunctionModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/access_policy/functions/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['udfModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Delete user defined function metadata
   */
  static deleteUserDefinedFunctionMetadataUsingDelete(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/access_policy/functions/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class AccountControllerService {
  /**
   * listAccounts
   */
  static listAccountsUsingGet(
    params: {
      /** accessPolicyStatus */
      accessPolicyStatus?: string[];
      /** dataRiskCategory */
      dataRiskCategory?: string[];
      /** dataSeverity */
      dataSeverity?: string[];
      /** dataSourceName */
      dataSourceName?: string[];
      /** dataSourceType */
      dataSourceType?: string[];
      /** includeAll */
      includeAll?: boolean;
      /** includePolicyCount */
      includePolicyCount?: boolean;
      /** monitoringPolicyStatus */
      monitoringPolicyStatus?: string[];
      /** page_no */
      pageNo?: number;
      /** page_size */
      pageSize?: number;
      /** sort_by */
      sortBy?: string;
      /** sort_order */
      sortOrder?: string;
      /** status */
      status?: string[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxPaginatedResponseModel_AccountModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        accessPolicyStatus: params['accessPolicyStatus'],
        dataRiskCategory: params['dataRiskCategory'],
        dataSeverity: params['dataSeverity'],
        dataSourceName: params['dataSourceName'],
        dataSourceType: params['dataSourceType'],
        includeAll: params['includeAll'],
        includePolicyCount: params['includePolicyCount'],
        monitoringPolicyStatus: params['monitoringPolicyStatus'],
        page_no: params['pageNo'],
        page_size: params['pageSize'],
        sort_by: params['sortBy'],
        sort_order: params['sortOrder'],
        status: params['status']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * registerAccount
   */
  static registerAccountUsingPost(
    params: {
      /** accountModel */
      accountModel: AccountModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['accountModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * accountStats
   */
  static accountStatsUsingGet(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/accountStats';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getFilterObjectByType
   */
  static getFilterObjectByTypeUsingGet(
    params: {
      /** objectType */
      objectType?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PairModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/types';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { objectType: params['objectType'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getAccount
   */
  static getAccountUsingGet(
    params: {
      /** accountId */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Account> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * updateAccountDetails
   */
  static updateAccountDetailsUsingPut(
    params: {
      /** accountId */
      accountId: string;
      /** accountModel */
      accountModel: AccountModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['accountModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * deRegisterAccount
   */
  static deRegisterAccountUsingDelete(
    params: {
      /** accountId */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * accountInfo
   */
  static accountInfoUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** searchParameter */
      searchParameter?: string;
      /** type */
      type?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/accountProfile';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { searchParameter: params['searchParameter'], type: params['type'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * updateAccountStatus
   */
  static updateAccountStatusUsingPut(
    params: {
      /** accountId */
      accountId: string;
      /** accountStatus */
      accountStatus: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/account_status';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);
      configs.params = { accountStatus: params['accountStatus'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getDatabases
   */
  static getDatabasesUsingGet(
    params: {
      /** accountId */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Database[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/databases';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * accountHealthStatus
   */
  static accountHealthStatusUsingGet(
    params: {
      /** accountId */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/health';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * processOAuthCode
   */
  static processOAuthCodeUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** code */
      code: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/oauth';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { code: params['code'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get RSA key rotation status for Snowflake account
   */
  static getRsaKeyRotationStatusUsingGet(
    params: {
      /** accountId */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/rsa_key_rotation_status';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getSchemas
   */
  static getSchemasUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** databaseName */
      databaseName: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/schemas';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { databaseName: params['databaseName'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getAccountPolicySyncWatermark
   */
  static getAccountPolicySyncWatermarkUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** watermarkTimestampModel */
      watermarkTimestampModel: WatermarkTimestampModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/sync/fetch_watermark_timestamp';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['watermarkTimestampModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * saveAccountPolicySyncWatermark
   */
  static saveAccountPolicySyncWatermarkUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** watermarkTimestampModel */
      watermarkTimestampModel: WatermarkTimestampModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/sync/watermark_timestamp';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['watermarkTimestampModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getTables_Views
   */
  static getTablesViewsUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** databaseName */
      databaseName: string;
      /** objectType */
      objectType?: string;
      /** policyTypeId */
      policyTypeId?: string;
      /** schemaName */
      schemaName?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Table[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/tables';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        databaseName: params['databaseName'],
        objectType: params['objectType'],
        policyTypeId: params['policyTypeId'],
        schemaName: params['schemaName']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getUserResourceContext
   */
  static getUserResourceContextUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** resourceKey */
      resourceKey: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/user-context';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { resourceKey: params['resourceKey'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * upsertUserResourceContext
   */
  static upsertUserResourceContextUsingPut(
    params: {
      /** accountId */
      accountId: string;
      /** contextRequest */
      contextRequest: UserResourceContextRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/user-context';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['contextRequest'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getUsersName
   */
  static getUsersNameUsingGet(
    params: {
      /** accountId */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/users';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getAccountSubtypes
   */
  static getAccountSubtypesUsingGet(
    params: {
      /** datasourceType */
      datasourceType: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AccountSubtypeModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{datasourceType}/subtypes';
      url = url.replace('{datasourceType}', params['datasourceType'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getAccountConfigurationAllFeature
   */
  static getAccountConfigurationAllFeatureUsingGet(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TenantFeatureModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{id}/configurations';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Account feature configuration
   */
  static updateAccountConfigurationFeatureUsingPut(
    params: {
      /** configurationFeatureModel */
      configurationFeatureModel: AccountConfigurationFeatureModel;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{id}/configurations';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['configurationFeatureModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getAccountSetupScript
   */
  static getAccountSetupScriptUsingGet(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{id}/download_setup_script';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * listDIAccounts
   */
  static listDiAccountsUsingGet(
    params: {
      /** type */
      type?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Account[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/di_account';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { type: params['type'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getAccountBasedOnDataSource
   */
  static getAccountBasedOnDataSourceUsingGet(
    params: {
      /** dataSourceType */
      dataSourceType?: string;
      /** guardianAgentEnabled */
      guardianAgentEnabled?: boolean;
      /** isPolicyObjectSyncEnabled */
      isPolicyObjectSyncEnabled?: boolean;
      /** statusList */
      statusList?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Account[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/di_account/dataSourceType';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        dataSourceType: params['dataSourceType'],
        guardianAgentEnabled: params['guardianAgentEnabled'],
        isPolicyObjectSyncEnabled: params['isPolicyObjectSyncEnabled'],
        statusList: params['statusList']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getTlxAwsAccountId
   */
  static getTlxAwsAccountIdUsingGet(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/getTlxAwsAccountId';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * testConnection
   */
  static testConnectionUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** accountModel */
      accountModel: AccountModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/testConnection/account/{accountId}';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['accountModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * uploadPrivateKey
   */
  static uploadPrivateKeyUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /**  */
      file?: any;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/{accountId}/upload/privateKey';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'multipart/form-data', url, options);

      let data = undefined;
      data = new FormData();
      if (params['file']) {
        if (Object.prototype.toString.call(params['file']) === '[object Array]') {
          for (const item of params['file']) {
            data.append('file', item as any);
          }
        } else {
          data.append('file', params['file'] as any);
        }
      }

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class UdfControllerService {
  /**
   * getColumnGrants
   */
  static getColumnGrantsUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/access_policies/{id}/column_grants';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * fetchDataAccessPolicyRedshiftConnection
   */
  static fetchDataAccessPolicyRedshiftConnectionUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/access_policies/{id}/fetch_redshift_connection';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getDataPlanePolicyFailureMessage
   */
  static getDataPlanePolicyFailureMessageUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/access_policies/{id}/policy_failure_message';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * reviewPolicy
   */
  static reviewPolicyUsingGet1(
    params: {
      /** accountId */
      accountId: string;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/access_policies/{id}/review_policy';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getUDF
   */
  static getUdfUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/access_policies/{id}/udf';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * updateAccessPolicyUDFVIew
   */
  static updateAccessPolicyUdfvIewUsingPut(
    params: {
      /** accountId */
      accountId: string;
      /** dataAccessPolicyModel */
      dataAccessPolicyModel: DataAccessPolicyUDFViewModel;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/access_policies/{id}/udf_view';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['dataAccessPolicyModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * fetchGlueRedshiftConnection
   */
  static fetchGlueRedshiftConnectionUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** dataSourceName */
      dataSourceName: string;
      /** tableName */
      tableName: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/fetch_redshift_connection';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { dataSourceName: params['dataSourceName'], tableName: params['tableName'] };

      axios(configs, resolve, reject);
    });
  }
}

export class AlertControllerService {
  /**
   * getAlerts
   */
  static getAlertsUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** report_name */
      reportName: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Alert[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/alerts';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { report_name: params['reportName'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getTlxAlerts
   */
  static getTlxAlertsUsingGet(
    params: {
      /** accountId */
      accountId?: string;
      /** alertType */
      alertType?: string;
      /** complianceTags */
      complianceTags?: string[];
      /** eventNameCommaSeparated */
      eventNameCommaSeparated?: string;
      /** id */
      id?: string;
      /** last_no_of_days */
      lastNoOfDays?: number;
      /** objectName */
      objectName?: string;
      /** page_no */
      pageNo?: number;
      /** page_size */
      pageSize?: number;
      /** rangeEndDate */
      rangeEndDate?: string;
      /** rangeStartDate */
      rangeStartDate?: string;
      /** riskCategory */
      riskCategory?: string[];
      /** roleName */
      roleName?: string;
      /** severity */
      severity?: string[];
      /** sort_by */
      sortBy?: string;
      /** sort_order */
      sortOrder?: string;
      /** targetName */
      targetName?: string;
      /** triggeredBy */
      triggeredBy?: string[];
      /** userName */
      userName?: string;
      /** userType */
      userType?: string[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxAlertResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/alerts';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        accountId: params['accountId'],
        alertType: params['alertType'],
        complianceTags: params['complianceTags'],
        eventNameCommaSeparated: params['eventNameCommaSeparated'],
        id: params['id'],
        last_no_of_days: params['lastNoOfDays'],
        objectName: params['objectName'],
        page_no: params['pageNo'],
        page_size: params['pageSize'],
        rangeEndDate: params['rangeEndDate'],
        rangeStartDate: params['rangeStartDate'],
        riskCategory: params['riskCategory'],
        roleName: params['roleName'],
        severity: params['severity'],
        sort_by: params['sortBy'],
        sort_order: params['sortOrder'],
        targetName: params['targetName'],
        triggeredBy: params['triggeredBy'],
        userName: params['userName'],
        userType: params['userType']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * bulkAlertsDismiss
   */
  static bulkAlertsDismissUsingPut(
    params: {
      /** bulkAlertDismissalModel */
      bulkAlertDismissalModel: BulkAlertDismissalModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/alerts/bulk_dismiss';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['bulkAlertDismissalModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * alertsExistBatch
   */
  static alertsExistBatchUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** ids */
      ids: any | null[];
      /** policyName */
      policyName: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/alerts/exists-batch';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { accountId: params['accountId'], policyName: params['policyName'] };

      let data = params['ids'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getLatestMonitoringAlertsTimestamp
   */
  static getLatestMonitoringAlertsTimestampUsingGet(options: IRequestOptions = {}): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/alerts/latestMonitoringAlertsTimestamp';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getReportRisks
   */
  static getReportRisksUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** endDate */
      endDate: string;
      /** isReportSummary */
      isReportSummary: boolean;
      /** pageNo */
      pageNo?: number;
      /** pageSize */
      pageSize?: number;
      /** reportName */
      reportName: string;
      /** reportStatsType */
      reportStatsType?: string;
      /** sortBy */
      sortBy?: string;
      /** sortOrder */
      sortOrder?: string;
      /** startDate */
      startDate: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ReportMonitoringPoliciesRisksModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/alerts/report_risks';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        accountId: params['accountId'],
        endDate: params['endDate'],
        isReportSummary: params['isReportSummary'],
        pageNo: params['pageNo'],
        pageSize: params['pageSize'],
        reportName: params['reportName'],
        reportStatsType: params['reportStatsType'],
        sortBy: params['sortBy'],
        sortOrder: params['sortOrder'],
        startDate: params['startDate']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * updateMonitoringAlert
   */
  static updateMonitoringAlertUsingPut(
    params: {
      /** accountId */
      accountId: string;
      /** alertRecordModel */
      alertRecordModel: AlertRecordModelReq;
      /** id */
      id: string;
      /** policyName */
      policyName?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AlertRecordModelRes> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/alerts/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);
      configs.params = { accountId: params['accountId'], policyName: params['policyName'] };

      let data = params['alertRecordModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * alertExists
   */
  static alertExistsUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** id */
      id: string;
      /** policyName */
      policyName: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<boolean> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/alerts/{id}/alertexists';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { accountId: params['accountId'], policyName: params['policyName'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getRawAuditRecord
   */
  static getRawAuditRecordUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** id */
      id: string;
      /** policyName */
      policyName: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/alerts/{id}/rawAuditRecord';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { accountId: params['accountId'], policyName: params['policyName'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getTlxAlertsCountByCategory
   */
  static getTlxAlertsCountByCategoryUsingGet(options: IRequestOptions = {}): Promise<AlertsCategory[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/alerts_count_by_category';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getTlxAlertsCountByDatasource
   */
  static getTlxAlertsCountByDatasourceUsingGet(options: IRequestOptions = {}): Promise<AlertsByDataSource[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/alerts_count_by_datasource';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * setDismissedFlagTrue
   */
  static setDismissedFlagTrueUsingGet(options: IRequestOptions = {}): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/dismissStaleAlertsForGivenPolicy';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * saveMonitoringAlerts
   */
  static saveMonitoringAlertsUsingPost(
    params: {
      /** monitoringAlertsRequestList */
      monitoringAlertsRequestList: AlertRecordModelRequest[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AlertRecordModelRes[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/monitoring_alerts';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['monitoringAlertsRequestList'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class BulkPolicyImportControllerService {
  /**
   * List bulk import jobs
   */
  static listImportJobsUsingGet(
    params: {
      /** accountId */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BulkPolicyImportJobModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/bulk_policy_import';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Bulk import access policies from CSV file
   */
  static bulkImportPolicyUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /**  */
      file?: any;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BulkPolicyImportJobModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/bulk_policy_import';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'multipart/form-data', url, options);

      let data = undefined;
      data = new FormData();
      if (params['file']) {
        if (Object.prototype.toString.call(params['file']) === '[object Array]') {
          for (const item of params['file']) {
            data.append('file', item as any);
          }
        } else {
          data.append('file', params['file'] as any);
        }
      }

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Process bulk import policies
   */
  static processBulkPoliciesUsingGet(
    params: {
      /** accountId */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/bulk_policy_import/process';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get Latest progress bulk import job status
   */
  static getProgressImportJobUsingGet(
    params: {
      /** accountId */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BulkPolicyImportJobModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/bulk_policy_import/progress';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get bulk import job rows details
   */
  static getBulkJobRowDetailsUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** jobId */
      jobId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BulkPolicyImportJobRowModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/bulk_policy_import/{jobId}/row';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{jobId}', params['jobId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class DataTypeConditionalMatchMappingControllerService {
  /**
   * getConditionAttributes
   */
  static getConditionAttributesUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** additionalFilter */
      additionalFilter?: string;
      /** policySubType */
      policySubType: string;
      /** policyTypeId */
      policyTypeId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ConditionAttributeMappingModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/conditionAttribute';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        additionalFilter: params['additionalFilter'],
        policySubType: params['policySubType'],
        policyTypeId: params['policyTypeId']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getConditionAttributesForApplication
   */
  static getConditionAttributesForApplicationUsingGet(
    params: {
      /** additionalFilter */
      additionalFilter?: string;
      /** applicationType */
      applicationType: string;
      /** policySubType */
      policySubType: string;
      /** policyTypeId */
      policyTypeId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ConditionAttributeMappingModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/conditionAttribute';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        additionalFilter: params['additionalFilter'],
        applicationType: params['applicationType'],
        policySubType: params['policySubType'],
        policyTypeId: params['policyTypeId']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getConditionAttributesByType
   */
  static getConditionAttributesByTypeUsingGet(
    params: {
      /** additionalFilter */
      additionalFilter?: string;
      /** conditionType */
      conditionType: string;
      /** policySubType */
      policySubType: string;
      /** policyTypeId */
      policyTypeId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ConditionAttributeMappingModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/{conditionType}/conditionAttribute';
      url = url.replace('{conditionType}', params['conditionType'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        additionalFilter: params['additionalFilter'],
        policySubType: params['policySubType'],
        policyTypeId: params['policyTypeId']
      };

      axios(configs, resolve, reject);
    });
  }
}

export class DataCatalogControllerService {
  /**
   * getDataCatalog
   */
  static getDataCatalogUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** dataSourceName */
      dataSourceName?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DataCatalog> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/data_catalog';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { dataSourceName: params['dataSourceName'] };

      axios(configs, resolve, reject);
    });
  }
}

export class GlueControllerService {
  /**
   * getDataElements
   */
  static getDataElementsUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** databaseName */
      databaseName: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/data_elements';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { databaseName: params['databaseName'] };

      axios(configs, resolve, reject);
    });
  }
}

export class AuditLogsControllerService {
  /**
   * createDataPlaneLogs
   */
  static createDataPlaneLogsUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** requestLogsList */
      requestLogsList: TenantAuditLogsModel[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/data_plane_logs';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['requestLogsList'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * listAccessPolicies
   */
  static listAccessPoliciesUsingGet(
    params: {
      /** accountIds */
      accountIds?: string[];
      /** actions */
      actions?: string[];
      /** endDate */
      endDate?: string;
      /** httpMethods */
      httpMethods?: string[];
      /** page_no */
      pageNo?: number;
      /** page_size */
      pageSize?: number;
      /** resourceIds */
      resourceIds?: string[];
      /** resourceNames */
      resourceNames?: string[];
      /** resourceTypes */
      resourceTypes?: string[];
      /** results */
      results?: string[];
      /** sort_by */
      sortBy?: string;
      /** sort_order */
      sortOrder?: string;
      /** startDate */
      startDate?: string;
      /** userIds */
      userIds?: string[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxPaginatedResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/tenant/audit_logs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        accountIds: params['accountIds'],
        actions: params['actions'],
        endDate: params['endDate'],
        httpMethods: params['httpMethods'],
        page_no: params['pageNo'],
        page_size: params['pageSize'],
        resourceIds: params['resourceIds'],
        resourceNames: params['resourceNames'],
        resourceTypes: params['resourceTypes'],
        results: params['results'],
        sort_by: params['sortBy'],
        sort_order: params['sortOrder'],
        startDate: params['startDate'],
        userIds: params['userIds']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getLoginIdResourceTypeActionsFromAuditTable
   */
  static getLoginIdResourceTypeActionsFromAuditTableUsingGet(
    params: {
      /** filterKey */
      filterKey: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ColumnFiltersResponseModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/tenant/audit_logs/columnFilter';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { filterKey: params['filterKey'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getLast24HoursAuditLogs
   */
  static getLast24HoursAuditLogsUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** tenantId */
      tenantId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TenantAuditLogs[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/tenant/{tenantId}/account/{accountId}/audit_logs/last24hrs';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{tenantId}', params['tenantId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class RemediationControllerService {
  /**
   * createDisableUserPolicy
   */
  static createDisableUserPolicyUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** disableUserModel */
      disableUserModel: DisableUserPolicyModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/disable_user';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['disableUserModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * publishedPolicyList
   */
  static publishedPolicyListUsingGet1(
    params: {
      /** accountId */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/disable_user/published_policy';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * deployDataPlaneDisablePolicy
   */
  static deployDataPlaneDisablePolicyUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** id */
      id: string;
      /** statusModel */
      statusModel: StatusModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/disable_user/{id}/deploy_policy';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['statusModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * createMaskingPolicy
   */
  static createMaskingPolicyUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** remediationDataAccessPolicyModel */
      remediationDataAccessPolicyModel: RemediationDataAccessPolicyModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/remedial_masking_policy';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['remediationDataAccessPolicyModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class AccountPatControllerService {
  /**
   * getDremioPatStatus
   */
  static getDremioPatStatusUsingGet(
    params: {
      /** accountId */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PatStatusModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/dremio_pat';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * setDremioPat
   */
  static setDremioPatUsingPut(
    params: {
      /** accountId */
      accountId: string;
      /** body */
      body: PatRequestModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/dremio_pat';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * deleteDremioPat
   */
  static deleteDremioPatUsingDelete(
    params: {
      /** accountId */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/dremio_pat';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getSnowflakePatStatus
   */
  static getSnowflakePatStatusUsingGet(
    params: {
      /** accountId */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PatStatusModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/snowflake_pat';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * setSnowflakePat
   */
  static setSnowflakePatUsingPut(
    params: {
      /** accountId */
      accountId: string;
      /** body */
      body: PatRequestModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/snowflake_pat';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * deleteSnowflakePat
   */
  static deleteSnowflakePatUsingDelete(
    params: {
      /** accountId */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/snowflake_pat';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class UserEntitlementReptControllerService {
  /**
   * getObjectEntitlementDetails
   */
  static getObjectEntitlementDetailsUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** includeChildMetadata */
      includeChildMetadata?: boolean;
      /** objectName */
      objectName: string;
      /** objectType */
      objectType: string;
      /** page */
      page?: number;
      /** pageSize */
      pageSize?: number;
      /** roleNames */
      roleNames?: string[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ObjectEntitlementDetailModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/entitlements';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        includeChildMetadata: params['includeChildMetadata'],
        objectName: params['objectName'],
        objectType: params['objectType'],
        page: params['page'],
        pageSize: params['pageSize'],
        roleNames: params['roleNames']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getUserEntitlementReport
   */
  static getUserEntitlementReportUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** databaseName */
      databaseName?: string;
      /** page_no */
      pageNo?: number;
      /** page_size */
      pageSize?: number;
      /** sort_by */
      sortBy?: string;
      /** sort_order */
      sortOrder?: string;
      /** userName */
      userName: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxPaginatedResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/user_entitlement_report';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        databaseName: params['databaseName'],
        page_no: params['pageNo'],
        page_size: params['pageSize'],
        sort_by: params['sortBy'],
        sort_order: params['sortOrder'],
        userName: params['userName']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getObjectEntitlementMetadata
   */
  static getObjectEntitlementMetadataUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** objectName */
      objectName?: string;
      /** objectType */
      objectType: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/entitlements/{accountId}/metadata';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { objectName: params['objectName'], objectType: params['objectType'] };

      axios(configs, resolve, reject);
    });
  }
}

export class AccountTagControllerService {
  /**
   * Create an account tag reference (external API)
   */
  static createExternalTagReferenceUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** tagReference */
      tagReference: AccountTagReferenceModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/external/account_tag/tag_references';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['tagReference'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Update an account tag reference (external API)
   */
  static updateExternalTagReferenceUsingPut(
    params: {
      /** accountId */
      accountId: string;
      /** updateRequest */
      updateRequest: AccountTagReferenceUpdateRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/external/account_tag/tag_references';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['updateRequest'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Delete an account tag reference (external API)
   */
  static deleteExternalTagReferenceUsingDelete(
    params: {
      /** accountId */
      accountId: string;
      /** columnName */
      columnName?: string;
      /** objectDatabase */
      objectDatabase: string;
      /** objectName */
      objectName: string;
      /** objectSchema */
      objectSchema: string;
      /** tagDatabase */
      tagDatabase: string;
      /** tagKey */
      tagKey: string;
      /** tagSchema */
      tagSchema: string;
      /** tagValue */
      tagValue: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/external/account_tag/tag_references';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = {
        columnName: params['columnName'],
        objectDatabase: params['objectDatabase'],
        objectName: params['objectName'],
        objectSchema: params['objectSchema'],
        tagDatabase: params['tagDatabase'],
        tagKey: params['tagKey'],
        tagSchema: params['tagSchema'],
        tagValue: params['tagValue']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Bulk create account tag references (external API)
   */
  static createExternalTagReferencesBulkUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** bulkRequest */
      bulkRequest: AccountTagReferenceBulkCreateRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/external/account_tag/tag_references/bulk';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['bulkRequest'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * bulkDeleteTags
   */
  static bulkDeleteTagsUsingDelete(
    params: {
      /** accountId */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account_tag/bulk_delete_tags';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { accountId: params['accountId'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * deleteDataSourceTags
   */
  static deleteDataSourceTagsUsingPut(
    params: {
      /** accountId */
      accountId: string;
      /** tagModel */
      tagModel: AccountTagModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account_tag/delete_tag';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);
      configs.params = { accountId: params['accountId'] };

      let data = params['tagModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * deleteTagAssociation
   */
  static deleteTagAssociationUsingPut(
    params: {
      /** accountId */
      accountId: string;
      /** accountTagEditModel */
      accountTagEditModel: AccountTagAssociationEditDeleteModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account_tag/delete_tag_association';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);
      configs.params = { accountId: params['accountId'] };

      let data = params['accountTagEditModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get tag association object type names based on the user and tag key name
   */
  static getObjectTypesUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** tagKey */
      tagKey?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ObjectTypeModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account_tag/object_types';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { accountId: params['accountId'], tagKey: params['tagKey'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * createTagAssociation
   */
  static createTagAssociationUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** accountTagReferenceModel */
      accountTagReferenceModel: AccountTagAssociationModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account_tag/tag_association';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { accountId: params['accountId'] };

      let data = params['accountTagReferenceModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getTagAssociationMetadata
   */
  static getTagAssociationMetadataUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** columnNames */
      columnNames?: string[];
      /** objectDatabases */
      objectDatabases?: string[];
      /** objectNames */
      objectNames?: string[];
      /** objectSchemas */
      objectSchemas?: string[];
      /** objectTypes */
      objectTypes?: string[];
      /** tagDatabases */
      tagDatabases?: string[];
      /** tagKeys */
      tagKeys?: string[];
      /** tagSchemas */
      tagSchemas?: string[];
      /** type */
      type: string;
      /** workspace */
      workspace?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account_tag/tag_association_metadata';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        accountId: params['accountId'],
        columnNames: params['columnNames'],
        objectDatabases: params['objectDatabases'],
        objectNames: params['objectNames'],
        objectSchemas: params['objectSchemas'],
        objectTypes: params['objectTypes'],
        tagDatabases: params['tagDatabases'],
        tagKeys: params['tagKeys'],
        tagSchemas: params['tagSchemas'],
        type: params['type'],
        workspace: params['workspace']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getTagReferences
   */
  static getTagReferencesUsingGet(
    params: {
      /** accountId */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AccountTagReferenceModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account_tag/tag_reference';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { accountId: params['accountId'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getDataSourceTagReferences
   */
  static getDataSourceTagReferencesUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** objectDatabases */
      objectDatabases?: string[];
      /** objectNames */
      objectNames?: string[];
      /** objectSchemas */
      objectSchemas?: string[];
      /** objectTypes */
      objectTypes?: string[];
      /** page_no */
      pageNo?: number;
      /** page_size */
      pageSize?: number;
      /** sort_by */
      sortBy?: string;
      /** sort_order */
      sortOrder?: string;
      /** tagDatabases */
      tagDatabases?: string[];
      /** tagKeys */
      tagKeys?: string[];
      /** tagSchemas */
      tagSchemas?: string[];
      /** tagValues */
      tagValues?: string[];
      /** workspace */
      workspace?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxPaginatedResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account_tag/tag_references';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        accountId: params['accountId'],
        objectDatabases: params['objectDatabases'],
        objectNames: params['objectNames'],
        objectSchemas: params['objectSchemas'],
        objectTypes: params['objectTypes'],
        page_no: params['pageNo'],
        page_size: params['pageSize'],
        sort_by: params['sortBy'],
        sort_order: params['sortOrder'],
        tagDatabases: params['tagDatabases'],
        tagKeys: params['tagKeys'],
        tagSchemas: params['tagSchemas'],
        tagValues: params['tagValues'],
        workspace: params['workspace']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getDataSourceTags
   */
  static getDataSourceTagsUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** page_no */
      pageNo?: number;
      /** page_size */
      pageSize?: number;
      /** sort_by */
      sortBy?: string;
      /** sort_order */
      sortOrder?: string;
      /** tagDatabases */
      tagDatabases?: string[];
      /** tagNames */
      tagNames?: string[];
      /** tagSchemas */
      tagSchemas?: string[];
      /** tagValues */
      tagValues?: string[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxPaginatedResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account_tag/tags';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        accountId: params['accountId'],
        page_no: params['pageNo'],
        page_size: params['pageSize'],
        sort_by: params['sortBy'],
        sort_order: params['sortOrder'],
        tagDatabases: params['tagDatabases'],
        tagNames: params['tagNames'],
        tagSchemas: params['tagSchemas'],
        tagValues: params['tagValues']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * createDataSourceTags
   */
  static createDataSourceTagsUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** tagModels */
      tagModels: AccountTagModel[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account_tag/tags';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { accountId: params['accountId'] };

      let data = params['tagModels'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * updateDataSourceTags
   */
  static updateDataSourceTagsUsingPut(
    params: {
      /** accountId */
      accountId: string;
      /** updateTagModel */
      updateTagModel: AccountTagEditModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account_tag/tags';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);
      configs.params = { accountId: params['accountId'] };

      let data = params['updateTagModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getTagsMetadata
   */
  static getTagsMetadataUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** tagDatabaseName */
      tagDatabaseName?: string;
      /** tagKeyName */
      tagKeyName?: string;
      /** tagSchemaName */
      tagSchemaName?: string;
      /** type */
      type: string;
      /** workspace */
      workspace?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account_tag/tags_metadata';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        accountId: params['accountId'],
        tagDatabaseName: params['tagDatabaseName'],
        tagKeyName: params['tagKeyName'],
        tagSchemaName: params['tagSchemaName'],
        type: params['type'],
        workspace: params['workspace']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * filterTagsMetadata
   */
  static filterTagsMetadataUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** tagDatabases */
      tagDatabases?: string[];
      /** tagNames */
      tagNames?: string[];
      /** tagSchemas */
      tagSchemas?: string[];
      /** type */
      type: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account_tag/tags_metadata_filter';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        accountId: params['accountId'],
        tagDatabases: params['tagDatabases'],
        tagNames: params['tagNames'],
        tagSchemas: params['tagSchemas'],
        type: params['type']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * validateDataSourceTags
   */
  static validateDataSourceTagsUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** updateTagModel */
      updateTagModel: AccountTagEditModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<StatusModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account_tag/validate_tags';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { accountId: params['accountId'] };

      let data = params['updateTagModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getDatabases
   */
  static getDatabasesUsingGet1(
    params: {
      /** accountId */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DatabaseMetadata[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account_tag/{accountId}/tag_databases';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getSchemas
   */
  static getSchemasUsingGet1(
    params: {
      /** accountId */
      accountId: string;
      /** databaseNames */
      databaseNames: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SchemaMetadata[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account_tag/{accountId}/tag_schemas';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { databaseNames: params['databaseNames'] };

      axios(configs, resolve, reject);
    });
  }
}

export class MonitoringWatermarkControllerService {
  /**
   * getMonitoringWaterMarkTimestamp
   */
  static getMonitoringWaterMarkTimestampUsingGet(
    params: {
      /** accountId */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MonitoringWatermarkModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/monitoring_watermark_timestamp';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * putMonitoringWaterMarkTimestamp
   */
  static putMonitoringWaterMarkTimestampUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** monitoringWatermarkModel */
      monitoringWatermarkModel: MonitoringWatermarkModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/monitoring_watermark_timestamp';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['monitoringWatermarkModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class PolarisCredsControllerService {
  /**
   * getPolarisCredsStatus
   */
  static getPolarisCredsStatusUsingGet(
    params: {
      /** accountId */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PolarisCredsStatusModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/polaris_creds';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * setPolarisCreds
   */
  static setPolarisCredsUsingPut(
    params: {
      /** accountId */
      accountId: string;
      /** creds */
      creds: PolarisCredsModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/polaris_creds';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['creds'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * deletePolarisCreds
   */
  static deletePolarisCredsUsingDelete(
    params: {
      /** accountId */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/polaris_creds';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * testPolarisCreds
   */
  static testPolarisCredsUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** catalogUri */
      catalogUri: string;
      /** namespace */
      namespace: string;
      /** tableName */
      tableName: string;
      /** warehouse */
      warehouse: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PolarisCredsTestResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/polaris_creds/test';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = {
        catalogUri: params['catalogUri'],
        namespace: params['namespace'],
        tableName: params['tableName'],
        warehouse: params['warehouse']
      };

      axios(configs, resolve, reject);
    });
  }
}

export class PolicySyncJobControllerService {
  /**
   * Get all policy sync jobs for an account
   */
  static getPolicySyncJobsUsingGet(
    params: {
      /** accountId */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/policy_sync_jobs';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Create a new policy sync job
   */
  static createPolicySyncJobUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** syncJob */
      syncJob: AccountPolicySyncJob;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/policy_sync_jobs';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['syncJob'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get policy sync job details with policy information for the latest job
   */
  static getPolicySyncJobDetailsUsingGet(
    params: {
      /** accountId */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PolicySyncJobDetailResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/policy_sync_jobs/details';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get latest policy sync job by status
   */
  static getLatestPolicySyncJobByStatusUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** isOnDemandTriggeredSync */
      isOnDemandTriggeredSync: boolean;
      /** status */
      status?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AccountPolicySyncJob> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/policy_sync_jobs/latest';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { isOnDemandTriggeredSync: params['isOnDemandTriggeredSync'], status: params['status'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get policy sync job by ID
   */
  static getPolicySyncJobUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** jobId */
      jobId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/policy_sync_jobs/{jobId}';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{jobId}', params['jobId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Update an existing policy sync job
   */
  static updatePolicySyncJobUsingPut(
    params: {
      /** accountId */
      accountId: string;
      /** jobId */
      jobId: string;
      /** syncJob */
      syncJob: AccountPolicySyncJob;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/policy_sync_jobs/{jobId}';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{jobId}', params['jobId'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['syncJob'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Delete a policy sync job
   */
  static deletePolicySyncJobUsingDelete(
    params: {
      /** accountId */
      accountId: string;
      /** jobId */
      jobId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/policy_sync_jobs/{jobId}';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{jobId}', params['jobId'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get policy sync job details with policy information for the latest job
   */
  static getPolicySyncDeltaObjectsUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** jobId */
      jobId: string;
      /** policyId */
      policyId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/policy_sync_jobs/{jobId}/access_policy/{policyId}/delta_objects';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{jobId}', params['jobId'] + '');
      url = url.replace('{policyId}', params['policyId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Remove policy sync job and set policies to review and publish mode
   */
  static removePolicySyncJobUsingPut(
    params: {
      /** accountId */
      accountId: string;
      /** jobId */
      jobId: string;
      /** policyIds */
      policyIds: any | null[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AccountPolicySyncJob> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/policy_sync_jobs/{jobId}/sync';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{jobId}', params['jobId'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['policyIds'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class DataPrivacyPolicyControllerService {
  /**
   * listPrivacyPolicies
   */
  static listPrivacyPoliciesUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** dataSourceName */
      dataSourceName?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DataPrivacyPolicy[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/privacy_policies';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { dataSourceName: params['dataSourceName'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * createPrivacyPolicy
   */
  static createPrivacyPolicyUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** dataPrivacyPolicyModel */
      dataPrivacyPolicyModel: DataPrivacyPolicyModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/privacy_policies';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['dataPrivacyPolicyModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * updatePrivacyPolicy
   */
  static updatePrivacyPolicyUsingPut(
    params: {
      /** accountId */
      accountId: string;
      /** dataPrivacyPolicyReqModel */
      dataPrivacyPolicyReqModel: DataPrivacyPolicyModel;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/privacy_policies/{id}';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['dataPrivacyPolicyReqModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * deletePrivacyPolicy
   */
  static deletePrivacyPolicyUsingDelete(
    params: {
      /** accountId */
      accountId: string;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/privacy_policies/{id}';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * deployPrivacyPolicy
   */
  static deployPrivacyPolicyUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/privacy_policies/{id}/publish_policy';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class ReportsControllerService {
  /**
   * getLatestReport
   */
  static getLatestReportUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** endDate */
      endDate?: string;
      /** report_name */
      reportName: string;
      /** startDate */
      startDate?: string;
      /** type */
      type?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/report';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        endDate: params['endDate'],
        report_name: params['reportName'],
        startDate: params['startDate'],
        type: params['type']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * saveReport
   */
  static saveReportUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** report_name */
      reportName: string;
      /** reportJson */
      reportJson: object;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/report';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { report_name: params['reportName'] };

      let data = params['reportJson'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * checkTodayReportAvailability
   */
  static checkTodayReportAvailabilityUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** filters */
      filters?: string;
      /** reportName */
      reportName: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ReportStatus> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/reportDownload/checkTodayReportAvailability';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { filters: params['filters'], reportName: params['reportName'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * createScheduledRecordForTodaysReport
   */
  static createScheduledRecordForTodaysReportUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** numberOfDays */
      numberOfDays?: number;
      /** report_name */
      reportName: string;
      /** requestFiltersModel */
      requestFiltersModel?: RequestFiltersModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/reportDownload/createScheduledRecordForTodaysReport';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { numberOfDays: params['numberOfDays'], report_name: params['reportName'] };

      let data = params['requestFiltersModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * updateReportStatusAndS3Path
   */
  static updateReportStatusAndS3PathUsingPut(
    params: {
      /** accountId */
      accountId: string;
      /** filters */
      filters?: string;
      /** report_name */
      reportName: string;
      /** s3BucketModel */
      s3BucketModel: S3BucketModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/reportDownload/updateReportStatusAndS3Path';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);
      configs.params = { filters: params['filters'], report_name: params['reportName'] };

      let data = params['s3BucketModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * saveReportItem
   */
  static saveReportItemUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** reportsModel */
      reportsModel: ReportsModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/reportItem';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['reportsModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getLatestReportStats
   */
  static getLatestReportStatsUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** chart_type */
      chartType?: string;
      /** endDate */
      endDate?: string;
      /** is_demo */
      isDemo?: boolean;
      /** report_name */
      reportName: string;
      /** report_stats_type */
      reportStatsType?: string;
      /** startDate */
      startDate?: string;
      /** userName */
      userName?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/report_stats';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        chart_type: params['chartType'],
        endDate: params['endDate'],
        is_demo: params['isDemo'],
        report_name: params['reportName'],
        report_stats_type: params['reportStatsType'],
        startDate: params['startDate'],
        userName: params['userName']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getLatestReportStatsById
   */
  static getLatestReportStatsByIdUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<object[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/report_stats/{id}';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getReportStatsByLatestReportDate
   */
  static getReportStatsByLatestReportDateUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** report_name */
      reportName: string;
      /** report_stats_type */
      reportStatsType: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Reports> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/report_stats_by_report_date';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { report_name: params['reportName'], report_stats_type: params['reportStatsType'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getLatestReportStatsItems
   */
  static getLatestReportStatsItemsUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** endDate */
      endDate?: string;
      /** item_name */
      itemName?: string;
      /** report_name */
      reportName: string;
      /** report_stats_type */
      reportStatsType?: string;
      /** startDate */
      startDate?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<object[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/report_stats_items';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        endDate: params['endDate'],
        item_name: params['itemName'],
        report_name: params['reportName'],
        report_stats_type: params['reportStatsType'],
        startDate: params['startDate']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getNumberOfDaysToIngestReports
   */
  static getNumberOfDaysToIngestReportsUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** report_name */
      reportName: string;
      /** report_stats_type */
      reportStatsType: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AccountDIWatermarkModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/report_watermark';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { report_name: params['reportName'], report_stats_type: params['reportStatsType'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * generateSystemReport
   */
  static generateSystemReportUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** reportId */
      reportId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/system_report/generate';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { reportId: params['reportId'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getDataProtectionReportByTenant
   */
  static getDataProtectionReportByTenantUsingGet(options: IRequestOptions = {}): Promise<DataProtectionReport> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/report/data_protection';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getIngestedProcessedRecordsCountReport
   */
  static getIngestedProcessedRecordsCountReportUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** days */
      days?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<StatsItemCount> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/report/ingested_processed_report';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { accountId: params['accountId'], days: params['days'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getReportsScheduledForProcessing
   */
  static getReportsScheduledForProcessingUsingGet(
    params: {
      /** accountIds */
      accountIds?: string[];
      /** latest_Report */
      latestReport?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ReportStatus[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/reportDownload/fetchAllScheduledReportsForProcessing';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { accountIds: params['accountIds'], latest_Report: params['latestReport'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getReportGenerationHistory
   */
  static getReportGenerationHistoryUsingGet(
    params: {
      /** accountId */
      accountId?: string;
      /** actions */
      actions?: string[];
      /** classification */
      classification?: string[];
      /** databases */
      databases?: string[];
      /** endDate */
      endDate?: string[];
      /** generatedBy */
      generatedBy?: string[];
      /** groups */
      groups?: string[];
      /** name */
      name?: string;
      /** numberOfDays */
      numberOfDays?: number;
      /** objectName */
      objectName?: string[];
      /** objects */
      objects?: string[];
      /** objectType */
      objectType?: string[];
      /** pageNo */
      pageNo?: number;
      /** pageSize */
      pageSize?: number;
      /** policyVersion */
      policyVersion?: number[];
      /** privileges */
      privileges?: string[];
      /** roles */
      roles?: string[];
      /** schemas */
      schemas?: string[];
      /** sessionTime */
      sessionTime?: string[];
      /** sortBy */
      sortBy?: string;
      /** sortOrder */
      sortOrder?: string;
      /** startDate */
      startDate?: string[];
      /** status */
      status?: string;
      /** triggeredBy */
      triggeredBy?: string[];
      /** userNames */
      userNames?: string[];
      /** users */
      users?: string[];
      /** workspace */
      workspace?: string[];
      /** workspaceId */
      workspaceId?: string[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxPaginatedResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/reportDownload/fetchReportGenerationHistory';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        accountId: params['accountId'],
        actions: params['actions'],
        classification: params['classification'],
        databases: params['databases'],
        endDate: params['endDate'],
        generatedBy: params['generatedBy'],
        groups: params['groups'],
        name: params['name'],
        numberOfDays: params['numberOfDays'],
        objectName: params['objectName'],
        objects: params['objects'],
        objectType: params['objectType'],
        pageNo: params['pageNo'],
        pageSize: params['pageSize'],
        policyVersion: params['policyVersion'],
        privileges: params['privileges'],
        roles: params['roles'],
        schemas: params['schemas'],
        sessionTime: params['sessionTime'],
        sortBy: params['sortBy'],
        sortOrder: params['sortOrder'],
        startDate: params['startDate'],
        status: params['status'],
        triggeredBy: params['triggeredBy'],
        userNames: params['userNames'],
        users: params['users'],
        workspace: params['workspace'],
        workspaceId: params['workspaceId']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * fetchS3Object
   */
  static fetchS3ObjectUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** fileExtension */
      fileExtension?: string;
      /** reportId */
      reportId?: string;
      /** reportName */
      reportName: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/reportDownload/{accountId}/fetchS3Object';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        fileExtension: params['fileExtension'],
        reportId: params['reportId'],
        reportName: params['reportName']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get policies by account, policy data type, and policy subtype
   */
  static getPoliciesByAccountTypeAndSubtypeUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** policyDataTypeId */
      policyDataTypeId: string;
      /** policySubtype */
      policySubtype: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<object[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/reports/access_policies';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        accountId: params['accountId'],
        policyDataTypeId: params['policyDataTypeId'],
        policySubtype: params['policySubtype']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getAccessPolicyTypes
   */
  static getAccessPolicyTypesUsingGet(options: IRequestOptions = {}): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/reports/access_policy_types';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getReportFilters
   */
  static getReportFiltersUsingGet(
    params: {
      /** accountId */
      accountId?: string;
      /** filterKey */
      filterKey: string;
      /** triggeredBy */
      triggeredBy?: string[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PairModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/reports/filters';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        accountId: params['accountId'],
        filterKey: params['filterKey'],
        triggeredBy: params['triggeredBy']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getRecentReports
   */
  static getRecentReportsUsingGet(
    params: {
      /** accountId */
      accountId?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RecentReportModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/reports/getRecentReports';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { accountId: params['accountId'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getReports
   */
  static getReportsUsingGet(
    params: {
      /** datasource */
      datasource?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ReportBasicInfoModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/reports/getReports';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { datasource: params['datasource'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getObjectTypes
   */
  static getObjectTypesUsingGet1(
    params: {
      /** accountId */
      accountId: string;
      /** principalType */
      principalType: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/reports/object_type';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { accountId: params['accountId'], principalType: params['principalType'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * triggerReportScheduleService
   */
  static triggerReportScheduleServiceUsingPost(
    params: {
      /** requestModel */
      requestModel: OnDemandReportTriggerModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/reports/on_demand_trigger';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['requestModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class WatermarkTimestampControllerService {
  /**
   * getAccountWaterMarkTimestamp
   */
  static getAccountWaterMarkTimestampUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** defaultWatermark */
      defaultWatermark?: boolean;
      /** ingestionReportName */
      ingestionReportName?: string;
      /** reportType */
      reportType: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AccountDIWatermarkModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/report_type/{reportType}/watermark_timestamp';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{reportType}', params['reportType'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        defaultWatermark: params['defaultWatermark'],
        ingestionReportName: params['ingestionReportName']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * putAccountWaterMarkTimestamp
   */
  static putAccountWaterMarkTimestampUsingPost(
    params: {
      /** accountDIWatermarkModel */
      accountDiWatermarkModel: AccountDIWatermarkModel;
      /** accountId */
      accountId: string;
      /** ingestionReportName */
      ingestionReportName?: string;
      /** reportType */
      reportType: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/report_type/{reportType}/watermark_timestamp';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{reportType}', params['reportType'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { ingestionReportName: params['ingestionReportName'] };

      let data = params['accountDiWatermarkModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class UserEntitlementAttributeControllerService {
  /**
   * getUserAttributeValuesHistory
   */
  static getUserAttributeValuesHistoryUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TenantAuditLogs[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/{accountId}/user_entitlement_attribute/{id}/view_history';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getUserAttributeConfigurations
   */
  static getUserAttributeConfigurationsUsingGet(
    params: {
      /** accountId */
      accountId?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserAttributeConfigurationModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_attribute_configuration';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { accountId: params['accountId'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * saveUserAttributeConfigurations
   */
  static saveUserAttributeConfigurationsUsingPost(
    params: {
      /** userAttributeConfigurationModel */
      userAttributeConfigurationModel: UserAttributeConfigurationModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_attribute_configuration';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['userAttributeConfigurationModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getAccountExternalSourceAttributeDetails
   */
  static getAccountExternalSourceAttributeDetailsUsingGet(
    options: IRequestOptions = {}
  ): Promise<AccountExternalSourceAttributeDetailsModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_attribute_configuration/external_source_attributes';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * importAttributeFromExternalSource
   */
  static importAttributeFromExternalSourceUsingPost(
    params: {
      /** userAttributeImportMetadataModel */
      userAttributeImportMetadataModel: UserAttributeImportMetadataModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxSyncServiceResponseModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_attribute_configuration/import_attributes';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['userAttributeImportMetadataModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getUserAttributeSourceList
   */
  static getUserAttributeSourceListUsingGet(options: IRequestOptions = {}): Promise<UserAttributeSourceModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_attribute_configuration/source';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * userAttributeConfigurationTestConnection
   */
  static userAttributeConfigurationTestConnectionUsingPost(
    params: {
      /** userAttributeConfigurationModel */
      userAttributeConfigurationModel: UserAttributeConfigurationModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_attribute_configuration/test_connection';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['userAttributeConfigurationModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getUserAttributeConfigurationGetById
   */
  static getUserAttributeConfigurationGetByIdUsingGet(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserAttributeConfigurationModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_attribute_configuration/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * updateUserAttributeConfigurations
   */
  static updateUserAttributeConfigurationsUsingPut(
    params: {
      /** id */
      id: string;
      /** userAttributeConfiguration */
      userAttributeConfiguration: UserAttributeConfigurationModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_attribute_configuration/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['userAttributeConfiguration'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * deleteUserAttributeConfiguration
   */
  static deleteUserAttributeConfigurationUsingDelete(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_attribute_configuration/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getUserAttributeFromExternalSource
   */
  static getUserAttributeFromExternalSourceUsingGet(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalSourceUserAttributeModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_attribute_configuration/{id}/attributes';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getUsersFromExternalSource
   */
  static getUsersFromExternalSourceUsingPost(
    params: {
      /** id */
      id: string;
      /** nextLink */
      nextLink?: string;
      /** page_size */
      pageSize?: number;
      /** searchParams */
      searchParams: ExternalUserSearchRequestModel;
      /** sort_by */
      sortBy?: string;
      /** sort_order */
      sortOrder?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalSourceUserAttributeValueModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_attribute_configuration/{id}/users';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = {
        nextLink: params['nextLink'],
        page_size: params['pageSize'],
        sort_by: params['sortBy'],
        sort_order: params['sortOrder']
      };

      let data = params['searchParams'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * importUsersFromExternalSourceToDatasource
   */
  static importUsersFromExternalSourceToDatasourceUsingPost(
    params: {
      /** id */
      id: string;
      /** userImportModel */
      userImportModel: ExternalUserImportRequestModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxSyncServiceResponseModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_attribute_configuration/{id}/users/import';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['userImportModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getUserAttributeConfigurationTypes
   */
  static getUserAttributeConfigurationTypesUsingGet(
    options: IRequestOptions = {}
  ): Promise<UserAttributeConfigurationTypeModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_attribute_configuration_type';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getUserAttributeConfigurationTypeById
   */
  static getUserAttributeConfigurationTypeByIdUsingGet(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserAttributeConfigurationTypeModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_attribute_configuration_type/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getUserAttributeConfigurationTypeByDatasourceType
   */
  static getUserAttributeConfigurationTypeByDatasourceTypeUsingGet(
    params: {
      /** contextType */
      contextType?: string;
      /** sourceType */
      sourceType: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserAttributeConfigurationTypeModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_attribute_configuration_type_by_source_type/{sourceType}';
      url = url.replace('{sourceType}', params['sourceType'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { contextType: params['contextType'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getUserAttributeSyncJobRunDetails
   */
  static getUserAttributeSyncJobRunDetailsUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** attributeSourceConfigurationId */
      attributeSourceConfigurationId: string;
      /** dataProduct */
      dataProduct: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserAttributeSyncJobRunDetailsModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_attribute_sync_job_run_details';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        accountId: params['accountId'],
        attributeSourceConfigurationId: params['attributeSourceConfigurationId'],
        dataProduct: params['dataProduct']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * createUserAttributeSyncJobRunDetails
   */
  static createUserAttributeSyncJobRunDetailsUsingPost(
    params: {
      /** requestModel */
      requestModel: UserAttributeSyncJobRunDetailsModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserAttributeSyncJobRunDetailsModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_attribute_sync_job_run_details';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['requestModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * updateUserAttributeSyncJobRunDetails
   */
  static updateUserAttributeSyncJobRunDetailsUsingPut(
    params: {
      /** requestModel */
      requestModel: UserAttributeSyncJobRunDetailsModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserAttributeSyncJobRunDetailsModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_attribute_sync_job_run_details';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['requestModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getUserAttributesValues
   */
  static getUserAttributesValuesUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** attributeName */
      attributeName: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_attribute_value';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { accountId: params['accountId'], attributeName: params['attributeName'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getUserAttributesMetadata
   */
  static getUserAttributesMetadataUsingGet(
    params: {
      /** accountId */
      accountId?: string;
      /** attributeName */
      attributeName?: string;
      /** dataProduct */
      dataProduct?: string[];
      /** dataType */
      dataType?: string;
      /** deriveType */
      deriveType?: string[];
      /** identityType */
      identityType?: string;
      /** includePrincipal */
      includePrincipal?: boolean;
      /** isMasking */
      isMasking?: boolean;
      /** operator */
      operator?: string;
      /** serverName */
      serverName?: string;
      /** status */
      status?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserEntitlementAttributeModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_entitlement_attribute';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        accountId: params['accountId'],
        attributeName: params['attributeName'],
        dataProduct: params['dataProduct'],
        dataType: params['dataType'],
        deriveType: params['deriveType'],
        identityType: params['identityType'],
        includePrincipal: params['includePrincipal'],
        isMasking: params['isMasking'],
        operator: params['operator'],
        serverName: params['serverName'],
        status: params['status']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * saveUserAttributesMetadata
   */
  static saveUserAttributesMetadataUsingPost(
    params: {
      /** accountId */
      accountId?: string;
      /** identityType */
      identityType?: string;
      /** isSync */
      isSync?: boolean;
      /** owner */
      owner?: string;
      /** userEntitlementAttributeModel */
      userEntitlementAttributeModel: UserEntitlementAttributeModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserEntitlementAttributeModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_entitlement_attribute';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = {
        accountId: params['accountId'],
        identityType: params['identityType'],
        isSync: params['isSync'],
        owner: params['owner']
      };

      let data = params['userEntitlementAttributeModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * updateUserAttributesTableMetadata
   */
  static updateUserAttributesTableMetadataUsingPut(
    params: {
      /** accountId */
      accountId: string;
      /** tableId */
      tableId?: string;
      /** userAttributesResponseModel */
      userAttributesResponseModel: UserEntitlementAttributeModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserEntitlementAttributeModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_entitlement_attribute';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);
      configs.params = { accountId: params['accountId'], tableId: params['tableId'] };

      let data = params['userAttributesResponseModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * deleteUserAttributesTableMetadata
   */
  static deleteUserAttributesTableMetadataUsingDelete(
    params: {
      /** accountId */
      accountId?: string;
      /** columnName */
      columnName?: string;
      /** forceDelete */
      forceDelete?: boolean;
      /** id */
      id?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_entitlement_attribute';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = {
        accountId: params['accountId'],
        columnName: params['columnName'],
        forceDelete: params['forceDelete'],
        id: params['id']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * updateDetailsOfUserAttributesTableMetadata
   */
  static updateDetailsOfUserAttributesTableMetadataUsingPatch(
    params: {
      /** accountId */
      accountId?: string;
      /** id */
      id: string;
      /** identityType */
      identityType?: string;
      /** userAttributesColumnModel */
      userAttributesColumnModel: UserEntitlementAttributeColumnModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserEntitlementAttributeModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_entitlement_attribute';

      const configs: IRequestConfig = getConfigs('patch', 'application/json', url, options);
      configs.params = { accountId: params['accountId'], id: params['id'], identityType: params['identityType'] };

      /** 适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body */

      console.warn('适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body');

      let data = params['userAttributesColumnModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getDistinctAttributeGroupNames
   */
  static getDistinctAttributeGroupNamesUsingGet(
    params: {
      /** accountId */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_entitlement_attribute/attribute_group';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { accountId: params['accountId'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Classify users by attribute record count
   */
  static classifyUsersByAttributeRecordCountUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** dataProduct */
      dataProduct: string;
      /** targetUserName */
      targetUserName: string[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserAttributeRecordCountClassificationResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_entitlement_attribute/classify_users_by_record_count';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        accountId: params['accountId'],
        dataProduct: params['dataProduct'],
        targetUserName: params['targetUserName']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * copyUserEntitlementAttributeValues
   */
  static copyUserEntitlementAttributeValuesUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** requestBody */
      requestBody: CopyAttributeValueRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_entitlement_attribute/copy_value';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { accountId: params['accountId'] };

      let data = params['requestBody'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getUserAttributeDataType
   */
  static getUserAttributeDataTypeUsingGet(
    params: {
      /** columnDataType */
      columnDataType?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserAttributeDataTypeModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_entitlement_attribute/data_type';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { columnDataType: params['columnDataType'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * exportUserAttribute
   */
  static exportUserAttributeUsingPost(
    params: {
      /** filter */
      filter: AttributeExportFilter;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_entitlement_attribute/export';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['filter'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getAdditionalColumnConditionForAttribute
   */
  static getAdditionalColumnConditionForAttributeUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** attributeName */
      attributeName: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ColumnMetadata[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_entitlement_attribute/filter_column';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { accountId: params['accountId'], attributeName: params['attributeName'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Import user attributes from CSV
   */
  static importUserAttributeUsingPost(
    params: {
      /**  */
      accountId?: string;
      /**  */
      file?: any;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_entitlement_attribute/import';

      const configs: IRequestConfig = getConfigs('post', 'multipart/form-data', url, options);

      let data = undefined;
      data = new FormData();
      if (params['accountId']) {
        if (Object.prototype.toString.call(params['accountId']) === '[object Array]') {
          for (const item of params['accountId']) {
            data.append('accountId', item as any);
          }
        } else {
          data.append('accountId', params['accountId'] as any);
        }
      }

      if (params['file']) {
        if (Object.prototype.toString.call(params['file']) === '[object Array]') {
          for (const item of params['file']) {
            data.append('file', item as any);
          }
        } else {
          data.append('file', params['file'] as any);
        }
      }

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getUserAttributeMasterData
   */
  static getUserAttributeMasterDataUsingGet(
    params: {
      /** attributeId */
      attributeId: string;
      /** expandHierarchy */
      expandHierarchy?: boolean;
      /** page_no */
      pageNo?: number;
      /** page_size */
      pageSize?: number;
      /** path */
      path?: string[];
      /** query */
      query?: string;
      /** search */
      search?: string;
      /** searchColumn */
      searchColumn?: string[];
      /** sort_order */
      sortOrder?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxPaginatedResponseModel_AttributeDataResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_entitlement_attribute/masterdata/{attributeId}';
      url = url.replace('{attributeId}', params['attributeId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        expandHierarchy: params['expandHierarchy'],
        page_no: params['pageNo'],
        page_size: params['pageSize'],
        path: params['path'],
        query: params['query'],
        search: params['search'],
        searchColumn: params['searchColumn'],
        sort_order: params['sortOrder']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getUserAttributesMetadataByTenant
   */
  static getUserAttributesMetadataByTenantUsingGet(
    params: {
      /** accountId */
      accountId?: string[];
      /** attributeCode */
      attributeCode?: string[];
      /** attributeGroupNames */
      attributeGroupNames?: string[];
      /** attributeName */
      attributeName?: string[];
      /** attributeSource */
      attributeSource?: string;
      /** dataProduct */
      dataProduct?: string[];
      /** id */
      id?: string;
      /** identityType */
      identityType?: string;
      /** page_no */
      pageNo?: number;
      /** page_size */
      pageSize?: number;
      /** sort_by */
      sortBy?: string;
      /** sort_order */
      sortOrder?: string;
      /** status */
      status?: string[];
      /** userAttributeConfigurationId */
      userAttributeConfigurationId?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxUserEntitlementAttributeColumnResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_entitlement_attribute/metadata_by_tenant';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        accountId: params['accountId'],
        attributeCode: params['attributeCode'],
        attributeGroupNames: params['attributeGroupNames'],
        attributeName: params['attributeName'],
        attributeSource: params['attributeSource'],
        dataProduct: params['dataProduct'],
        id: params['id'],
        identityType: params['identityType'],
        page_no: params['pageNo'],
        page_size: params['pageSize'],
        sort_by: params['sortBy'],
        sort_order: params['sortOrder'],
        status: params['status'],
        userAttributeConfigurationId: params['userAttributeConfigurationId']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * syncUserAttributesMetadataAndValues
   */
  static syncUserAttributesMetadataAndValuesUsingPost(
    params: {
      /** accountId */
      accountId?: string[];
      /** attributeIds */
      attributeIds?: any | null[];
      /** syncType */
      syncType: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxSyncServiceResponseModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_entitlement_attribute/sync';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { accountId: params['accountId'], syncType: params['syncType'] };

      let data = params['attributeIds'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * List user attribute values with dynamic and reference attribute filtering
   */
  static listUserAttributesTableValuesUsingGet(
    params: {
      /** accountId */
      accountId?: string;
      /** attributeValueFilters */
      attributeValueFilters?: string[];
      /** cascaded */
      cascaded?: string;
      /** cascadedFrom */
      cascadedFrom?: string;
      /** dataProduct */
      dataProduct?: string;
      /** dynamicAttributes */
      dynamicAttributes?: string;
      /** identityType */
      identityType?: string;
      /** isValueList */
      isValueList?: boolean;
      /** manualOnly */
      manualOnly?: boolean;
      /** page_no */
      pageNo?: number;
      /** page_size */
      pageSize?: number;
      /** referenceAttributes */
      referenceAttributes?: string;
      /** sort_by */
      sortBy?: string;
      /** sort_order */
      sortOrder?: string;
      /** status */
      status?: string[];
      /** userId */
      userId?: string;
      /** userName */
      userName?: string[];
      /** userNameFilter */
      userNameFilter?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxUserEntitlementAttributeValueResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_entitlement_attribute/value';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        accountId: params['accountId'],
        attributeValueFilters: params['attributeValueFilters'],
        cascaded: params['cascaded'],
        cascadedFrom: params['cascadedFrom'],
        dataProduct: params['dataProduct'],
        dynamicAttributes: params['dynamicAttributes'],
        identityType: params['identityType'],
        isValueList: params['isValueList'],
        manualOnly: params['manualOnly'],
        page_no: params['pageNo'],
        page_size: params['pageSize'],
        referenceAttributes: params['referenceAttributes'],
        sort_by: params['sortBy'],
        sort_order: params['sortOrder'],
        status: params['status'],
        userId: params['userId'],
        userName: params['userName'],
        userNameFilter: params['userNameFilter']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * saveUserEntitlementAttributeValues
   */
  static saveUserEntitlementAttributeValuesUsingPost(
    params: {
      /** accountId */
      accountId?: string;
      /** attributeValueModel */
      attributeValueModel: UserEntitlementAttributeValueModel;
      /** identityType */
      identityType?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_entitlement_attribute/value';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { accountId: params['accountId'], identityType: params['identityType'] };

      let data = params['attributeValueModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * deleteUserAttributesTableValues
   */
  static deleteUserAttributesTableValuesUsingDelete(
    params: {
      /** accountId */
      accountId?: string;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_entitlement_attribute/value';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { accountId: params['accountId'], id: params['id'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * updateUserAttributesTableValues
   */
  static updateUserAttributesTableValuesUsingPatch(
    params: {
      /** accountId */
      accountId?: string;
      /** attributeValueModel */
      attributeValueModel: UserEntitlementAttributeValueModel;
      /** id */
      id?: string;
      /** identityType */
      identityType?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_entitlement_attribute/value';

      const configs: IRequestConfig = getConfigs('patch', 'application/json', url, options);
      configs.params = { accountId: params['accountId'], id: params['id'], identityType: params['identityType'] };

      /** 适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body */

      console.warn('适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body');

      let data = params['attributeValueModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getDataProductAccountUserNamesUsedInAttributeMetadata
   */
  static getDataProductAccountUserNamesUsedInAttributeMetadataUsingGet(
    params: {
      /** accountId */
      accountId?: string[];
      /** columnKey */
      columnKey?: string;
      /** dataProduct */
      dataProduct?: string[];
      /** filterKey */
      filterKey: string;
      /** isValueProduct */
      isValueProduct?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserAttributeAccountDattaProductResponseModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_entitlement_attribute/value/columnFilter';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        accountId: params['accountId'],
        columnKey: params['columnKey'],
        dataProduct: params['dataProduct'],
        filterKey: params['filterKey'],
        isValueProduct: params['isValueProduct']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * saveUserEntitlementData
   */
  static saveUserEntitlementDataUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** requestList */
      requestList: [];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_entitlement_data/{accountId}';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['requestList'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class EntitlementReportControllerService {
  /**
   * saveAccountObjectPrivilege
   */
  static saveAccountObjectPrivilegeUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** deleteExistingRecords */
      deleteExistingRecords?: boolean;
      /** grantsToRolePrivilegeModellList */
      grantsToRolePrivilegeModellList: AccountObjectPrivilegeModel[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account_object_privilege';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { accountId: params['accountId'], deleteExistingRecords: params['deleteExistingRecords'] };

      let data = params['grantsToRolePrivilegeModellList'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * saveAccountRoleHierarchy
   */
  static saveAccountRoleHierarchyUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** deleteExistingRecords */
      deleteExistingRecords?: boolean;
      /** grantsToRoleHierarchyModelList */
      grantsToRoleHierarchyModelList: AccountRolesHierarchyModel[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account_role_hierarchy';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { accountId: params['accountId'], deleteExistingRecords: params['deleteExistingRecords'] };

      let data = params['grantsToRoleHierarchyModelList'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * saveAccountUsers
   */
  static saveAccountUsersUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** deleteExistingRecords */
      deleteExistingRecords?: boolean;
      /** grantUserModellList */
      grantUserModellList: AccountUserModel[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account_users';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { accountId: params['accountId'], deleteExistingRecords: params['deleteExistingRecords'] };

      let data = params['grantUserModellList'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * saveAccountUserRoleMapping
   */
  static saveAccountUserRoleMappingUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** accountUsersRoleMappingModellList */
      accountUsersRoleMappingModellList: AccountUsersRoleMappingModel[];
      /** deleteExistingRecords */
      deleteExistingRecords?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account_users_role_mapping';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { accountId: params['accountId'], deleteExistingRecords: params['deleteExistingRecords'] };

      let data = params['accountUsersRoleMappingModellList'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getContextDetails
   */
  static getContextDetailsUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** name */
      name: string;
      /** pivotPoint */
      pivotPoint: string;
      /** pivotValue */
      pivotValue?: EntitlementReportPivotValue;
      /** type */
      type: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Item> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_entitlement/{accountId}/get_context';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { name: params['name'], pivotPoint: params['pivotPoint'], type: params['type'] };

      let data = params['pivotValue'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getItems
   */
  static getItemsUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** childrenType */
      childrenType?: string;
      /** page_no */
      pageNo?: number;
      /** page_size */
      pageSize?: number;
      /** pivotPoint */
      pivotPoint: string;
      /** pivotValue */
      pivotValue?: EntitlementReportPivotValue;
      /** queryType */
      queryType: string;
      /** search */
      search?: string;
      /** sort_order */
      sortOrder?: string;
      /** type */
      type: string;
      /** value */
      value: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxPaginatedResponseModel_Item> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_entitlement/{accountId}/items';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = {
        childrenType: params['childrenType'],
        page_no: params['pageNo'],
        page_size: params['pageSize'],
        pivotPoint: params['pivotPoint'],
        queryType: params['queryType'],
        search: params['search'],
        sort_order: params['sortOrder'],
        type: params['type'],
        value: params['value']
      };

      let data = params['pivotValue'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getLatestTriggerTimeOfAccessAnalyzerDiOfAccount
   */
  static getLatestTriggerTimeOfAccessAnalyzerDiOfAccountUsingGet(
    params: {
      /** accountId */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_entitlement/{accountId}/latestAccessAnalyzerDITime';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * triggerAccessAnalyzerDIForAccount
   */
  static triggerAccessAnalyzerDiForAccountUsingPost(
    params: {
      /** accountId */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_entitlement/{accountId}/triggerAccessAnalyzerDI';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class AgentControllerService {
  /**
   * MCP server bindings of an AI agent, shaped for the policy decision point
   */
  static getMcpServerBindingsOpaInputUsingGet(
    params: {
      /** agentId */
      agentId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentPolicyOpaInputModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent/{agentId}/mcp_server_bindings/agent_policies';
      url = url.replace('{agentId}', params['agentId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * List MCP server bindings by AI agent or by MCP server
   */
  static listMcpServerBindingsUsingGet(
    params: {
      /** agentId */
      agentId?: string;
      /** mcpServerId */
      mcpServerId?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentMcpServerBindingModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/mcp_server_bindings';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { agentId: params['agentId'], mcpServerId: params['mcpServerId'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Bind AI agents to MCP servers
   */
  static createMcpServerBindingsUsingPost(
    params: {
      /** requestModels */
      requestModels: AgentMcpServerBindingRequestModel[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/mcp_server_bindings';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['requestModels'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get one MCP server binding of an AI agent
   */
  static getMcpServerBindingUsingGet(
    params: {
      /** applicationId */
      applicationId: string;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentMcpServerBindingModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/mcp_server_bindings/{id}';
      url = url.replace('{applicationId}', params['applicationId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Update an MCP server binding of an AI agent
   */
  static updateMcpServerBindingUsingPut(
    params: {
      /** applicationId */
      applicationId: string;
      /** id */
      id: string;
      /** requestModel */
      requestModel: AgentMcpServerBindingModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/mcp_server_bindings/{id}';
      url = url.replace('{applicationId}', params['applicationId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['requestModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Delete an MCP server binding of an AI agent
   */
  static deleteMcpServerBindingUsingDelete(
    params: {
      /** applicationId */
      applicationId: string;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/mcp_server_bindings/{id}';
      url = url.replace('{applicationId}', params['applicationId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * List one page of the tenant's AI agents for the AI Agents page
   */
  static listEstateAgentsUsingGet(
    params: {
      /** agentRegistryId */
      agentRegistryId?: string;
      /** connectedResource */
      connectedResource?: string[];
      /** enforcementStatus */
      enforcementStatus?: string[];
      /** environmentId */
      environmentId?: string;
      /** environmentType */
      environmentType?: string[];
      /** hasRecommendations */
      hasRecommendations?: boolean;
      /** pageNo */
      pageNo?: number;
      /** pageSize */
      pageSize?: number;
      /** platform */
      platform?: string[];
      /** project */
      project?: string[];
      /** purpose */
      purpose?: string[];
      /** search */
      search?: string;
      /** securityStatus */
      securityStatus?: string[];
      /** sortBy */
      sortBy?: string;
      /** sortOrder */
      sortOrder?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxPaginatedResponseModel_EstateAgentModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/agents';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        agentRegistryId: params['agentRegistryId'],
        connectedResource: params['connectedResource'],
        enforcementStatus: params['enforcementStatus'],
        environmentId: params['environmentId'],
        environmentType: params['environmentType'],
        hasRecommendations: params['hasRecommendations'],
        pageNo: params['pageNo'],
        pageSize: params['pageSize'],
        platform: params['platform'],
        project: params['project'],
        purpose: params['purpose'],
        search: params['search'],
        securityStatus: params['securityStatus'],
        sortBy: params['sortBy'],
        sortOrder: params['sortOrder']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Stop (kill switch) or restore access for AI agents
   */
  static setAgentAccessRevocationUsingPost(
    params: {
      /** body */
      body: AgentAccessRevocationModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentAccessRevocationModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/agents/access-revocation';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * List the tenant's onboarded agent environments
   */
  static listAgentEnvironmentsUsingGet(options: IRequestOptions = {}): Promise<AgentEnvironmentModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/agents/environments';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Confirm, override or review an AI agent's mission
   */
  static updateAgentMissionUsingPost(
    params: {
      /** agentId */
      agentId: string;
      /** body */
      body: UpdateRequest;
      /** environmentId */
      environmentId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UpdateResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/agents/environments/{environmentId}/agents/{agentId}/mission';
      url = url.replace('{agentId}', params['agentId'] + '');
      url = url.replace('{environmentId}', params['environmentId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get one AI agent for the agent details page
   */
  static getEstateAgentUsingGet(
    params: {
      /** agentId */
      agentId: string;
      /** environmentId */
      environmentId?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<EstateAgentDetailModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/agents/{agentId}';
      url = url.replace('{agentId}', params['agentId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { environmentId: params['environmentId'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Confirm, override or review an AI agent's mission
   */
  static updateAgentMissionUsingPost1(
    params: {
      /** agentId */
      agentId: string;
      /** body */
      body: UpdateRequest;
      /** environmentId */
      environmentId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UpdateResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/agents/{agentId}/mission';
      url = url.replace('{agentId}', params['agentId'] + '');
      url = url.replace('{environmentId}', params['environmentId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get an AI agent's attribute values
   */
  static listEstateAgentAttributesUsingGet(
    params: {
      /** applicationId */
      applicationId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxUserEntitlementAttributeValueResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/agents/{applicationId}/attributes';
      url = url.replace('{applicationId}', params['applicationId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Replace an AI agent's attribute values
   */
  static updateEstateAgentAttributesUsingPatch(
    params: {
      /** applicationId */
      applicationId: string;
      /** body */
      body: EstateAgentAttributesModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxUserEntitlementAttributeValueResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/agents/{applicationId}/attributes';
      url = url.replace('{applicationId}', params['applicationId'] + '');

      const configs: IRequestConfig = getConfigs('patch', 'application/json', url, options);

      /** 适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body */

      console.warn('适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body');

      let data = params['body'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class ApplicationControllerService {
  /**
   * getAgentConfigurationAllFeature
   */
  static getAgentConfigurationAllFeatureUsingGet(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ApplicationConfigurationResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent/{id}/configurations';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * listApplications
   */
  static listApplicationsUsingGet(
    params: {
      /** includePolicies */
      includePolicies?: boolean;
      /** includeResourceCount */
      includeResourceCount?: boolean;
      /** includeResources */
      includeResources?: boolean;
      /** name */
      name?: string;
      /** type */
      type?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Application[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        includePolicies: params['includePolicies'],
        includeResourceCount: params['includeResourceCount'],
        includeResources: params['includeResources'],
        name: params['name'],
        type: params['type']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * createApplication
   */
  static createApplicationUsingPost(
    params: {
      /** applicationModel */
      applicationModel: ApplicationModel;
      /** preview */
      preview?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { preview: params['preview'] };

      let data = params['applicationModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * handleDcrCallback
   */
  static handleDcrCallbackUsingGet(
    params: {
      /** code */
      code?: string;
      /** error */
      error?: string;
      /** error_description */
      errorDescription?: string;
      /** state */
      state?: string;
      /** vendor */
      vendor?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/callback';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        code: params['code'],
        error: params['error'],
        error_description: params['errorDescription'],
        state: params['state'],
        vendor: params['vendor']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * initiateDcr
   */
  static initiateDcrUsingPost(
    params: {
      /** dcrRequest */
      dcrRequest: DcrRegistrationRequestModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DcrRegistrationResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/dcr/initiate';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['dcrRequest'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * downloadDcrToken
   */
  static downloadDcrTokenUsingPost(
    params: {
      /** clientId */
      clientId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/dcr/{clientId}/download_token';
      url = url.replace('{clientId}', params['clientId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getApplicationIdByClientId
   */
  static getApplicationIdByClientIdUsingGet(
    params: {
      /** clientId */
      clientId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/id';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { clientId: params['clientId'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getApplicationByClientId
   */
  static getApplicationByClientIdUsingGet(
    params: {
      /** clientId */
      clientId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/name';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { clientId: params['clientId'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get everything stored about one AI agent
   */
  static getAgentDetailsUsingGet(
    params: {
      /** agentId */
      agentId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentDetailsModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{agentId}/agent_details';
      url = url.replace('{agentId}', params['agentId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getApplicationProfile
   */
  static getApplicationProfileUsingGet(
    params: {
      /** applicationId */
      applicationId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/applicationProfile';
      url = url.replace('{applicationId}', params['applicationId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getDocumentSensitivityLabels
   */
  static getDocumentSensitivityLabelsUsingGet(
    params: {
      /** applicationId */
      applicationId: string;
      /** documentId */
      documentId?: string;
      /** driveId */
      driveId?: string;
      /** url */
      url?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PurviewDocumentSensitivityLabelsResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/document/sensitivity-labels';
      url = url.replace('{applicationId}', params['applicationId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { documentId: params['documentId'], driveId: params['driveId'], url: params['url'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * searchDocumentSensitivityLabels
   */
  static searchDocumentSensitivityLabelsUsingGet(
    params: {
      /** applicationId */
      applicationId: string;
      /** limit */
      limit?: number;
      /** searchQuery */
      searchQuery: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PurviewDocumentSensitivityLabelsSearchResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/document/sensitivity-labels/search';
      url = url.replace('{applicationId}', params['applicationId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { limit: params['limit'], searchQuery: params['searchQuery'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getApplication
   */
  static getApplicationUsingGet(
    params: {
      /** id */
      id: string;
      /** includePolicies */
      includePolicies?: boolean;
      /** includeResourceCount */
      includeResourceCount?: boolean;
      /** includeResources */
      includeResources?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Application> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        includePolicies: params['includePolicies'],
        includeResourceCount: params['includeResourceCount'],
        includeResources: params['includeResources']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * updateApplication
   */
  static updateApplicationUsingPut(
    params: {
      /** applicationModel */
      applicationModel: ApplicationModel;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Application> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['applicationModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * deleteApplication
   */
  static deleteApplicationUsingDelete(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getApplicationConfig
   */
  static getApplicationConfigUsingGet(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ApplicationConfigResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{id}/config';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * updateApplicationConfig
   */
  static updateApplicationConfigUsingPut(
    params: {
      /** configUpdateRequest */
      configUpdateRequest: ApplicationConfigUpdateRequest;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ApplicationConfigResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{id}/config';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['configUpdateRequest'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getApplicationConfigurationAllFeature
   */
  static getApplicationConfigurationAllFeatureUsingGet(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ApplicationConfigurationResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{id}/configurations';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * updateApplicationConfigurationFeature
   */
  static updateApplicationConfigurationFeatureUsingPut(
    params: {
      /** id */
      id: string;
      /** requestModel */
      requestModel: ApplicationConfigurationRequestModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ApplicationConfigurationResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{id}/configurations';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['requestModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * regenerateApiKey
   */
  static regenerateApiKeyUsingPut(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{id}/oauth/regenerateKey';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * List one page of the tenant's applications
   */
  static listApplicationsPageUsingGet(
    params: {
      /** agentRegistryId */
      agentRegistryId?: string;
      /** agentRegistryName */
      agentRegistryName?: string;
      /** includeResourceCount */
      includeResourceCount?: boolean;
      /** includeResources */
      includeResources?: boolean;
      /** pageNo */
      pageNo?: number;
      /** pageSize */
      pageSize?: number;
      /** platform */
      platform?: string;
      /** project */
      project?: string;
      /** searchQuery */
      searchQuery?: string;
      /** sortBy */
      sortBy?: string;
      /** sortOrder */
      sortOrder?: string;
      /** type */
      type?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxPaginatedResponseModel_Application> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/application';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        agentRegistryId: params['agentRegistryId'],
        agentRegistryName: params['agentRegistryName'],
        includeResourceCount: params['includeResourceCount'],
        includeResources: params['includeResources'],
        pageNo: params['pageNo'],
        pageSize: params['pageSize'],
        platform: params['platform'],
        project: params['project'],
        searchQuery: params['searchQuery'],
        sortBy: params['sortBy'],
        sortOrder: params['sortOrder'],
        type: params['type']
      };

      axios(configs, resolve, reject);
    });
  }
}

export class AgentAttributeControllerService {
  /**
   * listDefinitions
   */
  static listDefinitionsUsingGet(options: IRequestOptions = {}): Promise<AgentAttributeModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent_attributes';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * createDefinition
   */
  static createDefinitionUsingPost(
    params: {
      /** request */
      request: AgentAttributeUpsertRequestModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentAttributeDefinition> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent_attributes';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['request'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * bulkUpsertDefinitions
   */
  static bulkUpsertDefinitionsUsingPut(
    params: {
      /** request */
      request: AgentAttributeUpsertRequestModel[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentAttributeModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent_attributes';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['request'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getDefinition
   */
  static getDefinitionUsingGet(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentAttributeModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent_attributes/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * updateDefinition
   */
  static updateDefinitionUsingPut(
    params: {
      /** id */
      id: string;
      /** request */
      request: AgentAttributeUpsertRequestModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentAttributeDefinition> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent_attributes/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['request'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * deleteDefinition
   */
  static deleteDefinitionUsingDelete(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent_attributes/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * listAttributes
   */
  static listAttributesUsingGet(
    params: {
      /** applicationId */
      applicationId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentAttributeModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/agent_attributes';
      url = url.replace('{applicationId}', params['applicationId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * bulkSetValues
   */
  static bulkSetValuesUsingPut(
    params: {
      /** applicationId */
      applicationId: string;
      /** request */
      request: AgentAttributeValueItemRequestModel[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentAttributeModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/agent_attributes';
      url = url.replace('{applicationId}', params['applicationId'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['request'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getAttributesMapForOpaInput
   */
  static getAttributesMapForOpaInputUsingGet(
    params: {
      /** applicationId */
      applicationId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/agent_attributes/opa_input';
      url = url.replace('{applicationId}', params['applicationId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getAttribute
   */
  static getAttributeUsingGet(
    params: {
      /** applicationId */
      applicationId: string;
      /** attributeId */
      attributeId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentAttributeModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/agent_attributes/{attributeId}';
      url = url.replace('{applicationId}', params['applicationId'] + '');
      url = url.replace('{attributeId}', params['attributeId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * setValue
   */
  static setValueUsingPut(
    params: {
      /** applicationId */
      applicationId: string;
      /** attributeId */
      attributeId: string;
      /** request */
      request: AgentAttributeValueRequestModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentAttributeValue> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/agent_attributes/{attributeId}';
      url = url.replace('{applicationId}', params['applicationId'] + '');
      url = url.replace('{attributeId}', params['attributeId'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['request'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class AgentPromptControllerService {
  /**
   * List agent prompts
   */
  static listPromptsUsingGet(
    params: {
      /** agentType */
      agentType?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentPromptModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent_prompts';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { agentType: params['agentType'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Create an agent prompt
   */
  static createPromptUsingPost(
    params: {
      /** prompt */
      prompt: AgentPromptModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent_prompts';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['prompt'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get the effective agent prompt
   */
  static getEffectivePromptUsingGet(
    params: {
      /** name */
      name: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentPromptModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent_prompts/effective';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { name: params['name'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get an agent prompt
   */
  static getPromptUsingGet(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentPromptModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent_prompts/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Update an agent prompt
   */
  static updatePromptUsingPut(
    params: {
      /** id */
      id: string;
      /** prompt */
      prompt: AgentPromptModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent_prompts/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['prompt'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Delete an agent prompt
   */
  static deletePromptUsingDelete(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent_prompts/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class AgentPurposeControllerService {
  /**
   * listPurposes
   */
  static listPurposesUsingGet(options: IRequestOptions = {}): Promise<AgentPurposeModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent_purposes';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class AgentRegistryControllerService {
  /**
   * List the tenant's agent registries
   */
  static listAgentRegistriesUsingGet(
    params: {
      /** id */
      id?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalIntegrationModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent_registries';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { id: params['id'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Import an agent registry
   */
  static importRegistryUsingPost(
    params: {
      /** body */
      body: AgentRegistryRequestModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent_registries/import';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Preview the projects an agent registry can import agents from
   */
  static previewProjectsUsingPost(
    params: {
      /** body */
      body: AgentRegistryRequestModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent_registries/projects/preview';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Validate an agent registry's connection and identity
   */
  static validateUsingPost(
    params: {
      /** body */
      body: AgentRegistryRequestModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent_registries/validate';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Delete an agent registry
   */
  static deleteRegistryUsingDelete(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent_registries/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Sync the agents of an agent registry's selected projects
   */
  static syncAgentsUsingPost(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent_registries/{id}/sync_agents';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Sync the attributes of an agent registry's imported agents
   */
  static syncAttributesUsingPost(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent_registries/{id}/sync_attributes';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class AgentRegistrySyncJobControllerService {
  /**
   * List the agent registries the agent sync task is to sync
   */
  static getSyncTargetsUsingGet(options: IRequestOptions = {}): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent_registries/sync_targets';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Create the agent sync job of an agent registry
   */
  static createSyncJobUsingPost(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent_registries/{id}/sync_jobs';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * The most recent agent sync of an agent registry
   */
  static getLatestSyncJobUsingGet(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent_registries/{id}/sync_jobs/latest';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * One agent sync of an agent registry
   */
  static getSyncJobUsingGet(
    params: {
      /** id */
      id: string;
      /** jobId */
      jobId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent_registries/{id}/sync_jobs/{jobId}';
      url = url.replace('{id}', params['id'] + '');
      url = url.replace('{jobId}', params['jobId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Post the agent attributes an agent sync job read from the identity provider
   */
  static postSyncAttributesUsingPost(
    params: {
      /** body */
      body: AgentSyncAttributesModel;
      /** id */
      id: string;
      /** jobId */
      jobId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent_registries/{id}/sync_jobs/{jobId}/attributes';
      url = url.replace('{id}', params['id'] + '');
      url = url.replace('{jobId}', params['jobId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Post what an agent sync job read for one unit
   */
  static postSyncResultsUsingPost(
    params: {
      /** body */
      body: AgentSyncResultsModel;
      /** id */
      id: string;
      /** jobId */
      jobId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/agent_registries/{id}/sync_jobs/{jobId}/results';
      url = url.replace('{id}', params['id'] + '');
      url = url.replace('{jobId}', params['jobId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class IntentBasedAccessPolicyControllerService {
  /**
   * Create MCP server access policies from an AI agent's IIR
   */
  static createMcpPolicyUsingPost(
    params: {
      /** applicationId */
      applicationId: string;
      /** iir */
      iir: IntentRepresentationModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/aiagent/{applicationId}/create_mcp_policy';
      url = url.replace('{applicationId}', params['applicationId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['iir'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class AlertSuppressionRuleControllerService {
  /**
   * getActiveSuppressionRules
   */
  static getActiveSuppressionRulesUsingGet(
    params: {
      /** accountId */
      accountId?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AlertSuppressionRuleResponse[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/alert-suppression-rules';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { accountId: params['accountId'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * createSuppressionRule
   */
  static createSuppressionRuleUsingPost(
    params: {
      /** requestBody */
      requestBody: AlertSuppressionRuleRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AlertSuppressionRuleResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/alert-suppression-rules';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['requestBody'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getSuppressionRulesByPolicy
   */
  static getSuppressionRulesByPolicyUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** policyRefId */
      policyRefId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AlertSuppressionRuleResponse[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/alert-suppression-rules/policy/{policyRefId}';
      url = url.replace('{policyRefId}', params['policyRefId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { accountId: params['accountId'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * updateSuppressionRule
   */
  static updateSuppressionRuleUsingPut(
    params: {
      /** requestBody */
      requestBody: AlertSuppressionRuleUpdateRequest;
      /** ruleId */
      ruleId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AlertSuppressionRuleResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/alert-suppression-rules/{ruleId}';
      url = url.replace('{ruleId}', params['ruleId'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['requestBody'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * deleteSuppressionRule
   */
  static deleteSuppressionRuleUsingDelete(
    params: {
      /** ruleId */
      ruleId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/alert-suppression-rules/{ruleId}';
      url = url.replace('{ruleId}', params['ruleId'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class MonitoringPolicyControllerV1Service {
  /**
   * listAlertFrequency
   */
  static listAlertFrequencyUsingGet(options: IRequestOptions = {}): Promise<AlertFrequency[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/alert_frequency';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * listComplianceTag
   */
  static listComplianceTagUsingGet(options: IRequestOptions = {}): Promise<ComplianceTag[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/compliance_tag';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * listConditionType
   */
  static listConditionTypeUsingGet(
    params: {
      /** accountType */
      accountType?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ConditionType[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/condition_type';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { accountType: params['accountType'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * listMonPolicyListType
   */
  static listMonPolicyListTypeUsingGet(
    params: {
      /** accountType */
      accountType?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MonPolicyListType[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/list_type';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { accountType: params['accountType'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * listPolicies
   */
  static listPoliciesUsingGet(
    params: {
      /** accountIds */
      accountIds?: string[];
      /** dataSourceType */
      dataSourceType?: string;
      /** policyNames */
      policyNames?: string[];
      /** policyType */
      policyType?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MonitoringPolicyResponseModelV1[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/monitoring_policies';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        accountIds: params['accountIds'],
        dataSourceType: params['dataSourceType'],
        policyNames: params['policyNames'],
        policyType: params['policyType']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * createMonitoringPolicy
   */
  static createMonitoringPolicyUsingPost(
    params: {
      /** monitoringPolicyModel */
      monitoringPolicyModel: MonitoringPolicyModelV1;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MonitoringPolicyResponseModelV1> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/monitoring_policies';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['monitoringPolicyModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getActions
   */
  static getActionsUsingGet(
    params: {
      /** dataSourceType */
      dataSourceType: string;
      /** isObjectTypeAvalible */
      isObjectTypeAvalible?: boolean;
      /** resourceType */
      resourceType?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Actions[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/monitoring_policies/actions';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        dataSourceType: params['dataSourceType'],
        isObjectTypeAvalible: params['isObjectTypeAvalible'],
        resourceType: params['resourceType']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getFilterListByType
   */
  static getFilterListByTypeUsingGet1(
    params: {
      /** accountId */
      accountId: string;
      /** type */
      type: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/monitoring_policies/filter';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { accountId: params['accountId'], type: params['type'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getMonitoringPolicyTagsByAccount
   */
  static getMonitoringPolicyTagsByAccountUsingGet(
    params: {
      /** account_id */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TagsModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/monitoring_policies/tags/{account_id}';
      url = url.replace('{account_id}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getMonitoringPolicy
   */
  static getMonitoringPolicyUsingGet(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MonitoringPolicyResponseModelV1> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/monitoring_policies/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * updateMonitoringPolicy
   */
  static updateMonitoringPolicyUsingPut(
    params: {
      /** id */
      id: string;
      /** monitoringPolicyModel */
      monitoringPolicyModel: MonitoringPolicyModelV1;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MonitoringPolicyResponseModelV1> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/monitoring_policies/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['monitoringPolicyModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * deleteMonitoringPolicy
   */
  static deleteMonitoringPolicyUsingDelete(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/monitoring_policies/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * enableMonitoringPolicy
   */
  static enableMonitoringPolicyUsingPut(
    params: {
      /** id */
      id: string;
      /** status */
      status: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/monitoring_policies/{id}/activate/{status}';
      url = url.replace('{id}', params['id'] + '');
      url = url.replace('{status}', params['status'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * updateAlertCount
   */
  static updateAlertCountUsingPut(
    params: {
      /** id */
      id: string;
      /** monitoringPolicyModel */
      monitoringPolicyModel: MonitoringPolicyModelV1;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/monitoring_policies/{id}/alertCount';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['monitoringPolicyModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * listPrincipalTypes
   */
  static listPrincipalTypesUsingGet(
    params: {
      /** accountType */
      accountType?: string;
      /** isWhitelisting */
      isWhitelisting?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PrincipalType[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/principals';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { accountType: params['accountType'], isWhitelisting: params['isWhitelisting'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * listResourceTypes
   */
  static listResourceTypesUsingGet(
    params: {
      /** accountType */
      accountType?: string;
      /** isDataClassification */
      isDataClassification?: boolean;
      /** principalId */
      principalId?: string[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ResourceTypeModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/resources';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        accountType: params['accountType'],
        isDataClassification: params['isDataClassification'],
        principalId: params['principalId']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * listRiskCategory
   */
  static listRiskCategoryUsingGet(options: IRequestOptions = {}): Promise<RiskCategory[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/risk_category';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * listSeverity
   */
  static listSeverityUsingGet(options: IRequestOptions = {}): Promise<Severity[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/severity';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getMonitoringPoliciesPaginationList
   */
  static getMonitoringPoliciesPaginationListUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** complianceTags */
      complianceTags?: string[];
      /** page_no */
      pageNo?: number;
      /** page_size */
      pageSize?: number;
      /** policyName */
      policyName?: string[];
      /** policyType */
      policyType?: string[];
      /** riskCategory */
      riskCategory?: string[];
      /** riskCount */
      riskCount?: string;
      /** severity */
      severity?: string[];
      /** sort_by */
      sortBy?: string;
      /** sort_order */
      sortOrder?: string;
      /** status */
      status?: string[];
      /** workspace */
      workspace?: string[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxPaginatedResponseModel_MonitoringPolicyResponseModelV1> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/monitoring_policies';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        accountId: params['accountId'],
        complianceTags: params['complianceTags'],
        page_no: params['pageNo'],
        page_size: params['pageSize'],
        policyName: params['policyName'],
        policyType: params['policyType'],
        riskCategory: params['riskCategory'],
        riskCount: params['riskCount'],
        severity: params['severity'],
        sort_by: params['sortBy'],
        sort_order: params['sortOrder'],
        status: params['status'],
        workspace: params['workspace']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * muteOrUnmutePolicy
   */
  static muteOrUnmutePolicyUsingPut(
    params: {
      /** id */
      id: string;
      /** requestModel */
      requestModel: MonitoringPolicyMuteUnmuteModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/monitoring_policies/{id}/toggle_mute';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['requestModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class AnalyticsControllerService {
  /**
   * postOverlyGrantedRole
   */
  static postOverlyGrantedRoleUsingPost(
    params: {
      /** OverlyGrantedRoleList */
      overlyGrantedRoleList: OverGrantedRole[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/analytics/overly_granted_roles';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['overlyGrantedRoleList'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * postSensitiveData
   */
  static postSensitiveDataUsingPost(
    params: {
      /** senstiveObjectsList */
      senstiveObjectsList: SensitiveData[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/analytics/sensitive_objects';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['senstiveObjectsList'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * postUserToRole
   */
  static postUserToRoleUsingPost(
    params: {
      /** usersToRoles */
      usersToRoles: UsersToRole[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/analytics/user_to_role';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['usersToRoles'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class PolicyResourceControllerService {
  /**
   * getMcpServersPolicyResourceDetails
   */
  static getMcpServersPolicyResourceDetailsUsingGet(
    params: {
      /** agentId */
      agentId?: string;
      /** applicationId */
      applicationId?: string;
      /** resourceName */
      resourceName?: string;
      /** resourceSourceType */
      resourceSourceType: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PolicyResourceDetailResponse[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/mcp_servers/resource/details_by_name';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        agentId: params['agentId'],
        applicationId: params['applicationId'],
        resourceName: params['resourceName'],
        resourceSourceType: params['resourceSourceType']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * listPolicyResources
   */
  static listPolicyResourcesUsingGet(
    params: {
      /** applicationId */
      applicationId: string;
      /** includeDataProducts */
      includeDataProducts?: boolean;
      /** isAgentMetadata */
      isAgentMetadata?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxPaginatedResponseModel_PolicyResourceRequestModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/resource';
      url = url.replace('{applicationId}', params['applicationId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        includeDataProducts: params['includeDataProducts'],
        isAgentMetadata: params['isAgentMetadata']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * createPolicyResource
   */
  static createPolicyResourceUsingPost(
    params: {
      /** applicationId */
      applicationId: string;
      /** request */
      request: PolicyResourceRequestModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PolicyResource> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/resource';
      url = url.replace('{applicationId}', params['applicationId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['request'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * listPolicyResourceDetails
   */
  static listPolicyResourceDetailsUsingGet(
    params: {
      /** applicationId */
      applicationId: string;
      /** resourceName */
      resourceName?: string[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PolicyResourceDetailResponse[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/resource/details';
      url = url.replace('{applicationId}', params['applicationId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { resourceName: params['resourceName'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getPolicyResourceDetails
   */
  static getPolicyResourceDetailsUsingGet(
    params: {
      /** agentId */
      agentId?: string;
      /** applicationId */
      applicationId: string;
      /** resourceName */
      resourceName?: string;
      /** resourceSourceType */
      resourceSourceType?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PolicyResourceDetailResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/resource/details_by_name';
      url = url.replace('{applicationId}', params['applicationId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        agentId: params['agentId'],
        resourceName: params['resourceName'],
        resourceSourceType: params['resourceSourceType']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * listResourceTypes
   */
  static listResourceTypesUsingGet1(
    params: {
      /** applicationId */
      applicationId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxPaginatedResponseModel_PolicyResourceTypeRequestModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/resource/type';
      url = url.replace('{applicationId}', params['applicationId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * createResourceType
   */
  static createResourceTypeUsingPost(
    params: {
      /** applicationId */
      applicationId: string;
      /** request */
      request: PolicyResourceTypeRequestModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PolicyResourceType> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/resource/type';
      url = url.replace('{applicationId}', params['applicationId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['request'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getResourceType
   */
  static getResourceTypeUsingGet(
    params: {
      /** applicationId */
      applicationId: string;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PolicyResourceTypeRequestModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/resource/type/{id}';
      url = url.replace('{applicationId}', params['applicationId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * updateResourceType
   */
  static updateResourceTypeUsingPut(
    params: {
      /** applicationId */
      applicationId: string;
      /** id */
      id: string;
      /** request */
      request: PolicyResourceTypeRequestModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PolicyResourceType> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/resource/type/{id}';
      url = url.replace('{applicationId}', params['applicationId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['request'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * deleteResourceType
   */
  static deleteResourceTypeUsingDelete(
    params: {
      /** applicationId */
      applicationId: string;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/resource/type/{id}';
      url = url.replace('{applicationId}', params['applicationId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getPolicyResource
   */
  static getPolicyResourceUsingGet(
    params: {
      /** applicationId */
      applicationId: string;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PolicyResource> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/resource/{id}';
      url = url.replace('{applicationId}', params['applicationId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * updatePolicyResource
   */
  static updatePolicyResourceUsingPut(
    params: {
      /** applicationId */
      applicationId: string;
      /** id */
      id: string;
      /** request */
      request: PolicyResourceRequestModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PolicyResource> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/resource/{id}';
      url = url.replace('{applicationId}', params['applicationId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['request'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * deletePolicyResource
   */
  static deletePolicyResourceUsingDelete(
    params: {
      /** applicationId */
      applicationId: string;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/resource/{id}';
      url = url.replace('{applicationId}', params['applicationId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getPolicyInput
   */
  static getPolicyInputUsingPost(
    params: {
      /** application */
      application: string;
      /** resources */
      resources: PolicyResource[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PolicyInputModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/resource/evaluate';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { application: params['application'] };

      let data = params['resources'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class ApplicationUserEntitlementAttributeControllerService {
  /**
   * getAllMcpServersUserEntitlementAttributesMetadata
   */
  static getAllMcpServersUserEntitlementAttributesMetadataUsingGet(
    params: {
      /** identityType */
      identityType?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/mcp_servers/user_entitlement_attribute_metadata';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { identityType: params['identityType'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getApplicationUserAttributesMetadataByTenant
   */
  static getApplicationUserAttributesMetadataByTenantUsingGet(
    params: {
      /** applicationId */
      applicationId?: string[];
      /** displayName */
      displayName?: string[];
      /** id */
      id?: string;
      /** page_no */
      pageNo?: number;
      /** page_size */
      pageSize?: number;
      /** sort_by */
      sortBy?: string;
      /** sort_order */
      sortOrder?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxApplicationUserEntitlementAttributeColumnResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/user_entitlement_attribute/metadata_by_tenant';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        applicationId: params['applicationId'],
        displayName: params['displayName'],
        id: params['id'],
        page_no: params['pageNo'],
        page_size: params['pageSize'],
        sort_by: params['sortBy'],
        sort_order: params['sortOrder']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getApplicationUserAttributesMetadata
   */
  static getApplicationUserAttributesMetadataUsingGet(
    params: {
      /** applicationId */
      applicationId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ApplicationUserEntitlementAttributeModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/user_entitlement_attribute';
      url = url.replace('{applicationId}', params['applicationId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * saveApplicationUserAttributesMetadata
   */
  static saveApplicationUserAttributesMetadataUsingPost(
    params: {
      /** applicationId */
      applicationId: string;
      /** userEntitlementAttributeModel */
      userEntitlementAttributeModel: ApplicationUserEntitlementAttributeModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ApplicationUserEntitlementAttributeModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/user_entitlement_attribute';
      url = url.replace('{applicationId}', params['applicationId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['userEntitlementAttributeModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * deleteApplicationUserAttributeColumn
   */
  static deleteApplicationUserAttributeColumnUsingDelete(
    params: {
      /** applicationId */
      applicationId: string;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/user_entitlement_attribute';
      url = url.replace('{applicationId}', params['applicationId'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { id: params['id'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * updateApplicationUserAttributeColumn
   */
  static updateApplicationUserAttributeColumnUsingPatch(
    params: {
      /** applicationId */
      applicationId: string;
      /** model */
      model: ApplicationUserEntitlementAttributeModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ApplicationUserEntitlementAttributeModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/user_entitlement_attribute';
      url = url.replace('{applicationId}', params['applicationId'] + '');

      const configs: IRequestConfig = getConfigs('patch', 'application/json', url, options);

      /** 适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body */

      console.warn('适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body');

      let data = params['model'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getApplicationUserAttributeById
   */
  static getApplicationUserAttributeByIdUsingGet(
    params: {
      /** applicationId */
      applicationId: string;
      /** attributeId */
      attributeId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ApplicationUserEntitlementAttributeModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/user_entitlement_attribute/{attributeId}';
      url = url.replace('{applicationId}', params['applicationId'] + '');
      url = url.replace('{attributeId}', params['attributeId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getApplicationUserEntitlementAttributesMetadata
   */
  static getApplicationUserEntitlementAttributesMetadataUsingGet(
    params: {
      /** applicationId */
      applicationId: string;
      /** identityType */
      identityType?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ApplicationUserAttributesExternalSourceAttributeDetailsModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/user_entitlement_attribute_metadata';
      url = url.replace('{applicationId}', params['applicationId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { identityType: params['identityType'] };

      axios(configs, resolve, reject);
    });
  }
}

export class OpaPolicyEvaluationAuditLogControllerService {
  /**
   * listOpaAuditLogs
   */
  static listOpaAuditLogsUsingGet(
    params: {
      /** applicationId */
      applicationId?: string;
      /** auditType */
      auditType?: string[];
      /** decision */
      decision?: string[];
      /** endDate */
      endDate?: string;
      /** page_no */
      pageNo?: number;
      /** page_size */
      pageSize?: number;
      /** policyId */
      policyId?: string;
      /** resourceName */
      resourceName?: string[];
      /** resourceType */
      resourceType?: string[];
      /** serverApplicationId */
      serverApplicationId?: string[];
      /** sort_by */
      sortBy?: string;
      /** sort_order */
      sortOrder?: string;
      /** startDate */
      startDate?: string;
      /** userIdentity */
      userIdentity?: string[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxPaginatedResponseModel_OpaPolicyEvaluationAuditLogModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/opa_policy_evaluation_audit_log';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        applicationId: params['applicationId'],
        auditType: params['auditType'],
        decision: params['decision'],
        endDate: params['endDate'],
        page_no: params['pageNo'],
        page_size: params['pageSize'],
        policyId: params['policyId'],
        resourceName: params['resourceName'],
        resourceType: params['resourceType'],
        serverApplicationId: params['serverApplicationId'],
        sort_by: params['sortBy'],
        sort_order: params['sortOrder'],
        startDate: params['startDate'],
        userIdentity: params['userIdentity']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getOpaAuditLogColumnFilterValues
   */
  static getOpaAuditLogColumnFilterValuesUsingGet(
    params: {
      /** applicationId */
      applicationId: string;
      /** filterKey */
      filterKey: string;
      /** serverApplicationId */
      serverApplicationId?: string[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ColumnFiltersResponseModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/opa_policy_evaluation_audit_log/columnFilter';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        applicationId: params['applicationId'],
        filterKey: params['filterKey'],
        serverApplicationId: params['serverApplicationId']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * createOpaAuditLog
   */
  static createOpaAuditLogUsingPost(
    params: {
      /** applicationId */
      applicationId: string;
      /** request */
      request: OpaPolicyEvaluationAuditLogRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/opa_policy_evaluation_audit_log';
      url = url.replace('{applicationId}', params['applicationId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['request'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * createOpaAuditLogBulk
   */
  static createOpaAuditLogBulkUsingPost(
    params: {
      /** applicationId */
      applicationId: string;
      /** requests */
      requests: OpaPolicyEvaluationAuditLogRequest[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/opa_policy_evaluation_audit_log/bulk';
      url = url.replace('{applicationId}', params['applicationId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['requests'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getOpaAuditLogById
   */
  static getOpaAuditLogByIdUsingGet(
    params: {
      /** auditId */
      auditId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/opa-audit-logs/{auditId}';
      url = url.replace('{auditId}', params['auditId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Create tenant OPA audit logs in bulk
   */
  static createTenantOpaAuditLogBulkUsingPost(
    params: {
      /** requests */
      requests: OpaPolicyEvaluationAuditLogRequest[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/opa_policy_evaluation_audit_log/bulk';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['requests'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class AgentIntentGenerationControllerService {
  /**
   * Save a new intent generation for an AI agent
   */
  static saveUsingPost(
    params: {
      /** agentId */
      agentId: string;
      /** requestModel */
      requestModel: AgentIntentGenerationRequestModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{agentId}/intent_generations';
      url = url.replace('{agentId}', params['agentId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['requestModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get an AI agent's IIR
   */
  static getIirUsingGet(
    params: {
      /** agentId */
      agentId: string;
      /** intentType */
      intentType?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{agentId}/intent_generations/active';
      url = url.replace('{agentId}', params['agentId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { intentType: params['intentType'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get an AI agent's current intent generation
   */
  static getCurrentUsingGet(
    params: {
      /** agentId */
      agentId: string;
      /** intentType */
      intentType?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentIntentGenerationCurrentModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{agentId}/intent_generations/current';
      url = url.replace('{agentId}', params['agentId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { intentType: params['intentType'] };

      axios(configs, resolve, reject);
    });
  }
}

export class AgentPolicyControllerService {
  /**
   * List the policies authored for an agent
   */
  static listAuthoredAgentPoliciesUsingGet(
    params: {
      /** applicationId */
      applicationId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentPolicyResponseModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/agent_policies';
      url = url.replace('{applicationId}', params['applicationId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Create an agent policy
   */
  static createAgentPolicyUsingPost(
    params: {
      /** applicationId */
      applicationId: string;
      /**  */
      requestModel: AgentPolicyRequestModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentPolicyResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/agent_policies';
      url = url.replace('{applicationId}', params['applicationId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['requestModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Create several agent policies
   */
  static batchCreateAgentPoliciesUsingPost(
    params: {
      /** applicationId */
      applicationId: string;
      /** requestModels */
      requestModels: AgentPolicyRequestModel[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentPolicyBatchResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/agent_policies/batch';
      url = url.replace('{applicationId}', params['applicationId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['requestModels'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Update several agent policies
   */
  static batchUpdateAgentPoliciesUsingPut(
    params: {
      /** applicationId */
      applicationId: string;
      /** requestModels */
      requestModels: AgentPolicyRequestModel[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentPolicyBatchResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/agent_policies/batch';
      url = url.replace('{applicationId}', params['applicationId'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['requestModels'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get an agent policy
   */
  static getAgentPolicyUsingGet(
    params: {
      /** applicationId */
      applicationId: string;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentPolicyResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/agent_policies/{id}';
      url = url.replace('{applicationId}', params['applicationId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Update an agent policy
   */
  static updateAgentPolicyUsingPut(
    params: {
      /** applicationId */
      applicationId: string;
      /** id */
      id: string;
      /**  */
      requestModel: AgentPolicyRequestModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentPolicyResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/agent_policies/{id}';
      url = url.replace('{applicationId}', params['applicationId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['requestModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Delete an agent policy
   */
  static deleteAgentPolicyUsingDelete(
    params: {
      /** applicationId */
      applicationId: string;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/agent_policies/{id}';
      url = url.replace('{applicationId}', params['applicationId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * List the agent's policies in the Build with Conditions shape
   */
  static listAgentPoliciesUsingGet(
    params: {
      /** applicationId */
      applicationId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuthoredAgentPolicyModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/authored_agent_policies';
      url = url.replace('{applicationId}', params['applicationId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Edit one native policy of an agent policy
   */
  static updateNativePolicyUsingPut(
    params: {
      /** body */
      body: NativePolicyUpdateRequestModel;
      /** nativePolicyId */
      nativePolicyId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentNativePolicyModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/agents/native-policies/{nativePolicyId}';
      url = url.replace('{nativePolicyId}', params['nativePolicyId'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * List the tenant's agent policies
   */
  static listTenantAgentPoliciesUsingGet(
    params: {
      /** agentId */
      agentId?: string;
      /** environmentId */
      environmentId?: string;
      /** pageNo */
      pageNo?: number;
      /** pageSize */
      pageSize?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxPaginatedResponseModel_AgentPolicyItemModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/agents/policies';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        agentId: params['agentId'],
        environmentId: params['environmentId'],
        pageNo: params['pageNo'],
        pageSize: params['pageSize']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Apply agent policies to a scope of agents
   */
  static applyPoliciesUsingPost(
    params: {
      /** body */
      body: ApplyRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentPolicyApplyModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/agents/policies/apply';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get the policy catalog for a scope of agents
   */
  static resolvePolicyCatalogUsingPost(
    params: {
      /** body */
      body: CatalogRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentPolicyCatalogItemModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/agents/policies/catalog';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get the agent policies applied to a scope of agents
   */
  static resolveAgentPolicyCoverageUsingPost(
    params: {
      /** body */
      body: ScopedRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentPolicyReviewModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/agents/policies/coverage';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Generate a draft policy from a description
   */
  static generateDraftPolicyUsingPost(
    params: {
      /** body */
      body: DraftRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentPolicyDraftModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/agents/policies/draft';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get the native policies of applied agent policies
   */
  static listPolicyImplementationsUsingGet(
    params: {
      /** environmentId */
      environmentId?: string;
      /** policyIds */
      policyIds?: string[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentPolicyImplementationModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/agents/policies/implementations';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { environmentId: params['environmentId'], policyIds: params['policyIds'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Preview applying agent policies to a scope of agents
   */
  static previewAgentPoliciesUsingPost(
    params: {
      /** body */
      body: PreviewRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentPolicyApplyModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/agents/policies/preview';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get the policies recommended for a scope of agents
   */
  static resolveAgentPolicyRecommendationsUsingPost(
    params: {
      /** body */
      body: ScopedRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentPolicyRecommendationModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/agents/policies/recommendations';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Review agent policies for a scope of agents
   */
  static getPolicyReviewUsingPost(
    params: {
      /** body */
      body: ReviewRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentPolicyReviewModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/agents/policies/review';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get how an agent policy is enforced
   */
  static getEffectiveEnforcementUsingGet(
    params: {
      /** agentId */
      agentId?: string;
      /** contextType */
      contextType?: string;
      /** environmentId */
      environmentId?: string;
      /** groupId */
      groupId?: string;
      /** pathId */
      pathId?: string;
      /** policyId */
      policyId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentPolicyEffectiveEnforcementModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/agents/policies/{policyId}/enforcement';
      url = url.replace('{policyId}', params['policyId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        agentId: params['agentId'],
        contextType: params['contextType'],
        environmentId: params['environmentId'],
        groupId: params['groupId'],
        pathId: params['pathId']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Reapply an agent policy
   */
  static reapplyPolicyDefinitionUsingPost(
    params: {
      /** body */
      body: ReapplyRequest;
      /** policyId */
      policyId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentPolicyImplementationModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/agents/policies/{policyId}/reapply';
      url = url.replace('{policyId}', params['policyId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Retry a failed agent policy deployment
   */
  static retryPolicyDeploymentUsingPost(
    params: {
      /** body */
      body: RetryRequest;
      /** policyId */
      policyId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgentPolicyImplementationModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/agents/policies/{policyId}/retry';
      url = url.replace('{policyId}', params['policyId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class PolicyResourceAccessControllerService {
  /**
   * listResourceAccessPolicies
   */
  static listResourceAccessPoliciesUsingGet(
    params: {
      /** applicationId */
      applicationId: string;
      /** page_no */
      pageNo?: number;
      /** page_size */
      pageSize?: number;
      /** sort_by */
      sortBy?: string;
      /** sort_order */
      sortOrder?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxPaginatedResponseModel_DataAccessPolicyWithoutUDFModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/resource/access_policies';
      url = url.replace('{applicationId}', params['applicationId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        page_no: params['pageNo'],
        page_size: params['pageSize'],
        sort_by: params['sortBy'],
        sort_order: params['sortOrder']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * createResourcePolicy
   */
  static createResourcePolicyUsingPost(
    params: {
      /** applicationId */
      applicationId: string;
      /** dataAccessPolicyModel */
      dataAccessPolicyModel: DataAccessPolicyModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/resource/access_policies';
      url = url.replace('{applicationId}', params['applicationId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['dataAccessPolicyModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getAgentMetadata
   */
  static getAgentMetadataUsingGet(
    params: {
      /** applicationId */
      applicationId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/resource/access_policies/agent_metadata';
      url = url.replace('{applicationId}', params['applicationId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * batchCreateResourcePolicies
   */
  static batchCreateResourcePoliciesUsingPost(
    params: {
      /** applicationId */
      applicationId: string;
      /** policyModels */
      policyModels: DataAccessPolicyModel[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/resource/access_policies/batch';
      url = url.replace('{applicationId}', params['applicationId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['policyModels'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * batchUpdateAccessPolicies
   */
  static batchUpdateAccessPoliciesUsingPut(
    params: {
      /** applicationId */
      applicationId: string;
      /** updateRequests */
      updateRequests: BatchPolicyUpdateRequest[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/resource/access_policies/batch';
      url = url.replace('{applicationId}', params['applicationId'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['updateRequests'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * batchDeleteAccessPolicies
   */
  static batchDeleteAccessPoliciesUsingDelete(
    params: {
      /** applicationId */
      applicationId: string;
      /** policyIds */
      policyIds: any | null[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/resource/access_policies/batch';
      url = url.replace('{applicationId}', params['applicationId'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      /** 适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body */

      console.warn('适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body');

      let data = params['policyIds'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * batchDeployPolicies
   */
  static batchDeployPoliciesUsingPost(
    params: {
      /** applicationId */
      applicationId: string;
      /** policyIds */
      policyIds: any | null[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/resource/access_policies/batch/deploy_policy';
      url = url.replace('{applicationId}', params['applicationId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['policyIds'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * batchPublishPolicies
   */
  static batchPublishPoliciesUsingPost(
    params: {
      /** applicationId */
      applicationId: string;
      /** policyIds */
      policyIds: any | null[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/resource/access_policies/batch/publish_policy';
      url = url.replace('{applicationId}', params['applicationId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['policyIds'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * batchReviewPolicies
   */
  static batchReviewPoliciesUsingPost(
    params: {
      /** applicationId */
      applicationId: string;
      /** policyIds */
      policyIds: any | null[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/resource/access_policies/batch/review_policy';
      url = url.replace('{applicationId}', params['applicationId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['policyIds'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getResourceAccessPolicy
   */
  static getResourceAccessPolicyUsingGet(
    params: {
      /** applicationId */
      applicationId: string;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/resource/access_policies/{id}';
      url = url.replace('{applicationId}', params['applicationId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * updateAccessPolicy
   */
  static updateAccessPolicyUsingPut2(
    params: {
      /** applicationId */
      applicationId: string;
      /** dataAccessPolicyModel */
      dataAccessPolicyModel: DataAccessPolicyModel;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/resource/access_policies/{id}';
      url = url.replace('{applicationId}', params['applicationId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['dataAccessPolicyModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * deleteAccessPolicy
   */
  static deleteAccessPolicyUsingDelete1(
    params: {
      /** applicationId */
      applicationId: string;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/resource/access_policies/{id}';
      url = url.replace('{applicationId}', params['applicationId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * deployPolicy
   */
  static deployPolicyUsingPost(
    params: {
      /** applicationId */
      applicationId: string;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/resource/access_policies/{id}/deploy_policy';
      url = url.replace('{applicationId}', params['applicationId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * disablePolicy
   */
  static disablePolicyUsingPost(
    params: {
      /** applicationId */
      applicationId: string;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/resource/access_policies/{id}/disable';
      url = url.replace('{applicationId}', params['applicationId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * discardDraftResourceAccessPolicies
   */
  static discardDraftResourceAccessPoliciesUsingDelete(
    params: {
      /** applicationId */
      applicationId: string;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/resource/access_policies/{id}/discardDraft';
      url = url.replace('{applicationId}', params['applicationId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * publishPolicy
   */
  static publishPolicyUsingPost2(
    params: {
      /** applicationId */
      applicationId: string;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/resource/access_policies/{id}/publish_policy';
      url = url.replace('{applicationId}', params['applicationId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * reviewPolicy
   */
  static reviewPolicyUsingPost2(
    params: {
      /** applicationId */
      applicationId: string;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/resource/access_policies/{id}/review_policy';
      url = url.replace('{applicationId}', params['applicationId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getAccessPolicyHistory
   */
  static getAccessPolicyHistoryUsingGet1(
    params: {
      /** applicationId */
      applicationId: string;
      /** id */
      id: string;
      /** policy_status */
      policyStatus?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TenantAuditLogs[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/application/{applicationId}/resource/access_policies/{id}/view_history';
      url = url.replace('{applicationId}', params['applicationId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { policy_status: params['policyStatus'] };

      axios(configs, resolve, reject);
    });
  }
}

export class TenantControllerService {
  /**
   * updateAuthSecurity
   */
  static updateAuthSecurityUsingPut(
    params: {
      /** authSecurityModel */
      authSecurityModel: AdminAuthSecurityModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/auth_security';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['authSecurityModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * registerTenantData
   */
  static registerTenantDataUsingPost(
    params: {
      /** registerTenantDataModel */
      registerTenantDataModel: RegisterTenantDataModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/register_tenant_data';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['registerTenantDataModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getTenant
   */
  static getTenantUsingGet(options: IRequestOptions = {}): Promise<TenantProfile> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/tenant';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * createTenant
   */
  static createTenantUsingPost(
    params: {
      /** tenantModel */
      tenantModel: TenantModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/tenant';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['tenantModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * listTenantBuckets
   */
  static listTenantBucketsUsingGet(options: IRequestOptions = {}): Promise<CatalogBucket[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/tenant_bucket';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * updateTenantBuckets
   */
  static updateTenantBucketsUsingPut(
    params: {
      /** bucketModel */
      bucketModel: CatalogBucketModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/tenant_bucket';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['bucketModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * updateTenantBuckets
   */
  static updateTenantBucketsUsingPut1(
    params: {
      /** schemaModel */
      schemaModel: GroupUserMappingTableSchemaNameModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/tenant_group_entitlement_schema';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['schemaModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class AuthorizedSystemEntitiesControllerService {
  /**
   * listAuthorizedSystemEntities
   */
  static listAuthorizedSystemEntitiesUsingGet(
    params: {
      /** cloudAccountId */
      cloudAccountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuthorizedSystemEntity[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/authorized_system_entities';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { cloudAccountId: params['cloudAccountId'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * createAuthorizedSystemEntities
   */
  static createAuthorizedSystemEntitiesUsingPost(
    params: {
      /** authorizedSystemEntityModel */
      authorizedSystemEntityModel: AuthorizedSystemEntityModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuthorizedSystemEntity[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/authorized_system_entities';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['authorizedSystemEntityModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * listAuthorizedEntityGroups
   */
  static listAuthorizedEntityGroupsUsingGet(
    params: {
      /** accountId */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/authorized_system_entities/groups';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { accountId: params['accountId'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * updateAuthorizedSystemIp
   */
  static updateAuthorizedSystemIpUsingPut(
    params: {
      /** authorizedSystemEntityModel */
      authorizedSystemEntityModel: AuthorizedSystemEntityModel;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuthorizedSystemEntity> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/authorized_system_entity/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['authorizedSystemEntityModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * deleteAuthorizedSystemUser
   */
  static deleteAuthorizedSystemUserUsingDelete(
    params: {
      /** id */
      id: string;
      /** type */
      type: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuthorizedSystemEntity> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/authorized_system_entity/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { type: params['type'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * listAuthorizedSystemEntitiesDI
   */
  static listAuthorizedSystemEntitiesDiUsingGet(
    params: {
      /** cloudAccountId */
      cloudAccountId?: string;
      /** type */
      type: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuthorizedSystemEntity[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/di_authorized_system_entities';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { cloudAccountId: params['cloudAccountId'], type: params['type'] };

      axios(configs, resolve, reject);
    });
  }
}

export class AuthorizedSystemUserControllerService {
  /**
   * bulkDeleteAuthorizedUsers
   */
  static bulkDeleteAuthorizedUsersUsingDelete(
    params: {
      /** accountId */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/authorized_system_user/bulk_delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { accountId: params['accountId'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * listAuthorizedSystemUserDI
   */
  static listAuthorizedSystemUserDiUsingGet(
    params: {
      /** cloudAccountId */
      cloudAccountId?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuthorizedSystemUserResponse[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/di_authorized_system_user';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { cloudAccountId: params['cloudAccountId'] };

      axios(configs, resolve, reject);
    });
  }
}

export class AuthorizedAppAccessControllerService {
  /**
   * Get all authorized app access records
   */
  static getAuthorizedAppAccessListUsingGet(options: IRequestOptions = {}): Promise<AuthorizedAppAccess[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/authorized_user_app_mapping';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Create authorized app access record
   */
  static createAuthorizedAppAccessUsingPost(
    params: {
      /** access */
      access: AuthorizedAppAccess;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuthorizedAppAccess> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/authorized_user_app_mapping';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['access'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Delete authorized app access by filters
   */
  static deleteByFilterUsingDelete(
    params: {
      /** allowedIp */
      allowedIp?: string;
      /** appName */
      appName?: string;
      /** dbType */
      dbType?: string;
      /** description */
      description?: string;
      /** serviceUserName */
      serviceUserName?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/authorized_user_app_mapping/deleteByFilter';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = {
        allowedIp: params['allowedIp'],
        appName: params['appName'],
        dbType: params['dbType'],
        description: params['description'],
        serviceUserName: params['serviceUserName']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Delete authorized app access by composite key
   */
  static deleteByCompositeKeyUsingDelete(
    params: {
      /** accountId */
      accountId: string;
      /** appName */
      appName: string;
      /** serviceUserName */
      serviceUserName: string;
      /** tenantId */
      tenantId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/authorized_user_app_mapping/deleteByKey';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = {
        accountId: params['accountId'],
        appName: params['appName'],
        serviceUserName: params['serviceUserName'],
        tenantId: params['tenantId']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Filter authorized app access records
   */
  static filterAuthorizedAppAccessUsingGet(
    params: {
      /** allowedIp */
      allowedIp?: string;
      /** appName */
      appName?: string;
      /** dbType */
      dbType?: string;
      /** description */
      description?: string;
      /** serviceUserName */
      serviceUserName?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuthorizedAppAccess[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/authorized_user_app_mapping/filter';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        allowedIp: params['allowedIp'],
        appName: params['appName'],
        dbType: params['dbType'],
        description: params['description'],
        serviceUserName: params['serviceUserName']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get authorized app access by ID
   */
  static getAuthorizedAppAccessByIdUsingGet(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuthorizedAppAccess> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/authorized_user_app_mapping/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Update authorized app access record
   */
  static updateAuthorizedAppAccessUsingPut(
    params: {
      /** access */
      access: AuthorizedAppAccess;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuthorizedAppAccess> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/authorized_user_app_mapping/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['access'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Delete authorized app access record
   */
  static deleteAuthorizedAppAccessUsingDelete(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/authorized_user_app_mapping/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class ConditionControllerService {
  /**
   * listConditions
   */
  static listConditionsUsingGet(options: IRequestOptions = {}): Promise<Condition[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/conditions';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class TenantConfigurationControllerService {
  /**
   * getTenantConfigurations
   */
  static getTenantConfigurationsUsingGet(
    params: {
      /** accountId */
      accountId?: string;
      /** configurationKey */
      configurationKey?: string[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TenantConfigurationModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/configuration';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { accountId: params['accountId'], configurationKey: params['configurationKey'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * updateTenantConfigurations
   */
  static updateTenantConfigurationsUsingPut(
    params: {
      /** accountId */
      accountId?: string;
      /** tenantConfigurationModelList */
      tenantConfigurationModelList: TenantConfigurationModel[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/configuration';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);
      configs.params = { accountId: params['accountId'] };

      let data = params['tenantConfigurationModelList'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get URL configurations
   */
  static getUrlConfigurationsUsingGet(options: IRequestOptions = {}): Promise<UrlConfigurationResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/configuration/urls';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getTenantConfiguration
   */
  static getTenantConfigurationUsingGet(
    params: {
      /** accountId */
      accountId?: string;
      /** configurationKey */
      configurationKey: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TenantConfigurationModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/configuration/{configurationKey}';
      url = url.replace('{configurationKey}', params['configurationKey'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { accountId: params['accountId'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getTenantConfigurationFeature
   */
  static getTenantConfigurationFeatureUsingGet(
    params: {
      /** configurationKey */
      configurationKey: string[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TenantConfigurationFeatureModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/tenant/configuration';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { configurationKey: params['configurationKey'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Tenant feature configuration
   */
  static updateTenantConfigurationFeatureUsingPut(
    params: {
      /** featureModel */
      featureModel: TenantConfigurationFeatureModel[];
      /** tenant */
      tenant?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/tenant/configuration';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);
      configs.params = { tenant: params['tenant'] };

      let data = params['featureModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getTenantConfigurationAllFeature
   */
  static getTenantConfigurationAllFeatureUsingGet(
    params: {
      /** source */
      source?: string;
      /** tenant */
      tenant?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/tenant/configurations';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { source: params['source'], tenant: params['tenant'] };

      axios(configs, resolve, reject);
    });
  }
}

export class CopilotControllerService {
  /**
   * Copilot Category GET API
   */
  static listCopilotCategoriesUsingGet(options: IRequestOptions = {}): Promise<CopilotCategory[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/copilot/categories';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Copilot Chat API
   */
  static getCopilotChatResponseUsingPost(
    params: {
      /** request */
      request: CopilotChatRequestModel;
      /** sessionId */
      sessionId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CopilotCategorySummaryModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/copilot/chat';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { sessionId: params['sessionId'] };

      let data = params['request'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Copilot Category Overly Granted Privileges Monitoring Policy GET API
   */
  static getOverlyGrantedPrivilegesMonitoringPolicyUsingGet(
    params: {
      /** businessActionId */
      businessActionId: string;
      /** categoryId */
      categoryId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MonitoringPolicyResponseModelV1> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/copilot/overly_granted_privileges_monitoring_policy';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { businessActionId: params['businessActionId'], categoryId: params['categoryId'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Copilot Category Service Ticket Details GET API
   */
  static getServiceTicketUsingGet(
    params: {
      /** businessActionId */
      businessActionId: string;
      /** categoryId */
      categoryId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/copilot/service_ticket';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { businessActionId: params['businessActionId'], categoryId: params['categoryId'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Copilot Category summary overview GET API
   */
  static getCopilotSummaryUsingGet(
    params: {
      /** accountId */
      accountId?: string;
      /** categoryId */
      categoryId: string;
      /** contextType */
      contextType?: string;
      /** databaseName */
      databaseName?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CopilotCategorySummaryModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/copilot/summary';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        accountId: params['accountId'],
        categoryId: params['categoryId'],
        contextType: params['contextType'],
        databaseName: params['databaseName']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Copilot Category Unmasked Sensitive DataPolicy GET API
   */
  static getUnmaskedSensitiveDataPolicyUsingGet(
    params: {
      /** businessActionId */
      businessActionId: string;
      /** categoryId */
      categoryId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DataAccessPolicy> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/copilot/unmasked_sensitive_policy';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { businessActionId: params['businessActionId'], categoryId: params['categoryId'] };

      axios(configs, resolve, reject);
    });
  }
}

export class DashboardControllerService {
  /**
   * Get the AI and data inventory summary
   */
  static getInventorySummaryUsingGet(options: IRequestOptions = {}): Promise<DashboardInventorySummaryModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/dashboard/inventory-summary';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class DataClassificationControllerService {
  /**
   * listDataClassification
   */
  static listDataClassificationUsingGet(
    params: {
      /** cloudAccountId */
      cloudAccountId: string;
      /** dataSourceName */
      dataSourceName?: string;
      /** type */
      type?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DataClassification[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_classification';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        cloudAccountId: params['cloudAccountId'],
        dataSourceName: params['dataSourceName'],
        type: params['type']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * createDataClassification
   */
  static createDataClassificationUsingPost(
    params: {
      /** dataClassificationModel */
      dataClassificationModel: DataClassificationModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DataClassification> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_classification';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['dataClassificationModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * fetchS3ResourceTaggingInfo
   */
  static fetchS3ResourceTaggingInfoUsingGet(
    params: {
      /** accountId */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_classification/s3_tags';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { accountId: params['accountId'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * updateDataClassification
   */
  static updateDataClassificationUsingPut(
    params: {
      /** dataClassificationModel */
      dataClassificationModel: DataClassificationModel;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DataClassification> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_classification/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['dataClassificationModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * deleteDataClassification
   */
  static deleteDataClassificationUsingDelete(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DataClassification> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_classification/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * listClassificationType
   */
  static listClassificationTypeUsingGet(
    params: {
      /** accountId */
      accountId?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ClassificationType[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_classification_types';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { accountId: params['accountId'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * createDataClassificationType
   */
  static createDataClassificationTypeUsingPost(
    params: {
      /** classificationTypeModel */
      classificationTypeModel: ClassificationTypeModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ClassificationType> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_classification_types';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['classificationTypeModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * listDataSourceSupportedColumns
   */
  static listDataSourceSupportedColumnsUsingGet(options: IRequestOptions = {}): Promise<DataSourceSupportedColumns[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_source_supported_columns';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * listDataClassificationForTenant
   */
  static listDataClassificationForTenantUsingGet(
    params: {
      /** cloudAccountId */
      cloudAccountId?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DataClassificationResponse[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/di_data_classification';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { cloudAccountId: params['cloudAccountId'] };

      axios(configs, resolve, reject);
    });
  }
}

export class DataDomainControllerService {
  /**
   * getAllDataDomains
   */
  static getAllDataDomainsUsingGet(
    params: {
      /** accountId */
      accountId?: string[];
      /** domainValues */
      domainValues?: string;
      /** name */
      name?: string;
      /** page_no */
      pageNo?: number;
      /** page_size */
      pageSize?: number;
      /** sort_by */
      sortBy?: string;
      /** sort_order */
      sortOrder?: string;
      /** tenantUsers */
      tenantUsers?: string[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxPaginatedResponseModel_DataDomainPaginatedModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_domain';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        accountId: params['accountId'],
        domainValues: params['domainValues'],
        name: params['name'],
        page_no: params['pageNo'],
        page_size: params['pageSize'],
        sort_by: params['sortBy'],
        sort_order: params['sortOrder'],
        tenantUsers: params['tenantUsers']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * createDataDomain
   */
  static createDataDomainUsingPost(
    params: {
      /** reqDataDomain */
      reqDataDomain: DataDomainModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_domain';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['reqDataDomain'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getAccountForSelectedDomain
   */
  static getAccountForSelectedDomainUsingGet(
    params: {
      /** domainValue */
      domainValue?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AllowAccountListModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_domain/account';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { domainValue: params['domainValue'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getColumnFilterValues
   */
  static getColumnFilterValuesUsingGet(
    params: {
      /** filterKey */
      filterKey: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ColumnFiltersResponseModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_domain/columnFilter';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { filterKey: params['filterKey'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getAllDomains
   */
  static getAllDomainsUsingGet(options: IRequestOptions = {}): Promise<DomainProdutMetadata[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_domain/metadata';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * createTagAssociation
   */
  static createTagAssociationUsingPost1(
    params: {
      /** accountId */
      accountId: string;
      /** accountTagReferenceModel */
      accountTagReferenceModel: AccountTagAssociationModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_domain/tag_association';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { accountId: params['accountId'] };

      let data = params['accountTagReferenceModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getDataSourceTagReferences
   */
  static getDataSourceTagReferencesUsingGet1(
    params: {
      /** accountId */
      accountId: string;
      /** objectDatabases */
      objectDatabases?: string[];
      /** objectNames */
      objectNames?: string[];
      /** objectSchemas */
      objectSchemas?: string[];
      /** objectTypes */
      objectTypes?: string[];
      /** page_no */
      pageNo?: number;
      /** page_size */
      pageSize?: number;
      /** sort_by */
      sortBy?: string;
      /** sort_order */
      sortOrder?: string;
      /** tagDatabases */
      tagDatabases?: string[];
      /** tagKeys */
      tagKeys?: string[];
      /** tagSchemas */
      tagSchemas?: string[];
      /** tagValues */
      tagValues?: string[];
      /** workspace */
      workspace?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxPaginatedResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_domain/tag_references';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        accountId: params['accountId'],
        objectDatabases: params['objectDatabases'],
        objectNames: params['objectNames'],
        objectSchemas: params['objectSchemas'],
        objectTypes: params['objectTypes'],
        page_no: params['pageNo'],
        page_size: params['pageSize'],
        sort_by: params['sortBy'],
        sort_order: params['sortOrder'],
        tagDatabases: params['tagDatabases'],
        tagKeys: params['tagKeys'],
        tagSchemas: params['tagSchemas'],
        tagValues: params['tagValues'],
        workspace: params['workspace']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * deleteTagAssociation
   */
  static deleteTagAssociationUsingPut1(
    params: {
      /** accountId */
      accountId: string;
      /** accountTagEditModel */
      accountTagEditModel: AccountTagAssociationEditDeleteModel;
      /** domainId */
      domainId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_domain/{domainId}/delete_tag_association';
      url = url.replace('{domainId}', params['domainId'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);
      configs.params = { accountId: params['accountId'] };

      let data = params['accountTagEditModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getDataDomain
   */
  static getDataDomainUsingGet(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_domain/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * updateDataDomain
   */
  static updateDataDomainUsingPut(
    params: {
      /** id */
      id: string;
      /** reqDataDomainDetails */
      reqDataDomainDetails: DataDomainModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_domain/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['reqDataDomainDetails'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * deleteDataDomain
   */
  static deleteDataDomainUsingDelete(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_domain/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getTenantUsersByDataDomainId
   */
  static getTenantUsersByDataDomainIdUsingGet(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TenantUser[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_domain/{id}/users';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * createDataProductMapping
   */
  static createDataProductMappingUsingPost(
    params: {
      /** reqDataProduct */
      reqDataProduct: DataProductMappingModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_product_mapping';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['reqDataProduct'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getAccountForSelectedDomainProduct
   */
  static getAccountForSelectedDomainProductUsingGet(
    params: {
      /** domainName */
      domainName: string;
      /** filterKey */
      filterKey: string;
      /** productName */
      productName?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DataProductObjectListingAccountResponseModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/domain_product/columnFilter';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        domainName: params['domainName'],
        filterKey: params['filterKey'],
        productName: params['productName']
      };

      axios(configs, resolve, reject);
    });
  }
}

export class DataMovementControllerService {
  /**
   * getDataMovementDistinctExternalDataSourceNameByAccountId
   */
  static getDataMovementDistinctExternalDataSourceNameByAccountIdUsingGet(
    params: {
      /** accountId */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_movement/distinct_external_datasource_name_types';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { accountId: params['accountId'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getDataMovementDistinctExternalDataSourceTypeByAccountId
   */
  static getDataMovementDistinctExternalDataSourceTypeByAccountIdUsingGet(
    params: {
      /** accountId */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_movement/distinct_external_datasource_type_types';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { accountId: params['accountId'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getDataMovementDistinctNodeNamesAndNameTypesByAccountId
   */
  static getDataMovementDistinctNodeNamesAndNameTypesByAccountIdUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** endDate */
      endDate: string;
      /** nodeType */
      nodeType?: string;
      /** startDate */
      startDate: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DataMovementNodeNameType[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_movement/distinct_node_names_types/{accountId}';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { endDate: params['endDate'], nodeType: params['nodeType'], startDate: params['startDate'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getLatestDataMovementActivityTime
   */
  static getLatestDataMovementActivityTimeUsingGet(options: IRequestOptions = {}): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_movement/getLatestDataMovementActivityTime';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getDataMovementNodeToNodeDailyDataSizeSummaryByAccountId
   */
  static getDataMovementNodeToNodeDailyDataSizeSummaryByAccountIdUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** endDate */
      endDate?: string;
      /** externalDataSourceName */
      externalDataSourceName: string;
      /** movement */
      movement: string;
      /** sprawlType */
      sprawlType?: string;
      /** startDate */
      startDate?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DataMovementNodeDailyDataSizeSummaryModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_movement/node_to_node_summary/daily_datasize/{accountId}';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        endDate: params['endDate'],
        externalDataSourceName: params['externalDataSourceName'],
        movement: params['movement'],
        sprawlType: params['sprawlType'],
        startDate: params['startDate']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getDataMovementNodeToNodeObjectUsedInLLMSummaryByAccountId
   */
  static getDataMovementNodeToNodeObjectUsedInLlmSummaryByAccountIdUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** externalDataSourceName */
      externalDataSourceName: string;
      /** movement */
      movement: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DataMovementNodeSharesSummaryModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_movement/node_to_node_summary/llm/{accountId}';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { externalDataSourceName: params['externalDataSourceName'], movement: params['movement'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getDataMovementNodeToNodeLLMSummaryByAccountId
   */
  static getDataMovementNodeToNodeLlmSummaryByAccountIdUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** externalDataSourceName */
      externalDataSourceName: string;
      /** movement */
      movement: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<LLMMetadataModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_movement/node_to_node_summary/llm_metadata/{accountId}';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { externalDataSourceName: params['externalDataSourceName'], movement: params['movement'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getDataMovementNodeToNodeS3SummaryByAccountId
   */
  static getDataMovementNodeToNodeS3SummaryByAccountIdUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** externalDataSourceName */
      externalDataSourceName: string;
      /** movement */
      movement: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DataMovementNodeS3SummaryModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_movement/node_to_node_summary/s3/{accountId}';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { externalDataSourceName: params['externalDataSourceName'], movement: params['movement'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getDataMovementNodeToNodeSharesSummaryByAccountId
   */
  static getDataMovementNodeToNodeSharesSummaryByAccountIdUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** externalDataSourceName */
      externalDataSourceName: string;
      /** movement */
      movement: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DataMovementNodeSharesSummaryModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_movement/node_to_node_summary/shares/{accountId}';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { externalDataSourceName: params['externalDataSourceName'], movement: params['movement'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getDataMovementNodeToNodeSummaryByAccountId
   */
  static getDataMovementNodeToNodeSummaryByAccountIdUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** endDate */
      endDate?: string;
      /** externalDataSourceName */
      externalDataSourceName: string;
      /** movement */
      movement: string;
      /** sprawlType */
      sprawlType?: string;
      /** startDate */
      startDate?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DataMovementNodeSummaryModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_movement/node_to_node_summary/{accountId}';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        endDate: params['endDate'],
        externalDataSourceName: params['externalDataSourceName'],
        movement: params['movement'],
        sprawlType: params['sprawlType'],
        startDate: params['startDate']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getDataMovementByAccountId
   */
  static getDataMovementByAccountIdUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** dataSizeGreaterThan */
      dataSizeGreaterThan?: number;
      /** dataSizeLessThan */
      dataSizeLessThan?: number;
      /** endDate */
      endDate: string;
      /** externalDataSourceName */
      externalDataSourceName?: string;
      /** externalDataSourceType */
      externalDataSourceType?: string;
      /** startDate */
      startDate: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DataMovementResponseModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_movement/{accountId}';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        dataSizeGreaterThan: params['dataSizeGreaterThan'],
        dataSizeLessThan: params['dataSizeLessThan'],
        endDate: params['endDate'],
        externalDataSourceName: params['externalDataSourceName'],
        externalDataSourceType: params['externalDataSourceType'],
        startDate: params['startDate']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * saveDataMovement
   */
  static saveDataMovementUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** dataMovementActivities */
      dataMovementActivities: DataMovementActivityModel[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_movement/{accountId}';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['dataMovementActivities'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class DataProductControllerService {
  /**
   * listAllDataProducts
   */
  static listAllDataProductsUsingGet(options: IRequestOptions = {}): Promise<DataProductListItemModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_product';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * createDataProduct
   */
  static createDataProductUsingPost(
    params: {
      /** reqDataProductDetails */
      reqDataProductDetails: DataProductModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_product';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['reqDataProductDetails'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getAccountForSelectedDomainAndProduct
   */
  static getAccountForSelectedDomainAndProductUsingGet(
    params: {
      /** domainName */
      domainName: string;
      /** productValue */
      productValue?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AllowAccountListModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_product/account';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { domainName: params['domainName'], productValue: params['productValue'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * deleteTagAssociation
   */
  static deleteTagAssociationUsingPut2(
    params: {
      /** accountId */
      accountId: string;
      /** accountTagEditModel */
      accountTagEditModel: AccountTagAssociationEditDeleteModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_product/delete_tag_association';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);
      configs.params = { accountId: params['accountId'] };

      let data = params['accountTagEditModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getDataProducts
   */
  static getDataProductsUsingGet(
    params: {
      /** domainName */
      domainName?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DomainProdutMetadata[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_product/metadata';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { domainName: params['domainName'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * createTagAssociation
   */
  static createTagAssociationUsingPost2(
    params: {
      /** accountId */
      accountId: string;
      /** accountTagReferenceModel */
      accountTagReferenceModel: AccountTagAssociationModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_product/tag_association';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { accountId: params['accountId'] };

      let data = params['accountTagReferenceModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getDataSourceTagReferences
   */
  static getDataSourceTagReferencesUsingGet2(
    params: {
      /** accountId */
      accountId: string;
      /** objectDatabases */
      objectDatabases?: string[];
      /** objectNames */
      objectNames?: string[];
      /** objectSchemas */
      objectSchemas?: string[];
      /** objectTypes */
      objectTypes?: string[];
      /** page_no */
      pageNo?: number;
      /** page_size */
      pageSize?: number;
      /** sort_by */
      sortBy?: string;
      /** sort_order */
      sortOrder?: string;
      /** tagDatabases */
      tagDatabases?: string[];
      /** tagKeys */
      tagKeys?: string[];
      /** tagSchemas */
      tagSchemas?: string[];
      /** tagValues */
      tagValues?: string[];
      /** workspace */
      workspace?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxPaginatedResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_product/tag_references';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        accountId: params['accountId'],
        objectDatabases: params['objectDatabases'],
        objectNames: params['objectNames'],
        objectSchemas: params['objectSchemas'],
        objectTypes: params['objectTypes'],
        page_no: params['pageNo'],
        page_size: params['pageSize'],
        sort_by: params['sortBy'],
        sort_order: params['sortOrder'],
        tagDatabases: params['tagDatabases'],
        tagKeys: params['tagKeys'],
        tagSchemas: params['tagSchemas'],
        tagValues: params['tagValues'],
        workspace: params['workspace']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getDataProduct
   */
  static getDataProductUsingGet(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_product/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * updateDataProduct
   */
  static updateDataProductUsingPut(
    params: {
      /** id */
      id: string;
      /** reqDataProductDetails */
      reqDataProductDetails: DataProductModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_product/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['reqDataProductDetails'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * deleteDataProduct
   */
  static deleteDataProductUsingDelete(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_product/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getDataProductAttributes
   */
  static getDataProductAttributesUsingGet(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_product/{id}/attributes';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * upsertDataProductAttributes
   */
  static upsertDataProductAttributesUsingPut(
    params: {
      /** id */
      id: string;
      /** requestBody */
      requestBody: DataProductAttributesUpsertRequestModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/data_product/{id}/attributes';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['requestBody'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class AuthorizedSystemApplicationControllerService {
  /**
   * listAuthorizedSystemApplicationDI
   */
  static listAuthorizedSystemApplicationDiUsingGet(
    params: {
      /** cloudAccountId */
      cloudAccountId?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuthorizedSystemApplicationResponse[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/di_authorized_system_application';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { cloudAccountId: params['cloudAccountId'] };

      axios(configs, resolve, reject);
    });
  }
}

export class AuthorizedSystemIpControllerService {
  /**
   * listAuthorizedSystemIpDI
   */
  static listAuthorizedSystemIpDiUsingGet(
    params: {
      /** cloudAccountId */
      cloudAccountId?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuthorizedSystemIpResponse[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/di_authorized_system_ip';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { cloudAccountId: params['cloudAccountId'] };

      axios(configs, resolve, reject);
    });
  }
}

export class UserControllerService {
  /**
   * disableMfa
   */
  static disableMfaUsingPost(
    params: {
      /** userRequest */
      userRequest: UserAuth;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/disable_mfa';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['userRequest'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getMfaQrCode
   */
  static getMfaQrCodeUsingPost(
    params: {
      /** imageSize */
      imageSize?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MfaQrCode> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/enable_mfa';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { imageSize: params['imageSize'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * listUsers
   */
  static listUsersUsingGet(options: IRequestOptions = {}): Promise<TenantUser[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * createUser
   */
  static createUserUsingPost1(
    params: {
      /** userModel */
      userModel: UserModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['userModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * changePassword
   */
  static changePasswordUsingPut(
    params: {
      /** changeUserPassword */
      changeUserPassword: ChangeUserPassword;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user/changePassword';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['changeUserPassword'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * updateUserDetails
   */
  static updateUserDetailsUsingPut(
    params: {
      /** userId */
      userId: string;
      /** userModel */
      userModel: UserModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user/{userId}';
      url = url.replace('{userId}', params['userId'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['userModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * deRegisterAccount
   */
  static deRegisterAccountUsingDelete1(
    params: {
      /** userId */
      userId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user/{userId}';
      url = url.replace('{userId}', params['userId'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class DomainPolicyControllerService {
  /**
   * getDomainPolicies
   */
  static getDomainPoliciesUsingGet(options: IRequestOptions = {}): Promise<DomainDataAccessPolicyModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/domain_policies';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * createAccessPolicy
   */
  static createAccessPolicyUsingPost1(
    params: {
      /** dataAccessPolicyModel */
      dataAccessPolicyModel: DataAccessPolicyModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/domain_policies';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['dataAccessPolicyModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getDomainOrProducts
   */
  static getDomainOrProductsUsingGet(
    params: {
      /** domainNames */
      domainNames?: string;
      /** type */
      type: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DomainProdutMetadata[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/domain_policies/metadata';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { domainNames: params['domainNames'], type: params['type'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getDomainPrincipals
   */
  static getDomainPrincipalsUsingGet(
    params: {
      /** type */
      type: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/domain_policies/principals';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { type: params['type'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getDomainPolicyById
   */
  static getDomainPolicyByIdUsingGet(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/domain_policies/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * updateAccessPolicy
   */
  static updateAccessPolicyUsingPut1(
    params: {
      /** dataAccessPolicyModel */
      dataAccessPolicyModel: DataAccessPolicyModel;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/domain_policies/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['dataAccessPolicyModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * deleteDomainPolicy
   */
  static deleteDomainPolicyUsingDelete(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/domain_policies/{id}/delete_policy';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * disableAccessPolicy
   */
  static disableAccessPolicyUsingDelete1(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/domain_policies/{id}/disable';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * discardDraftAccessPolicy
   */
  static discardDraftAccessPolicyUsingDelete1(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/domain_policies/{id}/discardDraft';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getImpactedObjects
   */
  static getImpactedObjectsUsingPost(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DataAccessPolicyImpactedObjectResponseModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/domain_policies/{id}/impacted_objects';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * publishPolicy
   */
  static publishPolicyUsingPost1(
    params: {
      /** connectionDetail */
      connectionDetail: RedshiftJDBCConnectionDetail;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/domain_policies/{id}/publish_policy';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['connectionDetail'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * reviewPolicy
   */
  static reviewPolicyUsingPost1(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/domain_policies/{id}/review_policy';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getDomainPolicyHistory
   */
  static getDomainPolicyHistoryUsingGet(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TenantAuditLogs[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/domain_policies/{id}/view_history';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class GatewayConfigurationService {
  /**
   * Download gateway configuration
   */
  static getGatewayConfigurationUsingGet(
    params: {
      /** gatewayType */
      gatewayType: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/download-gateway-configs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { gatewayType: params['gatewayType'] };

      axios(configs, resolve, reject);
    });
  }
}

export class DataPlaneNotificationControllerService {
  /**
   * listDataPlaneNotification
   */
  static listDataPlaneNotificationUsingGet2(
    params: {
      /** accountId */
      accountId?: string;
      /** page_no */
      pageNo?: number;
      /** page_size */
      pageSize?: number;
      /** reportType */
      reportType?: string[];
      /** sort_by */
      sortBy?: string;
      /** sort_order */
      sortOrder?: string;
      /** statusType */
      statusType?: string;
      /** statusValue */
      statusValue?: string;
      /** taskType */
      taskType?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/dp_notifications';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        accountId: params['accountId'],
        page_no: params['pageNo'],
        page_size: params['pageSize'],
        reportType: params['reportType'],
        sort_by: params['sortBy'],
        sort_order: params['sortOrder'],
        statusType: params['statusType'],
        statusValue: params['statusValue'],
        taskType: params['taskType']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * saveDataPlaneNotification
   */
  static saveDataPlaneNotificationUsingPost(
    params: {
      /** dpNotificationRequestBody */
      dpNotificationRequestBody: DataPlaneNotification;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/dp_notifications';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['dpNotificationRequestBody'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * listDataPlaneNotification
   */
  static listDataPlaneNotificationUsingGet1(
    params: {
      /** accountDataType */
      accountDataType?: string;
      /** page_no */
      pageNo?: number;
      /** page_size */
      pageSize?: number;
      /** sinceDays */
      sinceDays?: number;
      /** sort_by */
      sortBy?: string;
      /** sort_order */
      sortOrder?: string;
      /** type */
      type?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/dp_notifications/accounts';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        accountDataType: params['accountDataType'],
        page_no: params['pageNo'],
        page_size: params['pageSize'],
        sinceDays: params['sinceDays'],
        sort_by: params['sortBy'],
        sort_order: params['sortOrder'],
        type: params['type']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * listDataPlaneNotificationForDashboard
   */
  static listDataPlaneNotificationForDashboardUsingGet(
    params: {
      /** accountDataType */
      accountDataType?: string;
      /** accountId */
      accountId?: string[];
      /** category */
      category?: string;
      /** page_no */
      pageNo?: number;
      /** page_size */
      pageSize?: number;
      /** reportType */
      reportType?: string[];
      /** sinceDays */
      sinceDays?: number;
      /** sort_by */
      sortBy?: string;
      /** sort_order */
      sortOrder?: string;
      /** statusType */
      statusType?: string;
      /** statusValue */
      statusValue?: string;
      /** taskType */
      taskType?: string;
      /** type */
      type?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DataPlaneNotificationDashboardResponseModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/dp_notifications/dashboard';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        accountDataType: params['accountDataType'],
        accountId: params['accountId'],
        category: params['category'],
        page_no: params['pageNo'],
        page_size: params['pageSize'],
        reportType: params['reportType'],
        sinceDays: params['sinceDays'],
        sort_by: params['sortBy'],
        sort_order: params['sortOrder'],
        statusType: params['statusType'],
        statusValue: params['statusValue'],
        taskType: params['taskType'],
        type: params['type']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getLatestDataRefreshTime
   */
  static getLatestDataRefreshTimeUsingGet(
    params: {
      /** account_id */
      accountId: string;
      /** name */
      name: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/dp_notifications/{account_id}/latest_data_refresh_time';
      url = url.replace('{account_id}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { name: params['name'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * dismissDataPlaneNotification
   */
  static dismissDataPlaneNotificationUsingPut(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DataPlaneNotification> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/dp_notifications/{id}/dismiss';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * markedAsReadDPNotification
   */
  static markedAsReadDpNotificationUsingPut(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DataPlaneNotification> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/dp_notifications/{id}/mark_read';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get initiated Delta Sync notification for a tenant
   */
  static getDeltaSyncNotificationUsingGet(
    params: {
      /** tenantId */
      tenantId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/tenants/{tenantId}/policy_sync/notification';
      url = url.replace('{tenantId}', params['tenantId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class TrustDspmControllerService {
  /**
   * Create Chat Query Tracker
   */
  static createChatQueryTrackerUsingPost(
    params: {
      /** tracker */
      tracker: TrustDspmChatQueryTracker;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TrustDspmChatQueryTracker> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/dspm/chat_query_tracker';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['tracker'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get Chat Query Tracker
   */
  static getChatQueryTrackerByIdUsingGet(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TrustDspmChatQueryTracker> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/dspm/chat_query_tracker/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Update Chat Query Tracker
   */
  static updateChatQueryTrackerUsingPut(
    params: {
      /** id */
      id: string;
      /** tracker */
      tracker: TrustDspmChatQueryTracker;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TrustDspmChatQueryTracker> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/dspm/chat_query_tracker/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['tracker'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Delete Chat Query Tracker
   */
  static deleteChatQueryTrackerUsingDelete(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/dspm/chat_query_tracker/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class EnterprisePolicyControllerService {
  /**
   * list
   */
  static listUsingGet(
    params: {
      /** enabled */
      enabled?: boolean;
      /** name */
      name?: string;
      /** page */
      page?: number;
      /** size */
      size?: number;
      /** status */
      status?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxPaginatedResponseModel_EnterprisePolicyResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/enterprise_policies';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        enabled: params['enabled'],
        name: params['name'],
        page: params['page'],
        size: params['size'],
        status: params['status']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * create
   */
  static createUsingPost(
    params: {
      /** body */
      body: EnterprisePolicyRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<EnterprisePolicyResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/enterprise_policies';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * get
   */
  static getUsingGet(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<EnterprisePolicyResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/enterprise_policies/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * update
   */
  static updateUsingPut(
    params: {
      /** body */
      body: EnterprisePolicyRequest;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<EnterprisePolicyResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/enterprise_policies/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * delete
   */
  static deleteUsingDelete(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/enterprise_policies/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getPlatformCoverage
   */
  static getPlatformCoverageUsingGet(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/enterprise_policies/{id}/platform-coverage';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * publish
   */
  static publishUsingPost(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<EnterprisePolicyResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/enterprise_policies/{id}/publish';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * save
   */
  static saveUsingPost1(
    params: {
      /** body */
      body?: EnterprisePolicyRequest;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<EnterprisePolicyResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/enterprise_policies/{id}/save';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class EntityAttributeMappingControllerService {
  /**
   * getDatabases
   */
  static getDatabasesUsingGet2(
    params: {
      /** accountId */
      accountId: string;
      /** search */
      search?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/entityMapping/{accountId}/database';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { search: params['search'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getTags
   */
  static getTagsUsingGet1(
    params: {
      /** accountId */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/entityMapping/{accountId}/domain';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class EstateSearchControllerService {
  /**
   * Search the tenant's AI agents, MCP servers and data sources by name
   */
  static searchEstateUsingGet(
    params: {
      /** limit */
      limit?: number;
      /** searchQuery */
      searchQuery: string;
      /** types */
      types?: string[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<EstateSearchResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/estate/search';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { limit: params['limit'], searchQuery: params['searchQuery'], types: params['types'] };

      axios(configs, resolve, reject);
    });
  }
}

export class ExternalIntegrationControllerService {
  /**
   * getExternalIntegrationList
   */
  static getExternalIntegrationListUsingGet(options: IRequestOptions = {}): Promise<ExternalIntegrationModelRes[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/external/integration';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * registerExternalIntegration
   */
  static registerExternalIntegrationUsingPost(
    params: {
      /**  */
      integrationType?: string;
      /**  */
      metadataXml?: any;
      /**  */
      type?: string;
      /**  */
      integrationDetails?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/external/integration';

      const configs: IRequestConfig = getConfigs('post', 'multipart/form-data', url, options);

      let data = undefined;
      data = new FormData();
      if (params['integrationType']) {
        if (Object.prototype.toString.call(params['integrationType']) === '[object Array]') {
          for (const item of params['integrationType']) {
            data.append('integrationType', item as any);
          }
        } else {
          data.append('integrationType', params['integrationType'] as any);
        }
      }

      if (params['metadataXml']) {
        if (Object.prototype.toString.call(params['metadataXml']) === '[object Array]') {
          for (const item of params['metadataXml']) {
            data.append('metadataXml', item as any);
          }
        } else {
          data.append('metadataXml', params['metadataXml'] as any);
        }
      }

      if (params['type']) {
        if (Object.prototype.toString.call(params['type']) === '[object Array]') {
          for (const item of params['type']) {
            data.append('type', item as any);
          }
        } else {
          data.append('type', params['type'] as any);
        }
      }

      if (params['integrationDetails']) {
        if (Object.prototype.toString.call(params['integrationDetails']) === '[object Array]') {
          for (const item of params['integrationDetails']) {
            data.append('integrationDetails', item as any);
          }
        } else {
          data.append('integrationDetails', params['integrationDetails'] as any);
        }
      }

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getExternalIntegrationTypeMetadata
   */
  static getExternalIntegrationTypeMetadataUsingGet(
    options: IRequestOptions = {}
  ): Promise<TlxExternalIntegrationTypeMetadata[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/external/integration/metadata';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getExternalSourceConnections
   */
  static getExternalSourceConnectionsUsingGet(
    params: {
      /** clientId */
      clientId?: string;
      /** id */
      id?: string;
      /** secret */
      secret?: string;
      /** url */
      url?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PairModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/external/integration/sourceConnection';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { clientId: params['clientId'], id: params['id'], secret: params['secret'], url: params['url'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getExternalIntegration
   */
  static getExternalIntegrationUsingGet(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalIntegrationModelRes> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/external/integration/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * updateExternalIntegration
   */
  static updateExternalIntegrationUsingPut(
    params: {
      /**  */
      integrationType?: string;
      /**  */
      metadataXml?: any;
      /**  */
      type?: string;
      /**  */
      integrationDetails?: string;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/external/integration/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'multipart/form-data', url, options);

      let data = undefined;
      data = new FormData();
      if (params['integrationType']) {
        if (Object.prototype.toString.call(params['integrationType']) === '[object Array]') {
          for (const item of params['integrationType']) {
            data.append('integrationType', item as any);
          }
        } else {
          data.append('integrationType', params['integrationType'] as any);
        }
      }

      if (params['metadataXml']) {
        if (Object.prototype.toString.call(params['metadataXml']) === '[object Array]') {
          for (const item of params['metadataXml']) {
            data.append('metadataXml', item as any);
          }
        } else {
          data.append('metadataXml', params['metadataXml'] as any);
        }
      }

      if (params['type']) {
        if (Object.prototype.toString.call(params['type']) === '[object Array]') {
          for (const item of params['type']) {
            data.append('type', item as any);
          }
        } else {
          data.append('type', params['type'] as any);
        }
      }

      if (params['integrationDetails']) {
        if (Object.prototype.toString.call(params['integrationDetails']) === '[object Array]') {
          for (const item of params['integrationDetails']) {
            data.append('integrationDetails', item as any);
          }
        } else {
          data.append('integrationDetails', params['integrationDetails'] as any);
        }
      }

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * deleteExternalIntegration
   */
  static deleteExternalIntegrationUsingDelete(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/external/integration/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Validate an agent registry's connection without saving it
   */
  static testExternalIntegrationConnectionUsingPost(
    params: {
      /** externalModel */
      externalModel: ExternalIntegrationModelReq;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/register/external/integration/validation_connection';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['externalModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class ExternalOauthTokenControllerService {
  /**
   * validateOauthToken
   */
  static validateOauthTokenUsingPost(
    params: {
      /** authTokenModel */
      authTokenModel: OAuthTokenModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/external_oauth/token';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['authTokenModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class SamlFederationControllerService {
  /**
   * samlSSO
   */
  static samlSsoUsingPost(
    params: {
      /** RelayState */
      relayState?: string;
      /** SAMLResponse */
      samlResponse: string;
      /** tenantId */
      tenantId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/federation/{tenantId}/sso';
      url = url.replace('{tenantId}', params['tenantId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { RelayState: params['relayState'], SAMLResponse: params['samlResponse'] };

      axios(configs, resolve, reject);
    });
  }
}

export class FreemiumControllerService {
  /**
   * getLatestFreemiumData
   */
  static getLatestFreemiumDataUsingGet(
    params: {
      /** tenantId */
      tenantId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FreemiumMeter> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/freemium/freemium_meter';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { tenantId: params['tenantId'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * saveFreemiumData
   */
  static saveFreemiumDataUsingPost(
    params: {
      /** freemiumMeterModel */
      freemiumMeterModel: FreemiumMeterModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/freemium/freemium_meter';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['freemiumMeterModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class GenAillmControllerService {
  /**
   * generatePolicySummary
   */
  static generatePolicySummaryUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/genai/policySummarizer';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { accountId: params['accountId'], id: params['id'] };

      axios(configs, resolve, reject);
    });
  }
}

export class GitBookControllerService {
  /**
   * debugPageContent
   */
  static debugPageContentUsingGet(
    params: {
      /** pageId */
      pageId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<JsonNode> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/gitbook/debug/page/{pageId}';
      url = url.replace('{pageId}', params['pageId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * syncFromGitBook
   */
  static syncFromGitBookUsingPost(options: IRequestOptions = {}): Promise<GitBookSyncResultModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/gitbook/sync';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getReleaseNotes
   */
  static getReleaseNotesUsingGet(
    params: {
      /** page */
      page?: number;
      /** search */
      search?: string;
      /** size */
      size?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ReleaseNoteListResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/release-notes';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { page: params['page'], search: params['search'], size: params['size'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getLatestRelease
   */
  static getLatestReleaseUsingGet(options: IRequestOptions = {}): Promise<ReleaseNoteResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/release-notes/latest';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * markSeen
   */
  static markSeenUsingPost(
    params: {
      /** request */
      request: MarkSeenRequestModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MarkSeenResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/release-notes/mark-seen';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['request'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getReleaseBySlug
   */
  static getReleaseBySlugUsingGet(
    params: {
      /** slug */
      slug: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ReleaseNoteResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/release-notes/{slug}';
      url = url.replace('{slug}', params['slug'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class HealthControllerService {
  /**
   * heathCheck
   */
  static heathCheckUsingGet(options: IRequestOptions = {}): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/health';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class IcebergControllerService {
  /**
   * getColumnsForTables
   */
  static getColumnsForTablesUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** fullyQualifiedTableNames */
      fullyQualifiedTableNames: any | null[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SnowflakeColumn[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/iceberg/{accountId}/columns';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['fullyQualifiedTableNames'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getNamespaces
   */
  static getNamespacesUsingGet(
    params: {
      /** accountId */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/iceberg/{accountId}/namespaces';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getChildNamespaces
   */
  static getChildNamespacesUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** parent */
      parent: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/iceberg/{accountId}/namespaces/children';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { parent: params['parent'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getTables
   */
  static getTablesUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** namespace */
      namespace: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/iceberg/{accountId}/tables';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { namespace: params['namespace'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getAllTables
   */
  static getAllTablesUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** rootNamespace */
      rootNamespace?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<object[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/iceberg/{accountId}/tables/all';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { rootNamespace: params['rootNamespace'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getTable
   */
  static getTableUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** namespace */
      namespace: string;
      /** tableName */
      tableName: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PolicyTableStructure> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/iceberg/{accountId}/tables/{tableName}';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{tableName}', params['tableName'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { namespace: params['namespace'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * tableExists
   */
  static tableExistsUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** namespace */
      namespace: string;
      /** tableName */
      tableName: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<boolean> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/iceberg/{accountId}/tables/{tableName}/exists';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{tableName}', params['tableName'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { namespace: params['namespace'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getViews
   */
  static getViewsUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** namespace */
      namespace: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/iceberg/{accountId}/views';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { namespace: params['namespace'] };

      axios(configs, resolve, reject);
    });
  }
}

export class InfraDeploymentStatusTrackerControllerService {
  /**
   * getInfraDeploymentStatusTrackerByAccountIdAndTenantId
   */
  static getInfraDeploymentStatusTrackerByAccountIdAndTenantIdUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** tenantId */
      tenantId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InfraDeploymentStatusTracker> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/infra_deployment_status_tracker';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { accountId: params['accountId'], tenantId: params['tenantId'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * createInfraDeploymentStatusTracker
   */
  static createInfraDeploymentStatusTrackerUsingPost(
    params: {
      /** infraDeploymentStatusTrackerModel */
      infraDeploymentStatusTrackerModel: InfraDeploymentStatusTrackerModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InfraDeploymentStatusTracker> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/infra_deployment_status_tracker';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['infraDeploymentStatusTrackerModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getInfraDeploymentStatusTracker
   */
  static getInfraDeploymentStatusTrackerUsingGet(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InfraDeploymentStatusTracker> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/infra_deployment_status_tracker/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * updateInfraDeploymentStatusTracker
   */
  static updateInfraDeploymentStatusTrackerUsingPut(
    params: {
      /** id */
      id: string;
      /** infraDeploymentStatusTrackerModel */
      infraDeploymentStatusTrackerModel: InfraDeploymentStatusTrackerModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InfraDeploymentStatusTracker> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/infra_deployment_status_tracker/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['infraDeploymentStatusTrackerModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * deleteInfraDeploymentStatusTracker
   */
  static deleteInfraDeploymentStatusTrackerUsingDelete(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InfraDeploymentStatusTracker> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/infra_deployment_status_tracker/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * listInfraDeploymentStatusTrakcer
   */
  static listInfraDeploymentStatusTrakcerUsingGet(
    options: IRequestOptions = {}
  ): Promise<InfraDeploymentStatusTracker[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/list_infra_deployment_status_tracker';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class DremioInventorySyncControllerService {
  /**
   * syncDremioInventory
   */
  static syncDremioInventoryUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** projectId */
      projectId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/inventory/dremio/sync';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { accountId: params['accountId'], projectId: params['projectId'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * syncPolicySecuredObjects
   */
  static syncPolicySecuredObjectsUsingGet(
    params: {
      /** policyId */
      policyId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PolicySecuredObjectSyncResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/inventory/sync/policy-secured-objects';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { policyId: params['policyId'] };

      axios(configs, resolve, reject);
    });
  }
}

export class AuthControllerService {
  /**
   * userLogin
   */
  static userLoginUsingPost(
    params: {
      /** userRequest */
      userRequest: UserAuth;
      /** userType */
      userType?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/login';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { userType: params['userType'] };

      let data = params['userRequest'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * userLogout
   */
  static userLogoutUsingPost(options: IRequestOptions = {}): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/logout';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * refreshtoken
   */
  static refreshtokenUsingPost(
    params: {
      /** tokenRequest */
      tokenRequest: TokenRefreshRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/refreshtoken';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['tokenRequest'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * ssoUserLogin
   */
  static ssoUserLoginUsingPost(
    params: {
      /** userRequest */
      userRequest: SSOUserAuthRequest;
      /** userType */
      userType?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/sso/login';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { userType: params['userType'] };

      let data = params['userRequest'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * userInfo
   */
  static userInfoUsingGet(options: IRequestOptions = {}): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/userInfo';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * verifyTotp
   */
  static verifyTotpUsingPost(
    params: {
      /** userRequest */
      userRequest: UserAuth;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/verify_totp';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['userRequest'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class TlxColumnMaskingPatternControllerService {
  /**
   * getAllColumnMaskingPatterns
   */
  static getAllColumnMaskingPatternsUsingGet(
    params: {
      /** type */
      type?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxColumnMaskingPatterns[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/masking_pattern';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { type: params['type'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getSupportedColumnMaskingPatterns
   */
  static getSupportedColumnMaskingPatternsUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** objectNameList */
      objectNameList: string[];
      /** policySubtype */
      policySubtype: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxColumnMaskingPatterns[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/masking_pattern/{accountId}';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { objectNameList: params['objectNameList'], policySubtype: params['policySubtype'] };

      axios(configs, resolve, reject);
    });
  }
}

export class TlxMcpControllerService {
  /**
   * handleOAuthCallback
   */
  static handleOAuthCallbackUsingGet(
    params: {
      /** code */
      code?: string;
      /** error */
      error?: string;
      /** error_description */
      errorDescription?: string;
      /** state */
      state?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/mcp/oauth/callback';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        code: params['code'],
        error: params['error'],
        error_description: params['errorDescription'],
        state: params['state']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * buildOAuthRedirect
   */
  static buildOAuthRedirectUsingPost(
    params: {
      /** request */
      request: McpOAuthRedirectRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<McpOAuthRedirectResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/mcp/redirect';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['request'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * previewMcpServer
   */
  static previewMcpServerUsingPost(
    params: {
      /** request */
      request: McpServerPreviewRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PolicyResourceRequestModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/mcp/server/preview';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['request'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getMcpUser
   */
  static getMcpUserUsingGet(options: IRequestOptions = {}): Promise<McpUserModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/mcp/user';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * createMcpUser
   */
  static createMcpUserUsingPost(
    params: {
      /** request */
      request: McpUserModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/mcp/user';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['request'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * deleteMcpUser
   */
  static deleteMcpUserUsingDelete(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/mcp/user';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * regenerateMcpApiKey
   */
  static regenerateMcpApiKeyUsingPut(options: IRequestOptions = {}): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/mcp/user/regenerate-api-key';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class MetadataControllerService {
  /**
   * getDataDomain
   */
  static getDataDomainUsingGet1(options: IRequestOptions = {}): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/metadata/data_domain';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getDisplayDataTypes
   */
  static getDisplayDataTypesUsingGet(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/metadata/display_data_types';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getResourceActions
   */
  static getResourceActionsUsingGet(
    params: {
      /** resourceIds */
      resourceIds: string[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxGenericNameIdModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/metadata/resource_actions';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { resourceIds: params['resourceIds'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getResourceAttributes
   */
  static getResourceAttributesUsingGet(
    params: {
      /** accountId */
      accountId?: string;
      /** applicationId */
      applicationId?: string;
      /** objectNames */
      objectNames?: string[];
      /** objectType */
      objectType?: string;
      /** resourceIds */
      resourceIds?: string[];
      /** resourceSourceType */
      resourceSourceType?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxGenericNameIdModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/metadata/resource_attributes';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        accountId: params['accountId'],
        applicationId: params['applicationId'],
        objectNames: params['objectNames'],
        objectType: params['objectType'],
        resourceIds: params['resourceIds'],
        resourceSourceType: params['resourceSourceType']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getApplicationRoles
   */
  static getApplicationRolesUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** applicationNames */
      applicationNames: string[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/metadata/{accountId}/applicationRoles';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { applicationNames: params['applicationNames'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getApplications
   */
  static getApplicationsUsingGet(
    params: {
      /** accountId */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ApplicationMetadata[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/metadata/{accountId}/applications';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getColumnValues
   */
  static getColumnValuesUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** columnName */
      columnName: string;
      /** workspace */
      workspace?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/metadata/{accountId}/column_values';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { columnName: params['columnName'], workspace: params['workspace'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getColumns
   */
  static getColumnsUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** databaseName */
      databaseName?: string;
      /** datasourceType */
      datasourceType?: string;
      /** dataType */
      dataType?: string;
      /** isDataAttribute */
      isDataAttribute?: boolean;
      /** operator */
      operator?: string;
      /** projectId */
      projectId?: string;
      /** schemaName */
      schemaName?: string;
      /** tableNames */
      tableNames: string;
      /** workspace */
      workspace?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ColumnMetadata[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/metadata/{accountId}/columns';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        databaseName: params['databaseName'],
        datasourceType: params['datasourceType'],
        dataType: params['dataType'],
        isDataAttribute: params['isDataAttribute'],
        operator: params['operator'],
        projectId: params['projectId'],
        schemaName: params['schemaName'],
        tableNames: params['tableNames'],
        workspace: params['workspace']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getDataProductTags
   */
  static getDataProductTagsUsingGet(
    params: {
      /** accountId */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TagMetadata[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/metadata/{accountId}/data_product';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getDatabases
   */
  static getDatabasesUsingGet3(
    params: {
      /** accountId */
      accountId: string;
      /** datasourceType */
      datasourceType?: string;
      /** domain */
      domain?: string;
      /** projectId */
      projectId?: string;
      /** workspace */
      workspace?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DatabaseMetadata[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/metadata/{accountId}/databases';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        datasourceType: params['datasourceType'],
        domain: params['domain'],
        projectId: params['projectId'],
        workspace: params['workspace']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getFunctionDescriptions
   */
  static getFunctionDescriptionsUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** functionName */
      functionName: string;
      /** workspace */
      workspace?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AccessPolicyUserDefinedFunctionModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/metadata/{accountId}/describe_function';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { functionName: params['functionName'], workspace: params['workspace'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getFunctions
   */
  static getFunctionsUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** databaseNames */
      databaseNames?: string;
      /** isMultiObject */
      isMultiObject?: string;
      /** schemaNames */
      schemaNames?: string;
      /** type */
      type?: string;
      /** workspace */
      workspace?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/metadata/{accountId}/functions';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        databaseNames: params['databaseNames'],
        isMultiObject: params['isMultiObject'],
        schemaNames: params['schemaNames'],
        type: params['type'],
        workspace: params['workspace']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getMcpServerNames
   */
  static getMcpServerNamesUsingGet(
    params: {
      /** accountId */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<McpServerDiscoveryModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/metadata/{accountId}/mcpServerName';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getObjects
   */
  static getObjectsUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** database */
      database?: string;
      /** objectType */
      objectType?: string;
      /** schemaNames */
      schemaNames?: string;
      /** workspace */
      workspace?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ObjectMetadata[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/metadata/{accountId}/objects';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        database: params['database'],
        objectType: params['objectType'],
        schemaNames: params['schemaNames'],
        workspace: params['workspace']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getPrincipals
   */
  static getPrincipalsUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** databaseNames */
      databaseNames?: string[];
      /** includeDatabaseRoles */
      includeDatabaseRoles?: boolean;
      /** includeSystemRoles */
      includeSystemRoles?: boolean;
      /** tagNames */
      tagNames?: string[];
      /** type */
      type: string;
      /** workspace */
      workspace?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/metadata/{accountId}/principals';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        databaseNames: params['databaseNames'],
        includeDatabaseRoles: params['includeDatabaseRoles'],
        includeSystemRoles: params['includeSystemRoles'],
        tagNames: params['tagNames'],
        type: params['type'],
        workspace: params['workspace']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getPrincipalsWithType
   */
  static getPrincipalsWithTypeUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** databaseNames */
      databaseNames?: string[];
      /** includeDatabaseRoles */
      includeDatabaseRoles?: boolean;
      /** includeSystemRoles */
      includeSystemRoles?: boolean;
      /** tagNames */
      tagNames?: string[];
      /** type */
      type: string;
      /** workspace */
      workspace?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PairNameUserTypeModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/metadata/{accountId}/principals_with_type';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        databaseNames: params['databaseNames'],
        includeDatabaseRoles: params['includeDatabaseRoles'],
        includeSystemRoles: params['includeSystemRoles'],
        tagNames: params['tagNames'],
        type: params['type'],
        workspace: params['workspace']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getProjectsByAccountId
   */
  static getProjectsByAccountIdUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** registered */
      registered?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DatabaseMetadata[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/metadata/{accountId}/projects';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { registered: params['registered'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getSchemas
   */
  static getSchemasUsingGet2(
    params: {
      /** accountId */
      accountId: string;
      /** databaseNames */
      databaseNames: string;
      /** datasourceType */
      datasourceType?: string;
      /** domain */
      domain?: string;
      /** enableAllSchemas */
      enableAllSchemas?: boolean;
      /** isMultiDb */
      isMultiDb?: boolean;
      /** projectId */
      projectId?: string;
      /** workspace */
      workspace?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SchemaMetadata[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/metadata/{accountId}/schemas';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        databaseNames: params['databaseNames'],
        datasourceType: params['datasourceType'],
        domain: params['domain'],
        enableAllSchemas: params['enableAllSchemas'],
        isMultiDb: params['isMultiDb'],
        projectId: params['projectId'],
        workspace: params['workspace']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getSecurityRolesInfo
   */
  static getSecurityRolesInfoUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** schemaNames */
      schemaNames: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PowerBIRoleInfoMetadata[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/metadata/{accountId}/security_role_info';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { schemaNames: params['schemaNames'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getOutBoundShares
   */
  static getOutBoundSharesUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** databaseName */
      databaseName?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/metadata/{accountId}/shares';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { databaseName: params['databaseName'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getTableRelationships
   */
  static getTableRelationshipsUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** schemaNames */
      schemaNames: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PowerBIRelationshipMetadata[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/metadata/{accountId}/table_relationships';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { schemaNames: params['schemaNames'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getTables
   */
  static getTablesUsingGet1(
    params: {
      /** accountId */
      accountId: string;
      /** database */
      database?: string;
      /** datasourceType */
      datasourceType?: string;
      /** domain */
      domain?: string;
      /** objectType */
      objectType?: string;
      /** projectId */
      projectId?: string;
      /** schemaNames */
      schemaNames?: string;
      /** search */
      search?: string;
      /** workspace */
      workspace?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TableMetadata[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/metadata/{accountId}/tables';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        database: params['database'],
        datasourceType: params['datasourceType'],
        domain: params['domain'],
        objectType: params['objectType'],
        projectId: params['projectId'],
        schemaNames: params['schemaNames'],
        search: params['search'],
        workspace: params['workspace']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getTags
   */
  static getTagsUsingGet2(
    params: {
      /** accountId */
      accountId: string;
      /** domain */
      domain?: string;
      /** includeTagValue */
      includeTagValue?: boolean;
      /** includeUnclassifiedTag */
      includeUnclassifiedTag?: boolean;
      /** policyTypeId */
      policyTypeId?: string;
      /** tagNames */
      tagNames?: string;
      /** workspace */
      workspace?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TagMetadata[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/metadata/{accountId}/tags';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        domain: params['domain'],
        includeTagValue: params['includeTagValue'],
        includeUnclassifiedTag: params['includeUnclassifiedTag'],
        policyTypeId: params['policyTypeId'],
        tagNames: params['tagNames'],
        workspace: params['workspace']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getWorkspaces
   */
  static getWorkspacesUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** registered */
      registered?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AccountWorkspaceModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/metadata/{accountId}/workspaces';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { registered: params['registered'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getPolicyResources
   */
  static getPolicyResourcesUsingGet(
    params: {
      /** applicationId */
      applicationId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DatabaseMetadata[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/metadata/{applicationId}/policy_resources';
      url = url.replace('{applicationId}', params['applicationId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class ObjectFilterMetadataControllerService {
  /**
   * getFiltersMetadata
   */
  static getFiltersMetadataUsingGet(
    params: {
      /** accountId */
      accountId?: string;
      /** accountType */
      accountType?: string;
      /** dataProduct */
      dataProduct?: string;
      /** objectName */
      objectName: string;
      /** reportType */
      reportType?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ObjectFilterMetadataResponseModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/metadata/object_filters';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        accountId: params['accountId'],
        accountType: params['accountType'],
        dataProduct: params['dataProduct'],
        objectName: params['objectName'],
        reportType: params['reportType']
      };

      axios(configs, resolve, reject);
    });
  }
}

export class PolicyDataTypeControllerService {
  /**
   * listPolicyDataTypes
   */
  static listPolicyDataTypesUsingGet(
    params: {
      /** dataObjectAccess */
      dataObjectAccess?: boolean;
      /** displayTargetScopes */
      displayTargetScopes?: boolean;
      /** reportAccess */
      reportAccess?: boolean;
      /** supportedObjectType */
      supportedObjectType?: string;
      /** type */
      type: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PolicyDataType[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/policy_data_types';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        dataObjectAccess: params['dataObjectAccess'],
        displayTargetScopes: params['displayTargetScopes'],
        reportAccess: params['reportAccess'],
        supportedObjectType: params['supportedObjectType'],
        type: params['type']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getPolicySubTypes
   */
  static getPolicySubTypesUsingGet(
    params: {
      /** dataSourceType */
      dataSourceType: string;
      /** policyDataTypeId */
      policyDataTypeId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/report/policy_sub_types';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { dataSourceType: params['dataSourceType'], policyDataTypeId: params['policyDataTypeId'] };

      axios(configs, resolve, reject);
    });
  }
}

export class PrivacyEnforcementTypeControllerService {
  /**
   * listPrivacyEnforcementTypes
   */
  static listPrivacyEnforcementTypesUsingGet(options: IRequestOptions = {}): Promise<PrivacyEnforcementType[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/privacy_enforcement_type';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class PrivilegeTemplateControllerService {
  /**
   * listPrivilegeTemplate
   */
  static listPrivilegeTemplateUsingGet(
    params: {
      /** dataSourceType */
      dataSourceType?: string[];
      /** name */
      name?: string[];
      /** page_no */
      pageNo?: number;
      /** page_size */
      pageSize?: number;
      /** search */
      search?: string;
      /** sort_by */
      sortBy?: string;
      /** sort_order */
      sortOrder?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxPaginatedResponseModel_PrivilegeTemplateModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/privilegeTemplate';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        dataSourceType: params['dataSourceType'],
        name: params['name'],
        page_no: params['pageNo'],
        page_size: params['pageSize'],
        search: params['search'],
        sort_by: params['sortBy'],
        sort_order: params['sortOrder']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * createPrivilegeTemplate
   */
  static createPrivilegeTemplateUsingPost(
    params: {
      /** templateModel */
      templateModel: PrivilegeTemplateModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/privilegeTemplate';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['templateModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * deletePrivilegeTemplate
   */
  static deletePrivilegeTemplateUsingDelete(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/privilegeTemplate';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { id: params['id'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getPrivilegeTemplateDataSources
   */
  static getPrivilegeTemplateDataSourcesUsingGet(options: IRequestOptions = {}): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/privilegeTemplate/dataSources';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getPrivilegeTemplateMetadata
   */
  static getPrivilegeTemplateMetadataUsingGet(
    params: {
      /** accountType */
      accountType: string;
      /** isDomainPrivilegeTemplate */
      isDomainPrivilegeTemplate?: boolean;
      /** objectType */
      objectType?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ObjectTypeAndPrivilegeMappingModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/privilegeTemplate/metadata';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        accountType: params['accountType'],
        isDomainPrivilegeTemplate: params['isDomainPrivilegeTemplate'],
        objectType: params['objectType']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * validateDeleteOrEditPrivilegeTemplate
   */
  static validateDeleteOrEditPrivilegeTemplateUsingPost(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/privilegeTemplate/validate';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { id: params['id'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * updatePrivilegeTemplate
   */
  static updatePrivilegeTemplateUsingPut(
    params: {
      /** preference */
      preference?: string;
      /** templateId */
      templateId: string;
      /** templateModel */
      templateModel: PrivilegeTemplateModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/privilegeTemplate/{templateId}';
      url = url.replace('{templateId}', params['templateId'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);
      configs.params = { preference: params['preference'] };

      let data = params['templateModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class PurviewControllerService {
  /**
   * getDocumentSensitivityLabels
   */
  static getDocumentSensitivityLabelsUsingPost(
    params: {
      /** request */
      request: PurviewDocumentSensitivityLabelsRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PurviewDocumentSensitivityLabelsResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/purview/documents/sensitivity_labels';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['request'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class QueryTypeRegexMappingControllerService {
  /**
   * getAll
   */
  static getAllUsingGet(options: IRequestOptions = {}): Promise<QueryTypeRegexMapping[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/query-type-regex-mappings';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * create
   */
  static createUsingPost1(
    params: {
      /** mapping */
      mapping: QueryTypeRegexMapping;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<QueryTypeRegexMapping> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/query-type-regex-mappings';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['mapping'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getById
   */
  static getByIdUsingGet(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<QueryTypeRegexMapping> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/query-type-regex-mappings/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * update
   */
  static updateUsingPut1(
    params: {
      /** id */
      id: string;
      /** mapping */
      mapping: QueryTypeRegexMapping;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<QueryTypeRegexMapping> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/query-type-regex-mappings/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['mapping'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * delete
   */
  static deleteUsingDelete1(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/query-type-regex-mappings/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class QueryContextControllerService {
  /**
   * listQueryContexts
   */
  static listQueryContextsUsingGet(
    params: {
      /** accountType */
      accountType?: string;
      /** dataObjectAccess */
      dataObjectAccess?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<QueryContext[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/query_contexts';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { accountType: params['accountType'], dataObjectAccess: params['dataObjectAccess'] };

      axios(configs, resolve, reject);
    });
  }
}

export class RecommendationPolicyControllerService {
  /**
   * getRecommendationPolicies
   */
  static getRecommendationPoliciesUsingGet(
    params: {
      /** accountId */
      accountId?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RecommendationPolicy[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/recommendation_policies';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { accountId: params['accountId'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * enableReccomendationPolicy
   */
  static enableReccomendationPolicyUsingPut(
    params: {
      /** id */
      id: string;
      /** status */
      status: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/recommendation_policies/{id}/activate/{status}';
      url = url.replace('{id}', params['id'] + '');
      url = url.replace('{status}', params['status'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class ReleaseInfoControllerService {
  /**
   * getLatestVersions
   */
  static getLatestVersionsUsingGet(options: IRequestOptions = {}): Promise<UnifiedReleasesWrapper> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/releases/latest';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class RiskThresholdControllerService {
  /**
   * Get all risk thresholds for a tenant
   */
  static getRiskThresholdsUsingGet(options: IRequestOptions = {}): Promise<RiskThresholdResponse[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/risk_threshold';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Create a new risk threshold
   */
  static createRiskThresholdUsingPost(
    params: {
      /** request */
      request: RiskThresholdRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RiskThresholdResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/risk_threshold';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['request'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get a risk threshold by ID
   */
  static getRiskThresholdByIdUsingGet(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RiskThresholdResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/risk_threshold/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Update a risk threshold by ID
   */
  static updateRiskThresholdUsingPut(
    params: {
      /** id */
      id: string;
      /** request */
      request: RiskThresholdRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RiskThresholdResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/risk_threshold/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['request'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Delete a risk threshold by ID
   */
  static deleteRiskThresholdUsingDelete(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/risk_threshold/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class RoleControllerService {
  /**
   * getRoles
   */
  static getRolesUsingGet(options: IRequestOptions = {}): Promise<Role[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/role';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class ScimTokenControllerService {
  /**
   * getServiceProviderConfig
   */
  static getServiceProviderConfigUsingGet(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/scim/v2/ServiceProviderConfig';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * generateToken
   */
  static generateTokenUsingPost(
    params: {
      /** tokenType */
      tokenType?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/scim/v2/token';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { tokenType: params['tokenType'] };

      axios(configs, resolve, reject);
    });
  }
}

export class SiemIntegrationToolControllerService {
  /**
   * listSiemIntegrationTool
   */
  static listSiemIntegrationToolUsingGet(options: IRequestOptions = {}): Promise<SiemIntegrationTool[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/siemintegrationtool';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class SnowflakeControllerService {
  /**
   * reviewPolicy
   */
  static reviewPolicyUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** id */
      id: string;
      /** includeViewAccessGrants */
      includeViewAccessGrants?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/snowflake/{accountId}/access_policies/{id}/review_policy';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { includeViewAccessGrants: params['includeViewAccessGrants'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getMultiTableColumns
   */
  static getMultiTableColumnsUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** isDataAttribute */
      isDataAttribute?: boolean;
      /** tableName */
      tableName: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SnowflakeColumn[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/snowflake/{accountId}/columns';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { isDataAttribute: params['isDataAttribute'], tableName: params['tableName'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getDatabases
   */
  static getDatabasesUsingGet4(
    params: {
      /** accountId */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SnowflakeDatabase[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/snowflake/{accountId}/databases';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getFunctions
   */
  static getFunctionsUsingGet1(
    params: {
      /** accountId */
      accountId: string;
      /** databaseNames */
      databaseNames: string;
      /** isMultiObject */
      isMultiObject?: string;
      /** schemaNames */
      schemaNames: string;
      /** type */
      type?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/snowflake/{accountId}/functions';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        databaseNames: params['databaseNames'],
        isMultiObject: params['isMultiObject'],
        schemaNames: params['schemaNames'],
        type: params['type']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getRoles
   */
  static getRolesUsingGet1(
    params: {
      /** accountId */
      accountId: string;
      /** databases */
      databases?: string[];
      /** includeSystemRoles */
      includeSystemRoles?: boolean;
      /** tags */
      tags?: string[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/snowflake/{accountId}/roles';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        databases: params['databases'],
        includeSystemRoles: params['includeSystemRoles'],
        tags: params['tags']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getSchemas
   */
  static getSchemasUsingGet4(
    params: {
      /** accountId */
      accountId: string;
      /** databaseName */
      databaseName: string;
      /** dataObjectAccess */
      dataObjectAccess?: string;
      /** isMultiDb */
      isMultiDb?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SnowflakeSchema[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/snowflake/{accountId}/schemas';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        databaseName: params['databaseName'],
        dataObjectAccess: params['dataObjectAccess'],
        isMultiDb: params['isMultiDb']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getOutBoundShares
   */
  static getOutBoundSharesUsingGet1(
    params: {
      /** accountId */
      accountId: string;
      /** databaseName */
      databaseName?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/snowflake/{accountId}/shares';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { databaseName: params['databaseName'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getSnowflakeObjects
   */
  static getSnowflakeObjectsUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** objectTypes */
      objectTypes: string[];
      /** schemaNames */
      schemaNames?: string[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/snowflake/{accountId}/snowflake_objects';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { objectTypes: params['objectTypes'], schemaNames: params['schemaNames'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getTableColumns
   */
  static getTableColumnsUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** databaseName */
      databaseName: string;
      /** schemaName */
      schemaName: string;
      /** tableName */
      tableName: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PolicyTableStructure> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/snowflake/{accountId}/table_details';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        databaseName: params['databaseName'],
        schemaName: params['schemaName'],
        tableName: params['tableName']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getTables
   */
  static getTablesUsingGet2(
    params: {
      /** accountId */
      accountId: string;
      /** databaseName */
      databaseName: string;
      /** dataObjectAccess */
      dataObjectAccess?: string;
      /** includeView */
      includeView?: string;
      /** isMultiObject */
      isMultiObject?: string;
      /** schemaName */
      schemaName?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SnowflakeTable[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/snowflake/{accountId}/tables';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        databaseName: params['databaseName'],
        dataObjectAccess: params['dataObjectAccess'],
        includeView: params['includeView'],
        isMultiObject: params['isMultiObject'],
        schemaName: params['schemaName']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getTaggedDatabases
   */
  static getTaggedDatabasesUsingGet(
    params: {
      /** accountId */
      accountId: string;
      /** tags */
      tags: string[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/snowflake/{accountId}/taggedDatabases';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { tags: params['tags'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getTags
   */
  static getTagsUsingGet3(
    params: {
      /** accountId */
      accountId: string;
      /** domain */
      domain?: string;
      /** isTagValue */
      isTagValue?: boolean;
      /** tableTagNames */
      tableTagNames?: string;
      /** type */
      type?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SnowflakeTag[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/snowflake/{accountId}/tags';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        domain: params['domain'],
        isTagValue: params['isTagValue'],
        tableTagNames: params['tableTagNames'],
        type: params['type']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getUsers
   */
  static getUsersUsingGet(
    params: {
      /** accountId */
      accountId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/snowflake/{accountId}/users';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * getViews
   */
  static getViewsUsingGet1(
    params: {
      /** accountId */
      accountId: string;
      /** databaseNames */
      databaseNames: string;
      /** isMultiObject */
      isMultiObject?: string;
      /** schemaNames */
      schemaNames: string;
      /** type */
      type?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/snowflake/{accountId}/views';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        databaseNames: params['databaseNames'],
        isMultiObject: params['isMultiObject'],
        schemaNames: params['schemaNames'],
        type: params['type']
      };

      axios(configs, resolve, reject);
    });
  }
}

export class GoogleSsoControllerService {
  /**
   * redirectToGoogle
   */
  static redirectToGoogleUsingGet(
    params: {
      /** tenantId */
      tenantId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/sso/google/{tenantId}';
      url = url.replace('{tenantId}', params['tenantId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class TrustAiSsmKeyControllerService {
  /**
   * getTrustAiSsmKeys
   */
  static getTrustAiSsmKeysUsingGet(options: IRequestOptions = {}): Promise<SsmKeySource[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/trustai/ssm-keys';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class TrustAiFabricErrorLogControllerService {
  /**
   * listErrorLogs
   */
  static listErrorLogsUsingGet(
    params: {
      /** endDate */
      endDate?: string;
      /** errorType */
      errorType?: string;
      /** mcpServerId */
      mcpServerId?: string;
      /** page_no */
      pageNo?: number;
      /** page_size */
      pageSize?: number;
      /** sort_order */
      sortOrder?: string;
      /** startDate */
      startDate?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxPaginatedResponseModel_TrustAiFabricErrorLogModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/trustai_fabric_errors';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        endDate: params['endDate'],
        errorType: params['errorType'],
        mcpServerId: params['mcpServerId'],
        page_no: params['pageNo'],
        page_size: params['pageSize'],
        sort_order: params['sortOrder'],
        startDate: params['startDate']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * createErrorLog
   */
  static createErrorLogUsingPost(
    params: {
      /** request */
      request: TrustAiFabricErrorLogRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/trustai_fabric_errors';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['request'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class UnifiedIcebergInventoryControllerService {
  /**
   * listInventories
   */
  static listInventoriesUsingGet(
    params: {
      /** catalog */
      catalog?: string;
      /** namespace */
      namespace?: string;
      /** page_no */
      pageNo?: number;
      /** page_size */
      pageSize?: number;
      /** platform */
      platform?: string;
      /** sort_by */
      sortBy?: string;
      /** sort_order */
      sortOrder?: string;
      /** table_format */
      tableFormat?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxPaginatedResponseModel_UnifiedIcebergInventoryModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/unified-iceberg-inventory';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        catalog: params['catalog'],
        namespace: params['namespace'],
        page_no: params['pageNo'],
        page_size: params['pageSize'],
        platform: params['platform'],
        sort_by: params['sortBy'],
        sort_order: params['sortOrder'],
        table_format: params['tableFormat']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * createInventory
   */
  static createInventoryUsingPost(
    params: {
      /** inventoryRequest */
      inventoryRequest: UnifiedIcebergInventoryModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/unified-iceberg-inventory';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['inventoryRequest'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getInventoryByStorageLocation
   */
  static getInventoryByStorageLocationUsingGet(
    params: {
      /** catalog */
      catalog?: string;
      /** format */
      format?: string;
      /** platform */
      platform?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/unified-iceberg-inventory/by-storage-location';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { catalog: params['catalog'], format: params['format'], platform: params['platform'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * getInventoryById
   */
  static getInventoryByIdUsingGet(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/unified-iceberg-inventory/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * updateInventory
   */
  static updateInventoryUsingPut(
    params: {
      /** id */
      id: string;
      /** inventoryRequest */
      inventoryRequest: UnifiedIcebergInventoryModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/unified-iceberg-inventory/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['inventoryRequest'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * deleteInventory
   */
  static deleteInventoryUsingDelete(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/unified-iceberg-inventory/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class UnifiedLakehousePoliciesService {
  /**
   * List Unified Lakehouse policies
   */
  static listPoliciesUsingGet1(
    params: {
      /** canonicalObject */
      canonicalObject?: string;
      /** Coverage status filter. Allowed values: Fully Covered, Drift Detected, Not Covered */
      coverageStatus?: string;
      /** dataSourceId */
      dataSourceId?: string;
      /** id */
      id?: string;
      /** page */
      page?: number;
      /** policyStatus */
      policyStatus?: string;
      /** policyType */
      policyType?: string;
      /** search */
      search?: string;
      /** size */
      size?: number;
      /** updatedAfter */
      updatedAfter?: string;
      /** updatedBefore */
      updatedBefore?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxPaginatedResponseModel_UnifiedLakeHousePolicyListItemResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/unified_lakehouse/policies';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        canonicalObject: params['canonicalObject'],
        coverageStatus: params['coverageStatus'],
        dataSourceId: params['dataSourceId'],
        id: params['id'],
        page: params['page'],
        policyStatus: params['policyStatus'],
        policyType: params['policyType'],
        search: params['search'],
        size: params['size'],
        updatedAfter: params['updatedAfter'],
        updatedBefore: params['updatedBefore']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Create Unified Lakehouse policy
   */
  static createPolicyUsingPost(
    params: {
      /** policyModel */
      policyModel: DataAccessPolicyModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/unified_lakehouse/policies';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['policyModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * List canonical names for Unified Lakehouse RBAC
   */
  static getCanonicalNamesUsingGet(
    params: {
      /** limit */
      limit?: number;
      /** search */
      search?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/unified_lakehouse/policies/canonical-names';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { limit: params['limit'], search: params['search'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Fetch deployable Unified Lakehouse RBAC policies
   */
  static getDeployablePoliciesUsingGet(
    params: {
      /** accountId */
      accountId?: string;
      /** limit */
      limit?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/unified_lakehouse/policies/deployable_policy';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { accountId: params['accountId'], limit: params['limit'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Fetch CP mapping deltas for drift detection (Policy Sync Service)
   */
  static fetchMappingDeltasUsingGet(
    params: {
      /** accountId */
      accountId?: string;
      /** lastCheckpoint */
      lastCheckpoint: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/unified_lakehouse/policies/drift/mappings/delta';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { accountId: params['accountId'], lastCheckpoint: params['lastCheckpoint'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Search ULH policies by canonical names (Policy Sync Service)
   */
  static fetchPoliciesByCanonicalNamesUsingPost(
    params: {
      /** accountId */
      accountId?: string;
      /** canonicalNames */
      canonicalNames: any | null[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/unified_lakehouse/policies/drift/policies/search/by_canonical_names';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { accountId: params['accountId'] };

      let data = params['canonicalNames'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Auto-process ULH policy drift (Policy Sync Service)
   */
  static autoProcessDriftUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** action */
      action: string;
      /** policyId */
      policyId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url =
        basePath + '/api/unified_lakehouse/policies/drift/policies/{policyId}/accounts/{accountId}/auto_process_drift';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{policyId}', params['policyId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { action: params['action'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Mark ULH policy drift (Policy Sync Service)
   */
  static markPolicyDriftUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** driftDetails */
      driftDetails: object;
      /** policyId */
      policyId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/unified_lakehouse/policies/drift/policies/{policyId}/accounts/{accountId}/mark_drift';
      url = url.replace('{accountId}', params['accountId'] + '');
      url = url.replace('{policyId}', params['policyId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['driftDetails'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Fetch deployable Unified Lakehouse RBAC policies
   */
  static getDeployablePoliciesUsingGet1(
    params: {
      /** accountId */
      accountId?: string;
      /** limit */
      limit?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/unified_lakehouse/policies/published_policy';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { accountId: params['accountId'], limit: params['limit'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Update Unified Lakehouse policy
   */
  static updatePolicyUsingPut(
    params: {
      /** id */
      id: string;
      /** policyModel */
      policyModel: DataAccessPolicyModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/unified_lakehouse/policies/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['policyModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Delete Unified Lakehouse RBAC policy
   */
  static deletePolicyUsingDelete(
    params: {
      /** consent */
      consent?: boolean;
      /** id */
      id: string;
      /** includeViewAccessGrants */
      includeViewAccessGrants?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/unified_lakehouse/policies/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { consent: params['consent'], includeViewAccessGrants: params['includeViewAccessGrants'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Record Unified Lakehouse RBAC deployment results. Optional accountId for incremental per-account status reporting.
   */
  static deployPolicyUsingPost1(
    params: {
      /** accountId */
      accountId?: string;
      /** id */
      id: string;
      /** request */
      request: UnifiedLakeHouseAccessPolicyDeployRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/unified_lakehouse/policies/{id}/deploy_policy';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { accountId: params['accountId'] };

      let data = params['request'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Disable Unified Lakehouse RBAC policy
   */
  static disablePolicyUsingDelete(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/unified_lakehouse/policies/{id}/disable';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Discard Unified Lakehouse RBAC draft policy
   */
  static discardDraftPolicyUsingDelete(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/unified_lakehouse/policies/{id}/discard_draft';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Enable Unified Lakehouse RBAC policy
   */
  static enablePolicyUsingPut(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/unified_lakehouse/policies/{id}/enable';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Publish Unified Lakehouse policy
   */
  static publishPolicyUsingPost3(
    params: {
      /** deltaDeploy */
      deltaDeploy?: boolean;
      /** id */
      id: string;
      /** includeViewAccessGrants */
      includeViewAccessGrants?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/unified_lakehouse/policies/{id}/publish_policy';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = {
        deltaDeploy: params['deltaDeploy'],
        includeViewAccessGrants: params['includeViewAccessGrants']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Initiate a Unified Lakehouse RBAC redeploy
   */
  static redeployPolicyUsingPut(
    params: {
      /** accountId */
      accountId?: string;
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/unified_lakehouse/policies/{id}/redeploy_policy';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);
      configs.params = { accountId: params['accountId'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Review Unified Lakehouse policy
   */
  static reviewPolicyUsingPost3(
    params: {
      /** deltaDeploy */
      deltaDeploy?: boolean;
      /** id */
      id: string;
      /** includeViewAccessGrants */
      includeViewAccessGrants?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/unified_lakehouse/policies/{id}/review_policy';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = {
        deltaDeploy: params['deltaDeploy'],
        includeViewAccessGrants: params['includeViewAccessGrants']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get Unified Lakehouse policy details by policyId
   */
  static getPolicyByIdUsingGet(
    params: {
      /** Optional account filter. Returns grant rows only for this accountId. */
      accountId?: string;
      /** Optional grant deployment status filter (case-insensitive), e.g. POLICY_DEPLOYED, POLICY_DEPLOYMENT_FAILED. */
      grantStatus?: string;
      /** When false, omits grant rows and returns policy summary only. */
      includeGrants?: boolean;
      /** Optional platform filter (case-insensitive), e.g. DATABRICKS, DREMIO, SNOWFLAKE. */
      platform?: string;
      /** policyId */
      policyId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/unified_lakehouse/policies/{policyId}';
      url = url.replace('{policyId}', params['policyId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        accountId: params['accountId'],
        grantStatus: params['grantStatus'],
        includeGrants: params['includeGrants'],
        platform: params['platform']
      };

      axios(configs, resolve, reject);
    });
  }
}

export class RoleProvisionPolicyControllerService {
  /**
   * deployProvisioningPolicy
   */
  static deployProvisioningPolicyUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** roleProvisioningModel */
      roleProvisioningModel: RoleProvisioningModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_entitlement/{accountId}/role_provision';
      url = url.replace('{accountId}', params['accountId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['roleProvisioningModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class UserPolicyControllerService {
  /**
   * saveUserPolicyDetails
   */
  static saveUserPolicyDetailsUsingPost(
    params: {
      /** accountId */
      accountId: string;
      /** deleteExistingRecords */
      deleteExistingRecords?: boolean;
      /** userPolicyModelList */
      userPolicyModelList: UserPolicyModel[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_policy';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { accountId: params['accountId'], deleteExistingRecords: params['deleteExistingRecords'] };

      let data = params['userPolicyModelList'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class UserPreferenceControllerService {
  /**
   * Get all of the caller's preferences
   */
  static getAllPreferencesUsingGet(options: IRequestOptions = {}): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_preferences';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Delete all of the caller's preferences; idempotent
   */
  static deleteAllPreferencesUsingDelete(options: IRequestOptions = {}): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_preferences';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * List the currently valid preferenceType values
   */
  static getAvailablePreferenceTypesUsingGet(options: IRequestOptions = {}): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_preferences/types';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get a single preference; returns value: null if never set
   */
  static getPreferenceUsingGet(
    params: {
      /** preferenceType */
      preferenceType: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_preferences/{preferenceType}';
      url = url.replace('{preferenceType}', params['preferenceType'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Upsert a preference's value
   */
  static upsertPreferenceUsingPut(
    params: {
      /** preferenceType */
      preferenceType: string;
      /** requestBody */
      requestBody: UserPreferenceRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_preferences/{preferenceType}';
      url = url.replace('{preferenceType}', params['preferenceType'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['requestBody'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Delete a preference; idempotent
   */
  static deletePreferenceUsingDelete(
    params: {
      /** preferenceType */
      preferenceType: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user_preferences/{preferenceType}';
      url = url.replace('{preferenceType}', params['preferenceType'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class UtilityScriptDownloadControllerService {
  /**
   * listUtilityScripts
   */
  static listUtilityScriptsUsingGet(options: IRequestOptions = {}): Promise<UtilityScriptResponse[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/utility-scripts';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * downloadUtilityScript
   */
  static downloadUtilityScriptUsingGet(
    params: {
      /** scriptDescriptorName */
      scriptDescriptorName: string;
      /** version */
      version?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/utility-scripts/download';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { scriptDescriptorName: params['scriptDescriptorName'], version: params['version'] };

      axios(configs, resolve, reject);
    });
  }
}

export class GlobalAccountsService {
  /**
   * Query global accounts
   */
  static queryAccountsUsingGet(
    params: {
      /** Filter by account ID */
      accountId?: string;
      /** Filter by application team */
      appTeam?: string;
      /** Filter by database type (sqlserver, oracle, mysql, etc.) */
      dbType?: string;
      /** Filter by active status (true/false) */
      isActive?: boolean;
      /** Page number (default: 1) */
      pageNo?: number;
      /** Page size (default: 50, max: 500) */
      pageSize?: number;
      /** Filter by service type */
      svcType?: string;
      /** Filter by service username */
      svcUsername?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GlobalTrustedAccountResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/global-accounts';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        account_id: params['accountId'],
        app_team: params['appTeam'],
        db_type: params['dbType'],
        is_active: params['isActive'],
        page_no: params['pageNo'],
        page_size: params['pageSize'],
        svc_type: params['svcType'],
        svc_username: params['svcUsername']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get account ID list
   */
  static getAccountIdListUsingGet(
    params: {
      /** Filter by database type (can be specified multiple times) */
      dbType?: string[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GlobalAccountIdListResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/global-accounts/account-idlist';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { db_type: params['dbType'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Health check
   */
  static healthCheckUsingGet(options: IRequestOptions = {}): Promise<GlobalAccountHealthResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/global-accounts/health';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Ingest global accounts data
   */
  static ingestAccountsUsingPost(
    params: {
      /** Global accounts ingestion request */
      ingestRequest: GlobalAccountIngestRequestModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GlobalAccountIngestResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/global-accounts/ingest';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['ingestRequest'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Ingest global accounts in batch mode
   */
  static ingestAccountsBatchUsingPost(
    params: {
      /** Global accounts ingestion request */
      ingestRequest: GlobalAccountIngestRequestModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GlobalAccountIngestResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/global-accounts/ingest/batch';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['ingestRequest'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get batch ingestion status
   */
  static getBatchStatusUsingGet(
    params: {
      /** Batch ID to check status */
      batchId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GlobalAccountBatchStatusResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/global-accounts/ingest/status/{batch_id}';
      url = url.replace('{batch_id}', params['batchId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Save global trusted accounts
   */
  static saveGlobalTrustedAccountsUsingPost(
    params: {
      /** Account ID */
      accountId: string;
      /** Delete existing records for this tenant+account before inserting (default: true) */
      deleteExistingRecords?: boolean;
      /** List of global trusted account records */
      records: GlobalAccountRecordModel[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/global-accounts/trusted-accounts';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { accountId: params['accountId'], deleteExistingRecords: params['deleteExistingRecords'] };

      let data = params['records'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class UnifiedLakehouseService {
  /**
   * Get catalog master data hierarchy
   */
  static getCatalogMasterDataUsingGet(
    params: {
      /** If true, return fully expanded hierarchy from root to specified path. Default is false. */
      expandHierarchy?: boolean;
      /** Page number (1-based) */
      pageNo?: number;
      /** Page size */
      pageSize?: number;
      /** Path filter to query specific level (e.g., 'catalog' or 'catalog.schema') */
      path?: string[];
      /** Search term to filter catalog items */
      search?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxPaginatedResponseModel_CatalogMasterDataModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/unified_lakehouse/catalog/masterdata';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        expandHierarchy: params['expandHierarchy'],
        page_no: params['pageNo'],
        page_size: params['pageSize'],
        path: params['path'],
        search: params['search']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Query catalog entries
   */
  static getCatalogsUsingGet(
    params: {
      /** List of canonical names (fully qualified or partial, e.g., 'cat.folder', 'cat2.folder2.tbl') */
      canonicalName?: string[];
      /** Page number (1-based) */
      pageNo?: number;
      /** Page size */
      pageSize?: number;
      /** Sort field */
      sortBy?: string;
      /** Sort order (ASC or DESC) */
      sortOrder?: string;
      /** Storage location filter (partial match) */
      storageLocation?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxPaginatedResponseModel_CatalogResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/unified_lakehouse/catalogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        canonicalName: params['canonicalName'],
        pageNo: params['pageNo'],
        pageSize: params['pageSize'],
        sortBy: params['sortBy'],
        sortOrder: params['sortOrder'],
        storageLocation: params['storageLocation']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get entitlement attribute columns
   */
  static getEntitlementAttributesUsingGet(
    params: {
      /** List of canonical names (fully qualified or partial, e.g., 'snowflake:db.schema.table') */
      databaseObjects?: string[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<EntitlementAttributeColumnModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/unified_lakehouse/entitlement/attribute';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { databaseObjects: params['databaseObjects'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * syncIcebergInventory
   */
  static syncIcebergInventoryUsingPost(
    params: {
      /** syncRequest */
      syncRequest: IcebergInventorySyncRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/unified_lakehouse/iceberg-inventory/sync';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['syncRequest'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * List principal role canonical mappings
   */
  static getRoleMappingsUsingGet(options: IRequestOptions = {}): Promise<PrincipalRoleMappingResponseModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/unified_lakehouse/role-mappings';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get role mappings list
   */
  static getRolesUsingGet2(
    params: {
      /** Response should have mapping details for these platforms (optional) */
      mapping?: boolean;
      /** Role name filters  */
      name?: string[];
      /** Page number (1-based) */
      pageNo?: number;
      /** Page size */
      pageSize?: number;
      /** search on canonical role name */
      search?: string;
      /** Sort field */
      sortBy?: string;
      /** Sort order (ASC or DESC) */
      sortOrder?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxPaginatedResponseModel_RoleMappingListResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/unified_lakehouse/roles';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        mapping: params['mapping'],
        name: params['name'],
        pageNo: params['pageNo'],
        pageSize: params['pageSize'],
        search: params['search'],
        sortBy: params['sortBy'],
        sortOrder: params['sortOrder']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Save role metadata
   */
  static saveRoleUsingPost(
    params: {
      /** Role metadata to save (do not include tenant_id - it is auto-extracted from JWT) */
      roleModel: UnifiedLakeHouseRoleModel[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UnifiedLakeHouseRoleModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/unified_lakehouse/roles';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['roleModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Delete stale roles
   */
  static cleanupStaleRolesUsingDelete(
    params: {
      /** Account ID */
      accountId: string;
      /** Delete records detected before this timestamp (ISO-8601) */
      beforeTimestamp: string;
      /** Platform (dremio|snowflake|databricks) */
      platform: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/unified_lakehouse/roles/cleanup';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = {
        accountId: params['accountId'],
        beforeTimestamp: params['beforeTimestamp'],
        platform: params['platform']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Resolve a canonical role to its per-account/platform rows
   */
  static resolveRoleUsingGet(
    params: {
      /** Role name to resolve */
      roleName: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AccountRoleMapping[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/unified_lakehouse/roles/resolve';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { roleName: params['roleName'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Query tables
   */
  static getTablesUsingGet3(
    params: {
      /** Account ID filter */
      accountId?: string;
      /** Catalog name filter */
      catalogName?: string;
      /** Page number (0-based) */
      page?: number;
      /** Platform filter (dremio|snowflake|databricks) */
      platform?: string;
      /** Schema name filter */
      schemaName?: string;
      /** Page size */
      size?: number;
      /** Storage location/path filter */
      storageLocation?: string;
      /** Table name filter */
      tableName?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Page_UnifiedLakeHouseTableResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/unified_lakehouse/tables';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        accountId: params['accountId'],
        catalogName: params['catalogName'],
        page: params['page'],
        platform: params['platform'],
        schemaName: params['schemaName'],
        size: params['size'],
        storageLocation: params['storageLocation'],
        tableName: params['tableName']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Save table metadata
   */
  static saveTableUsingPost(
    params: {
      /** Table metadata to save (do not include tenant_id - it is auto-extracted from JWT) */
      tableModel: UnifiedLakeHouseTableModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UnifiedLakeHouseTableModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/unified_lakehouse/tables';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['tableModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Delete stale tables
   */
  static cleanupStaleTablesUsingDelete(
    params: {
      /** Account ID */
      accountId: string;
      /** Delete records detected before this timestamp (ISO-8601) */
      beforeTimestamp: string;
      /** Platform (dremio|snowflake|databricks) */
      platform: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/unified_lakehouse/tables/cleanup';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = {
        accountId: params['accountId'],
        beforeTimestamp: params['beforeTimestamp'],
        platform: params['platform']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get unique storage locations
   */
  static getUniqueStorageLocationsUsingGet(
    params: {
      /** Account ID filter */
      accountId?: string;
      /** Platform filter (dremio|snowflake|databricks) */
      platform?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/unified_lakehouse/tables/storage-locations';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { accountId: params['accountId'], platform: params['platform'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get table mapping by storage location
   */
  static getStorageMappingUsingGet(
    options: IRequestOptions = {}
  ): Promise<UnifiedLakeHouseTableMappingResponseModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/unified_lakehouse/tables/storage-mapping';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * List principal user canonical mappings
   */
  static getUserMappingsUsingGet(options: IRequestOptions = {}): Promise<PrincipalUserMappingResponseModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/unified_lakehouse/user-mappings';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Query users
   */
  static getUsersUsingGet1(
    params: {
      /** Account ID filter */
      accountId?: string;
      /** Email filter */
      email?: string;
      /** Page number (0-based) */
      page?: number;
      /** Platform filter (dremio|snowflake|databricks) */
      platform?: string;
      /** Page size */
      size?: number;
      /** Username filter */
      userName?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Page_UnifiedLakeHouseUserResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/unified_lakehouse/users';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        accountId: params['accountId'],
        email: params['email'],
        page: params['page'],
        platform: params['platform'],
        size: params['size'],
        userName: params['userName']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Save user metadata
   */
  static saveUserUsingPost(
    params: {
      /** User metadata to save (do not include tenant_id - it is auto-extracted from JWT) */
      userModel: UnifiedLakeHouseUserModel[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UnifiedLakeHouseUserModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/unified_lakehouse/users';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['userModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Delete stale users
   */
  static cleanupStaleUsersUsingDelete(
    params: {
      /** Account ID */
      accountId: string;
      /** Delete records detected before this timestamp (ISO-8601) */
      beforeTimestamp: string;
      /** Platform (dremio|snowflake|databricks) */
      platform: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/unified_lakehouse/users/cleanup';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = {
        accountId: params['accountId'],
        beforeTimestamp: params['beforeTimestamp'],
        platform: params['platform']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Resolve a canonical user to its per-account/platform rows
   */
  static resolveUserUsingGet(
    params: {
      /** Login username to resolve */
      userName: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AccountUserMapping[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v1/unified_lakehouse/users/resolve';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { userName: params['userName'] };

      axios(configs, resolve, reject);
    });
  }
}

export class TrustAiBoardControllerService {
  /**
   * Get the audit evidence
   */
  static listAuditEvidenceUsingGet(options: IRequestOptions = {}): Promise<AuditEvidence[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/trustai/audit-evidence';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get the priority controls
   */
  static listPriorityControlsUsingGet(options: IRequestOptions = {}): Promise<PriorityControl[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/trustai/controls';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get the decision panel of a control
   */
  static getControlDecisionUsingGet(
    params: {
      /** controlId */
      controlId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ControlDecision> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/trustai/controls/{controlId}/decision';
      url = url.replace('{controlId}', params['controlId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Enforce a control
   */
  static enforcePolicyUsingPost(
    params: {
      /** body */
      body: ControlEnforcementRequestModel;
      /** controlId */
      controlId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ControlEnforcement> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/trustai/controls/{controlId}/enforce';
      url = url.replace('{controlId}', params['controlId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get the verified outcomes of a control
   */
  static getVerifiedOutcomesUsingGet(
    params: {
      /** controlId */
      controlId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<VerifiedOutcomes> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/trustai/controls/{controlId}/outcomes';
      url = url.replace('{controlId}', params['controlId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Start an evaluation
   */
  static startEvaluationUsingPost(options: IRequestOptions = {}): Promise<Readiness> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/trustai/evaluation';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get the relevant intelligence
   */
  static listRelevantIntelligenceUsingGet(options: IRequestOptions = {}): Promise<Advisory[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/trustai/intelligence';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Start an onboarding run
   */
  static startOnboardingRunUsingPost(
    params: {
      /** body */
      body: OnboardingRunRequestModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Readiness> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/trustai/onboarding-run';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get the enterprise posture
   */
  static getEnterprisePostureUsingGet(options: IRequestOptions = {}): Promise<Posture> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/trustai/posture';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get the estate readiness
   */
  static getEstateReadinessUsingGet(options: IRequestOptions = {}): Promise<Readiness> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/trustai/readiness';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get what changed since the previous evaluation
   */
  static getWhatsChangedUsingGet(options: IRequestOptions = {}): Promise<WhatsChanged> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/trustai/whats-changed';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class TlxRegistrationControllerService {
  /**
   * AWS Marketplace Setup API
   */
  static redirectToSetupUsingPost(
    params: {
      /** formData */
      formData: object;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/aws/setup';

      const configs: IRequestConfig = getConfigs('post', 'application/x-www-form-urlencoded', url, options);

      let data = params['formData'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Resend Verification Email API
   */
  static resendVerificationEmailUsingGet(
    params: {
      /** token */
      token: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/internal/resend_verification_email';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { token: params['token'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Reset tenant user password
   */
  static resetTenantUserPasswordUsingPut(
    params: {
      /** resetUserPassword */
      resetUserPassword: ResetUserPassword;
      /** token */
      token: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/internal/reset_password';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);
      configs.params = { token: params['token'] };

      let data = params['resetUserPassword'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * AWS Marketplace Signup API
   */
  static signupUsingPost(
    params: {
      /** signupModel */
      signupModel: SignupModel;
      /** token */
      token: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/internal/signup';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { token: params['token'] };

      let data = params['signupModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Verify Email API
   */
  static verifyEmailUsingGet(
    params: {
      /** token */
      token: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/internal/verify_email';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { token: params['token'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Tenant Provision API
   */
  static provisionUsingPost(
    params: {
      /** features */
      features: object;
      /** tenantId */
      tenantId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/private/provision';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { tenantId: params['tenantId'] };

      let data = params['features'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Snowflake Native App Signup API
   */
  static tlxSignupUsingPost(
    params: {
      /** signupModel */
      signupModel: SignupModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/tlx/internal/signup';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['signupModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * TrustLogix Website Signup API
   */
  static tlxWebsiteSignupUsingPost(
    params: {
      /** signupModel */
      signupModel: SignupModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TlxHttpResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/tlx/website/signup';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['signupModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class ScimUsersControllerService {
  /**
   * getAllUsers
   */
  static getAllUsersUsingGet(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/scim/v2/Users';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * createUser
   */
  static createUserUsingPost(
    params: {
      /** scimUser */
      scimUser: SCIMUserModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SCIMUserModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/scim/v2/Users';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['scimUser'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * getUser
   */
  static getUserUsingGet(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SCIMUserModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/scim/v2/Users/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * updateUser
   */
  static updateUserUsingPut(
    params: {
      /** id */
      id: string;
      /** scimPatchOpModel */
      scimPatchOpModel: SCIMUserModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SCIMUserModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/scim/v2/Users/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params['scimPatchOpModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * deleteUser
   */
  static deleteUserUsingDelete(
    params: {
      /** id */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/scim/v2/Users/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/scim+json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * updateUserUsingPatch
   */
  static updateUserUsingPatchUsingPatch(
    params: {
      /** id */
      id: string;
      /** scimPatchOpModel */
      scimPatchOpModel: ScimPatchOpModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SCIMUserModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/scim/v2/Users/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('patch', 'application/json', url, options);

      /** 适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body */

      console.warn('适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body');

      let data = params['scimPatchOpModel'];

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

/** AWSAccountInfo */
export interface AWSAccountInfo {
  /**  */
  arn?: string;

  /**  */
  email?: string;

  /**  */
  id?: string;

  /**  */
  joinedMethod?: string;

  /**  */
  joinedTimestamp?: string;

  /**  */
  name?: string;

  /**  */
  status?: string;
}

/** AccessPolicyUserDefinedFunctionModel */
export interface AccessPolicyUserDefinedFunctionModel {
  /**  */
  accountId?: string;

  /**  */
  arguments?: FunctionArgumentModel[];

  /**  */
  dataSourceType?: string;

  /**  */
  databaseName?: string;

  /**  */
  description?: string;

  /**  */
  displayName?: string;

  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  returnType?: string;

  /**  */
  schemaName?: string;

  /**  */
  tenantId?: string;

  /**  */
  workspace?: string;
}

/** Account */
export interface Account {
  /**  */
  accountIds?: string[];

  /**  */
  accountStatus?: string;

  /**  */
  authType?: string;

  /**  */
  awsAccountId?: string;

  /**  */
  blobAccountName?: string;

  /**  */
  blobContainerName?: string;

  /**  */
  clusterName?: string;

  /**  */
  configParameters?: string;

  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  dataClassificationScheme?: string;

  /**  */
  databaseIdentifier?: string;

  /**  */
  dbName?: string;

  /**  */
  dbPassword?: string;

  /**  */
  dbUsername?: string;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  edition?: string;

  /**  */
  exchangeAudience?: string;

  /**  */
  externalCatalog?: boolean;

  /**  */
  externalId?: string;

  /**  */
  id?: string;

  /**  */
  jdbcConnectionUrl?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  mappingAttributes?: EntityAttributeMapping[];

  /**  */
  metastoreId?: string;

  /**  */
  name?: string;

  /**  */
  oauthAuthzEndpoint?: string;

  /**  */
  oauthClientId?: string;

  /**  */
  oauthRedirectEndpoint?: string;

  /**  */
  oauthTenantId?: string;

  /**  */
  oauthTokenEndpoint?: string;

  /**  */
  privateKeyFileName?: string;

  /**  */
  region?: string;

  /**  */
  roleArn?: string;

  /**  */
  roleName?: string;

  /**  */
  s3RawDataBucketName?: string;

  /**  */
  sasToken?: string;

  /**  */
  scope?: string;

  /**  */
  serviceAccountId?: string;

  /**  */
  servicesDeployed?: boolean;

  /**  */
  siUserName?: string;

  /**  */
  stageName?: string;

  /**  */
  storageIntegrationName?: string;

  /**  */
  subtype?: string;

  /**  */
  tenantId?: string;

  /**  */
  type?: string;

  /**  */
  userId?: string;

  /**  */
  username?: string;

  /**  */
  warehouse?: string;

  /**  */
  workspace?: string;
}

/** AccountConfigurationFeatureModel */
export interface AccountConfigurationFeatureModel {
  /**  */
  configurationKey?: string;

  /**  */
  configurationValue?: boolean;
}

/** AccountDIWatermarkModel */
export interface AccountDIWatermarkModel {
  /**  */
  metadata?: string;

  /**  */
  watermarkTimestamp?: Date;
}

/** AccountExternalSourceAttributeDetailsModel */
export interface AccountExternalSourceAttributeDetailsModel {
  /**  */
  account?: AccountModel;

  /**  */
  externalSourceConfigurationDetails?: ExternalSourceConfigurationDetails[];
}

/** AccountModel */
export interface AccountModel {
  /**  */
  accountIds?: string[];

  /**  */
  accountStatus?: string;

  /**  */
  alertCount?: number;

  /**  */
  attributeMapping?: EntityMappingModel[];

  /**  */
  authType?: string;

  /**  */
  awsAccountId?: string;

  /**  */
  blobAccountName?: string;

  /**  */
  blobContainerName?: string;

  /**  */
  clusterName?: string;

  /**  */
  configParameters?: string;

  /**  */
  dataAccessPolicyCount?: number;

  /**  */
  dataClassificationScheme?: string;

  /**  */
  databaseIdentifier?: string;

  /**  */
  dbName?: string;

  /**  */
  dbPassword?: string;

  /**  */
  dbUsername?: string;

  /**  */
  description?: string;

  /**  */
  edition?: string;

  /**  */
  exchangeAudience?: string;

  /**  */
  externalCatalog?: boolean;

  /**  */
  externalId?: string;

  /**  */
  id?: string;

  /**  */
  integrationEnabled?: boolean;

  /**  */
  jdbcConnectionUrl?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  metastoreId?: string;

  /**  */
  monitoringPolicyCount?: number;

  /**  */
  name?: string;

  /**  */
  notificationErrorsCount?: number;

  /**  */
  oauthAuthzEndpoint?: string;

  /**  */
  oauthClientId?: string;

  /**  */
  oauthClientSecret?: string;

  /**  */
  oauthTenantId?: string;

  /**  */
  oauthTokenEndpoint?: string;

  /**  */
  passphrase?: string;

  /**  */
  password?: string;

  /**  */
  privateKey?: string;

  /**  */
  privateKeyFileName?: string;

  /**  */
  region?: string;

  /**  */
  roleArn?: string;

  /**  */
  roleName?: string;

  /**  */
  s3RawDataBucketName?: string;

  /**  */
  sasToken?: string;

  /**  */
  scope?: string;

  /**  */
  serviceAccountId?: string;

  /**  */
  servicesDeployed?: boolean;

  /**  */
  siUserName?: string;

  /**  */
  stageName?: string;

  /**  */
  storageIntegrationName?: string;

  /**  */
  subtype?: string;

  /**  */
  tenantId?: string;

  /**  */
  type?: string;

  /**  */
  userId?: string;

  /**  */
  username?: string;

  /**  */
  warehouse?: string;

  /**  */
  workspace?: string;
}

/** AccountObjectPrivilegeModel */
export interface AccountObjectPrivilegeModel {
  /**  */
  createdDate?: string;

  /**  */
  databaseName?: string;

  /**  */
  grantOption?: string;

  /**  */
  grantedBy?: string;

  /**  */
  granteeName?: string;

  /**  */
  lastModifiedDate?: string;

  /**  */
  objectName?: string;

  /**  */
  objectPrivileges?: string;

  /**  */
  objectType?: string;

  /**  */
  principalType?: string;

  /**  */
  schemaName?: string;

  /**  */
  source?: string;

  /**  */
  workspaceId?: string;

  /**  */
  workspaceName?: string;
}

/** AccountPolicySyncJob */
export interface AccountPolicySyncJob {
  /**  */
  abacImpactedObjects?: string;

  /**  */
  abacPolicyIds?: string;

  /**  */
  accountId?: string;

  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;

  /**  */
  onDemandSyncTriggered?: boolean;

  /**  */
  rbacImpactedObjects?: string;

  /**  */
  rbacPolicyIds?: string;

  /**  */
  status?: string;
}

/** AccountRole */
export interface AccountRole {
  /**  */
  grantedRoles?: AccountRole[];

  /**  */
  grantedToRoles?: AccountRole[];

  /**  */
  name?: string;
}

/** AccountRoleMapping */
export interface AccountRoleMapping {
  /**  */
  account_id?: string;

  /**  */
  owner?: string;

  /**  */
  platform?: string;

  /**  */
  role_id?: string;

  /**  */
  role_name?: string;

  /**  */
  role_type?: string;
}

/** AccountRolesHierarchyModel */
export interface AccountRolesHierarchyModel {
  /**  */
  grantedRole?: string;

  /**  */
  granteeRoleName?: string;

  /**  */
  level?: number;

  /**  */
  source?: string;
}

/** AccountSubtypeModel */
export interface AccountSubtypeModel {
  /**  */
  description?: string;

  /**  */
  name?: string;
}

/** AccountTag */
export interface AccountTag {
  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;

  /**  */
  tagDatabase?: string;

  /**  */
  tagSchema?: string;

  /**  */
  tagValues?: string;
}

/** AccountTagAssociationEditDeleteModel */
export interface AccountTagAssociationEditDeleteModel {
  /**  */
  columnName?: string;

  /**  */
  domain?: EnumAccountTagAssociationEditDeleteModelDomain;

  /**  */
  id?: string;

  /**  */
  newColumnName?: string;

  /**  */
  newObjectDatabase?: string;

  /**  */
  newObjectName?: string;

  /**  */
  newObjectSchema?: string;

  /**  */
  newTagDatabase?: string;

  /**  */
  newTagKey?: string;

  /**  */
  newTagSchema?: string;

  /**  */
  newTagValue?: string;

  /**  */
  objectDatabase?: string;

  /**  */
  objectName?: string;

  /**  */
  objectSchema?: string;

  /**  */
  tagDatabase?: string;

  /**  */
  tagKey?: string;

  /**  */
  tagSchema?: string;

  /**  */
  tagValue?: string;

  /**  */
  workspace?: string;
}

/** AccountTagAssociationModel */
export interface AccountTagAssociationModel {
  /**  */
  columnName?: string[];

  /**  */
  domain?: EnumAccountTagAssociationModelDomain;

  /**  */
  isSystemTag?: boolean;

  /**  */
  objectDatabase?: string[];

  /**  */
  objectName?: string[];

  /**  */
  objectSchema?: string[];

  /**  */
  tagDatabase?: string;

  /**  */
  tagKey?: string;

  /**  */
  tagSchema?: string;

  /**  */
  tagValue?: string;

  /**  */
  workspace?: string;
}

/** AccountTagEditModel */
export interface AccountTagEditModel {
  /**  */
  newTagName?: string;

  /**  */
  newTagValues?: string;

  /**  */
  tagDatabase?: string;

  /**  */
  tagName?: string;

  /**  */
  tagSchema?: string;

  /**  */
  tagValues?: string;
}

/** AccountTagModel */
export interface AccountTagModel {
  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedDate?: string;

  /**  */
  name?: string;

  /**  */
  tagDatabase?: string;

  /**  */
  tagOwner?: string;

  /**  */
  tagSchema?: string;

  /**  */
  tagValues?: string;

  /**  */
  workspace?: string;
}

/** AccountTagReferenceBulkCreateRequest */
export interface AccountTagReferenceBulkCreateRequest {
  /**  */
  tagReferences?: AccountTagReferenceModel[];
}

/** AccountTagReferenceModel */
export interface AccountTagReferenceModel {
  /**  */
  accountTag?: AccountTagModel;

  /**  */
  columnName?: string;

  /**  */
  columnType?: string;

  /**  */
  description?: string;

  /**  */
  domain: EnumAccountTagReferenceModelDomain;

  /**  */
  id?: string;

  /**  */
  isSystemTag?: boolean;

  /**  */
  objectDatabase: string;

  /**  */
  objectName: string;

  /**  */
  objectSchema: string;

  /**  */
  tagDatabase: string;

  /**  */
  tagKey: string;

  /**  */
  tagSchema: string;

  /**  */
  tagValue: string;

  /**  */
  workspace?: string;
}

/** AccountTagReferenceUpdateRequest */
export interface AccountTagReferenceUpdateRequest {
  /**  */
  current: AccountTagReferenceModel;

  /**  */
  updated: AccountTagReferenceModel;
}

/** AccountUserMapping */
export interface AccountUserMapping {
  /**  */
  account_id?: string;

  /**  */
  display_name?: string;

  /**  */
  email?: string;

  /**  */
  is_active?: boolean;

  /**  */
  platform?: string;

  /**  */
  user_id?: string;

  /**  */
  user_name?: string;
}

/** AccountUserModel */
export interface AccountUserModel {
  /**  */
  createdDate?: string;

  /**  */
  deletedDate?: string;

  /**  */
  disabled?: boolean;

  /**  */
  expiresAt?: string;

  /**  */
  groupName?: string;

  /**  */
  lastSuccessLogin?: string;

  /**  */
  mfaEnabled?: boolean;

  /**  */
  name?: string;

  /**  */
  owner?: string;

  /**  */
  passwordEnabled?: boolean;

  /**  */
  rsaEnabled?: boolean;

  /**  */
  source?: string;

  /**  */
  type?: string;

  /**  */
  userType?: string;

  /**  */
  workSpaceId?: string;

  /**  */
  workSpaceName?: string;
}

/** AccountUsersRoleMappingModel */
export interface AccountUsersRoleMappingModel {
  /**  */
  createdDate?: string;

  /**  */
  deletedDate?: string;

  /**  */
  grantedBy?: string;

  /**  */
  grantedTo?: string;

  /**  */
  granteeName?: string;

  /**  */
  role?: string;

  /**  */
  source?: string;
}

/** AccountWorkspaceModel */
export interface AccountWorkspaceModel {
  /**  */
  deploymentName?: string;

  /**  */
  id?: string;

  /**  */
  name?: string;
}

/** Actions */
export interface Actions {
  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;

  /**  */
  similarActions?: ActionsModel[];

  /**  */
  supportedFields?: string;

  /**  */
  type?: string;
}

/** ActionsModel */
export interface ActionsModel {
  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;

  /**  */
  type?: string;
}

/** AdminAuthSecurityModel */
export interface AdminAuthSecurityModel {
  /**  */
  lockoutTimeInMin?: number;

  /**  */
  maxFailedAttempts?: number;
}

/** AdminConfigurationKey */
export interface AdminConfigurationKey {
  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;
}

/** Advisory */
export interface Advisory {
  /**  */
  customerRelevance?: string;

  /**  */
  dateLabel?: string;

  /**  */
  exposures?: AdvisoryExposure[];

  /**  */
  exposuresDisclaimer?: string;

  /**  */
  facts?: AdvisoryFact[];

  /**  */
  guardianInterpretation?: string;

  /**  */
  id?: string;

  /**  */
  impactStatus?: string;

  /**  */
  matchingTechnologies?: string[];

  /**  */
  recommendations?: AdvisoryRecommendation[];

  /**  */
  relatedResources?: string[];

  /**  */
  relevance?: string;

  /**  */
  shortTitle?: string;

  /**  */
  signals?: AdvisorySignal[];

  /**  */
  signalsDisclaimer?: string;

  /**  */
  signalsHeadline?: string;

  /**  */
  sourceLabel?: string;

  /**  */
  sourceUrl?: string;

  /**  */
  title?: string;

  /**  */
  version?: string;

  /**  */
  whatHappened?: string;

  /**  */
  whatHappenedHeadline?: string;
}

/** AdvisoryExposure */
export interface AdvisoryExposure {
  /**  */
  appliedStatus?: string;

  /**  */
  appliedSummary?: string;

  /**  */
  count?: number;

  /**  */
  id?: string;

  /**  */
  label?: string;

  /**  */
  status?: string;

  /**  */
  summary?: string;
}

/** AdvisoryFact */
export interface AdvisoryFact {
  /**  */
  detail?: string;

  /**  */
  label?: string;

  /**  */
  value?: string;
}

/** AdvisoryRecommendation */
export interface AdvisoryRecommendation {
  /**  */
  items?: string[];

  /**  */
  phase?: string;
}

/** AdvisorySignal */
export interface AdvisorySignal {
  /**  */
  detail?: string;

  /**  */
  id?: string;

  /**  */
  title?: string;
}

/** AgentAccessRevocationModel */
export interface AgentAccessRevocationModel {
  /**  */
  accessRevoked: boolean;

  /**  */
  agentIds: string[];
}

/** AgentAttributeDefinition */
export interface AgentAttributeDefinition {
  /**  */
  allowedValues?: string;

  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  dataType?: string;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  displayName?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;

  /**  */
  type?: string;
}

/** AgentAttributeModel */
export interface AgentAttributeModel {
  /**  */
  allowedValues?: string[];

  /**  */
  createdAt?: Date;

  /**  */
  dataType?: string;

  /**  */
  description?: string;

  /**  */
  displayName?: string;

  /**  */
  id?: string;

  /**  */
  modifiedAt?: Date;

  /**  */
  name?: string;

  /**  */
  type?: string;

  /**  */
  value?: object;

  /**  */
  valueModifiedAt?: Date;
}

/** AgentAttributeUpsertRequestModel */
export interface AgentAttributeUpsertRequestModel {
  /**  */
  allowedValues?: string[];

  /**  */
  dataType?: string;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  name?: string;
}

/** AgentAttributeValue */
export interface AgentAttributeValue {
  /**  */
  attribute?: AgentAttributeDefinition;

  /**  */
  createdAt?: Date;

  /**  */
  deleted?: boolean;

  /**  */
  id?: string;

  /**  */
  modifiedAt?: Date;

  /**  */
  valueBoolean?: boolean;

  /**  */
  valueNumber?: number;

  /**  */
  valueString?: string;
}

/** AgentAttributeValueItemRequestModel */
export interface AgentAttributeValueItemRequestModel {
  /**  */
  attributeId?: string;

  /**  */
  value?: object;
}

/** AgentAttributeValueModel */
export interface AgentAttributeValueModel {
  /**  */
  attributeId?: string;

  /**  */
  dataType?: string;

  /**  */
  displayName?: string;

  /**  */
  isImported?: boolean;

  /**  */
  multiValue?: boolean;

  /**  */
  name?: string;

  /**  */
  value?: object;
}

/** AgentAttributeValueRequestModel */
export interface AgentAttributeValueRequestModel {
  /**  */
  value?: object;
}

/** AgentCountsModel */
export interface AgentCountsModel {
  /**  */
  attentionRequired?: number;

  /**  */
  notEvaluatedCount?: number;

  /**  */
  notSecureCount?: number;

  /**  */
  ready?: number;

  /**  */
  secureCount?: number;

  /**  */
  securePercent?: number;

  /**  */
  setupRequired?: number;

  /**  */
  totalAgents?: number;

  /**  */
  unknown?: number;
}

/** AgentDefinitionModel */
export interface AgentDefinitionModel {
  /**  */
  createdDate?: Date;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  instructions?: string;

  /**  */
  isLatest?: boolean;

  /**  */
  lastConfirmedAt?: Date;

  /**  */
  name?: string;

  /**  */
  platform?: AgentDefinitionPlatformModel;

  /**  */
  tools?: object[];

  /**  */
  version?: number;
}

/** AgentDefinitionPlatformModel */
export interface AgentDefinitionPlatformModel {
  /**  */
  displayId?: string;

  /**  */
  externalAgentId?: string;

  /**  */
  externalProjectId?: string;

  /**  */
  identityTags?: object;

  /**  */
  kind?: string;

  /**  */
  logo?: string;

  /**  */
  model?: string;

  /**  */
  modified_at?: string;

  /**  */
  name?: EnumAgentDefinitionPlatformModelName;

  /**  */
  state?: string;

  /**  */
  version?: string;
}

/** AgentDetailsModel */
export interface AgentDetailsModel {
  /**  */
  agentRegistryId?: string;

  /**  */
  agentRegistryName?: string;

  /**  */
  attributes?: AgentAttributeValueModel[];

  /**  */
  createdDate?: Date;

  /**  */
  definition?: AgentDefinitionModel;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  identity?: object;

  /**  */
  isImported?: boolean;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  lastSyncedAt?: string;

  /**  */
  mcpServerBindings?: AgentMcpServerBindingModel[];

  /**  */
  name?: string;

  /**  */
  state?: string;

  /**  */
  type?: string;
}

/** AgentEnforcementPathModel */
export interface AgentEnforcementPathModel {
  /**  */
  kind?: EnumAgentEnforcementPathModelKind;

  /**  */
  reason?: EnumAgentEnforcementPathModelReason;

  /**  */
  serviceId?: string;

  /**  */
  serviceName?: string;

  /**  */
  state?: EnumAgentEnforcementPathModelState;
}

/** AgentEnforcementReadinessModel */
export interface AgentEnforcementReadinessModel {
  /**  */
  agentRoutedThroughEnforcement?: boolean;

  /**  */
  environmentConfigured?: boolean;

  /**  */
  method?: EnumAgentEnforcementReadinessModelMethod;

  /**  */
  paths?: AgentEnforcementPathModel[];

  /**  */
  reason?: EnumAgentEnforcementReadinessModelReason;

  /**  */
  routingObserved?: boolean;

  /**  */
  status?: EnumAgentEnforcementReadinessModelStatus;
}

/** AgentEnvironmentModel */
export interface AgentEnvironmentModel {
  /**  */
  health?: EnumAgentEnvironmentModelHealth;

  /**  */
  id?: string;

  /**  */
  identityProvider?: EnumAgentEnvironmentModelIdentityProvider;

  /**  */
  name?: string;

  /**  */
  platform?: EnumAgentEnvironmentModelPlatform;

  /**  */
  projects?: TlxGenericNameIdModel[];

  /**  */
  startedAt?: string;

  /**  */
  totalAgents?: number;
}

/** AgentIntentGenerationCurrentModel */
export interface AgentIntentGenerationCurrentModel {
  /**  */
  active?: AgentIntentGenerationModel;

  /**  */
  latest?: AgentIntentGenerationModel;
}

/** AgentIntentGenerationModel */
export interface AgentIntentGenerationModel {
  /**  */
  createdDate?: Date;

  /**  */
  definitionVersion?: number;

  /**  */
  id?: string;

  /**  */
  inputHash?: string;

  /**  */
  intentDocument?: object;

  /**  */
  intentType?: EnumAgentIntentGenerationModelIntentType;

  /**  */
  mission?: object;

  /**  */
  name?: string;

  /**  */
  reason?: string;

  /**  */
  status?: EnumAgentIntentGenerationModelStatus;

  /**  */
  toolsConfidence?: string;
}

/** AgentIntentGenerationRequestModel */
export interface AgentIntentGenerationRequestModel {
  /**  */
  definitionVersion?: number;

  /**  */
  inputHash: string;

  /**  */
  intentDocument?: object;

  /**  */
  intentType: string;

  /**  */
  mission?: object;

  /**  */
  name?: string;

  /**  */
  reason?: string;

  /**  */
  status: string;

  /**  */
  toolsConfidence?: string;
}

/** AgentInventory */
export interface AgentInventory {
  /**  */
  lastImportedAt?: string;

  /**  */
  lastSyncedAt?: string;

  /**  */
  source?: EnumAgentInventorySource;
}

/** AgentMcpServerBindingModel */
export interface AgentMcpServerBindingModel {
  /**  */
  agentApplicationId?: string;

  /**  */
  agentName?: string;

  /**  */
  effect?: EnumAgentMcpServerBindingModelEffect;

  /**  */
  id?: string;

  /**  */
  mcpServerApplicationId: string;

  /**  */
  mcpServerName?: string;

  /**  */
  noPolicy?: boolean;

  /**  */
  policyMetadata?: RegoPolicy;

  /**  */
  policyStatus?: string;

  /**  */
  rootPolicyId?: string;

  /**  */
  rules?: AgentPolicyRuleModel[];

  /**  */
  scope?: EnumAgentMcpServerBindingModelScope;

  /**  */
  status?: EnumAgentMcpServerBindingModelStatus;

  /**  */
  toolNames?: string[];
}

/** AgentMcpServerBindingRequestModel */
export interface AgentMcpServerBindingRequestModel {
  /**  */
  agentApplicationId: string;

  /**  */
  mcpServerApplicationIds?: string[];
}

/** AgentMissionModel */
export interface AgentMissionModel {
  /**  */
  candidates?: object[];

  /**  */
  confidence?: object;

  /**  */
  confirmedAt?: string;

  /**  */
  confirmedBy?: string;

  /**  */
  contextChanges?: object[];

  /**  */
  description?: string;

  /**  */
  evidence?: object[];

  /**  */
  history?: HistoryModel[];

  /**  */
  inferenceUnavailable?: boolean;

  /**  */
  lastReviewedAt?: string;

  /**  */
  name?: string;

  /**  */
  purposeCategory?: EnumAgentMissionModelPurposeCategory;

  /**  */
  source?: EnumAgentMissionModelSource;

  /**  */
  status?: EnumAgentMissionModelStatus;

  /**  */
  suggestedMission?: object;

  /**  */
  synthesis?: string;
}

/** AgentNativePolicyLogicModel */
export interface AgentNativePolicyLogicModel {
  /**  */
  effect: EnumAgentNativePolicyLogicModelEffect;

  /**  */
  rule?: string;

  /**  */
  subject?: string;
}

/** AgentNativePolicyModel */
export interface AgentNativePolicyModel {
  /**  */
  createdAt?: string;

  /**  */
  current?: AgentNativePolicyLogicModel;

  /**  */
  deployedAt?: string;

  /**  */
  engine?: string;

  /**  */
  environmentId?: string;

  /**  */
  expected?: AgentNativePolicyLogicModel;

  /**  */
  failure?: string;

  /**  */
  groupId?: string;

  /**  */
  id?: string;

  /**  */
  modifiedAt?: string;

  /**  */
  name?: string;

  /**  */
  parentDefinitionId?: string;

  /**  */
  parentDefinitionName?: string;

  /**  */
  registryServerId?: string;

  /**  */
  resource?: AgentPolicyMcpServerTargetModel;

  /**  */
  source?: EnumAgentNativePolicyModelSource;

  /**  */
  state?: EnumAgentNativePolicyModelState;

  /**  */
  target?: EnumAgentNativePolicyModelTarget;

  /**  */
  targetKey?: string;
}

/** AgentPolicyAccessPathModel */
export interface AgentPolicyAccessPathModel {
  /**  */
  hops?: AgentPolicyFindingModel[];

  /**  */
  id?: string;

  /**  */
  label?: string;
}

/** AgentPolicyAgentModel */
export interface AgentPolicyAgentModel {
  /**  */
  applicability?: EnumAgentPolicyAgentModelApplicability;

  /**  */
  applicabilityUnresolved?: boolean;

  /**  */
  businessUnit?: string;

  /**  */
  gaps?: AgentPolicyGapModel[];

  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  pendingPolicyIds?: string[];

  /**  */
  policyIds?: string[];

  /**  */
  readiness?: AgentEnforcementReadinessModel;

  /**  */
  reason?: EnumAgentPolicyAgentModelReason;

  /**  */
  remainingGapCount?: number;

  /**  */
  status?: EnumAgentPolicyAgentModelStatus;

  /**  */
  statusAfter?: EnumAgentPolicyAgentModelStatusAfter;

  /**  */
  statusBefore?: EnumAgentPolicyAgentModelStatusBefore;

  /**  */
  targets?: AgentPolicyTargetsModel;
}

/** AgentPolicyAppliesToModel */
export interface AgentPolicyAppliesToModel {
  /**  */
  agentCount?: number;

  /**  */
  label?: string;
}

/** AgentPolicyApplyModel */
export interface AgentPolicyApplyModel {
  /**  */
  actualCoverageChanges?: CoverageChangesModel;

  /**  */
  affectedAgentCount?: number;

  /**  */
  agents?: AgentPolicyAgentModel[];

  /**  */
  applicationPlan?: ApplicationPlanModel;

  /**  */
  appliedAt?: string;

  /**  */
  cohort?: CohortModel;

  /**  */
  coverageAfter?: AgentCountsModel;

  /**  */
  coverageBefore?: AgentCountsModel;

  /**  */
  enforcement?: AgentCountsModel;

  /**  */
  id?: string;

  /**  */
  implementationPlan?: ImplementationPlanModel;

  /**  */
  implementations?: AgentPolicyImplementationModel[];

  /**  */
  newlySecureCount?: number;

  /**  */
  plan?: ApplyPlanModel;

  /**  */
  policies?: AgentPolicyItemModel[];

  /**  */
  results?: AgentPolicyItemModel[];

  /**  */
  scopeAgentCount?: number;

  /**  */
  sourceAgentCount?: number;

  /**  */
  targetedAgentCount?: number;
}

/** AgentPolicyBatchResponseModel */
export interface AgentPolicyBatchResponseModel {
  /**  */
  failed?: number;

  /**  */
  results?: Result[];

  /**  */
  succeeded?: number;

  /**  */
  total?: number;
}

/** AgentPolicyCatalogItemModel */
export interface AgentPolicyCatalogItemModel {
  /**  */
  applicability?: EnumAgentPolicyCatalogItemModelApplicability;

  /**  */
  applicabilityReason?: string;

  /**  */
  category?: string;

  /**  */
  controls?: AgentPolicyControlModel[];

  /**  */
  description?: string;

  /**  */
  enforcement?: AgentCountsModel;

  /**  */
  frameworks?: string[];

  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  recommendationStrength?: EnumAgentPolicyCatalogItemModelRecommendationStrength;

  /**  */
  requirement?: AgentPolicyRequirementModel;

  /**  */
  scope?: string;

  /**  */
  targets?: AgentPolicyTargetsModel;

  /**  */
  technology?: string;

  /**  */
  whyRecommended?: string;
}

/** AgentPolicyConditionModel */
export interface AgentPolicyConditionModel {
  /**  */
  attribute?: Attribute;

  /**  */
  columnRules?: AgentPolicyConditionModel[];

  /**  */
  conditionId?: string;

  /**  */
  conditionName?: string;

  /**  */
  conjunction?: string;

  /**  */
  elementDataType?: string;

  /**  */
  elementName?: string;

  /**  */
  elementType?: string;

  /**  */
  id?: string;

  /**  */
  matchWith?: MatchWith;

  /**  */
  operator?: Option;

  /**  */
  ruleSequenceNumber?: number;

  /**  */
  value?: object;

  /**  */
  valueType?: string;
}

/** AgentPolicyContextModel */
export interface AgentPolicyContextModel {
  /**  */
  agentId?: string;

  /**  */
  groupId?: string;

  /**  */
  pathId?: string;

  /**  */
  type?: EnumAgentPolicyContextModelType;
}

/** AgentPolicyControlModel */
export interface AgentPolicyControlModel {
  /**  */
  derivedFrom?: string;

  /**  */
  label?: string;

  /**  */
  sense?: EnumAgentPolicyControlModelSense;
}

/** AgentPolicyDataControlModel */
export interface AgentPolicyDataControlModel {
  /**  */
  description?: string;

  /**  */
  detail?: string;

  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  status?: EnumAgentPolicyDataControlModelStatus;
}

/** AgentPolicyDataEnforcementModel */
export interface AgentPolicyDataEnforcementModel {
  /**  */
  agentIds?: string[];

  /**  */
  controls?: AgentPolicyDataControlModel[];

  /**  */
  name?: string;

  /**  */
  platform?: string;

  /**  */
  platformId?: string;

  /**  */
  sourceId?: string;

  /**  */
  status?: EnumAgentPolicyDataEnforcementModelStatus;
}

/** AgentPolicyDataSourceTargetModel */
export interface AgentPolicyDataSourceTargetModel {
  /**  */
  controlCount?: number;

  /**  */
  id?: string;

  /**  */
  name?: string;
}

/** AgentPolicyDraftModel */
export interface AgentPolicyDraftModel {
  /**  */
  category?: string;

  /**  */
  controls?: AgentPolicyControlModel[];

  /**  */
  id?: string;

  /**  */
  intent?: string;

  /**  */
  intentSummary?: string;

  /**  */
  suggestedName?: string;

  /**  */
  technology?: string;

  /**  */
  unmatchedTerms?: string[];
}

/** AgentPolicyEffectiveEnforcementModel */
export interface AgentPolicyEffectiveEnforcementModel {
  /**  */
  agents?: AgentPolicyEnforcedAgentsModel;

  /**  */
  applied?: boolean;

  /**  */
  context?: AgentPolicyContextModel;

  /**  */
  contextLabel?: string;

  /**  */
  coverage?: AgentPolicyTargetsModel;

  /**  */
  dataSources?: AgentPolicyDataEnforcementModel[];

  /**  */
  findings?: AgentPolicyFindingModel[];

  /**  */
  mcpServers?: AgentPolicyMcpEnforcementModel[];

  /**  */
  path?: AgentPolicyAccessPathModel;

  /**  */
  policy?: AgentPolicyIntentModel;

  /**  */
  status?: EnumAgentPolicyEffectiveEnforcementModelStatus;
}

/** AgentPolicyEnforcedAgentsModel */
export interface AgentPolicyEnforcedAgentsModel {
  /**  */
  effective?: AgentPolicyAgentModel[];

  /**  */
  recommended?: AgentPolicyAgentModel[];
}

/** AgentPolicyEnforcementDetailModel */
export interface AgentPolicyEnforcementDetailModel {
  /**  */
  allowed?: string[];

  /**  */
  blocked?: string[];

  /**  */
  enforcementLayer?: string;

  /**  */
  resource?: string;

  /**  */
  toolGroups?: string[];
}

/** AgentPolicyFindingModel */
export interface AgentPolicyFindingModel {
  /**  */
  agentNames?: string[];

  /**  */
  control?: string;

  /**  */
  detail?: string;

  /**  */
  id?: string;

  /**  */
  label?: string;

  /**  */
  layer?: EnumAgentPolicyFindingModelLayer;

  /**  */
  resource?: string;

  /**  */
  status?: EnumAgentPolicyFindingModelStatus;
}

/** AgentPolicyGapModel */
export interface AgentPolicyGapModel {
  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  recommendationId?: string;

  /**  */
  resource?: string;

  /**  */
  title?: string;

  /**  */
  toolNames?: string[];
}

/** AgentPolicyHistoryEventModel */
export interface AgentPolicyHistoryEventModel {
  /**  */
  count?: number;

  /**  */
  id?: string;

  /**  */
  kind?: EnumAgentPolicyHistoryEventModelKind;

  /**  */
  label?: string;

  /**  */
  occurredAt?: string;
}

/** AgentPolicyImplementationCountsModel */
export interface AgentPolicyImplementationCountsModel {
  /**  */
  dataControls?: number;

  /**  */
  deployed?: number;

  /**  */
  failed?: number;

  /**  */
  mcpServerPolicies?: number;

  /**  */
  modified?: number;

  /**  */
  tlxDeployed?: number;

  /**  */
  tlxPolicies?: number;

  /**  */
  toolPolicies?: number;

  /**  */
  total?: number;
}

/** AgentPolicyImplementationGroupModel */
export interface AgentPolicyImplementationGroupModel {
  /**  */
  controlCount?: number;

  /**  */
  deployedCount?: number;

  /**  */
  engine?: string;

  /**  */
  failedCount?: number;

  /**  */
  id?: string;

  /**  */
  modifiedCount?: number;

  /**  */
  name?: string;

  /**  */
  platform?: string;

  /**  */
  platformId?: string;

  /**  */
  policies?: AgentNativePolicyModel[];

  /**  */
  registryServerId?: string;

  /**  */
  serverPolicyCount?: number;

  /**  */
  state?: EnumAgentPolicyImplementationGroupModelState;

  /**  */
  technology?: string;

  /**  */
  toolPolicyCount?: number;
}

/** AgentPolicyImplementationModel */
export interface AgentPolicyImplementationModel {
  /**  */
  alignment?: EnumAgentPolicyImplementationModelAlignment;

  /**  */
  counts?: AgentPolicyImplementationCountsModel;

  /**  */
  definitionId?: string;

  /**  */
  definitionName?: string;

  /**  */
  definitionState?: EnumAgentPolicyImplementationModelDefinitionState;

  /**  */
  environmentId?: string;

  /**  */
  failed?: AgentNativePolicyModel[];

  /**  */
  groups?: AgentPolicyImplementationGroupModel[];

  /**  */
  history?: AgentPolicyHistoryEventModel[];

  /**  */
  implementationState?: EnumAgentPolicyImplementationModelImplementationState;

  /**  */
  inFlight?: boolean;

  /**  */
  modified?: AgentNativePolicyModel[];

  /**  */
  run?: AgentPolicyRunModel;

  /**  */
  steps?: AgentPolicyStepModel[];
}

/** AgentPolicyIntentModel */
export interface AgentPolicyIntentModel {
  /**  */
  allow?: string[];

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  restrict?: string[];
}

/** AgentPolicyItemModel */
export interface AgentPolicyItemModel {
  /**  */
  agentIds?: string[];

  /**  */
  agents?: AgentPolicyAgentModel[];

  /**  */
  alreadyAppliedCount?: number;

  /**  */
  applicability?: EnumAgentPolicyItemModelApplicability;

  /**  */
  applicabilityReason?: string;

  /**  */
  appliedAt?: string;

  /**  */
  category?: string;

  /**  */
  contextLabel?: string;

  /**  */
  controls?: AgentPolicyControlModel[];

  /**  */
  definitionState?: EnumAgentPolicyItemModelDefinitionState;

  /**  */
  description?: string;

  /**  */
  effect?: EnumAgentPolicyItemModelEffect;

  /**  */
  enforcement?: AgentCountsModel;

  /**  */
  enforcementMethod?: string;

  /**  */
  enforcementTargets?: AgentPolicyTargetsModel;

  /**  */
  excludedAgentCount?: number;

  /**  */
  exclusions?: AgentPolicyAgentModel[];

  /**  */
  frameworks?: string[];

  /**  */
  implementationPlan?: ImplementationPlanModel;

  /**  */
  intent?: AgentPolicyIntentModel;

  /**  */
  intentBased?: boolean;

  /**  */
  isDraft?: boolean;

  /**  */
  name?: string;

  /**  */
  newlySecureCount?: number;

  /**  */
  outcome?: string;

  /**  */
  ownerAgentId?: string;

  /**  */
  policyId?: string;

  /**  */
  policyName?: string;

  /**  */
  policyState?: EnumAgentPolicyItemModelPolicyState;

  /**  */
  reason?: string;

  /**  */
  recommendation?: AgentPolicyReviewRecommendationModel;

  /**  */
  requirement?: AgentPolicyRequirementModel;

  /**  */
  scopeAgentCount?: number;

  /**  */
  state?: string;

  /**  */
  status?: string;

  /**  */
  summary?: string;
}

/** AgentPolicyMcpEnforcementModel */
export interface AgentPolicyMcpEnforcementModel {
  /**  */
  agentIds?: string[];

  /**  */
  customToolCount?: number;

  /**  */
  name?: string;

  /**  */
  registryServerId?: string;

  /**  */
  serverId?: string;

  /**  */
  serverPolicy?: AgentPolicyToolEnforcementModel;

  /**  */
  status?: EnumAgentPolicyMcpEnforcementModelStatus;

  /**  */
  technology?: string;

  /**  */
  tools?: AgentPolicyToolEnforcementModel[];
}

/** AgentPolicyMcpServerTargetModel */
export interface AgentPolicyMcpServerTargetModel {
  /**  */
  classification?: string;

  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  platform?: string;

  /**  */
  platformId?: string;

  /**  */
  serverId?: string;

  /**  */
  serverName?: string;

  /**  */
  technology?: string;

  /**  */
  toolCount?: number;
}

/** AgentPolicyOpaInputModel */
export interface AgentPolicyOpaInputModel {
  /**  */
  agentPolicyEnabled?: boolean;

  /**  */
  bindings?: AgentMcpServerBindingModel[];
}

/** AgentPolicyRecommendationModel */
export interface AgentPolicyRecommendationModel {
  /**  */
  advisory?: boolean;

  /**  */
  appliesTo?: AgentPolicyAppliesToModel;

  /**  */
  category?: string;

  /**  */
  controls?: AgentPolicyControlModel[];

  /**  */
  enforcement?: AgentPolicyEnforcementDetailModel;

  /**  */
  enforcementReadiness?: AgentCountsModel;

  /**  */
  enforcementTargets?: AgentPolicyTargetsModel;

  /**  */
  frameworks?: string[];

  /**  */
  id?: string;

  /**  */
  intent?: AgentPolicyIntentModel;

  /**  */
  name?: string;

  /**  */
  outcome?: string;

  /**  */
  strength?: EnumAgentPolicyRecommendationModelStrength;

  /**  */
  targets?: AgentPolicyTargetsModel;

  /**  */
  technology?: string;

  /**  */
  whyRecommended?: string;
}

/** AgentPolicyRequestModel */
export interface AgentPolicyRequestModel {
  /**  */
  effect: EnumAgentPolicyRequestModelEffect;

  /**  */
  id?: string;

  /**  */
  mcpServerApplicationIds?: string[];

  /**  */
  policy: DataAccessPolicyModel;

  /**  */
  version?: number;
}

/** AgentPolicyRequirementModel */
export interface AgentPolicyRequirementModel {
  /**  */
  detected?: string;

  /**  */
  required?: string;
}

/** AgentPolicyResponseModel */
export interface AgentPolicyResponseModel {
  /**  */
  agentApplicationId?: string;

  /**  */
  bindings?: AgentMcpServerBindingModel[];

  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  description?: string;

  /**  */
  effect?: EnumAgentPolicyResponseModelEffect;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;

  /**  */
  policy?: DataAccessPolicyModel;

  /**  */
  policyStatus?: string;

  /**  */
  rootPolicyId?: string;

  /**  */
  version?: number;
}

/** AgentPolicyReviewModel */
export interface AgentPolicyReviewModel {
  /**  */
  agents?: AgentPolicyAgentModel[];

  /**  */
  cohort?: CohortModel;

  /**  */
  enforcement?: AgentCountsModel;

  /**  */
  enforcementScope?: string;

  /**  */
  policies?: AgentPolicyItemModel[];

  /**  */
  scopeAgentCount?: number;

  /**  */
  targets?: AgentPolicyTargetsModel[];

  /**  */
  viewedAgentId?: string;
}

/** AgentPolicyReviewRecommendationModel */
export interface AgentPolicyReviewRecommendationModel {
  /**  */
  rationale?: string;

  /**  */
  strength?: EnumAgentPolicyReviewRecommendationModelStrength;
}

/** AgentPolicyRuleModel */
export interface AgentPolicyRuleModel {
  /**  */
  effect?: EnumAgentPolicyRuleModelEffect;

  /**  */
  id?: string;

  /**  */
  mcpServerApplicationId?: string;

  /**  */
  name?: string;

  /**  */
  toolIds?: string[];

  /**  */
  toolNames?: string[];
}

/** AgentPolicyRunModel */
export interface AgentPolicyRunModel {
  /**  */
  id?: string;

  /**  */
  kind?: EnumAgentPolicyRunModelKind;

  /**  */
  startedAt?: string;

  /**  */
  state?: EnumAgentPolicyRunModelState;
}

/** AgentPolicyScopeModel */
export interface AgentPolicyScopeModel {
  /**  */
  agentIds?: string[];

  /**  */
  dimension?: EnumAgentPolicyScopeModelDimension;

  /**  */
  filters?: EstateAgentFilter;

  /**  */
  kind: EnumAgentPolicyScopeModelKind;

  /**  */
  value?: string;
}

/** AgentPolicyStepModel */
export interface AgentPolicyStepModel {
  /**  */
  key?: EnumAgentPolicyStepModelKey;

  /**  */
  policyCount?: number;

  /**  */
  resources?: string[];

  /**  */
  status?: EnumAgentPolicyStepModelStatus;
}

/** AgentPolicyTargetsModel */
export interface AgentPolicyTargetsModel {
  /**  */
  controlCount?: number;

  /**  */
  dataControlCount?: number;

  /**  */
  dataSourceCount?: number;

  /**  */
  dataSourceIds?: string[];

  /**  */
  dataSources?: AgentPolicyDataSourceTargetModel[];

  /**  */
  mcpServerCount?: number;

  /**  */
  mcpServers?: AgentPolicyMcpServerTargetModel[];

  /**  */
  mcpServiceIds?: string[];

  /**  */
  policyId?: string;

  /**  */
  toolCount?: number;

  /**  */
  toolKeys?: string[];
}

/** AgentPolicyToolEnforcementModel */
export interface AgentPolicyToolEnforcementModel {
  /**  */
  classification?: string;

  /**  */
  id?: string;

  /**  */
  mode?: string;

  /**  */
  name?: string;

  /**  */
  rule?: string;

  /**  */
  status?: EnumAgentPolicyToolEnforcementModelStatus;
}

/** AgentPromptModel */
export interface AgentPromptModel {
  /**  */
  agentType: string;

  /**  */
  description?: string;

  /**  */
  global?: boolean;

  /**  */
  id?: string;

  /**  */
  name: string;

  /**  */
  promptText: string;

  /**  */
  promptType: EnumAgentPromptModelPromptType;
}

/** AgentPurposeModel */
export interface AgentPurposeModel {
  /**  */
  allowedActions?: string[];

  /**  */
  description?: string;

  /**  */
  displayName?: string;

  /**  */
  value?: string;
}

/** AgentRegistryIdentityModel */
export interface AgentRegistryIdentityModel {
  /**  */
  credentialSource?: string;

  /**  */
  provider?: string;
}

/** AgentRegistryPrerequisitesModelReq */
export interface AgentRegistryPrerequisitesModelReq {
  /**  */
  confirmedAt?: string;

  /**  */
  confirmedBy?: string;

  /**  */
  requiredMcpServicesConfirmed?: boolean;
}

/** AgentRegistryPrerequisitesModelRes */
export interface AgentRegistryPrerequisitesModelRes {
  /**  */
  confirmedAt?: string;

  /**  */
  confirmedBy?: string;

  /**  */
  gatewayId?: string;

  /**  */
  requiredMcpServicesConfirmed?: boolean;
}

/** AgentRegistryProjectModel */
export interface AgentRegistryProjectModel {
  /**  */
  accountName?: string;

  /**  */
  id?: string;

  /**  */
  projectName?: string;
}

/** AgentRegistryRequestModel */
export interface AgentRegistryRequestModel {
  /**  */
  configuration: Configuration;

  /**  */
  prerequisites?: AgentRegistryPrerequisitesModelReq;

  /**  */
  projectSelection?: ProjectSelection;

  /**  */
  target?: EnumAgentRegistryRequestModelTarget;
}

/** AgentSyncAgentModel */
export interface AgentSyncAgentModel {
  /**  */
  description?: string;

  /**  */
  identity?: Identity;

  /**  */
  instructions?: string;

  /**  */
  metadata?: object;

  /**  */
  sourceAgentKey?: string;

  /**  */
  tools?: Tool[];
}

/** AgentSyncAttributeAgentModel */
export interface AgentSyncAttributeAgentModel {
  /**  */
  attributes?: object;

  /**  */
  clientId?: string;
}

/** AgentSyncAttributesModel */
export interface AgentSyncAttributesModel {
  /**  */
  agents?: AgentSyncAttributeAgentModel[];

  /**  */
  definitions?: CustomSecurityAttributeDefinitionModel[];

  /**  */
  reason?: string;

  /**  */
  status?: string;
}

/** AgentSyncResultsModel */
export interface AgentSyncResultsModel {
  /**  */
  agents?: AgentSyncAgentModel[];

  /**  */
  hasMore?: boolean;

  /**  */
  pageIndex?: number;

  /**  */
  reason?: string;

  /**  */
  status?: string;

  /**  */
  unitId?: string;
}

/** Alert */
export interface Alert {
  /**  */
  auditRecordId?: string;

  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  details?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;

  /**  */
  ocurredOn?: Date;

  /**  */
  policyRefId?: string;

  /**  */
  summary?: string;
}

/** AlertFrequency */
export interface AlertFrequency {
  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;
}

/** AlertModel */
export interface AlertModel {
  /**  */
  auditRecordId?: string;

  /**  */
  details?: string;

  /**  */
  ocurredOn?: Date;

  /**  */
  policyRefId?: string;

  /**  */
  summary?: string;
}

/** AlertRecordModelReq */
export interface AlertRecordModelReq {
  /**  */
  accountId?: string;

  /**  */
  alertType?: string;

  /**  */
  applicationName?: string;

  /**  */
  auditRecordId?: string;

  /**  */
  category?: string;

  /**  */
  complianceFramework?: string;

  /**  */
  complianceTags?: string;

  /**  */
  dataSourceType?: string;

  /**  */
  dbType?: string;

  /**  */
  details?: string;

  /**  */
  detectedOn?: Date;

  /**  */
  dismissalMessage?: string;

  /**  */
  dismissed?: boolean;

  /**  */
  dismissedDate?: Date;

  /**  */
  eventId?: string;

  /**  */
  eventName?: string;

  /**  */
  id?: string;

  /**  */
  ipAddress?: string;

  /**  */
  matchingCondition?: string;

  /**  */
  monitoringData?: string;

  /**  */
  objectName?: string;

  /**  */
  ocurredOn?: Date;

  /**  */
  policyDescription?: string;

  /**  */
  policyRecordId?: string;

  /**  */
  policyRefId?: string;

  /**  */
  policyRemediation?: string;

  /**  */
  privilegeName?: string;

  /**  */
  privilegedRoleName?: string;

  /**  */
  rawAuditRecord?: string;

  /**  */
  remediationMetaData?: RemediationActionResponseModel[];

  /**  */
  resourceName?: string;

  /**  */
  roleName?: string;

  /**  */
  severity?: string;

  /**  */
  status?: string;

  /**  */
  summary?: string;

  /**  */
  targetName?: string;

  /**  */
  tenantId?: string;

  /**  */
  ticketDetails?: string;

  /**  */
  userName?: string;

  /**  */
  userTypes?: string[];

  /**  */
  workspace?: string;
}

/** AlertRecordModelRequest */
export interface AlertRecordModelRequest {
  /**  */
  accountId?: string;

  /**  */
  alertType?: string;

  /**  */
  applicationName?: string;

  /**  */
  auditRecordId?: string;

  /**  */
  category?: string;

  /**  */
  complianceFramework?: string;

  /**  */
  complianceTags?: string;

  /**  */
  dataSourceType?: string;

  /**  */
  details?: string;

  /**  */
  detectedOn?: Date;

  /**  */
  dismissalMessage?: string;

  /**  */
  dismissed?: boolean;

  /**  */
  dismissedDate?: Date;

  /**  */
  eventId?: string;

  /**  */
  eventName?: string;

  /**  */
  id?: string;

  /**  */
  ipAddress?: string;

  /**  */
  matchingCondition?: string;

  /**  */
  monitoringData?: string;

  /**  */
  objectName?: string;

  /**  */
  ocurredOn?: Date;

  /**  */
  policyDescription?: string;

  /**  */
  policyRecordId?: string;

  /**  */
  policyRefId?: string;

  /**  */
  policyRemediation?: string;

  /**  */
  privilegeName?: string;

  /**  */
  rawAuditRecord?: string;

  /**  */
  resourceName?: string;

  /**  */
  roleName?: string;

  /**  */
  severity?: string;

  /**  */
  status?: string;

  /**  */
  summary?: string;

  /**  */
  targetName?: string;

  /**  */
  tenantId?: string;

  /**  */
  userName?: string;

  /**  */
  workspace?: string;
}

/** AlertRecordModelRes */
export interface AlertRecordModelRes {
  /**  */
  accountId?: string;

  /**  */
  alertType?: string;

  /**  */
  applicationName?: string;

  /**  */
  auditRecordId?: string;

  /**  */
  category?: string;

  /**  */
  complianceFramework?: string;

  /**  */
  complianceTags?: string;

  /**  */
  dataSourceType?: string;

  /**  */
  dbType?: string;

  /**  */
  details?: string;

  /**  */
  detectedOn?: Date;

  /**  */
  dismissalMessage?: string;

  /**  */
  dismissed?: boolean;

  /**  */
  dismissedDate?: Date;

  /**  */
  eventId?: string;

  /**  */
  eventName?: string;

  /**  */
  id?: string;

  /**  */
  ipAddress?: string;

  /**  */
  matchingCondition?: string;

  /**  */
  monitoringData?: string;

  /**  */
  new?: boolean;

  /**  */
  objectName?: string;

  /**  */
  ocurredOn?: Date;

  /**  */
  policyDescription?: string;

  /**  */
  policyRecordId?: string;

  /**  */
  policyRefId?: string;

  /**  */
  policyRemediation?: string;

  /**  */
  privilegeName?: string;

  /**  */
  privilegedRoleName?: string;

  /**  */
  rawAuditRecord?: string;

  /**  */
  remediationMetaData?: RemediationActionResponseModel[];

  /**  */
  resourceName?: string;

  /**  */
  roleName?: string;

  /**  */
  severity?: string;

  /**  */
  status?: string;

  /**  */
  summary?: string;

  /**  */
  targetName?: string;

  /**  */
  tenantId?: string;

  /**  */
  ticketDetails?: string;

  /**  */
  userName?: string;

  /**  */
  userTypes?: string[];

  /**  */
  workspace?: string;
}

/** AlertSuppressionRuleRequest */
export interface AlertSuppressionRuleRequest {
  /**  */
  accountId: string;

  /**  */
  alertId: string;

  /**  */
  description?: string;

  /**  */
  name?: string;

  /**  */
  policyRefId: string;

  /**  */
  suppressionDays: number;
}

/** AlertSuppressionRuleResponse */
export interface AlertSuppressionRuleResponse {
  /**  */
  accountId?: string;

  /**  */
  createdAt?: Date;

  /**  */
  createdBy?: string;

  /**  */
  daysRemaining?: number;

  /**  */
  description?: string;

  /**  */
  expiryDate?: Date;

  /**  */
  id?: string;

  /**  */
  isActive?: boolean;

  /**  */
  isExpired?: boolean;

  /**  */
  matchCriteria?: object;

  /**  */
  modifiedAt?: Date;

  /**  */
  modifiedBy?: string;

  /**  */
  name?: string;

  /**  */
  policyRefId?: string;

  /**  */
  suppressionDays?: number;

  /**  */
  tenantId?: string;
}

/** AlertSuppressionRuleUpdateRequest */
export interface AlertSuppressionRuleUpdateRequest {
  /**  */
  description?: string;

  /**  */
  isActive?: boolean;

  /**  */
  name?: string;

  /**  */
  suppressionDays?: number;
}

/** AlertsByDataSource */
export interface AlertsByDataSource {
  /**  */
  accountId?: string;

  /**  */
  accountName?: string;

  /**  */
  alertByCategory?: AlertsCategory[];
}

/** AlertsCategory */
export interface AlertsCategory {
  /**  */
  alertCount?: number;

  /**  */
  category?: string;
}

/** AlertsComplianceTags */
export interface AlertsComplianceTags {
  /**  */
  alertCount?: number;

  /**  */
  complianceTags?: string;
}

/** AllowAccountListModel */
export interface AllowAccountListModel {
  /**  */
  allowAccountList?: AccountModel[];

  /**  */
  availableAccountList?: AccountModel[];
}

/** Application */
export interface Application {
  /**  */
  account?: Account;

  /**  */
  agentPolicyEnabled?: boolean;

  /**  */
  configParameters?: string;

  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  externalProjectId?: string;

  /**  */
  id?: string;

  /**  */
  isImported?: boolean;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  mcpStaticHeaders?: object;

  /**  */
  name?: string;

  /**  */
  policies?: DataAccessPolicy[];

  /**  */
  resourceAccountId?: string;

  /**  */
  resourceCount?: number;

  /**  */
  resources?: PolicyResourceRequestModel[];

  /**  */
  sourceIntegrationId?: string;

  /**  */
  status?: string;

  /**  */
  tlxMcpUrl?: string;

  /**  */
  type?: string;
}

/** ApplicationBasicDetailsRequest */
export interface ApplicationBasicDetailsRequest {
  /**  */
  description?: string;

  /**  */
  name?: string;

  /**  */
  status?: string;
}

/** ApplicationConfigResponse */
export interface ApplicationConfigResponse {
  /**  */
  agentAttributes?: AgentAttributeModel[];

  /**  */
  application?: ApplicationSummary;

  /**  */
  configurations?: ApplicationConfigurationResponseModel;
}

/** ApplicationConfigUpdateRequest */
export interface ApplicationConfigUpdateRequest {
  /**  */
  agentAttributes?: AgentAttributeValueItemRequestModel[];

  /**  */
  basicDetails?: ApplicationBasicDetailsRequest;

  /**  */
  configurations?: ApplicationConfigurationRequestModel;

  /**  */
  type?: string;
}

/** ApplicationConfigurationRequestModel */
export interface ApplicationConfigurationRequestModel {
  /**  */
  authCode?: string;

  /**  */
  authConfig?: CredentialsConfigModel;

  /**  */
  authType?: string;

  /**  */
  serverType?: string;

  /**  */
  transport?: string;

  /**  */
  url?: string;
}

/** ApplicationConfigurationResponseModel */
export interface ApplicationConfigurationResponseModel {
  /**  */
  applicationService?: ApplicationServiceConfig;
}

/** ApplicationMetadata */
export interface ApplicationMetadata {
  /**  */
  name?: string;

  /**  */
  source?: string;
}

/** ApplicationModel */
export interface ApplicationModel {
  /**  */
  accountId?: string;

  /**  */
  authType?: string;

  /**  */
  configurations?: ApplicationConfigurationRequestModel;

  /**  */
  description?: string;

  /**  */
  name?: string;

  /**  */
  resourceAccountId?: string;

  /**  */
  resources?: PolicyResourceRequestModel[];

  /**  */
  serverType?: string;

  /**  */
  status?: string;

  /**  */
  transport?: string;

  /**  */
  type?: string;

  /**  */
  url?: string;
}

/** ApplicationPlanModel */
export interface ApplicationPlanModel {
  /**  */
  operations?: OperationsModel;

  /**  */
  sharedImpact?: SharedImpactModel;

  /**  */
  units?: UnitsModel;
}

/** ApplicationServiceConfig */
export interface ApplicationServiceConfig {
  /**  */
  type?: string;

  /**  */
  values?: CredentialsConfigModel;
}

/** ApplicationSummary */
export interface ApplicationSummary {
  /**  */
  createdAt?: Date;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  modifiedAt?: Date;

  /**  */
  name?: string;

  /**  */
  status?: string;

  /**  */
  type?: string;
}

/** ApplicationUserAttributesExternalSourceAttributeDetailsModel */
export interface ApplicationUserAttributesExternalSourceAttributeDetailsModel {
  /**  */
  account?: AccountModel;

  /**  */
  applicationUserAttributeColumns?: ApplicationUserEntitlementAttributeColumnModel[];

  /**  */
  configType?: string;

  /**  */
  externalIntegration?: ExternalIntegrationSourceDetails;

  /**  */
  sourceConfigModel?: EntitlementAttributeSourceConfigModel;

  /**  */
  sourceConfigurationId?: string;

  /**  */
  tenantId?: string;
}

/** ApplicationUserEntitlementAttributeColumnModel */
export interface ApplicationUserEntitlementAttributeColumnModel {
  /**  */
  applicationId?: string;

  /**  */
  deriveType?: string;

  /**  */
  description?: string;

  /**  */
  displayName?: string;

  /**  */
  entitlementAttributeSourceConfigId?: string;

  /**  */
  id?: string;

  /** false */
  isMultiValue?: boolean;

  /**  */
  name?: string;

  /**  */
  sourceAttributeName?: string;

  /**  */
  tenantId?: string;

  /**  */
  type?: string;

  /**  */
  userAttributeConfigurationId?: string;
}

/** ApplicationUserEntitlementAttributeModel */
export interface ApplicationUserEntitlementAttributeModel {
  /**  */
  entitlementAttributeSourceConfig?: EntitlementAttributeSourceConfigModel;

  /**  */
  entitlementColumns?: ApplicationUserEntitlementAttributeColumnModel[];

  /**  */
  id?: string;

  /**  */
  status?: string;

  /**  */
  statusDetails?: string;

  /**  */
  userAttributeConfigurationId?: string;
}

/** AppliedPolicyModel */
export interface AppliedPolicyModel {
  /**  */
  appliedAt?: string;

  /**  */
  id?: string;

  /**  */
  name?: string;
}

/** ApplyPlanModel */
export interface ApplyPlanModel {
  /**  */
  assignments?: AssignmentModel[];

  /**  */
  records?: PlanRecordModel[];

  /**  */
  targetedAgentIds?: string[];
}

/** ApplyRequest */
export interface ApplyRequest {
  /**  */
  environmentId?: string;

  /**  */
  policyIds?: string[];

  /**  */
  previewId?: string;

  /**  */
  scope: AgentPolicyScopeModel;
}

/** AssignmentModel */
export interface AssignmentModel {
  /**  */
  agentId?: string;

  /**  */
  policyId?: string;
}

/** Attribute */
export interface Attribute {
  /**  */
  displayName?: string;

  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  operators?: Option[];

  /**  */
  type?: string;

  /**  */
  valueType?: string;
}

/** AttributeDataResponseModel */
export interface AttributeDataResponseModel {
  /**  */
  children?: AttributeDataResponseModel[];

  /**  */
  hasChildren?: boolean;

  /**  */
  path?: string;

  /**  */
  searchColumnValues?: object;

  /**  */
  value?: string;
}

/** AttributeExportFilter */
export interface AttributeExportFilter {
  /**  */
  accountId?: string[];

  /**  */
  attributeCode?: string[];

  /**  */
  attributeGroupNames?: string[];

  /**  */
  attributeName?: string[];

  /**  */
  dataProduct?: string[];
}

/** AttributeParamModel */
export interface AttributeParamModel {
  /**  */
  allowCustom?: boolean;

  /**  */
  availableOptions?: string[];

  /**  */
  defaultValue?: object;

  /**  */
  dependsOn?: DependsOnModel[];

  /**  */
  description?: string;

  /**  */
  displayName?: string;

  /**  */
  inputType?: string;

  /**  */
  name?: string;

  /**  */
  type?: string;

  /**  */
  value?: object;
}

/** AuditEvidence */
export interface AuditEvidence {
  /**  */
  agent?: string;

  /**  */
  dataClass?: string;

  /**  */
  decision?: string;

  /**  */
  declaredPurpose?: string;

  /**  */
  destinationRegion?: string;

  /**  */
  enforcementPoint?: string;

  /**  */
  evidenceStatus?: string;

  /**  */
  id?: string;

  /**  */
  matchedPolicy?: string;

  /**  */
  sourceRegion?: string;

  /**  */
  timestamp?: string;

  /**  */
  userIdentity?: string;
}

/** AuthoredAgentPolicyModel */
export interface AuthoredAgentPolicyModel {
  /**  */
  agentId?: string;

  /**  */
  appliedAt?: string;

  /**  */
  description?: string;

  /**  */
  draftId?: string;

  /**  */
  id?: string;

  /**  */
  inheritedPolicyIds?: string[];

  /**  */
  name: string;

  /**  */
  origin?: EnumAuthoredAgentPolicyModelOrigin;

  /**  */
  rules?: Rule[];

  /**  */
  status?: EnumAuthoredAgentPolicyModelStatus;

  /**  */
  updatedAt?: string;

  /**  */
  updatedBy?: string;

  /**  */
  version?: number;
}

/** AuthorizedAppAccess */
export interface AuthorizedAppAccess {
  /**  */
  allowedIp?: string;

  /**  */
  appName?: string;

  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  dbType?: string;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;

  /**  */
  serviceUserName?: string;
}

/** AuthorizedSystemApplication */
export interface AuthorizedSystemApplication {
  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  groupName?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;
}

/** AuthorizedSystemApplicationModel */
export interface AuthorizedSystemApplicationModel {
  /**  */
  authorizedApplicationList?: string[];

  /**  */
  cloudAccountId: string;
}

/** AuthorizedSystemApplicationResponse */
export interface AuthorizedSystemApplicationResponse {
  /**  */
  dbInstance?: string;

  /**  */
  name?: string;
}

/** AuthorizedSystemEntity */
export interface AuthorizedSystemEntity {
  /**  */
  desc?: string;

  /**  */
  groupName?: string;

  /**  */
  id?: string;

  /**  */
  isSystemUser?: boolean;

  /**  */
  name?: string;

  /**  */
  type?: string;
}

/** AuthorizedSystemEntityModel */
export interface AuthorizedSystemEntityModel {
  /**  */
  cloudAccountId: string;

  /**  */
  entityList?: AuthorizedSystemEntity[];
}

/** AuthorizedSystemIp */
export interface AuthorizedSystemIp {
  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  groupName?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;
}

/** AuthorizedSystemIpModel */
export interface AuthorizedSystemIpModel {
  /**  */
  authorizedIpList?: string[];

  /**  */
  cloudAccountId: string;
}

/** AuthorizedSystemIpResponse */
export interface AuthorizedSystemIpResponse {
  /**  */
  dbInstance?: string;

  /**  */
  name?: string;
}

/** AuthorizedSystemRole */
export interface AuthorizedSystemRole {
  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  groupName?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;
}

/** AuthorizedSystemRoleModel */
export interface AuthorizedSystemRoleModel {
  /**  */
  cloudAccountId: string;

  /**  */
  nameList?: string[];
}

/** AuthorizedSystemRoleResponse */
export interface AuthorizedSystemRoleResponse {
  /**  */
  dbInstance?: string;

  /**  */
  name?: string;
}

/** AuthorizedSystemUser */
export interface AuthorizedSystemUser {
  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  groupName?: string;

  /**  */
  id?: string;

  /**  */
  isSystemUser?: boolean;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;
}

/** AuthorizedSystemUserModel */
export interface AuthorizedSystemUserModel {
  /**  */
  cloudAccountId: string;

  /**  */
  isSystemUser?: boolean;

  /**  */
  nameList?: string[];
}

/** AuthorizedSystemUserResponse */
export interface AuthorizedSystemUserResponse {
  /**  */
  dbInstance?: string;

  /**  */
  isSystemUser?: boolean;

  /**  */
  name?: string;
}

/** BatchPolicyUpdateRequest */
export interface BatchPolicyUpdateRequest {
  /**  */
  id?: string;

  /**  */
  policy?: DataAccessPolicyModel;
}

/** BlockedAllowed */
export interface BlockedAllowed {
  /**  */
  allowed?: string[];

  /**  */
  blocked?: string[];
}

/** BulkAlertDismissalModel */
export interface BulkAlertDismissalModel {
  /**  */
  accountId?: string;

  /**  */
  alertType?: string[];

  /**  */
  complianceTags?: string[];

  /**  */
  dismissalMessage?: string;

  /**  */
  rangeEndDate?: Date;

  /**  */
  rangeStartDate?: Date;

  /**  */
  riskCategory?: string[];

  /**  */
  severity?: string[];

  /**  */
  triggeredBy?: string[];
}

/** BulkPolicyImportJobModel */
export interface BulkPolicyImportJobModel {
  /**  */
  accountId?: string;

  /**  */
  completedAt?: Date;

  /**  */
  failureCount?: number;

  /**  */
  fileName?: string;

  /**  */
  id?: string;

  /**  */
  startedAt?: Date;

  /**  */
  status?: EnumBulkPolicyImportJobModelStatus;

  /**  */
  successCount?: number;

  /**  */
  totalCount?: number;

  /**  */
  updatedBy?: string;
}

/** BulkPolicyImportJobRowModel */
export interface BulkPolicyImportJobRowModel {
  /**  */
  column?: string;

  /**  */
  id?: string;

  /**  */
  message?: string;

  /**  */
  objectType?: string;

  /**  */
  policyKind?: string;

  /**  */
  status?: EnumBulkPolicyImportJobRowModelStatus;

  /**  */
  submittedValues?: object;

  /**  */
  target?: string;

  /**  */
  updatedAt?: Date;
}

/** CatalogBucket */
export interface CatalogBucket {
  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;
}

/** CatalogBucketModel */
export interface CatalogBucketModel {
  /**  */
  bucketNames?: string[];
}

/** Platform-specific table mapping for a catalog entry */
export interface CatalogMappingModel {
  /** Data source/account ID */
  dataSourceId?: string;

  /** Database/catalog name */
  databaseCatalog?: string;

  /** Native object name in platform format */
  nativeObjectName?: string;

  /** Platform name */
  platform?: string;

  /** Schema/namespace name */
  schema?: string;

  /** Table name */
  table?: string;
}

/** Hierarchical catalog master data node */
export interface CatalogMasterDataModel {
  /** Child nodes (populated when querying with path parameter) */
  children?: CatalogMasterDataModel[];

  /** Whether this node has child nodes */
  hasChildren?: boolean;

  /** Full dot-separated path (e.g., 'dremio_samples.customer360.customer') */
  path?: string;

  /** Current segment name (catalog, schema, or table name) */
  value?: string;
}

/** CatalogRequest */
export interface CatalogRequest {
  /**  */
  category?: string;

  /**  */
  environmentId?: string;

  /**  */
  q?: string;

  /**  */
  scope: AgentPolicyScopeModel;

  /**  */
  technology?: string;
}

/** Unified catalog entry showing cross-platform table mappings */
export interface CatalogResponseModel {
  /** Catalog name */
  catalog?: string;

  /** List of data source IDs that have discovered this table */
  coverage?: string[];

  /** Table eligibility for policy */
  eligibility?: string;

  /** External storage location (S3/ADLS/GCS URI) */
  externalLocation?: string;

  /** Unique catalog entry ID (derived from canonical FQN) */
  id?: string;

  /** Platform-specific table mappings */
  mappings?: CatalogMappingModel[];

  /** Canonical object name (catalog.schema.table) */
  objectName?: string;

  /** Object type */
  objectType?: string;

  /** Schema/namespace name */
  schema?: string;

  /** Table name */
  table?: string;
}

/** ChangeUserPassword */
export interface ChangeUserPassword {
  /**  */
  currentPassword?: string;

  /**  */
  loginId?: string;

  /**  */
  newPassword?: string;
}

/** ChildMetadata */
export interface ChildMetadata {
  /**  */
  functions?: string[];

  /**  */
  pipes?: string[];

  /**  */
  procedures?: string[];

  /**  */
  schemas?: string[];

  /**  */
  sequences?: string[];

  /**  */
  tables?: string[];

  /**  */
  tasks?: string[];

  /**  */
  views?: string[];
}

/** ClassificationEvidenceModel */
export interface ClassificationEvidenceModel {
  /**  */
  applicationTags?: string[];

  /**  */
  dataSource?: string;

  /**  */
  metadata?: LabelValueModel[];

  /**  */
  registeredTools?: string[];

  /**  */
  systemPromptExcerpt?: string;
}

/** ClassificationType */
export interface ClassificationType {
  /**  */
  createdBy?: string;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  name?: string;
}

/** ClassificationTypeModel */
export interface ClassificationTypeModel {
  /**  */
  cloudAccountId: string;

  /**  */
  description?: string;

  /**  */
  name: string;
}

/** CodedConflictModel */
export interface CodedConflictModel {
  /**  */
  code?: string;

  /**  */
  message?: string;
}

/** CohortModel */
export interface CohortModel {
  /**  */
  applicabilityUnresolved?: boolean;

  /**  */
  candidateAgentIds?: string[];

  /**  */
  entry?: EnumCohortModelEntry;

  /**  */
  expectedCoverageChanges?: CoverageChangesModel;

  /**  */
  notTargeted?: NotTargetedModel[];

  /**  */
  selectedRecommendationIds?: string[];

  /**  */
  sourceAgentIds?: string[];

  /**  */
  targetedAgentIds?: string[];
}

/** Column */
export interface Column {
  /**  */
  comment?: string;

  /**  */
  name?: string;

  /**  */
  parameters?: object;

  /**  */
  type?: string;
}

/** ColumnFiltersResponseModel */
export interface ColumnFiltersResponseModel {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  type?: string;
}

/** ColumnMetadata */
export interface ColumnMetadata {
  /**  */
  check?: string;

  /**  */
  comment?: string;

  /**  */
  databaseName?: string;

  /**  */
  defaultValue?: string;

  /**  */
  expression?: string;

  /**  */
  fullDataType?: string;

  /**  */
  fullyQualifiedName?: string;

  /**  */
  isNull?: string;

  /**  */
  isPrimaryKey?: string;

  /**  */
  isUniqueKey?: string;

  /**  */
  kind?: string;

  /**  */
  name?: string;

  /**  */
  objectNames?: string[];

  /**  */
  policyName?: string;

  /**  */
  schemaName?: string;

  /**  */
  tableName?: string;

  /**  */
  type?: string;
}

/** ColumnRuleDetail */
export interface ColumnRuleDetail {
  /**  */
  columnRules?: ColumnRuleDetail[];

  /**  */
  condition?: ConditionDetail;

  /**  */
  conditionId?: string;

  /**  */
  conditionName?: string;

  /**  */
  conjunction?: string;

  /**  */
  elementDataType?: string;

  /**  */
  elementName?: string;

  /**  */
  elementType?: string;

  /**  */
  isMultiValue?: boolean;

  /**  */
  ruleSequenceNumber?: number;

  /**  */
  unProtect?: boolean;

  /**  */
  value?: string;

  /**  */
  valueName?: string;

  /**  */
  valueType?: string;

  /**  */
  valueTypeName?: string;
}

/** ComplianceTag */
export interface ComplianceTag {
  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;

  /**  */
  system?: boolean;
}

/** ComponentDetail */
export interface ComponentDetail {
  /**  */
  lastUpdated?: string;

  /**  */
  saasVersion?: string;

  /**  */
  status?: string;

  /**  */
  subComponents?: SubComponentDetail[];

  /**  */
  type?: string;

  /**  */
  version?: string;
}

/** Condition */
export interface Condition {
  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;
}

/** ConditionAttributeMappingModel */
export interface ConditionAttributeMappingModel {
  /**  */
  attributes?: DataTypeConditionMatchWithMappingModel[];

  /**  */
  dataLookUp?: string;

  /**  */
  displayName?: string;

  /**  */
  href?: HrefModel;

  /**  */
  infoText?: string;

  /**  */
  name?: string;

  /**  */
  type?: string;
}

/** ConditionDetail */
export interface ConditionDetail {
  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  name?: string;
}

/** ConditionModel */
export interface ConditionModel {
  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  name?: string;
}

/** ConditionType */
export interface ConditionType {
  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  dataSourceType?: string;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;
}

/** ConditionWithDynamicValue */
export interface ConditionWithDynamicValue {
  /**  */
  dataType?: string;

  /**  */
  dynamicProperty?: string;

  /**  */
  operator?: string;

  /**  */
  propertyName?: string;
}

/** ConditionWithValue */
export interface ConditionWithValue {
  /**  */
  dataType?: string;

  /**  */
  operator?: string;

  /**  */
  propertyName?: string;

  /**  */
  values?: object[];
}

/** Configuration */
export interface Configuration {
  /**  */
  connection?: Connection;

  /**  */
  id?: string;

  /**  */
  identity?: AgentRegistryIdentityModel;

  /**  */
  integrationType?: string;

  /**  */
  name?: string;
}

/** Connection */
export interface Connection {
  /**  */
  clientId?: string;

  /**  */
  clientSecret?: string;

  /**  */
  tenantId?: string;
}

/** ContainmentStrategy */
export interface ContainmentStrategy {
  /**  */
  alternativeGroup?: string;

  /**  */
  benefits?: string[];

  /**  */
  complianceCoverage?: string;

  /**  */
  confidencePercent?: number;

  /**  */
  disruption?: string;

  /**  */
  id?: string;

  /**  */
  isEmergencyAction?: boolean;

  /**  */
  isHandoff?: boolean;

  /**  */
  isRecommended?: boolean;

  /**  */
  name?: string;

  /**  */
  options?: string[];

  /**  */
  riskReductionPercent?: number;

  /**  */
  riskyActivitiesPrevented?: number;

  /**  */
  summary?: string;
}

/** ControlDecision */
export interface ControlDecision {
  /**  */
  affectedAgentIds?: string[];

  /**  */
  affectedApplications?: string[];

  /**  */
  blockedStepLabel?: string;

  /**  */
  complianceImpact?: string[];

  /**  */
  confidenceLabel?: string;

  /**  */
  containmentStrategies?: ContainmentStrategy[];

  /**  */
  controlId?: string;

  /**  */
  currentDecisionLabel?: string;

  /**  */
  evaluationDimensions?: string[];

  /**  */
  evidenceOutcomeLabel?: string;

  /**  */
  executive?: ExecutiveBriefing;

  /**  */
  expectedOutcome?: string[];

  /**  */
  guardianEvidence?: GuardianEvidence;

  /**  */
  guardianStrategyRationale?: StrategyRationale;

  /**  */
  impact?: DecisionImpact;

  /**  */
  ongoingEnforcementLabel?: string;

  /**  */
  pipelineSteps?: LabeledValue[];

  /**  */
  policyPack?: PolicyPack;

  /**  */
  recommendedAction?: string;

  /**  */
  supportsFutureAgentCoverage?: boolean;

  /**  */
  whyNow?: string;
}

/** ControlEnforcement */
export interface ControlEnforcement {
  /**  */
  blockedEventCount?: number;

  /**  */
  controlId?: string;

  /**  */
  coversFutureAgents?: boolean;

  /**  */
  enforcedAgentCount?: number;

  /**  */
  scopeId?: string;
}

/** ControlEnforcementRequestModel */
export interface ControlEnforcementRequestModel {
  /**  */
  agentCount?: number;

  /**  */
  agentIds?: string[];

  /**  */
  controlId?: string;

  /**  */
  includeFutureAgents?: boolean;

  /**  */
  scopeId: string;
}

/** CopilotCategory */
export interface CopilotCategory {
  /**  */
  accountId?: string;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  riskCount?: string;
}

/** CopilotCategoryBusinessAction */
export interface CopilotCategoryBusinessAction {
  /**  */
  actionName?: string;

  /**  */
  actionSuccessMessage?: string;

  /**  */
  actionType?: string;

  /**  */
  contextType?: string;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  list?: CopilotSensitiveColumnModel[];

  /**  */
  policyName?: string;

  /**  */
  ticketDetails?: string;
}

/** CopilotCategorySummaryModel */
export interface CopilotCategorySummaryModel {
  /**  */
  actions?: CopilotCategoryBusinessAction[];

  /**  */
  columns?: CopilotSensitiveColumnModel[];

  /**  */
  data?: CopilotContextData;

  /**  */
  message?: string;
}

/** CopilotChatRequestModel */
export interface CopilotChatRequestModel {
  /**  */
  accountId?: string;

  /**  */
  categoryId?: string;

  /**  */
  context?: string;

  /**  */
  databaseName?: string;

  /**  */
  prompt?: string;
}

/** CopilotContextData */
export interface CopilotContextData {
  /**  */
  details?: CopilotContextDetails[];

  /**  */
  title?: string;
}

/** CopilotContextDetails */
export interface CopilotContextDetails {
  /**  */
  markdown?: string;

  /**  */
  objectList?: ObjectList[];

  /**  */
  type?: string;
}

/** CopilotSensitiveColumnModel */
export interface CopilotSensitiveColumnModel {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  type?: string;
}

/** CopyAttributeValueRequest */
export interface CopyAttributeValueRequest {
  /**  */
  sourceAttributeValueId: string;

  /**  */
  targetUserName?: string[];
}

/** CoverageChangesModel */
export interface CoverageChangesModel {
  /**  */
  improved?: number;

  /**  */
  newlyCovered?: number;

  /**  */
  regressed?: number;

  /**  */
  unchanged?: number;
}

/** CredentialsConfigModel */
export interface CredentialsConfigModel {
  /**  */
  account?: string;

  /**  */
  agentApplicationId?: string;

  /**  */
  apiKey?: string;

  /**  */
  authorizationEndpoint?: string;

  /**  */
  authorizationServer?: string;

  /**  */
  clientId?: string;

  /**  */
  clientSecret?: string;

  /**  */
  exchangeType?: EnumCredentialsConfigModelExchangeType;

  /**  */
  grantType?: EnumCredentialsConfigModelGrantType;

  /**  */
  issuer?: string;

  /**  */
  jwksUri?: string;

  /**  */
  passphrase?: string;

  /**  */
  password?: string;

  /**  */
  privateKey?: string;

  /**  */
  scope?: string;

  /**  */
  serviceIdentity?: EnumCredentialsConfigModelServiceIdentity;

  /**  */
  token?: string;

  /**  */
  tokenEndpoint?: string;

  /**  */
  urlHost?: string;

  /**  */
  username?: string;
}

/** CustomSecurityAttributeDefinitionModel */
export interface CustomSecurityAttributeDefinitionModel {
  /**  */
  attributeSet?: string;

  /**  */
  collection?: boolean;

  /**  */
  description?: string;

  /**  */
  name?: string;

  /**  */
  status?: string;

  /**  */
  type?: string;
}

/** DashboardInventorySummaryModel */
export interface DashboardInventorySummaryModel {
  /**  */
  generatedAt?: string;

  /**  */
  inventory?: InventoryModel;
}

/** DataAccessPolicy */
export interface DataAccessPolicy {
  /**  */
  accessGrants?: string;

  /**  */
  autoDeploy?: boolean;

  /**  */
  canonicalName?: string;

  /**  */
  canonicalNames?: string[];

  /**  */
  columnName?: string;

  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  dataSourceName?: string;

  /**  */
  databaseObjects?: DataAccessPolicyDatabaseObject[];

  /**  */
  datasourcePolicyName?: string;

  /**  */
  deleted?: boolean;

  /**  */
  deployFullGrants?: boolean;

  /**  */
  description?: string;

  /**  */
  draftPolicyId?: string;

  /**  */
  enableFutureGrants?: boolean;

  /**  */
  enableRedeployFromDeltaSync?: boolean;

  /**  */
  enableRiskBasedAccess?: boolean;

  /**  */
  enabled?: boolean;

  /**  */
  entitlements?: DataAccessPolicyEntitlements;

  /**  */
  evaluationResult?: ResourcePolicyEvaluationResultConfiguration;

  /**  */
  failMessage?: string;

  /**  */
  failMessageDetail?: string;

  /**  */
  functionName?: string;

  /**  */
  globalPolicy?: boolean;

  /**  */
  groupPolicy?: boolean;

  /**  */
  groupTableSchemaName?: string;

  /**  */
  groupUserMappingTableName?: string;

  /**  */
  icebergPolicy?: boolean;

  /**  */
  id?: string;

  /**  */
  includeViewAccessGrants?: boolean;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  latestDeployPolicySerialNo?: number;

  /**  */
  maskingPatternName?: string;

  /**  */
  maskingPatternValue?: string;

  /**  */
  name?: string;

  /**  */
  objectNameList?: string[];

  /**  */
  objectOwnerList?: string;

  /**  */
  objectPrivilege?: string;

  /**  */
  objectType?: string;

  /**  */
  parentRoleTemplate?: DataAccessPolicyRoleTemplate;

  /**  */
  parentRoleTemplateId?: string;

  /**  */
  policyActions?: TlxObjectActionMappingModel[];

  /**  */
  policyDataTypeDisplayName?: string;

  /**  */
  policyDataTypeId?: string;

  /**  */
  policyDataTypeName?: string;

  /**  */
  policySubtype?: string;

  /**  */
  prevPolicy?: DataAccessPolicy;

  /**  */
  principals?: string[];

  /**  */
  privilegeList?: ObjectPrivilege[];

  /**  */
  rawDatabaseObjects?: DataAccessPolicyDatabaseObject[];

  /**  */
  redeployRequired?: boolean;

  /**  */
  redshiftJDBCURL?: string;

  /**  */
  regoUdf?: string;

  /**  */
  remediationMsg?: string;

  /**  */
  remediationSource?: RemediationMappingSource;

  /**  */
  resourceMetadata?: ResourceSourceRequestModel;

  /**  */
  resourceSourceType?: EnumDataAccessPolicyResourceSourceType;

  /**  */
  retryCount?: number;

  /**  */
  reviewAndPublish?: boolean;

  /**  */
  roleTemplate?: DataAccessPolicyRoleTemplate;

  /**  */
  roleTemplateId?: string;

  /**  */
  rootPolicy?: DataAccessPolicy;

  /**  */
  rootPolicyId?: string;

  /**  */
  rules?: DataAccessPolicyRule[];

  /**  */
  schemaName?: string;

  /**  */
  securedObjects?: string;

  /**  */
  status?: string;

  /**  */
  tableName?: string;

  /**  */
  udf?: string;

  /**  */
  version?: number;

  /**  */
  view?: string;

  /**  */
  viewDescription?: string;

  /**  */
  viewFilterConditions?: string;

  /**  */
  viewJoinConditions?: string;

  /**  */
  viewName?: string;

  /**  */
  viewTableName?: string;

  /**  */
  workspace?: string;
}

/** DataAccessPolicyColumnGrant */
export interface DataAccessPolicyColumnGrant {
  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;
}

/** DataAccessPolicyColumnGrantModel */
export interface DataAccessPolicyColumnGrantModel {
  /**  */
  name?: string;

  /**  */
  type?: string;
}

/** DataAccessPolicyDBDetails */
export interface DataAccessPolicyDBDetails {
  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  databaseName?: string;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;

  /**  */
  schemaName?: string;

  /**  */
  tableName?: string;

  /**  */
  tableType?: string;
}

/** DataAccessPolicyDatabaseObject */
export interface DataAccessPolicyDatabaseObject {
  /**  */
  names?: string;

  /**  */
  type?: string;
}

/** DataAccessPolicyDeployStatusTracker */
export interface DataAccessPolicyDeployStatusTracker {
  /**  */
  activated?: boolean;

  /**  */
  dataAccessPolicy?: DataAccessPolicy;

  /**  */
  id?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  serialNo?: number;

  /**  */
  udfDefinition?: string;

  /**  */
  viewDefinition?: string;
}

/** DataAccessPolicyEntitlements */
export interface DataAccessPolicyEntitlements {
  /**  */
  columnDetails?: object[];

  /**  */
  conjunction?: string;

  /**  */
  description?: string;

  /**  */
  joinPredicate?: string;

  /**  */
  name?: string;
}

/** DataAccessPolicyImpactedObject */
export interface DataAccessPolicyImpactedObject {
  /**  */
  columnName?: string;

  /**  */
  database?: string;

  /**  */
  datasourceName?: string;

  /**  */
  name?: string;

  /**  */
  objectName?: string;

  /**  */
  objectType?: string;

  /**  */
  platformFullyQualifiedName?: string[];

  /**  */
  reason?: string;

  /**  */
  schema?: string;

  /**  */
  status?: string;
}

/** DataAccessPolicyImpactedObjectResponseModel */
export interface DataAccessPolicyImpactedObjectResponseModel {
  /**  */
  accountName?: string;

  /**  */
  count?: number;

  /**  */
  dapImpactedObjects?: DataAccessPolicyImpactedObject[];

  /**  */
  type?: string;
}

/** DataAccessPolicyModel */
export interface DataAccessPolicyModel {
  /**  */
  columnName?: string;

  /**  */
  dataSourceName?: string;

  /**  */
  databaseObjects?: DataAccessPolicyDatabaseObject[];

  /**  */
  datasourcePolicyName?: string;

  /**  */
  deleted?: boolean;

  /** false */
  deployFullGrants?: boolean;

  /**  */
  description?: string;

  /**  */
  enableFutureGrants?: boolean;

  /**  */
  enableRedeployFromDeltaSync?: boolean;

  /**  */
  enableRiskBasedAccess?: boolean;

  /**  */
  enabled?: boolean;

  /**  */
  entitlements?: DataAccessPolicyEntitlements;

  /**  */
  evaluationResult?: ResourcePolicyEvaluationResultConfiguration;

  /**  */
  functionName?: string;

  /**  */
  globalPolicy?: boolean;

  /**  */
  groupUserMappingTableName?: string;

  /**  */
  icebergPolicy?: boolean;

  /**  */
  maskingPatternName?: string;

  /**  */
  maskingPatternValue?: string;

  /**  */
  name?: string;

  /**  */
  objectNameList?: string[];

  /**  */
  objectOwnerList?: string;

  /**  */
  objectPrivilegeList?: string[];

  /**  */
  objectPrivilegeMapping?: ObjectPrivilegeMappingModel[];

  /**  */
  objectType?: string;

  /**  */
  parentRoleTemplateId?: string;

  /**  */
  policyDataTypeId?: string;

  /**  */
  policySubtype?: EnumDataAccessPolicyModelPolicySubtype;

  /**  */
  remediationSource?: RemediationMappingSource;

  /**  */
  resourceMetadata?: ResourceSourceRequestModel;

  /**  */
  resourceSourceType?: EnumDataAccessPolicyModelResourceSourceType;

  /**  */
  roleTemplateId?: string;

  /**  */
  rules?: DataAccessPolicyRuleModel[];

  /**  */
  schemaName?: string;

  /**  */
  status?: string;

  /**  */
  tableName?: string;

  /**  */
  viewDescription?: string;

  /**  */
  viewFilterConditions?: string;

  /**  */
  viewJoinConditions?: string;

  /**  */
  viewName?: string;

  /**  */
  viewTableName?: string;

  /**  */
  workspace?: string;
}

/** DataAccessPolicyObjectPrivilegeMapping */
export interface DataAccessPolicyObjectPrivilegeMapping {
  /**  */
  dataAccessPolicyId?: string;

  /**  */
  dataAccessPolicyRoleTemplateId?: string;

  /**  */
  id?: string;

  /**  */
  objectPrivilege?: string;

  /**  */
  objectType?: string;
}

/** DataAccessPolicyResourceDetails */
export interface DataAccessPolicyResourceDetails {
  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  dataAccessPolicyId?: string;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;

  /**  */
  resourceId?: string;

  /**  */
  resourceMetadata?: string;

  /**  */
  resourceSourceType?: EnumDataAccessPolicyResourceDetailsResourceSourceType;
}

/** DataAccessPolicyRoleTemplate */
export interface DataAccessPolicyRoleTemplate {
  /**  */
  accountType?: string;

  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  customObjectTypeSelectionEnabled?: boolean;

  /**  */
  dataAccessPolicyObjectPrivilegeMappings?: DataAccessPolicyObjectPrivilegeMapping[];

  /**  */
  dataAccessPolicyRoleTemplateMappings?: DataAccessPolicyRoleTemplateMapping[];

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  domainTemplate?: boolean;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;

  /**  */
  objectSelection?: string;

  /**  */
  queryContextKey?: string;

  /**  */
  subRoleTemplates?: DataAccessPolicyRoleTemplate[];

  /**  */
  typeNamesNeeded?: boolean;
}

/** DataAccessPolicyRoleTemplateMapping */
export interface DataAccessPolicyRoleTemplateMapping {
  /**  */
  dataAccessPolicyRoleTemplateId?: string;

  /**  */
  grantOption?: boolean;

  /**  */
  id?: string;

  /**  */
  objectPrivilege?: string;

  /**  */
  objectType?: string;
}

/** DataAccessPolicyRule */
export interface DataAccessPolicyRule {
  /**  */
  columnGrantSQL?: string;

  /**  */
  columnGrants?: DataAccessPolicyColumnGrant[];

  /**  */
  columnRules?: DataAccessPolicyRuleColumns[];

  /**  */
  description?: string;

  /**  */
  entitlements?: DataAccessPolicyEntitlements;

  /**  */
  futureObjectSchemaGrantSQL?: string;

  /**  */
  groupUserTableSchemaGrantSQL?: string;

  /**  */
  name?: string;

  /**  */
  outputSchemaGrantSQL?: string;

  /**  */
  queryContextId?: string;

  /**  */
  queryContextKey?: string;

  /**  */
  queryContextName?: string;

  /**  */
  queryContextValue?: string;

  /**  */
  sourceSchemaGrantSQL?: string;

  /**  */
  tableGrantSQL?: string;
}

/** DataAccessPolicyRuleColumns */
export interface DataAccessPolicyRuleColumns {
  /**  */
  arguments?: FunctionArgumentModel;

  /**  */
  columnRules?: DataAccessPolicyRuleColumns[];

  /**  */
  conditionId?: string;

  /**  */
  conditionName?: string;

  /**  */
  conjunction?: string;

  /**  */
  description?: string;

  /**  */
  elementArguments?: FunctionArgumentModel[];

  /**  */
  elementAttributeCode?: string;

  /**  */
  elementDataType?: string;

  /**  */
  elementName?: string;

  /**  */
  elementType?: string;

  /**  */
  functionArguments?: string;

  /**  */
  multiValue?: boolean;

  /**  */
  name?: string;

  /**  */
  ruleSequenceNumber?: number;

  /**  */
  selfConjunction?: string;

  /**  */
  unProtect?: boolean;

  /**  */
  value?: string;

  /**  */
  valueArguments?: FunctionArgumentModel[];

  /**  */
  valueAttributeCode?: string;

  /**  */
  valueDataType?: string;

  /**  */
  valueName?: string;

  /**  */
  valueType?: string;
}

/** DataAccessPolicyRuleColumnsModel */
export interface DataAccessPolicyRuleColumnsModel {
  /**  */
  arguments?: FunctionArgumentModel;

  /**  */
  columnRules?: DataAccessPolicyRuleColumnsModel[];

  /**  */
  conditionId?: string;

  /**  */
  conditionName?: string;

  /**  */
  conjunction?: string;

  /**  */
  elementDataType?: string;

  /**  */
  elementName?: string;

  /**  */
  elementType?: string;

  /**  */
  multiValue?: boolean;

  /**  */
  ruleSequenceNumber?: number;

  /**  */
  selectedConditionValue?: string;

  /**  */
  selfConjunction?: string;

  /**  */
  unProtect?: boolean;

  /**  */
  value?: string;

  /**  */
  valueName?: string;

  /**  */
  valueType?: string;
}

/** DataAccessPolicyRuleModel */
export interface DataAccessPolicyRuleModel {
  /**  */
  columnGrants?: DataAccessPolicyColumnGrantModel[];

  /**  */
  columnRules?: DataAccessPolicyRuleColumnsModel[];

  /**  */
  entitlements?: DataAccessPolicyEntitlements;

  /**  */
  queryContextId?: string;

  /**  */
  queryContextKey?: string;

  /**  */
  queryContextValue?: string;

  /**  */
  selectedPrincipalValue?: string;
}

/** DataAccessPolicyUDFViewModel */
export interface DataAccessPolicyUDFViewModel {
  /**  */
  udf?: string;

  /**  */
  view?: string;
}

/** DataAccessPolicyWithoutUDFModel */
export interface DataAccessPolicyWithoutUDFModel {
  /**  */
  columnName?: string;

  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  dataSourceName?: string;

  /**  */
  databaseObjects?: DataAccessPolicyDatabaseObject[];

  /**  */
  datasourcePolicyName?: string;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  draftPolicyId?: string;

  /**  */
  enableFutureGrants?: boolean;

  /**  */
  enableRedeployFromDeltaSync?: boolean;

  /**  */
  enableRiskBasedAccess?: boolean;

  /**  */
  enabled?: boolean;

  /**  */
  entitlements?: DataAccessPolicyEntitlements;

  /**  */
  evaluationResult?: ResourcePolicyEvaluationResultConfiguration;

  /**  */
  failMessage?: string;

  /**  */
  functionName?: string;

  /**  */
  groupUserMappingTableName?: string;

  /**  */
  id?: string;

  /**  */
  includeViewAccessGrants?: boolean;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  maskingPatternName?: string;

  /**  */
  maskingPatternValue?: string;

  /**  */
  name?: string;

  /**  */
  objectNameList?: string[];

  /**  */
  objectOwnerList?: string;

  /**  */
  objectPrivilege?: string;

  /**  */
  objectType?: string;

  /**  */
  parentRoleTemplate?: DataAccessPolicyRoleTemplate;

  /**  */
  parentRoleTemplateId?: string;

  /**  */
  policyActions?: TlxObjectActionMappingModel[];

  /**  */
  policyDataTypeId?: string;

  /**  */
  policyDataTypeName?: string;

  /**  */
  policyOwner?: boolean;

  /**  */
  policySubtype?: string;

  /**  */
  prevPolicyId?: string;

  /**  */
  previousModelJSON?: string;

  /**  */
  principals?: string[];

  /**  */
  privilegeList?: ObjectPrivilege[];

  /**  */
  redeployRequired?: boolean;

  /**  */
  redshiftJDBCURL?: string;

  /**  */
  remediationMsg?: string;

  /**  */
  resourceIdList?: string[];

  /**  */
  resourceMetadata?: ResourceSourceRequestModel;

  /**  */
  resourceSourceType?: EnumDataAccessPolicyWithoutUDFModelResourceSourceType;

  /**  */
  roleTemplate?: DataAccessPolicyRoleTemplate;

  /**  */
  roleTemplateId?: string;

  /**  */
  rootPolicyCreatedBy?: string;

  /**  */
  rules?: DataAccessPolicyRule[];

  /**  */
  schemaName?: string;

  /**  */
  securedObjects?: SecuredObjects;

  /**  */
  status?: string;

  /**  */
  tableName?: string;

  /**  */
  version?: number;

  /**  */
  viewDescription?: string;

  /**  */
  viewFilterConditions?: string;

  /**  */
  viewJoinConditions?: string;

  /**  */
  viewName?: string;

  /**  */
  viewTableName?: string;

  /**  */
  workspace?: string;
}

/** DataCatalog */
export interface DataCatalog {
  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  dataCatalogElements?: DataCatalogElement[];

  /**  */
  dataSourceName?: string;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;
}

/** DataCatalogElement */
export interface DataCatalogElement {
  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;

  /**  */
  tagNames?: string[];

  /**  */
  tags?: Tag[];
}

/** DataCatalogElementModel */
export interface DataCatalogElementModel {
  /**  */
  name?: string;

  /**  */
  tagNames?: string[];
}

/** DataCatalogModel */
export interface DataCatalogModel {
  /**  */
  dataCatalogElements?: DataCatalogElementModel[];

  /**  */
  dataSourceName?: string;
}

/** DataClassification */
export interface DataClassification {
  /**  */
  classificationType?: ClassificationType[];

  /**  */
  columnName?: string;

  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  dataSourceName?: string;

  /**  */
  dbName?: string;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  isSystemTag?: boolean;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;

  /**  */
  objectName?: string;

  /**  */
  objectType?: string;

  /**  */
  schemaName?: string;

  /**  */
  tableName?: string;

  /**  */
  tagKey?: string;

  /**  */
  tagValue?: string;
}

/** DataClassificationModel */
export interface DataClassificationModel {
  /**  */
  classificationList?: string[];

  /**  */
  cloudAccountId: string;

  /**  */
  dataSourceName?: string;

  /**  */
  dbName?: string;

  /**  */
  isSystemTag?: boolean;

  /**  */
  objectName: string;

  /**  */
  objectType: string;

  /**  */
  schemaName?: string;

  /**  */
  tableName?: string;
}

/** DataClassificationResponse */
export interface DataClassificationResponse {
  /**  */
  classificationType?: ClassificationType[];

  /**  */
  dataSourceName?: string;

  /**  */
  dbInstance?: string;

  /**  */
  dbName?: string;

  /**  */
  dbType?: string;

  /**  */
  isSystemTag?: boolean;

  /**  */
  objectName?: string;

  /**  */
  objectType?: string;

  /**  */
  schemaName?: string;

  /**  */
  tableName?: string;

  /**  */
  tagKey?: string;

  /**  */
  tagValue?: string;

  /**  */
  tenantId?: string;
}

/** DataDomainModel */
export interface DataDomainModel {
  /**  */
  accounts?: string[];

  /**  */
  description?: string;

  /**  */
  domainValues?: string;

  /**  */
  name?: string;
}

/** DataDomainPaginatedModel */
export interface DataDomainPaginatedModel {
  /**  */
  accounts?: AccountModel[];

  /**  */
  description?: string;

  /**  */
  domainValues?: string;

  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  products?: DataProductPaginatedModel[];

  /**  */
  users?: string[];
}

/** DataLakePrincipal */
export interface DataLakePrincipal {
  /**  */
  dataLakePrincipalIdentifier?: string;
}

/** DataMovementActivityModel */
export interface DataMovementActivityModel {
  /**  */
  activityTime?: Date;

  /**  */
  loginClient?: string;

  /**  */
  operationType?: string;

  /**  */
  optinAccountId?: string;

  /**  */
  optinClassification?: string;

  /**  */
  optinDatasourceName?: string;

  /**  */
  optinDatasourceType?: string;

  /**  */
  optinLLMMetadata?: LLMMetadataModel[];

  /**  */
  optinLocation?: string;

  /**  */
  optinRole?: string;

  /**  */
  optinS3Metada?: S3MetadataModel[];

  /**  */
  optinSnowflakeMetada?: SnowflakeShareMetadataModel[];

  /**  */
  optinUser?: string;

  /**  */
  primaryClassification?: string;

  /**  */
  primaryLocation?: string;

  /**  */
  primaryRole?: string;

  /**  */
  primaryUser?: string;

  /**  */
  queryText?: string;

  /**  */
  reportName?: string;

  /**  */
  transferDataSize?: number;
}

/** DataMovementNodeDailyDataSizeSummaryModel */
export interface DataMovementNodeDailyDataSizeSummaryModel {
  /**  */
  activity_time?: string;

  /**  */
  alert_count?: number;

  /**  */
  query_transaction_count?: number;

  /**  */
  size?: number;
}

/** DataMovementNodeNameType */
export interface DataMovementNodeNameType {
  /**  */
  externalDatasourceName?: string;

  /**  */
  externalDatasourceType?: string;

  /**  */
  operationType?: string;
}

/** DataMovementNodeS3SummaryModel */
export interface DataMovementNodeS3SummaryModel {
  /**  */
  awsAccountName?: string;

  /**  */
  awsAccountNumber?: string;

  /**  */
  awsRegion?: string;

  /**  */
  creationDate?: string;

  /**  */
  encryption?: Details;

  /**  */
  objectName?: string;

  /**  */
  publicAccess?: Details;

  /**  */
  tags?: object[];
}

/** DataMovementNodeSharesSummaryModel */
export interface DataMovementNodeSharesSummaryModel {
  /**  */
  activity_time?: string;

  /**  */
  classification?: string;

  /**  */
  column_name?: string;

  /**  */
  consumer?: string;

  /**  */
  database_name?: string;

  /**  */
  object_name?: string;

  /**  */
  object_type?: string;

  /**  */
  schema_name?: string;

  /**  */
  user_name?: string;
}

/** DataMovementNodeSummaryModel */
export interface DataMovementNodeSummaryModel {
  /**  */
  activity_time?: string;

  /**  */
  destination_location?: string;

  /**  */
  destination_type?: string;

  /**  */
  login_client?: string;

  /**  */
  name?: string;

  /**  */
  query_text?: string;

  /**  */
  size?: number;

  /**  */
  source_classification?: string;

  /**  */
  source_location?: string;

  /**  */
  source_type?: string;

  /**  */
  user?: string;
}

/** DataMovementResponseModel */
export interface DataMovementResponseModel {
  /**  */
  inbound?: ExternalInfo[];

  /**  */
  name?: string;

  /**  */
  outbound?: ExternalInfo[];

  /**  */
  type?: string;
}

/** DataPlaneNotification */
export interface DataPlaneNotification {
  /**  */
  accountId?: string;

  /**  */
  accountName?: string;

  /**  */
  accountType?: string;

  /**  */
  category: string;

  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  description?: string;

  /**  */
  dismissed?: boolean;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  message: string;

  /**  */
  messageDetail: string;

  /**  */
  read?: boolean;

  /**  */
  recommendation?: string;

  /**  */
  statusType?: string;

  /**  */
  statusValue?: string;

  /**  */
  taskRunId?: string;

  /**  */
  taskType: string;

  /**  */
  tenantId: string;
}

/** DataPlaneNotificationDashboardResponseModel */
export interface DataPlaneNotificationDashboardResponseModel {
  /**  */
  accountId?: string;

  /**  */
  accountType?: string;

  /**  */
  createdAt?: Date;

  /**  */
  id?: string;

  /**  */
  issue?: string;

  /**  */
  notificationLevel?: string;

  /**  */
  read?: boolean;

  /**  */
  remedy?: string;

  /**  */
  reportOrPolicyName?: string;

  /**  */
  tenantId?: string;
}

/** DataPrivacyPolicy */
export interface DataPrivacyPolicy {
  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  dataPrivacyPolicyElements?: DataPrivacyPolicyElement[];

  /**  */
  dataSourceName?: string;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  enabled?: boolean;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;

  /**  */
  outputPath?: string;

  /**  */
  status?: string;
}

/** DataPrivacyPolicyElement */
export interface DataPrivacyPolicyElement {
  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;

  /**  */
  privacyEnforcementType?: PrivacyEnforcementType;

  /**  */
  privacyEnforcementTypeId?: string;

  /**  */
  privacyEnforcementTypeName?: string;

  /**  */
  tag?: Tag;

  /**  */
  tagId?: string;

  /**  */
  tagName?: string;
}

/** DataPrivacyPolicyElementModel */
export interface DataPrivacyPolicyElementModel {
  /**  */
  privacyEnforcementTypeId?: string;

  /**  */
  privacyEnforcementTypeName?: string;

  /**  */
  tagId?: string;

  /**  */
  tagName?: string;
}

/** DataPrivacyPolicyModel */
export interface DataPrivacyPolicyModel {
  /**  */
  dataPrivacyPolicyElements?: DataPrivacyPolicyElementModel[];

  /**  */
  dataSourceName?: string;

  /**  */
  description?: string;

  /**  */
  enabled?: boolean;

  /**  */
  name?: string;

  /**  */
  outputPath?: string;
}

/** DataProductAttributesUpsertRequestModel */
export interface DataProductAttributesUpsertRequestModel {
  /**  */
  attributes?: object;
}

/** DataProductListItemModel */
export interface DataProductListItemModel {
  /**  */
  attributes?: object;

  /**  */
  description?: string;

  /**  */
  domains?: string[];

  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  objectNames?: string[];
}

/** DataProductMappingModel */
export interface DataProductMappingModel {
  /**  */
  dataDomainId?: string;

  /**  */
  dataProducts?: DataProductModel[];
}

/** DataProductModel */
export interface DataProductModel {
  /**  */
  accounts?: string[];

  /**  */
  description?: string;

  /**  */
  domainId?: string;

  /**  */
  name?: string;

  /**  */
  productValue?: string;
}

/** DataProductObjectListingAccountResponseModel */
export interface DataProductObjectListingAccountResponseModel {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  type?: string;
}

/** DataProductPaginatedModel */
export interface DataProductPaginatedModel {
  /**  */
  accounts?: AccountModel[];

  /**  */
  description?: string;

  /**  */
  domainNames?: string;

  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  productValues?: string;
}

/** DataProtectionReport */
export interface DataProtectionReport {
  /**  */
  alertCount?: number;

  /**  */
  dataAccessPolicyCount?: number;

  /**  */
  monitoringPolicyCount?: number;

  /**  */
  securedDataSourceCount?: number;
}

/** DataSourceSupportedColumns */
export interface DataSourceSupportedColumns {
  /**  */
  createdDate?: Date;

  /**  */
  dataSourceName?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  supportedColumns?: string;
}

/** DataTypeConditionMatchWithMappingModel */
export interface DataTypeConditionMatchWithMappingModel {
  /**  */
  condition?: ConditionModel;

  /**  */
  dataType?: DataTypeModel;

  /**  */
  id?: string;

  /**  */
  matchWithElement?: MatchWithElementModel[];

  /**  */
  multiValue?: boolean;
}

/** DataTypeModel */
export interface DataTypeModel {
  /**  */
  elementType?: string;

  /**  */
  equivalentTypes?: string;

  /**  */
  name?: string;
}

/** Database */
export interface Database {
  /**  */
  catalogId?: string;

  /**  */
  createTableDefaultPermissions?: PrincipalPermissions[];

  /**  */
  createTime?: Date;

  /**  */
  description?: string;

  /**  */
  locationUri?: string;

  /**  */
  name?: string;

  /**  */
  parameters?: object;

  /**  */
  targetDatabase?: DatabaseIdentifier;
}

/** DatabaseIdentifier */
export interface DatabaseIdentifier {
  /**  */
  catalogId?: string;

  /**  */
  databaseName?: string;
}

/** DatabaseMetadata */
export interface DatabaseMetadata {
  /**  */
  id?: string;

  /**  */
  name?: string;
}

/** DatabaseObject */
export interface DatabaseObject {
  /**  */
  names?: string;
}

/** DcrRegistrationRequestModel */
export interface DcrRegistrationRequestModel {
  /**  */
  scope?: string;

  /**  */
  vendor: string;
}

/** DcrRegistrationResponseModel */
export interface DcrRegistrationResponseModel {
  /**  */
  authorizationUrl?: string;

  /**  */
  tokenName?: string;
}

/** DecisionAgent */
export interface DecisionAgent {
  /**  */
  application?: string;

  /**  */
  businessUnit?: string;

  /**  */
  classification?: string;

  /**  */
  complianceFramework?: string;

  /**  */
  dataSource?: string;

  /**  */
  id?: string;

  /**  */
  name?: string;
}

/** DecisionImpact */
export interface DecisionImpact {
  /**  */
  after?: string[];

  /**  */
  before?: string[];

  /**  */
  completeDecisionLogging?: boolean;

  /**  */
  defaultScopeId?: string;

  /**  */
  futureRequestsRouted?: boolean;

  /**  */
  noExpectedDowntime?: boolean;

  /**  */
  recentRiskyActivitiesBlocked?: number;

  /**  */
  scopeOptions?: ScopeOption[];
}

/** DependsOnModel */
export interface DependsOnModel {
  /**  */
  field?: string;

  /**  */
  value?: object;
}

/** DeploymentItem */
export interface DeploymentItem {
  /**  */
  accountId?: string;

  /**  */
  currentDeployGrants?: string;

  /**  */
  currentRevokeGrants?: string;

  /**  */
  message?: string;

  /**  */
  schemaGrants?: string;

  /**  */
  status?: string;

  /**  */
  tableGrants?: string;
}

/** Details */
export interface Details {
  /**  */
  attributeName?: string;

  /**  */
  attributeValue?: string;

  /**  */
  isRisk?: boolean;
}

/** DisableUserPolicyModel */
export interface DisableUserPolicyModel {
  /**  */
  source?: RemediationMappingSource;

  /**  */
  tenantId?: string;

  /**  */
  username?: string;
}

/** DomainDataAccessPolicyModel */
export interface DomainDataAccessPolicyModel {
  /**  */
  account?: Account;

  /**  */
  accountId?: string;

  /**  */
  autoDeploy?: boolean;

  /**  */
  columnName?: string;

  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  dataAccessPolicyDBDetails?: DataAccessPolicyDBDetails[];

  /**  */
  dataAccessPolicyDeploymentStatusList?: DataAccessPolicyDeployStatusTracker[];

  /**  */
  dataSourceName?: string;

  /**  */
  databaseObjects?: DataAccessPolicyDatabaseObject[];

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  domainPolicyGrants?: DomainPolicyAccountGrantsModel[];

  /**  */
  draftPolicyId?: string;

  /**  */
  enableFutureGrants?: boolean;

  /**  */
  enabled?: boolean;

  /**  */
  entitlements?: DataAccessPolicyEntitlements;

  /**  */
  failMessage?: string;

  /**  */
  failMessageDetail?: string;

  /**  */
  functionName?: string;

  /**  */
  globalPolicy?: boolean;

  /**  */
  groupPolicy?: boolean;

  /**  */
  groupTableSchemaName?: string;

  /**  */
  groupUserMappingTableName?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  latestDeployPolicySerialNo?: number;

  /**  */
  maskingPatternName?: string;

  /**  */
  maskingPatternValue?: string;

  /**  */
  name?: string;

  /**  */
  objectNameList?: string[];

  /**  */
  objectOwnerList?: string;

  /**  */
  objectPrivilege?: string;

  /**  */
  objectType?: string;

  /**  */
  parentRoleTemplate?: DataAccessPolicyRoleTemplate;

  /**  */
  parentRoleTemplateId?: string;

  /**  */
  policyAccountsCount?: number;

  /**  */
  policyActions?: TlxObjectActionMappingModel[];

  /**  */
  policyDataType?: PolicyDataType;

  /**  */
  policyDataTypeId?: string;

  /**  */
  policyDataTypeName?: string;

  /**  */
  policySubtype?: string;

  /**  */
  prevPolicy?: DataAccessPolicy;

  /**  */
  prevPolicyId?: string;

  /**  */
  previousModelJSON?: string;

  /**  */
  privilegeList?: ObjectPrivilege[];

  /**  */
  redshiftJDBCURL?: string;

  /**  */
  remediationMsg?: string;

  /**  */
  remediationSource?: RemediationMappingSource;

  /**  */
  retryCount?: number;

  /**  */
  roleTemplate?: DataAccessPolicyRoleTemplate;

  /**  */
  roleTemplateId?: string;

  /**  */
  rootPolicyId?: string;

  /**  */
  rules?: DataAccessPolicyRule[];

  /**  */
  schemaName?: string;

  /**  */
  status?: string;

  /**  */
  tableName?: string;

  /**  */
  tenantProfile?: TenantProfile;

  /**  */
  udf?: string;

  /**  */
  version?: number;

  /**  */
  view?: string;

  /**  */
  viewDescription?: string;

  /**  */
  viewFilterConditions?: string;

  /**  */
  viewJoinConditions?: string;

  /**  */
  viewName?: string;

  /**  */
  viewTableName?: string;
}

/** DomainPolicyAccountGrantsModel */
export interface DomainPolicyAccountGrantsModel {
  /**  */
  account?: AccountModel;

  /**  */
  failMessage?: string;

  /**  */
  failMessageDetail?: string;

  /**  */
  id?: string;

  /**  */
  schemaGrants?: string;

  /**  */
  status?: string;

  /**  */
  tableGrants?: string;
}

/** DomainProdutMetadata */
export interface DomainProdutMetadata {
  /**  */
  name?: string;
}

/** DraftRequest */
export interface DraftRequest {
  /**  */
  environmentId?: string;

  /**  */
  intent: string;

  /**  */
  scope?: AgentPolicyScopeModel;
}

/** EnforcementCoverage */
export interface EnforcementCoverage {
  /**  */
  API?: number;

  /**  */
  DATA?: object;

  /**  */
  MISSING?: number;

  /**  */
  NATIVE?: number;
}

/** EnforcementEnvironment */
export interface EnforcementEnvironment {
  /**  */
  enabled?: boolean;

  /**  */
  status?: EnumEnforcementEnvironmentStatus;
}

/** EnterprisePolicyRequest */
export interface EnterprisePolicyRequest {
  /**  */
  description?: string;

  /**  */
  enabled?: boolean;

  /**  */
  enforcementCoverage?: EnforcementCoverage;

  /**  */
  name?: string;

  /**  */
  rules?: DataAccessPolicyRuleModel[];

  /**  */
  severityId?: string;
}

/** EnterprisePolicyResponse */
export interface EnterprisePolicyResponse {
  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  enabled?: boolean;

  /**  */
  enforcementCoverage?: EnforcementCoverage;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;

  /**  */
  policyActions?: TlxObjectActionMappingModel[];

  /**  */
  rules?: DataAccessPolicyRuleModel[];

  /**  */
  severity?: EnterpriseSeverityResponse;

  /**  */
  status?: string;

  /**  */
  version?: number;
}

/** EnterpriseSeverityResponse */
export interface EnterpriseSeverityResponse {
  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  name?: string;
}

/** Entitlement attribute column with account-specific mappings */
export interface EntitlementAttributeColumnModel {
  /** Display name of the attribute */
  displayName?: string;

  /** List of account-specific mappings for this attribute */
  mapping?: EntitlementAttributeMappingModel[];

  /** Internal name of the attribute */
  name?: string;

  /** Data type of the attribute */
  type?: string;
}

/** Account-specific mapping for an entitlement attribute column */
export interface EntitlementAttributeMappingModel {
  /** Actual data type in the target account */
  actualDataType?: string;

  /** Whether this column supports multiple values */
  isMultiValue?: boolean;

  /** Column name in the target account */
  name?: string;

  /** Target account ID */
  targetAccount?: string;
}

/** EntitlementAttributeSourceConfigModel */
export interface EntitlementAttributeSourceConfigModel {
  /**  */
  filterCondition?: GenericFilterConditionModel;

  /**  */
  id?: string;

  /**  */
  tableName?: string;

  /**  */
  workspace?: string;
}

/** EntitlementPrivilegeModel */
export interface EntitlementPrivilegeModel {
  /**  */
  name?: string;

  /**  */
  privileges?: string[];
}

/** EntitlementReportPivotValue */
export interface EntitlementReportPivotValue {
  /**  */
  databaseName?: string;

  /**  */
  groupName?: string;

  /**  */
  objectName?: string;

  /**  */
  objectType?: string;

  /**  */
  roleName?: string;

  /**  */
  schemaName?: string;

  /**  */
  userName?: string;
}

/** EntityAttributeMapping */
export interface EntityAttributeMapping {
  /**  */
  accountId?: string;

  /**  */
  attributeType?: string;

  /**  */
  attributeValue?: string;

  /**  */
  domainId?: string;

  /**  */
  entityId?: string;

  /**  */
  entityType?: string;

  /**  */
  id?: string;

  /**  */
  tenantId?: string;
}

/** EntityMappingModel */
export interface EntityMappingModel {
  /**  */
  accountId?: string;

  /**  */
  attributeContextValues?: string;

  /**  */
  attributeKey?: string;

  /**  */
  attributeValue?: string;

  /**  */
  domain?: string;

  /**  */
  entityKey?: string;

  /**  */
  entityType?: string;
}

/** EstateAgentAttributesModel */
export interface EstateAgentAttributesModel {
  /**  */
  agentId?: string;

  /**  */
  values: object;
}

/** EstateAgentDetailModel */
export interface EstateAgentDetailModel {
  /**  */
  accessFlow?: object;

  /**  */
  accessRevoked?: boolean;

  /**  */
  appliedPolicies?: AppliedPolicyModel[];

  /**  */
  appliedPolicyNames?: string[];

  /**  */
  businessUnit?: string;

  /**  */
  classificationEvidence?: ClassificationEvidenceModel;

  /**  */
  connectedResource?: string;

  /**  */
  description?: string;

  /**  */
  effectivePolicies?: object[];

  /**  */
  enforcementReadiness?: AgentEnforcementReadinessModel;

  /**  */
  environmentType?: string;

  /**  */
  id?: string;

  /**  */
  identityName?: string;

  /**  */
  identityProvider?: EnumEstateAgentDetailModelIdentityProvider;

  /**  */
  lastEvaluated?: string;

  /**  */
  lastObserved?: string;

  /**  */
  mcpServiceCount?: number;

  /**  */
  mcpServices?: McpServiceModel[];

  /**  */
  mission?: AgentMissionModel;

  /**  */
  model?: string;

  /**  */
  name?: string;

  /**  */
  owner?: string;

  /**  */
  platform?: EnumEstateAgentDetailModelPlatform;

  /**  */
  policyGaps?: object[];

  /**  */
  project?: string;

  /**  */
  purpose?: string;

  /**  */
  purposeDescription?: string;

  /**  */
  recentActivity?: object[];

  /**  */
  recommendedPolicyCount?: number;

  /**  */
  region?: string;

  /**  */
  securityStatus?: EnumEstateAgentDetailModelSecurityStatus;

  /**  */
  sourceIntegrationId?: string;

  /**  */
  status?: string;

  /**  */
  toolCount?: number;
}

/** EstateAgentFilter */
export interface EstateAgentFilter {
  /**  */
  agentRegistryId?: string;

  /**  */
  connectedResource?: string[];

  /**  */
  enforcementStatus?: string[];

  /**  */
  environmentId?: string;

  /**  */
  environmentType?: string[];

  /**  */
  hasRecommendations?: boolean;

  /**  */
  platform?: string[];

  /**  */
  project?: string[];

  /**  */
  purpose?: string[];

  /**  */
  search?: string;

  /**  */
  securityStatus?: string[];
}

/** EstateAgentModel */
export interface EstateAgentModel {
  /**  */
  accessRevoked?: boolean;

  /**  */
  appliedPolicyNames?: string[];

  /**  */
  businessUnit?: string;

  /**  */
  connectedResource?: string;

  /**  */
  enforcementReadiness?: AgentEnforcementReadinessModel;

  /**  */
  environmentType?: string;

  /**  */
  id?: string;

  /**  */
  identityName?: string;

  /**  */
  identityProvider?: EnumEstateAgentModelIdentityProvider;

  /**  */
  lastEvaluated?: string;

  /**  */
  lastObserved?: string;

  /**  */
  mcpServiceCount?: number;

  /**  */
  name?: string;

  /**  */
  owner?: string;

  /**  */
  platform?: EnumEstateAgentModelPlatform;

  /**  */
  project?: string;

  /**  */
  purpose?: string;

  /**  */
  purposeDescription?: string;

  /**  */
  recommendedPolicyCount?: number;

  /**  */
  region?: string;

  /**  */
  securityStatus?: EnumEstateAgentModelSecurityStatus;

  /**  */
  sourceIntegrationId?: string;

  /**  */
  status?: string;

  /**  */
  toolCount?: number;
}

/** EstateCard */
export interface EstateCard {
  /**  */
  availability?: string;

  /**  */
  description?: string;

  /**  */
  discoveredDelta?: number;

  /**  */
  discoveryState?: string;

  /**  */
  id?: string;

  /**  */
  label?: string;

  /**  */
  value?: number;
}

/** EstateSearchGroupModel */
export interface EstateSearchGroupModel {
  /**  */
  items?: EstateSearchItemModel[];

  /**  */
  total?: number;

  /**  */
  type?: EnumEstateSearchGroupModelType;
}

/** EstateSearchItemModel */
export interface EstateSearchItemModel {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  status?: string;

  /**  */
  subType?: string;

  /**  */
  subTypeLabel?: string;

  /**  */
  type?: EnumEstateSearchItemModelType;
}

/** EstateSearchResponseModel */
export interface EstateSearchResponseModel {
  /**  */
  groups?: EstateSearchGroupModel[];

  /**  */
  query?: string;
}

/** ExecutiveBriefing */
export interface ExecutiveBriefing {
  /**  */
  affectedAgents?: DecisionAgent[];

  /**  */
  behavior?: BlockedAllowed;

  /**  */
  confidencePercent?: number;

  /**  */
  evidenceSignals?: LabeledValue[];

  /**  */
  guardianQuestions?: GuardianQuestion[];

  /**  */
  impactDimensions?: ImpactDimension[];

  /**  */
  rationale?: string[];

  /**  */
  summary?: ExecutiveSummary;

  /**  */
  technicalDetails?: LabeledValue[];
}

/** ExecutiveSummary */
export interface ExecutiveSummary {
  /**  */
  businessOwner?: string;

  /**  */
  businessOwnerRole?: string;

  /**  */
  description?: string;

  /**  */
  headline?: string;

  /**  */
  severity?: string;
}

/** ExternalInfo */
export interface ExternalInfo {
  /**  */
  alertCount?: number;

  /**  */
  name?: string;

  /**  */
  objectCount?: number;

  /**  */
  sprawlType?: string[];

  /**  */
  type?: string;

  /**  */
  weight?: string;
}

/** ExternalIntegrationDetailsMetadata */
export interface ExternalIntegrationDetailsMetadata {
  /**  */
  accountIds?: string[];

  /**  */
  apiToken?: string;

  /**  */
  applicationId?: string;

  /**  */
  applicationURL?: string;

  /**  */
  catalogApiType?: string;

  /**  */
  catalogName?: string;

  /**  */
  clientId?: string;

  /**  */
  clientSecret?: string;

  /**  */
  deleteInactiveUser?: boolean;

  /**  */
  emailList?: string[];

  /**  */
  enableFullSync?: boolean;

  /**  */
  humanReadable?: boolean;

  /**  */
  identity?: AgentRegistryIdentityModel;

  /**  */
  name?: string;

  /**  */
  prerequisites?: AgentRegistryPrerequisitesModelRes;

  /**  */
  scimDetails?: ExternalIntegrationScimModel;

  /**  */
  scimToken?: string;

  /**  */
  scimUrl?: string;

  /**  */
  selectedProjects?: AgentRegistryProjectModel[];

  /**  */
  severity?: string[];

  /**  */
  sourceId?: string;

  /**  */
  tenantId?: string;

  /**  */
  token?: string;

  /**  */
  tokenExpiryTime?: string;

  /**  */
  url?: string;

  /**  */
  userDeprovisioningEnabled?: boolean;

  /**  */
  userId?: number;

  /**  */
  userName?: string;

  /**  */
  userProvisioningEnabled?: boolean;

  /**  */
  webhookUrl?: string;
}

/** ExternalIntegrationDetailsMetadataReq */
export interface ExternalIntegrationDetailsMetadataReq {
  /**  */
  accountIds?: string[];

  /**  */
  apiToken?: string;

  /**  */
  applicationId?: string;

  /**  */
  applicationURL?: string;

  /**  */
  catalogApiType?: string;

  /**  */
  catalogName?: string;

  /**  */
  clientId?: string;

  /**  */
  clientSecret?: string;

  /**  */
  deleteInactiveUser?: boolean;

  /**  */
  emailList?: string[];

  /**  */
  enableFullSync?: boolean;

  /**  */
  humanReadable?: boolean;

  /**  */
  identity?: AgentRegistryIdentityModel;

  /**  */
  name?: string;

  /**  */
  prerequisites?: AgentRegistryPrerequisitesModelReq;

  /**  */
  scimDetails?: ExternalIntegrationScimModel;

  /**  */
  scimToken?: string;

  /**  */
  scimUrl?: string;

  /**  */
  selectedProjects?: AgentRegistryProjectModel[];

  /**  */
  severity?: string[];

  /**  */
  sourceId?: string;

  /**  */
  tenantId?: string;

  /**  */
  token?: string;

  /**  */
  tokenExpiryTime?: string;

  /**  */
  url?: string;

  /**  */
  userDeprovisioningEnabled?: boolean;

  /**  */
  userId?: number;

  /**  */
  userName?: string;

  /**  */
  userProvisioningEnabled?: boolean;

  /**  */
  webhookUrl?: string;
}

/** ExternalIntegrationDetailsMetadataRes */
export interface ExternalIntegrationDetailsMetadataRes {
  /**  */
  accountIds?: string[];

  /**  */
  apiToken?: string;

  /**  */
  applicationId?: string;

  /**  */
  applicationURL?: string;

  /**  */
  catalogApiType?: string;

  /**  */
  catalogName?: string;

  /**  */
  clientId?: string;

  /**  */
  clientSecret?: string;

  /**  */
  deleteInactiveUser?: boolean;

  /**  */
  emailList?: string[];

  /**  */
  enableFullSync?: boolean;

  /**  */
  humanReadable?: boolean;

  /**  */
  identity?: AgentRegistryIdentityModel;

  /**  */
  name?: string;

  /**  */
  prerequisites?: AgentRegistryPrerequisitesModelRes;

  /**  */
  scimDetails?: ExternalIntegrationScimModel;

  /**  */
  scimToken?: string;

  /**  */
  scimUrl?: string;

  /**  */
  selectedProjects?: AgentRegistryProjectModel[];

  /**  */
  severity?: string[];

  /**  */
  sourceId?: string;

  /**  */
  tenantId?: string;

  /**  */
  token?: string;

  /**  */
  tokenExpiryTime?: string;

  /**  */
  url?: string;

  /**  */
  userDeprovisioningEnabled?: boolean;

  /**  */
  userId?: number;

  /**  */
  userName?: string;

  /**  */
  userProvisioningEnabled?: boolean;

  /**  */
  webhookUrl?: string;
}

/** ExternalIntegrationModel */
export interface ExternalIntegrationModel {
  /**  */
  agentCount?: number;

  /**  */
  domainName?: string;

  /**  */
  id?: string;

  /**  */
  integrationDetails?: ExternalIntegrationDetailsMetadata;

  /**  */
  integrationType?: string;

  /**  */
  password?: string;

  /**  */
  status?: string;

  /**  */
  type?: string;
}

/** ExternalIntegrationModelReq */
export interface ExternalIntegrationModelReq {
  /**  */
  agentCount?: number;

  /**  */
  domainName?: string;

  /**  */
  id?: string;

  /**  */
  integrationDetails?: ExternalIntegrationDetailsMetadataReq;

  /**  */
  integrationType?: string;

  /**  */
  password?: string;

  /**  */
  status?: string;

  /**  */
  type?: string;
}

/** ExternalIntegrationModelRes */
export interface ExternalIntegrationModelRes {
  /**  */
  agentCount?: number;

  /**  */
  domainName?: string;

  /**  */
  id?: string;

  /**  */
  integrationDetails?: ExternalIntegrationDetailsMetadataRes;

  /**  */
  integrationType?: string;

  /**  */
  password?: string;

  /**  */
  status?: string;

  /**  */
  type?: string;
}

/** ExternalIntegrationScimModel */
export interface ExternalIntegrationScimModel {
  /**  */
  scimToken?: string;

  /**  */
  scimUrl?: string;

  /**  */
  tokenExpiryTime?: Date;
}

/** ExternalIntegrationSourceDetails */
export interface ExternalIntegrationSourceDetails {
  /**  */
  azureClientId?: string;

  /**  */
  azureTenantId?: string;

  /**  */
  deleteInactiveUser?: boolean;

  /**  */
  id?: string;

  /**  */
  syncMode?: EnumExternalIntegrationSourceDetailsSyncMode;
}

/** ExternalSourceConfigurationDetails */
export interface ExternalSourceConfigurationDetails {
  /**  */
  attributeProperty?: ExternalSourceUserAttributeModel[];

  /**  */
  configType?: string;

  /**  */
  dataProductColumnName?: string;

  /**  */
  entitlementAttributeTableName?: string;

  /**  */
  externalIdentityGroupMembershipTableName?: string;

  /**  */
  externalIdentityGroupTableName?: string;

  /**  */
  externalIntegration?: ExternalIntegrationSourceDetails;

  /**  */
  sourceConfigurationId?: string;

  /**  */
  userAttributeColumns?: UserEntitlementAttributeColumnModel[];
}

/** ExternalSourceUserAttributeModel */
export interface ExternalSourceUserAttributeModel {
  /**  */
  availableInPortal?: boolean;

  /**  */
  description?: string;

  /**  */
  displayName?: string;

  /**  */
  multiValue?: boolean;

  /**  */
  name?: string;

  /**  */
  type?: string;

  /**  */
  usedInUserFlows?: boolean;
}

/** ExternalSourceUserAttributeValueModel */
export interface ExternalSourceUserAttributeValueModel {
  /**  */
  columns?: ExternalSourceUserAttributeModel[];

  /**  */
  nextLink?: string;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  values?: object[];
}

/** ExternalUserImportRequestModel */
export interface ExternalUserImportRequestModel {
  /**  */
  attributeAndValue?: object[];

  /**  */
  targetDataSource?: TargetDatasourceModel[];
}

/** ExternalUserSearchRequestModel */
export interface ExternalUserSearchRequestModel {
  /**  */
  pageNo?: number;

  /**  */
  pageSize?: number;

  /**  */
  params?: SearchParamModel[];

  /**  */
  search?: string;

  /**  */
  targetDataSource?: TargetDatasourceModel[];
}

/** FailureDetail */
export interface FailureDetail {
  /**  */
  datasetPath?: string;

  /**  */
  reason?: string;
}

/** FlowContext */
export interface FlowContext {
  /**  */
  agentIds?: string[];

  /**  */
  label?: string;
}

/** FreemiumMeter */
export interface FreemiumMeter {
  /**  */
  currentDataSize?: number;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  reportDate?: Date;

  /**  */
  tenantId?: string;

  /**  */
  totalSizeThreshold?: number;
}

/** FreemiumMeterModel */
export interface FreemiumMeterModel {
  /**  */
  currentDataSize?: number;

  /**  */
  description?: string;

  /**  */
  name?: string;

  /**  */
  reportDate?: Date;

  /**  */
  tenantId?: string;

  /**  */
  totalSizeThreshold?: number;
}

/** FunctionArgumentModel */
export interface FunctionArgumentModel {
  /**  */
  argName?: string;

  /**  */
  argValue?: string;

  /**  */
  argValueDataType?: string;

  /**  */
  dataType?: string;

  /**  */
  defaultValue?: string;

  /**  */
  elementArguments?: FunctionArgumentModel[];

  /**  */
  hideParamInConditionBuilder?: boolean;

  /**  */
  order?: number;

  /**  */
  type?: string;

  /**  */
  valueArguments?: FunctionArgumentModel[];
}

/** GenericFilterConditionModel */
export interface GenericFilterConditionModel {
  /**  */
  columnRules?: DataAccessPolicyRuleColumnsModel[];
}

/** GitBookSyncResultModel */
export interface GitBookSyncResultModel {
  /**  */
  message?: string;

  /**  */
  pagesAdded?: number;

  /**  */
  pagesDeactivated?: number;

  /**  */
  pagesUpdated?: number;

  /**  */
  syncedAt?: Date;
}

/** GlobalAccountBatchStatusResponseModel */
export interface GlobalAccountBatchStatusResponseModel {
  /**  */
  batch_id?: string;

  /**  */
  batches_received?: number;

  /**  */
  batches_total?: number;

  /**  */
  completed_at?: Date;

  /**  */
  error_message?: string;

  /**  */
  started_at?: Date;

  /**  */
  status?: string;

  /**  */
  total_records_stored?: number;
}

/** GlobalAccountHealthResponseModel */
export interface GlobalAccountHealthResponseModel {
  /**  */
  database_connection?: string;

  /**  */
  error?: string;

  /**  */
  service?: string;

  /**  */
  status?: string;

  /**  */
  timestamp?: Date;

  /**  */
  version?: string;
}

/** Response containing list of account IDs for a tenant */
export interface GlobalAccountIdListResponseModel {
  /** Flat list of all account IDs */
  accounts?: string[];

  /** Accounts grouped by database type */
  by_type?: object;

  /** Tenant identifier */
  tenant_id?: string;

  /** Response timestamp */
  timestamp?: string;

  /** Total number of accounts */
  total?: number;
}

/** GlobalAccountIngestRequestModel */
export interface GlobalAccountIngestRequestModel {
  /**  */
  ingestion_timestamp?: Date;

  /**  */
  records: GlobalAccountRecordModel[];

  /**  */
  tenant_id: string;
}

/** GlobalAccountIngestResponseModel */
export interface GlobalAccountIngestResponseModel {
  /**  */
  batch_current?: number;

  /**  */
  batch_id?: string;

  /**  */
  batch_total?: number;

  /**  */
  message?: string;

  /**  */
  records_received?: number;

  /**  */
  records_stored?: number;

  /**  */
  records_updated?: number;

  /**  */
  status?: string;

  /**  */
  timestamp?: Date;
}

/** GlobalAccountRecordModel */
export interface GlobalAccountRecordModel {
  /**  */
  accountId: string;

  /**  */
  accountName?: string;

  /**  */
  appHostname?: string;

  /**  */
  appTeam?: string;

  /**  */
  applicationName?: string;

  /**  */
  createdAt?: Date;

  /**  */
  createdBy?: string;

  /**  */
  dbServerHostname: string;

  /**  */
  dbServerType: string;

  /**  */
  dbVersion?: string;

  /**  */
  ingestionTimestamp?: Date;

  /**  */
  instanceType?: string;

  /**  */
  isActive?: boolean;

  /**  */
  oudAccount?: string;

  /**  */
  serverType?: string;

  /**  */
  svcType?: string;

  /**  */
  svcUsername: string;

  /**  */
  tenantId?: string;
}

/** GlobalPolicy */
export interface GlobalPolicy {
  /**  */
  conditionsWithDynamicValue?: ConditionWithDynamicValue[];

  /**  */
  conditionsWithValue?: ConditionWithValue[];

  /**  */
  description?: string;

  /**  */
  effect?: EnumGlobalPolicyEffect;

  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  principals?: Principal[];

  /**  */
  resourceActions?: ResourceAction[];
}

/** GlobalTrustedAccountResponseModel */
export interface GlobalTrustedAccountResponseModel {
  /**  */
  items?: GlobalAccountRecordModel[];

  /**  */
  pageNo?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;
}

/** GrantedAuthority */
export interface GrantedAuthority {
  /**  */
  authority?: string;
}

/** GroupUserMappingTableSchemaNameModel */
export interface GroupUserMappingTableSchemaNameModel {
  /**  */
  schemaName?: string;
}

/** GuardianEvidence */
export interface GuardianEvidence {
  /**  */
  affectedData?: string;

  /**  */
  agentId?: string;

  /**  */
  agentName?: string;

  /**  */
  approvedBasis?: string;

  /**  */
  controlGap?: string;

  /**  */
  destinationRegion?: string;

  /**  */
  explanation?: string;

  /**  */
  identityModel?: string;

  /**  */
  missingPurpose?: boolean;

  /**  */
  observedEvents?: number;

  /**  */
  platform?: string;

  /**  */
  safeguardEvidence?: string;

  /**  */
  severity?: string;

  /**  */
  sourceRegion?: string;
}

/** GuardianQuestion */
export interface GuardianQuestion {
  /**  */
  answer?: string;

  /**  */
  id?: string;

  /**  */
  question?: string;
}

/** HistoryModel */
export interface HistoryModel {
  /**  */
  action?: string;

  /**  */
  actor?: string;

  /**  */
  detail?: string;

  /**  */
  id?: string;

  /**  */
  occurredAt?: string;
}

/** HrefModel */
export interface HrefModel {
  /**  */
  params?: ObjectFilterParamsModel[];

  /**  */
  url?: string;
}

/** IcebergInventorySyncRequest */
export interface IcebergInventorySyncRequest {
  /**  */
  items?: UnifiedIcebergInventoryModel[];

  /**  */
  lastPage?: boolean;

  /**  */
  scope: Scope;

  /**  */
  syncRunId?: string;
}

/** Identity */
export interface Identity {
  /**  */
  clientId?: string;
}

/** IdentitySecurityAlertModel */
export interface IdentitySecurityAlertModel {
  /**  */
  listOfIdentitySecurityModel?: IdentitySecurityModel[];

  /**  */
  totalRiskCount?: number;
}

/** IdentitySecurityModel */
export interface IdentitySecurityModel {
  /**  */
  policyName?: string;

  /**  */
  riskCount?: number;
}

/** ImpactDimension */
export interface ImpactDimension {
  /**  */
  headline?: string;

  /**  */
  id?: string;

  /**  */
  metrics?: LabeledValue[];
}

/** ImplementationPlanModel */
export interface ImplementationPlanModel {
  /**  */
  definitionIds?: string[];

  /**  */
  mcpServers?: McpServerPlanModel[];

  /**  */
  platforms?: PlatformPlanModel[];

  /**  */
  serverPolicyCount?: number;

  /**  */
  toolPolicyCount?: number;

  /**  */
  updatedCount?: number;
}

/** InfraDeploymentStatusTracker */
export interface InfraDeploymentStatusTracker {
  /**  */
  accountId?: string;

  /**  */
  deleted?: boolean;

  /**  */
  deploymentStatus?: string;

  /**  */
  id?: string;

  /**  */
  runId?: string;

  /**  */
  tenantId?: string;
}

/** InfraDeploymentStatusTrackerModel */
export interface InfraDeploymentStatusTrackerModel {
  /**  */
  accountId?: string;

  /**  */
  deploymentStatus?: string;

  /**  */
  runId?: string;

  /**  */
  tenantId?: string;
}

/** InputStream */
export interface InputStream {}

/** IntentBasedPolicyAttributeModel */
export interface IntentBasedPolicyAttributeModel {
  /**  */
  name?: string;

  /**  */
  namespace?: string;
}

/** IntentBasedPolicyConditionModel */
export interface IntentBasedPolicyConditionModel {
  /**  */
  attribute?: IntentBasedPolicyAttributeModel;

  /**  */
  conditions?: IntentBasedPolicyConditionModel[];

  /**  */
  conjunction?: string;

  /**  */
  exception_tools?: string[];

  /**  */
  id?: string;

  /**  */
  value?: string[];
}

/** IntentRepresentationConstraintModel */
export interface IntentRepresentationConstraintModel {
  /**  */
  allow_when?: IntentBasedPolicyConditionModel;
}

/** IntentRepresentationMcpServerModel */
export interface IntentRepresentationMcpServerModel {
  /**  */
  mcp_server_id: string;
}

/** IntentRepresentationMcpServiceModel */
export interface IntentRepresentationMcpServiceModel {
  /**  */
  access?: string;

  /**  */
  constraint?: IntentRepresentationConstraintModel;

  /**  */
  server: IntentRepresentationMcpServerModel;
}

/** IntentRepresentationModel */
export interface IntentRepresentationModel {
  /**  */
  iir_version: string;

  /**  */
  mcp_services?: IntentRepresentationMcpServiceModel[];
}

/** InventoryCountModel */
export interface InventoryCountModel {
  /**  */
  total?: number;
}

/** InventoryModel */
export interface InventoryModel {
  /**  */
  aiAgents?: InventoryCountModel;

  /**  */
  dataSources?: InventoryCountModel;

  /**  */
  mcpServices?: InventoryCountModel;

  /**  */
  tools?: InventoryCountModel;
}

/** Item */
export interface Item {
  /**  */
  attributes?: object;

  /**  */
  name?: string;

  /**  */
  type?: EnumItemType;

  /**  */
  workspaceId?: string;

  /**  */
  workspaceName?: string;
}

/** JsonNode */
export interface JsonNode {
  /**  */
  array?: boolean;

  /**  */
  bigDecimal?: boolean;

  /**  */
  bigInteger?: boolean;

  /**  */
  binary?: boolean;

  /**  */
  boolean?: boolean;

  /**  */
  containerNode?: boolean;

  /**  */
  double?: boolean;

  /**  */
  empty?: boolean;

  /**  */
  float?: boolean;

  /**  */
  floatingPointNumber?: boolean;

  /**  */
  int?: boolean;

  /**  */
  integralNumber?: boolean;

  /**  */
  long?: boolean;

  /**  */
  missingNode?: boolean;

  /**  */
  nodeType?: EnumJsonNodeNodeType;

  /**  */
  null?: boolean;

  /**  */
  number?: boolean;

  /**  */
  object?: boolean;

  /**  */
  pojo?: boolean;

  /**  */
  short?: boolean;

  /**  */
  textual?: boolean;

  /**  */
  valueNode?: boolean;
}

/** LLMMetadataModel */
export interface LLMMetadataModel {
  /**  */
  awsRegion?: string;

  /**  */
  classification?: string;

  /**  */
  endPoint?: string;

  /**  */
  isModalVersionRisk?: boolean;

  /**  */
  mlFunction?: string;

  /**  */
  modelName?: string;

  /**  */
  modelVersion?: string;

  /**  */
  snowflakeStageName?: string;

  /**  */
  trainingDataSet?: string;
}

/** LabelValueModel */
export interface LabelValueModel {
  /**  */
  label?: string;

  /**  */
  value?: string;
}

/** LabeledValue */
export interface LabeledValue {
  /**  */
  id?: string;

  /**  */
  label?: string;

  /**  */
  value?: string;
}

/** LakehousePolicyTypeDetail */
export interface LakehousePolicyTypeDetail {
  /**  */
  displayName?: string;

  /**  */
  id?: string;

  /**  */
  name?: string;
}

/** MarkSeenRequestModel */
export interface MarkSeenRequestModel {
  /**  */
  slug?: string;
}

/** MarkSeenResponseModel */
export interface MarkSeenResponseModel {
  /**  */
  lastSeenSlug?: string;

  /**  */
  success?: boolean;
}

/** MaskingPatternParameter */
export interface MaskingPatternParameter {
  /**  */
  label?: string;

  /**  */
  name?: string;

  /**  */
  type?: string;

  /**  */
  value?: string;
}

/** MaskingPatternParameterDetails */
export interface MaskingPatternParameterDetails {
  /**  */
  numberOfParameters?: number;

  /**  */
  parameters?: MaskingPatternParameter[];
}

/** MatchWith */
export interface MatchWith {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  paginatedFetchOptions?: object;

  /**  */
  valueType?: string;
}

/** MatchWithElementModel */
export interface MatchWithElementModel {
  /**  */
  name?: string;

  /**  */
  policySubTypes?: string;

  /**  */
  valueType?: string;
}

/** McpOAuthRedirectRequest */
export interface McpOAuthRedirectRequest {
  /**  */
  authorizationEndpoint?: string;

  /**  */
  clientId?: string;

  /**  */
  scope?: string;

  /**  */
  serverType?: string;

  /**  */
  serverUrl?: string;

  /**  */
  tokenEndpoint?: string;
}

/** McpOAuthRedirectResponse */
export interface McpOAuthRedirectResponse {
  /**  */
  authorizationUrl?: string;

  /**  */
  tokenName?: string;
}

/** McpServerDiscoveryModel */
export interface McpServerDiscoveryModel {
  /**  */
  authConfig?: CredentialsConfigModel;

  /**  */
  name?: string;

  /**  */
  serverType?: string;

  /**  */
  url?: string;
}

/** McpServerPlanModel */
export interface McpServerPlanModel {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  serverPolicyCount?: number;

  /**  */
  technology?: string;

  /**  */
  toolPolicyCount?: number;
}

/** McpServerPreviewRequest */
export interface McpServerPreviewRequest {
  /**  */
  applicationId?: string;

  /**  */
  authCode?: string;

  /**  */
  authConfig?: CredentialsConfigModel;

  /**  */
  authType?: string;

  /**  */
  serverType?: string;

  /**  */
  transport?: string;

  /**  */
  url?: string;
}

/** McpServiceModel */
export interface McpServiceModel {
  /**  */
  capabilities?: string[];

  /**  */
  dataAccess?: string[];

  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  protectionStatus?: EnumMcpServiceModelProtectionStatus;

  /**  */
  technology?: string;

  /**  */
  tools?: McpToolModel[];
}

/** McpToolModel */
export interface McpToolModel {
  /**  */
  access?: EnumMcpToolModelAccess;

  /**  */
  classification?: string;

  /**  */
  dataAccess?: string;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  policyId?: string;

  /**  */
  policyName?: string;

  /**  */
  protectionStatus?: EnumMcpToolModelProtectionStatus;

  /**  */
  risk?: string;
}

/** McpUserModel */
export interface McpUserModel {
  /**  */
  credentials?: CredentialsConfigModel;

  /**  */
  enforcementMode?: EnumMcpUserModelEnforcementMode;

  /**  */
  entitlementSourceAccountId?: string;
}

/** MfaQrCode */
export interface MfaQrCode {
  /**  */
  base64QrCodeImage?: string;

  /**  */
  qrSetupKey?: string;
}

/** MigrateDataAccessPolicyModel */
export interface MigrateDataAccessPolicyModel {
  /**  */
  migrateAccountId?: string;

  /**  */
  sourceAccountId?: string;

  /**  */
  sourceAccountObjects?: string[];

  /**  */
  sourceAccountPolicyNames?: string[];
}

/** MissionInput */
export interface MissionInput {
  /**  */
  description: string;

  /**  */
  name: string;

  /**  */
  purposeCategory: EnumMissionInputPurposeCategory;

  /**  */
  reason?: string;
}

/** MonAttribute */
export interface MonAttribute {
  /**  */
  description?: string;

  /**  */
  id: string;

  /**  */
  name: string;

  /**  */
  similarActions?: MonAttribute[];

  /**  */
  supportedFields?: string;

  /**  */
  value?: string[];
}

/** MonPolicyListType */
export interface MonPolicyListType {
  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  dataSourceType?: string;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;
}

/** MonPrincipal */
export interface MonPrincipal {
  /**  */
  conditionType: MonAttribute;

  /**  */
  listType: MonAttribute;

  /**  */
  principalType: MonAttribute;

  /**  */
  principalValue?: MonAttribute[];
}

/** MonitoringPolicyModelV1 */
export interface MonitoringPolicyModelV1 {
  /**  */
  accounts?: string[];

  /**  */
  actions?: string[];

  /**  */
  alertCount?: number;

  /**  */
  alertFrequency?: string;

  /**  */
  alertManagement?: string;

  /**  */
  complianceTags?: string;

  /**  */
  dataClassification?: string[];

  /**  */
  dataSize?: string;

  /**  */
  dataSourceType?: string;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  isActive?: boolean;

  /**  */
  isSystemPolicy?: boolean;

  /**  */
  listType?: string;

  /**  */
  matchingCondition?: string;

  /**  */
  name?: string;

  /**  */
  policyType?: string;

  /**  */
  principalConditionData?: string;

  /**  */
  principals?: MonPrincipal[];

  /**  */
  queryText?: string;

  /**  */
  resourceType?: string;

  /**  */
  resourceValue?: string[];

  /**  */
  riskCategory?: string;

  /**  */
  severity?: string;

  /**  */
  tenantId?: string;

  /**  */
  ticketDetails?: string;

  /**  */
  timeThreshold?: string;

  /**  */
  violationThreshold?: number;

  /**  */
  workspace?: string;
}

/** MonitoringPolicyMuteUnmuteModel */
export interface MonitoringPolicyMuteUnmuteModel {
  /**  */
  accountId?: string;

  /**  */
  action?: string;

  /**  */
  muteDuration?: string;

  /**  */
  policyId?: string;

  /**  */
  policyName?: string;
}

/** MonitoringPolicyResponseModelV1 */
export interface MonitoringPolicyResponseModelV1 {
  /**  */
  accounts?: string[];

  /**  */
  actions?: MonAttribute[];

  /**  */
  alertCount?: number;

  /**  */
  alertFrequency?: MonAttribute;

  /**  */
  alertManagement?: string;

  /**  */
  complianceTags?: MonAttribute[];

  /**  */
  dataClassification?: MonAttribute[];

  /**  */
  dataSize?: string;

  /**  */
  dataSourceType: string;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  isActive?: boolean;

  /**  */
  isMuted?: boolean;

  /**  */
  isSuppressed?: boolean;

  /**  */
  isSystemPolicy?: boolean;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  listType?: MonAttribute;

  /**  */
  matchingCondition?: string;

  /**  */
  muteDuration?: string;

  /**  */
  mutedOn?: Date;

  /**  */
  name: string;

  /**  */
  policyActions?: TlxObjectActionMappingModel[];

  /**  */
  policyType?: string;

  /**  */
  principalConditionData?: string;

  /**  */
  principals?: MonPrincipal[];

  /**  */
  queryText?: string;

  /**  */
  resourceType?: MonAttribute;

  /**  */
  riskCategory?: MonAttribute;

  /**  */
  severity?: MonAttribute;

  /**  */
  tenantId?: string;

  /**  */
  ticketDetails?: string;

  /**  */
  timeThreshold?: string;

  /**  */
  violationThreshold?: number;

  /**  */
  workspace?: string;
}

/** MonitoringPolicyRiskCountModel */
export interface MonitoringPolicyRiskCountModel {
  /**  */
  policyName?: string;

  /**  */
  riskCount?: number;
}

/** MonitoringWatermarkModel */
export interface MonitoringWatermarkModel {
  /**  */
  watermarkTimestamp?: Date;
}

/** Name */
export interface Name {
  /**  */
  familyName?: string;

  /**  */
  givenName?: string;
}

/** NativePolicyUpdateRequestModel */
export interface NativePolicyUpdateRequestModel {
  /**  */
  current: AgentNativePolicyLogicModel;

  /**  */
  environmentId?: string;

  /**  */
  nativePolicyId: string;
}

/** NativePreview */
export interface NativePreview {
  /**  */
  dataSourceId?: string;

  /**  */
  preview?: string;

  /**  */
  previewError?: string;
}

/** NotEvaluatedCount */
export interface NotEvaluatedCount {
  /**  */
  count?: number;

  /**  */
  id?: string;
}

/** NotTargetedModel */
export interface NotTargetedModel {
  /**  */
  agentId?: string;

  /**  */
  reason?: EnumNotTargetedModelReason;
}

/** OAuthTokenModel */
export interface OAuthTokenModel {
  /**  */
  apiKey?: string;

  /**  */
  clientId?: string;

  /**  */
  clientSecret?: string;

  /**  */
  oauthToken?: string;

  /**  */
  tenantId?: string;

  /**  */
  userName?: string;
}

/** ObjectEntitlementDetailModel */
export interface ObjectEntitlementDetailModel {
  /**  */
  childMetadata?: ChildMetadata;

  /**  */
  groups?: EntitlementPrivilegeModel[];

  /**  */
  links?: object;

  /**  */
  objectName?: string;

  /**  */
  objectType?: string;

  /**  */
  page?: number;

  /**  */
  pageSize?: number;

  /**  */
  roles?: EntitlementPrivilegeModel[];

  /**  */
  servicePrincipals?: EntitlementPrivilegeModel[];

  /**  */
  totalPages?: number;

  /**  */
  totalRoles?: number;

  /**  */
  users?: EntitlementPrivilegeModel[];
}

/** ObjectFilterMetadataResponseModel */
export interface ObjectFilterMetadataResponseModel {
  /**  */
  dataLookUp?: string;

  /**  */
  displayName?: string;

  /**  */
  fieldOrder?: number;

  /**  */
  href?: HrefModel;

  /**  */
  info?: string;

  /**  */
  inputType?: string;

  /**  */
  name?: string;

  /**  */
  options?: string[];

  /**  */
  required?: boolean;
}

/** ObjectFilterParamsModel */
export interface ObjectFilterParamsModel {
  /**  */
  name?: string;

  /**  */
  paramType?: string;

  /**  */
  required?: boolean;

  /**  */
  value?: string;

  /**  */
  valueType?: string;
}

/** ObjectList */
export interface ObjectList {
  /**  */
  desc?: string;

  /**  */
  name?: string;
}

/** ObjectMetadata */
export interface ObjectMetadata {
  /**  */
  databaseName?: string;

  /**  */
  fullyQualifiedName?: string;

  /**  */
  name?: string;

  /**  */
  objectType?: string;

  /**  */
  schemaName?: string;
}

/** ObjectPrivilege */
export interface ObjectPrivilege {
  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  name?: string;
}

/** ObjectPrivilegeMappingModel */
export interface ObjectPrivilegeMappingModel {
  /**  */
  objectPrivilege?: string;

  /**  */
  objectType?: string;
}

/** ObjectType */
export interface ObjectType {
  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;
}

/** ObjectTypeAndPrivilegeMappingModel */
export interface ObjectTypeAndPrivilegeMappingModel {
  /**  */
  commaSeparatedObjectPrivileges?: string;

  /**  */
  grantOption?: boolean;

  /**  */
  objectPrivileges?: string[];

  /**  */
  objectType?: string;
}

/** ObjectTypeModel */
export interface ObjectTypeModel {
  /**  */
  displayName?: string;

  /**  */
  name?: string;
}

/** OnDemandReportTriggerModel */
export interface OnDemandReportTriggerModel {
  /**  */
  accountId?: string;

  /**  */
  reportName?: string;
}

/** OnboardingRunRequestModel */
export interface OnboardingRunRequestModel {
  /**  */
  platformId: EnumOnboardingRunRequestModelPlatformId;
}

/** OpaPolicyEvaluationAuditLogModel */
export interface OpaPolicyEvaluationAuditLogModel {
  /**  */
  applicationId?: string;

  /**  */
  auditType?: EnumOpaPolicyEvaluationAuditLogModelAuditType;

  /**  */
  createdDate?: Date;

  /**  */
  decision?: string;

  /**  */
  policyEvaluationMetadata?: string;

  /**  */
  policyId?: string;

  /**  */
  policyPackage?: string;

  /**  */
  requestPayload?: string;

  /**  */
  resourceName?: string;

  /**  */
  resourceType?: string;

  /**  */
  result?: string;

  /**  */
  serverApplicationId?: string;

  /**  */
  tenantId?: string;

  /**  */
  toolInvocationId?: string;

  /**  */
  userIdentity?: string;
}

/** OpaPolicyEvaluationAuditLogRequest */
export interface OpaPolicyEvaluationAuditLogRequest {
  /**  */
  applicationId?: string;

  /**  */
  auditType?: EnumOpaPolicyEvaluationAuditLogRequestAuditType;

  /**  */
  decision?: string;

  /**  */
  policyEvaluationMetadata?: string;

  /**  */
  policyId?: string;

  /**  */
  policyPackage?: string;

  /**  */
  requestPayload?: string;

  /**  */
  resourceName?: string;

  /**  */
  resourceType?: string;

  /**  */
  result?: string;

  /**  */
  serverApplicationId?: string;

  /**  */
  tenantId?: string;

  /**  */
  toolInvocationId?: string;

  /**  */
  userIdentity?: string;
}

/** Operation */
export interface Operation {
  /**  */
  op?: string;

  /**  */
  path?: string;

  /**  */
  value?: object;
}

/** OperationsModel */
export interface OperationsModel {
  /**  */
  create?: number;

  /**  */
  pending?: number;

  /**  */
  skipped?: number;

  /**  */
  unchanged?: number;

  /**  */
  update?: number;
}

/** Option */
export interface Option {
  /**  */
  id?: string;

  /**  */
  name?: string;
}

/** Order */
export interface Order {
  /**  */
  column?: string;

  /**  */
  sortOrder?: number;
}

/** OutcomeDelta */
export interface OutcomeDelta {
  /**  */
  controlId?: string;

  /**  */
  metrics?: OutcomeMetric[];

  /**  */
  summary?: string;

  /**  */
  title?: string;
}

/** OutcomeMetric */
export interface OutcomeMetric {
  /**  */
  after?: string;

  /**  */
  before?: string;

  /**  */
  id?: string;

  /**  */
  label?: string;
}

/** OverGrantedRole */
export interface OverGrantedRole {
  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  dbinstance?: string;

  /**  */
  dbtype?: string;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;

  /**  */
  role?: string;

  /**  */
  tenantId?: string;

  /**  */
  userName?: string;
}

/** OverGrantedRoleModel */
export interface OverGrantedRoleModel {
  /**  */
  count?: number;

  /**  */
  overGrantedRole?: OverGrantedRole[];
}

/** Pageable */
export interface Pageable {
  /**  */
  offset?: number;

  /**  */
  pageNumber?: number;

  /**  */
  pageSize?: number;

  /**  */
  paged?: boolean;

  /**  */
  sort?: Sort;

  /**  */
  unpaged?: boolean;
}

/** Page_UnifiedLakeHouseTableResponseModel */
export interface Page_UnifiedLakeHouseTableResponseModel {
  /**  */
  content?: UnifiedLakeHouseTableResponseModel[];

  /**  */
  empty?: boolean;

  /**  */
  first?: boolean;

  /**  */
  last?: boolean;

  /**  */
  number?: number;

  /**  */
  numberOfElements?: number;

  /**  */
  pageable?: Pageable;

  /**  */
  size?: number;

  /**  */
  sort?: Sort;

  /**  */
  totalElements?: number;

  /**  */
  totalPages?: number;
}

/** Page_UnifiedLakeHouseUserResponseModel */
export interface Page_UnifiedLakeHouseUserResponseModel {
  /**  */
  content?: UnifiedLakeHouseUserResponseModel[];

  /**  */
  empty?: boolean;

  /**  */
  first?: boolean;

  /**  */
  last?: boolean;

  /**  */
  number?: number;

  /**  */
  numberOfElements?: number;

  /**  */
  pageable?: Pageable;

  /**  */
  size?: number;

  /**  */
  sort?: Sort;

  /**  */
  totalElements?: number;

  /**  */
  totalPages?: number;
}

/** PairModel */
export interface PairModel {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  type?: string;
}

/** PairNameUserTypeModel */
export interface PairNameUserTypeModel {
  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  userType?: string;
}

/** PatRequestModel */
export interface PatRequestModel {
  /**  */
  pat?: string;
}

/** PatStatusModel */
export interface PatStatusModel {
  /**  */
  configured?: boolean;
}

/** PlanRecordModel */
export interface PlanRecordModel {
  /**  */
  definitionIds?: string[];

  /**  */
  dependentAgentIds?: string[];

  /**  */
  destination?: EnumPlanRecordModelDestination;

  /**  */
  id?: string;

  /**  */
  operation?: EnumPlanRecordModelOperation;
}

/** PlatformCoverage */
export interface PlatformCoverage {
  /**  */
  dataSourceId?: string;

  /**  */
  objectExists?: boolean;

  /**  */
  platform?: string;

  /**  */
  policyStatus?: string;

  /**  */
  previewError?: string;
}

/** PlatformPlanModel */
export interface PlatformPlanModel {
  /**  */
  controlNames?: string[];

  /**  */
  name?: string;

  /**  */
  platformId?: string;

  /**  */
  sourceId?: string;
}

/** PolarisCredsModel */
export interface PolarisCredsModel {
  /**  */
  clientId?: string;

  /**  */
  clientSecret?: string;

  /**  */
  scope?: string;
}

/** PolarisCredsStatusModel */
export interface PolarisCredsStatusModel {
  /**  */
  configured?: boolean;

  /**  */
  scope?: string;
}

/** PolarisCredsTestResponseModel */
export interface PolarisCredsTestResponseModel {
  /**  */
  message?: string;

  /**  */
  resolvedLocation?: string;

  /**  */
  success?: boolean;
}

/** PolicyDataType */
export interface PolicyDataType {
  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  disabled?: boolean;

  /**  */
  displayName?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;

  /**  */
  targetScopes?: string[];
}

/** PolicyInputModel */
export interface PolicyInputModel {
  /**  */
  agentAttributes?: object;

  /**  */
  applicationId?: string;

  /**  */
  entitlements?: UserEntitlementAttributeValueModel[];

  /**  */
  regoPolicies?: RegoPolicy[];

  /**  */
  resources?: ResourceModel[];
}

/** PolicyPack */
export interface PolicyPack {
  /**  */
  auditLoggingEnabled?: boolean;

  /**  */
  centralAuthorizationRequired?: boolean;

  /**  */
  defaultScope?: string;

  /**  */
  description?: string;

  /**  */
  estimatedAgentCoverage?: number;

  /**  */
  estimatedViolationsBlocked?: number;

  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  requirements?: string[];
}

/** PolicyPosture */
export interface PolicyPosture {
  /**  */
  notEvaluated?: number;

  /**  */
  notEvaluatedBreakdown?: NotEvaluatedCount[];

  /**  */
  notSecure?: number;

  /**  */
  secure?: number;
}

/** PolicyResource */
export interface PolicyResource {
  /**  */
  accountId?: string;

  /**  */
  actions?: string;

  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  dataAccessPolicyResourceDetailsList?: DataAccessPolicyResourceDetails[];

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;

  /**  */
  policyResourceAttributeList?: PolicyResourceAttribute[];

  /**  */
  resourceSourceType?: EnumPolicyResourceResourceSourceType;

  /**  */
  source?: string;

  /**  */
  type?: string;
}

/** PolicyResourceAttribute */
export interface PolicyResourceAttribute {
  /**  */
  attributeType?: string;

  /**  */
  attributeValues?: string[];

  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  dataType?: string;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;

  /**  */
  values?: string;
}

/** PolicyResourceAttributeModel */
export interface PolicyResourceAttributeModel {
  /**  */
  dataType?: string;

  /**  */
  name?: string;

  /**  */
  values?: object;
}

/** PolicyResourceAttributeRequestModel */
export interface PolicyResourceAttributeRequestModel {
  /**  */
  attributeType?: string;

  /**  */
  dataType?: string;

  /**  */
  name?: string;

  /**  */
  values?: string[];
}

/** PolicyResourceDetailResponse */
export interface PolicyResourceDetailResponse {
  /**  */
  agentAttributes?: object;

  /**  */
  applicationId?: string;

  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  policyMetadata?: RegoPolicy;

  /**  */
  resourceAttributes?: PolicyResourceAttributeModel[];

  /**  */
  resourceType?: ResourceTypeRef;
}

/** PolicyResourceRequestModel */
export interface PolicyResourceRequestModel {
  /**  */
  actions?: string[];

  /**  */
  applicationId?: string;

  /**  */
  attributes?: PolicyResourceAttributeRequestModel[];

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  name: string;

  /**  */
  resourceTypeId: string;

  /**  */
  resourceTypeName?: string;

  /**  */
  source?: string;

  /**  */
  status?: string;
}

/** PolicyResourceType */
export interface PolicyResourceType {
  /**  */
  actions?: string;

  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;

  /**  */
  resourceTypeAttribute?: string;
}

/** PolicyResourceTypeAttributeRequestModel */
export interface PolicyResourceTypeAttributeRequestModel {
  /**  */
  dataType?: string;

  /**  */
  name?: string;

  /**  */
  values?: string[];
}

/** PolicyResourceTypeRequestModel */
export interface PolicyResourceTypeRequestModel {
  /**  */
  actions?: string[];

  /**  */
  applicationId?: string;

  /**  */
  attributes?: PolicyResourceTypeAttributeRequestModel[];

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  name: string;
}

/** PolicySecuredObjectSyncResult */
export interface PolicySecuredObjectSyncResult {
  /**  */
  durationMs?: number;

  /**  */
  failedSyncCount?: number;

  /**  */
  failures?: FailureDetail[];

  /**  */
  policyId?: string;

  /**  */
  skippedCount?: number;

  /**  */
  successfulSyncCount?: number;

  /**  */
  totalSecuredObjects?: number;
}

/** PolicySecuredObjectsReportModel */
export interface PolicySecuredObjectsReportModel {
  /**  */
  policyIds?: string[];
}

/** PolicySyncDetailModel */
export interface PolicySyncDetailModel {
  /**  */
  createdBy?: string;

  /**  */
  deltaObjects?: string[];

  /**  */
  description?: string;

  /**  */
  policyId?: string;

  /**  */
  policyName?: string;

  /**  */
  policyType?: string;

  /**  */
  securedObjects?: string[];
}

/** PolicySyncJobDetailResponseModel */
export interface PolicySyncJobDetailResponseModel {
  /**  */
  abacPolicies?: PolicySyncDetailModel[];

  /**  */
  accountId?: string;

  /**  */
  jobId?: string;

  /**  */
  policies?: PolicySyncDetailModel[];

  /**  */
  rbacPolicies?: PolicySyncDetailModel[];

  /**  */
  status?: string;
}

/** PolicyTableStructure */
export interface PolicyTableStructure {
  /**  */
  columns?: SnowflakeColumn[];

  /**  */
  databaseName?: string;

  /**  */
  name?: string;

  /**  */
  schemaName?: string;
}

/** Posture */
export interface Posture {
  /**  */
  dataPlatforms?: string[];

  /**  */
  estate?: EstateCard[];

  /**  */
  lastAnalyzedAt?: string;

  /**  */
  outcomeDelta?: OutcomeDelta;

  /**  */
  policyPosture?: PolicyPosture;
}

/** PowerBIRelationshipMetadata */
export interface PowerBIRelationshipMetadata {
  /**  */
  active?: boolean;

  /**  */
  fromCardinality?: string;

  /**  */
  fromColumn?: string;

  /**  */
  fromTable?: string;

  /**  */
  semanticModel?: string;

  /**  */
  toCardinality?: string;

  /**  */
  toColumn?: string;

  /**  */
  toTable?: string;

  /**  */
  workspace?: string;
}

/** PowerBIRoleInfoMetadata */
export interface PowerBIRoleInfoMetadata {
  /**  */
  description?: string;

  /**  */
  filterExpression?: string;

  /**  */
  roleName?: string;

  /**  */
  tableName?: string;
}

/** PreviewRequest */
export interface PreviewRequest {
  /**  */
  environmentId?: string;

  /**  */
  policyIds?: string[];

  /**  */
  scope: AgentPolicyScopeModel;
}

/** Principal */
export interface Principal {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  type?: EnumPrincipalType;
}

/** PrincipalPermissions */
export interface PrincipalPermissions {
  /**  */
  permissions?: string[];

  /**  */
  principal?: DataLakePrincipal;
}

/** PrincipalRoleMappingResponseModel */
export interface PrincipalRoleMappingResponseModel {
  /**  */
  canonical_account_id?: string;

  /**  */
  canonical_discovered_at?: string;

  /**  */
  canonical_platform?: string;

  /**  */
  platform_array?: string[];

  /**  */
  role_name?: string;

  /**  */
  tenant_id?: string;
}

/** PrincipalType */
export interface PrincipalType {
  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  dataSourceType?: string;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;
}

/** PrincipalUserMappingResponseModel */
export interface PrincipalUserMappingResponseModel {
  /**  */
  canonical_account_id?: string;

  /**  */
  canonical_discovered_at?: string;

  /**  */
  canonical_platform?: string;

  /**  */
  platform_array?: string[];

  /**  */
  tenant_id?: string;

  /**  */
  user_name?: string;
}

/** PriorityControl */
export interface PriorityControl {
  /**  */
  affectedAgentCount?: number;

  /**  */
  affectedAgentIds?: string[];

  /**  */
  affectedApplicationCount?: number;

  /**  */
  affectedBusinessUnits?: string[];

  /**  */
  businessImpact?: string;

  /**  */
  flowContext?: FlowContext;

  /**  */
  hasDecision?: boolean;

  /**  */
  id?: string;

  /**  */
  isEnforced?: boolean;

  /**  */
  name?: string;

  /**  */
  policyContext?: string;

  /**  */
  priorityRank?: number;

  /**  */
  recommendation?: string;

  /**  */
  reference?: LabeledValue;

  /**  */
  severity?: string;

  /**  */
  violationCount?: number;
}

/** PrivacyEnforcementType */
export interface PrivacyEnforcementType {
  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;
}

/** PrivacyEnforcementTypeModel */
export interface PrivacyEnforcementTypeModel {
  /**  */
  description?: string;

  /**  */
  name?: string;
}

/** PrivilegeDetail */
export interface PrivilegeDetail {
  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  name?: string;
}

/** PrivilegeTemplateModel */
export interface PrivilegeTemplateModel {
  /**  */
  datasourceType?: string;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  isDomainTemplate?: boolean;

  /**  */
  mappings?: ObjectTypeAndPrivilegeMappingModel[];

  /**  */
  name?: string;

  /**  */
  systemTemplate?: boolean;
}

/** ProjectSelection */
export interface ProjectSelection {
  /**  */
  mode?: string;

  /**  */
  projectIds?: string[];
}

/** PromoteDataAccessPolicyDetails */
export interface PromoteDataAccessPolicyDetails {
  /**  */
  policyName?: string;

  /**  */
  policyVersion?: number;
}

/** PromoteDataAccessPolicyModel */
export interface PromoteDataAccessPolicyModel {
  /**  */
  migrateAccountId?: string;

  /**  */
  policies?: PromoteDataAccessPolicyDetails[];

  /**  */
  sourceAccountId?: string;
}

/** ProofPanel */
export interface ProofPanel {
  /**  */
  enforcement?: string;

  /**  */
  evidence?: string;

  /**  */
  outcome?: string;

  /**  */
  policy?: string;

  /**  */
  scope?: string;

  /**  */
  verificationStatus?: string;
}

/** PurviewDocumentSensitivityLabelsRequest */
export interface PurviewDocumentSensitivityLabelsRequest {
  /**  */
  documentId: string;

  /**  */
  driveId: string;
}

/** PurviewDocumentSensitivityLabelsResponse */
export interface PurviewDocumentSensitivityLabelsResponse {
  /**  */
  documentId?: string;

  /**  */
  documentName?: string;

  /**  */
  driveId?: string;

  /**  */
  labelStatus?: EnumPurviewDocumentSensitivityLabelsResponseLabelStatus;

  /**  */
  labels?: PurviewSensitivityLabel[];
}

/** PurviewDocumentSensitivityLabelsSearchResponse */
export interface PurviewDocumentSensitivityLabelsSearchResponse {
  /**  */
  documents?: PurviewDocumentSensitivityLabelsResponse[];

  /**  */
  matchCount?: number;

  /**  */
  searchQuery?: string;

  /**  */
  truncated?: boolean;
}

/** PurviewSensitivityLabel */
export interface PurviewSensitivityLabel {
  /**  */
  assignmentMethod?: EnumPurviewSensitivityLabelAssignmentMethod;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  sensitivityLabelId?: string;

  /**  */
  tenantId?: string;

  /**  */
  tooltip?: string;
}

/** QueryContext */
export interface QueryContext {
  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;
}

/** QueryTypeRegexMapping */
export interface QueryTypeRegexMapping {
  /**  */
  createdAt?: Date;

  /**  */
  createdBy?: string;

  /**  */
  dbType?: string;

  /**  */
  id?: string;

  /**  */
  modifiedAt?: Date;

  /**  */
  modifiedBy?: string;

  /**  */
  queryType?: string;

  /**  */
  regexPattern?: string;

  /**  */
  tenantId?: string;
}

/** Readiness */
export interface Readiness {
  /**  */
  agentInventory?: AgentInventory;

  /**  */
  agentsAnalyzed?: number;

  /**  */
  agentsEvaluated?: number;

  /**  */
  chainedOnboarding?: boolean;

  /**  */
  completedEvaluations?: number;

  /**  */
  connectedPlatforms?: number;

  /**  */
  dataSourcesAnalyzed?: number;

  /**  */
  discoveredAgents?: number;

  /**  */
  discoveredDataSources?: number;

  /**  */
  discoveredMcpServers?: number;

  /**  */
  discoveredTools?: number;

  /**  */
  discoveryPercentComplete?: number;

  /**  */
  discoveryStatus?: EnumReadinessDiscoveryStatus;

  /**  */
  enforcement?: AgentCountsModel;

  /**  */
  enforcementEnvironment?: EnforcementEnvironment;

  /**  */
  evaluationPercentComplete?: number;

  /**  */
  evaluationStatus?: EnumReadinessEvaluationStatus;

  /**  */
  onboardingPercentComplete?: number;

  /**  */
  totalAgents?: number;
}

/** ReapplyRequest */
export interface ReapplyRequest {
  /**  */
  acknowledgeOverrides?: boolean;

  /**  */
  environmentId?: string;

  /**  */
  policyId?: string;
}

/** RecentReportModel */
export interface RecentReportModel {
  /**  */
  category?: EnumRecentReportModelCategory;

  /**  */
  downloadAvailable?: boolean;

  /**  */
  downloadUrl?: string;

  /**  */
  filters?: ReportFilterDTO[];

  /**  */
  lastUsedAt?: Date;

  /**  */
  name?: string;

  /**  */
  reportName?: string;

  /**  */
  s3ReportDetails?: S3BucketModel;

  /**  */
  status?: string;
}

/** RecommendationPolicy */
export interface RecommendationPolicy {
  /**  */
  accountId?: string;

  /**  */
  alertCount?: number;

  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  dataSourceType?: string;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  isActive?: boolean;

  /**  */
  isSystemPolicy?: boolean;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  matchingCondition?: string;

  /**  */
  name?: string;

  /**  */
  policyRemediation?: string;

  /**  */
  riskCategory?: string;

  /**  */
  severity?: string;

  /**  */
  tenantId?: string;
}

/** RedshiftJDBCConnectionDetail */
export interface RedshiftJDBCConnectionDetail {
  /**  */
  jdbcConnectionURL?: string;
}

/** RegisterTenantDataModel */
export interface RegisterTenantDataModel {
  /**  */
  configParameters?: string;

  /**  */
  tagNames?: string;

  /**  */
  templatePolicySupported?: boolean;

  /**  */
  tenantAddress?: string;

  /**  */
  tenantDescription?: string;

  /**  */
  tenantName?: string;

  /**  */
  useExternalSSM?: boolean;

  /**  */
  userDescription?: string;

  /**  */
  userEmail?: string;

  /**  */
  userLoginId?: string;

  /**  */
  userName?: string;

  /**  */
  userPassword?: string;

  /**  */
  userRoleNames?: string;
}

/** RegoPolicy */
export interface RegoPolicy {
  /**  */
  policyEvalResult?: string;

  /**  */
  policyId?: string;

  /**  */
  resourceName?: string;

  /**  */
  udf?: string;
}

/** ReleaseFeatureModel */
export interface ReleaseFeatureModel {
  /**  */
  description?: string;

  /**  */
  gitBookUrl?: string;

  /**  */
  id?: string;

  /**  */
  isSectionHeader?: boolean;

  /**  */
  title?: string;
}

/** ReleaseNoteListResponseModel */
export interface ReleaseNoteListResponseModel {
  /**  */
  items?: ReleaseNoteResponseModel[];

  /**  */
  page?: number;

  /**  */
  size?: number;

  /**  */
  total?: number;
}

/** ReleaseNoteResponseModel */
export interface ReleaseNoteResponseModel {
  /**  */
  createdAt?: string;

  /**  */
  featureCount?: number;

  /**  */
  features?: ReleaseFeatureModel[];

  /**  */
  gitBookUrl?: string;

  /**  */
  id?: string;

  /**  */
  read?: boolean;

  /**  */
  slug?: string;

  /**  */
  tags?: string[];

  /**  */
  version?: string;
}

/** RemediationActionResponseModel */
export interface RemediationActionResponseModel {
  /**  */
  actionName?: string;

  /**  */
  data?: RemediationDataModel;

  /**  */
  displayName?: string;
}

/** RemediationDataAccessPolicyModel */
export interface RemediationDataAccessPolicyModel {
  /**  */
  databaseName?: string;

  /**  */
  description?: string;

  /**  */
  maskColumn?: string;

  /**  */
  maskingPatternName?: string;

  /**  */
  maskingPatternValue?: string;

  /**  */
  name?: string;

  /**  */
  objectName?: string;

  /**  */
  policyDataTypeId?: string;

  /**  */
  principalType?: EnumRemediationDataAccessPolicyModelPrincipalType;

  /**  */
  principals?: string[];

  /**  */
  schemaName?: string;

  /**  */
  source?: RemediationMappingSource;
}

/** RemediationDataModel */
export interface RemediationDataModel {
  /**  */
  attribute?: object;

  /**  */
  message?: string;

  /**  */
  remediationMsg?: string;

  /**  */
  status?: string;
}

/** RemediationMappingSource */
export interface RemediationMappingSource {
  /**  */
  id?: string;

  /**  */
  type?: string;
}

/** RenamePolicyModel */
export interface RenamePolicyModel {
  /**  */
  description?: string;

  /**  */
  name?: string;
}

/** ReportBasicInfoModel */
export interface ReportBasicInfoModel {
  /**  */
  category?: string;

  /**  */
  description?: string;

  /**  */
  displayName?: string;

  /**  */
  name?: string;
}

/** ReportFilterDTO */
export interface ReportFilterDTO {
  /**  */
  key?: string;

  /**  */
  label?: string;

  /**  */
  value?: string;
}

/** ReportMonitoringPoliciesRisksModel */
export interface ReportMonitoringPoliciesRisksModel {
  /**  */
  items?: AlertRecordModelRes[];

  /**  */
  listOfMonitoringPolicyRiskCounts?: MonitoringPolicyRiskCountModel[];

  /**  */
  pageNo?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  totalRiskCount?: number;
}

/** ReportStatus */
export interface ReportStatus {
  /**  */
  accountId?: string;

  /**  */
  awsAccountId?: string;

  /**  */
  completedAt?: Date;

  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  displayName?: string;

  /**  */
  filters?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;

  /**  */
  numberOfDays?: number;

  /**  */
  policyId?: string;

  /**  */
  policyVersion?: number;

  /**  */
  region?: string;

  /**  */
  reportName?: string;

  /**  */
  s3BucketName?: string;

  /**  */
  s3FilePath?: string;

  /**  */
  status?: string;

  /**  */
  tenantId?: string;
}

/** Reports */
export interface Reports {
  /**  */
  count?: number;

  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  data?: string;

  /**  */
  dbType?: string;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  itemName?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;

  /**  */
  reportDate?: Date;

  /**  */
  statsName?: string;

  /**  */
  tenantId?: string;

  /**  */
  userName?: string;
}

/** ReportsModel */
export interface ReportsModel {
  /**  */
  accountId?: string;

  /**  */
  count?: number;

  /**  */
  data?: object[];

  /**  */
  dbType?: string;

  /**  */
  itemName?: string;

  /**  */
  name?: string;

  /**  */
  reportDate?: Date;

  /**  */
  statsName?: string;

  /**  */
  tenantId?: string;

  /**  */
  userName?: string;
}

/** RequestFiltersModel */
export interface RequestFiltersModel {
  /**  */
  filters?: object;
}

/** ResetUserPassword */
export interface ResetUserPassword {
  /**  */
  confirmPassword?: string;

  /**  */
  loginId?: string;

  /**  */
  newPassword?: string;
}

/** Resource */
export interface Resource {
  /**  */
  description?: string;

  /**  */
  file?: any;

  /**  */
  filename?: string;

  /**  */
  inputStream?: InputStream;

  /**  */
  open?: boolean;

  /**  */
  readable?: boolean;

  /**  */
  uri?: string;

  /**  */
  url?: string;
}

/** ResourceAction */
export interface ResourceAction {
  /**  */
  actions?: string[];

  /**  */
  databaseName?: string;

  /**  */
  id?: string;

  /**  */
  resources?: PolicyResource[];

  /**  */
  schemaName?: string;
}

/** ResourceModel */
export interface ResourceModel {
  /**  */
  actions?: object;

  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  policyResourceAttributeList?: PolicyResourceAttributeModel[];

  /**  */
  type?: string;
}

/** ResourcePolicyEvaluationResultConfiguration */
export interface ResourcePolicyEvaluationResultConfiguration {
  /**  */
  actions?: string[];

  /**  */
  context?: object;

  /**  */
  entitlementsAttributes?: string[];

  /**  */
  resourceAttributes?: string[];
}

/** ResourceSourceRequestModel */
export interface ResourceSourceRequestModel {
  /**  */
  accountId?: string;

  /**  */
  agentPolicyConditions?: object;

  /**  */
  agentPolicyRules?: AgentPolicyRuleModel[];

  /**  */
  id?: string;

  /**  */
  objectNames?: string[];

  /**  */
  objectType?: string;

  /**  */
  resourceIdList?: TlxGenericNameIdModel[];
}

/** ResourceTypeModel */
export interface ResourceTypeModel {
  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  dataSourceType?: string;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;

  /**  */
  objectTypeAvalible?: boolean;

  /**  */
  objectTypes?: string[];
}

/** ResourceTypeRef */
export interface ResourceTypeRef {
  /**  */
  id?: string;

  /**  */
  name?: string;
}

/** Result */
export interface Result {
  /**  */
  code?: string;

  /**  */
  data?: AgentPolicyResponseModel;

  /**  */
  message?: string;

  /**  */
  policyId?: string;

  /**  */
  policyName?: string;

  /**  */
  success?: boolean;
}

/** RetryRequest */
export interface RetryRequest {
  /**  */
  environmentId?: string;

  /**  */
  policyId?: string;
}

/** ReviewRequest */
export interface ReviewRequest {
  /**  */
  agentId?: string;

  /**  */
  environmentId?: string;

  /**  */
  policyIds?: string[];

  /**  */
  scope: AgentPolicyScopeModel;
}

/** RiskCategory */
export interface RiskCategory {
  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;
}

/** RiskThresholdRequest */
export interface RiskThresholdRequest {
  /**  */
  blockedLimit?: number;

  /**  */
  normalLimit?: number;
}

/** RiskThresholdResponse */
export interface RiskThresholdResponse {
  /**  */
  accountIds?: string;

  /**  */
  blockedLimit?: number;

  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  normalLimit?: number;

  /**  */
  tenantId?: string;
}

/** Role */
export interface Role {
  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;

  /**  */
  roleGroup?: string;

  /**  */
  sequence?: number;
}

/** Canonical role with platform-specific mappings */
export interface RoleMappingListResponseModel {
  /** Platform-specific role mappings */
  mapping?: RolePlatformMapping[];

  /** Canonical role name */
  name?: string;
}

/** RoleModel */
export interface RoleModel {
  /**  */
  description?: string;

  /**  */
  name?: string;
}

/** Platform-specific role mapping entry */
export interface RolePlatformMapping {
  /** Canonical role name */
  canonicalRole?: string;

  /** Native role name in target platform */
  nativeRole?: string;

  /** Target account name */
  targetAccount?: string;

  /** Target platform */
  targetPlatform?: string;
}

/** RoleProvisioningModel */
export interface RoleProvisioningModel {
  /**  */
  action?: EnumRoleProvisioningModelAction;

  /**  */
  name?: string;

  /**  */
  roles?: string[];

  /**  */
  source?: RemediationMappingSource;

  /**  */
  type?: EnumRoleProvisioningModelType;

  /**  */
  users?: string[];
}

/** Rule */
export interface Rule {
  /**  */
  columnRules?: AgentPolicyConditionModel[];

  /**  */
  conjunction?: EnumRuleConjunction;

  /**  */
  effect: EnumRuleEffect;

  /**  */
  id?: string;

  /**  */
  mcpServerId: string;

  /**  */
  name?: string;

  /**  */
  toolIds?: string[];
}

/** RuleDetail */
export interface RuleDetail {
  /**  */
  columnRules?: ColumnRuleDetail[];

  /**  */
  queryContextId?: string;

  /**  */
  queryContextKey?: string;

  /**  */
  queryContextValue?: string;
}

/** S3BucketModel */
export interface S3BucketModel {
  /**  */
  awsAccountId?: string;

  /**  */
  region?: string;

  /**  */
  s3BucketName?: string;

  /**  */
  s3FilePath?: string;
}

/** S3MetadataModel */
export interface S3MetadataModel {
  /**  */
  awsAccountName?: string;

  /**  */
  awsAccountNumber?: string;

  /**  */
  awsRegion?: string;

  /**  */
  creationDate?: string;

  /**  */
  encryption?: string;

  /**  */
  publicAccess?: string;

  /**  */
  tags?: object[];
}

/** SCIMGroupModel */
export interface SCIMGroupModel {
  /**  */
  displayName?: string;

  /**  */
  id?: string;

  /**  */
  members?: string[];
}

/** SCIMUserEmails */
export interface SCIMUserEmails {
  /**  */
  primary?: boolean;

  /**  */
  type?: string;

  /**  */
  value?: string;
}

/** SCIMUserModel */
export interface SCIMUserModel {
  /**  */
  Territory?: string;

  /**  */
  active?: boolean;

  /**  */
  country?: string;

  /**  */
  department?: string;

  /**  */
  emails?: SCIMUserEmails[];

  /**  */
  employeeId?: string;

  /**  */
  externalId?: string;

  /**  */
  id?: string;

  /**  */
  name?: Name;

  /**  */
  schemas?: string[];

  /**  */
  title?: string;

  /**  */
  'urn:ietf:params:scim:schemas:extension:enterprise:2.0:User'?: enpriseUserAttributes;

  /**  */
  userName?: string;
}

/** SSOUserAuthRequest */
export interface SSOUserAuthRequest {
  /**  */
  loginId?: string;
}

/** SchemaId */
export interface SchemaId {
  /**  */
  registryName?: string;

  /**  */
  schemaArn?: string;

  /**  */
  schemaName?: string;
}

/** SchemaMetadata */
export interface SchemaMetadata {
  /**  */
  databaseName?: string;

  /**  */
  fullyQualifiedName?: string;

  /**  */
  id?: string;

  /**  */
  name?: string;
}

/** SchemaReference */
export interface SchemaReference {
  /**  */
  schemaId?: SchemaId;

  /**  */
  schemaVersionId?: string;

  /**  */
  schemaVersionNumber?: number;
}

/** ScimPatchOpModel */
export interface ScimPatchOpModel {
  /**  */
  Operations?: Operation[];

  /**  */
  schemas?: string[];
}

/** Scope */
export interface Scope {
  /**  */
  accountId?: string;

  /**  */
  platform?: string;

  /**  */
  projectId?: string;
}

/** ScopeOption */
export interface ScopeOption {
  /**  */
  agentCount?: number;

  /**  */
  agentIds?: string[];

  /**  */
  applicationCount?: number;

  /**  */
  businessUnitCount?: number;

  /**  */
  id?: string;

  /**  */
  label?: string;
}

/** ScopedRequest */
export interface ScopedRequest {
  /**  */
  environmentId?: string;

  /**  */
  scope: AgentPolicyScopeModel;
}

/** SearchParamModel */
export interface SearchParamModel {
  /**  */
  name?: string;

  /**  */
  operator?: string;

  /**  */
  value?: string;
}

/** SecuredObjects */
export interface SecuredObjects {
  /**  */
  columnName?: string;

  /**  */
  databaseName?: string;

  /**  */
  integration?: string;

  /**  */
  objectName?: string[];

  /**  */
  resourceMonitor?: string;

  /**  */
  schemaName?: string;

  /**  */
  sharedDatabase?: string;

  /**  */
  tableName?: string;

  /**  */
  warehouse?: string;
}

/** SensitiveData */
export interface SensitiveData {
  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  databaseName?: string;

  /**  */
  dbinstance?: string;

  /**  */
  dbtype?: string;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  isPolicyExists?: boolean;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;

  /**  */
  objectName?: string;

  /**  */
  objectType?: string;

  /**  */
  schemaName?: string;

  /**  */
  tenantId?: string;
}

/** SensitiveDataModel */
export interface SensitiveDataModel {
  /**  */
  sensitiveDataObjects?: SensitiveData[];

  /**  */
  total?: number;

  /**  */
  withoutPolicies?: number;
}

/** SerDeInfo */
export interface SerDeInfo {
  /**  */
  name?: string;

  /**  */
  parameters?: object;

  /**  */
  serializationLibrary?: string;
}

/** Severity */
export interface Severity {
  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;
}

/** SharedImpactModel */
export interface SharedImpactModel {
  /**  */
  agentIds?: string[];

  /**  */
  recordIds?: string[];
}

/** SiemIntegrationTool */
export interface SiemIntegrationTool {
  /**  */
  attributes?: string;

  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;
}

/** SignupModel */
export interface SignupModel {
  /**  */
  defaultPassword?: string;

  /**  */
  email?: string;

  /**  */
  name?: string;

  /**  */
  organizationName?: string;

  /**  */
  phone?: string;

  /**  */
  provisionSource?: string;
}

/** SkewedInfo */
export interface SkewedInfo {
  /**  */
  skewedColumnNames?: string[];

  /**  */
  skewedColumnValueLocationMaps?: object;

  /**  */
  skewedColumnValues?: string[];
}

/** SnowflakeColumn */
export interface SnowflakeColumn {
  /**  */
  check?: string;

  /**  */
  comment?: string;

  /**  */
  defaultValue?: string;

  /**  */
  expression?: string;

  /**  */
  fullName?: string;

  /**  */
  isNull?: string;

  /**  */
  isPrimaryKey?: string;

  /**  */
  isUniqueKey?: string;

  /**  */
  kind?: string;

  /**  */
  name?: string;

  /**  */
  policyName?: string;

  /**  */
  type?: string;
}

/** SnowflakeDatabase */
export interface SnowflakeDatabase {
  /**  */
  id?: string;

  /**  */
  name?: string;
}

/** SnowflakeObject */
export interface SnowflakeObject {
  /**  */
  name?: string;

  /**  */
  type?: string;
}

/** SnowflakeSchema */
export interface SnowflakeSchema {
  /**  */
  databaseName?: string;

  /**  */
  id?: string;

  /**  */
  name?: string;
}

/** SnowflakeShareMetadataModel */
export interface SnowflakeShareMetadataModel {
  /**  */
  consumerName?: string;

  /**  */
  databaseName?: string;

  /**  */
  objectCount?: string;

  /**  */
  schemaNames?: object[];
}

/** SnowflakeTable */
export interface SnowflakeTable {
  /**  */
  databaseName?: string;

  /**  */
  name?: string;

  /**  */
  schemaName?: string;
}

/** SnowflakeTag */
export interface SnowflakeTag {
  /**  */
  id?: string;

  /**  */
  name?: string;
}

/** Sort */
export interface Sort {
  /**  */
  empty?: boolean;

  /**  */
  sorted?: boolean;

  /**  */
  unsorted?: boolean;
}

/** SsmKeyEntry */
export interface SsmKeyEntry {
  /**  */
  keyVaultName?: string;

  /**  */
  purpose?: string;

  /**  */
  ssmKey?: string;
}

/** SsmKeySource */
export interface SsmKeySource {
  /**  */
  keys?: SsmKeyEntry[];

  /**  */
  sourceId?: string;

  /**  */
  sourceName?: string;

  /**  */
  sourceType?: string;
}

/** StatsItemCount */
export interface StatsItemCount {
  /**  */
  accountId?: string;

  /**  */
  date?: Date;

  /**  */
  itemCount?: object;

  /**  */
  statsName?: string;

  /**  */
  tenantId?: string;
}

/** StatusModel */
export interface StatusModel {
  /**  */
  data?: object;

  /**  */
  message?: string;

  /**  */
  remediationMsg?: string;

  /**  */
  success?: boolean;

  /**  */
  warningMessage?: string;
}

/** StorageDescriptor */
export interface StorageDescriptor {
  /**  */
  additionalLocations?: string[];

  /**  */
  bucketColumns?: string[];

  /**  */
  columns?: Column[];

  /**  */
  compressed?: boolean;

  /**  */
  inputFormat?: string;

  /**  */
  location?: string;

  /**  */
  numberOfBuckets?: number;

  /**  */
  outputFormat?: string;

  /**  */
  parameters?: object;

  /**  */
  schemaReference?: SchemaReference;

  /**  */
  serdeInfo?: SerDeInfo;

  /**  */
  skewedInfo?: SkewedInfo;

  /**  */
  sortColumns?: Order[];

  /**  */
  storedAsSubDirectories?: boolean;
}

/** StrategyRationale */
export interface StrategyRationale {
  /**  */
  alternativesNote?: string;

  /**  */
  confidencePercent?: number;

  /**  */
  reasons?: string[];

  /**  */
  strategyId?: string;
}

/** SubComponentDetail */
export interface SubComponentDetail {
  /**  */
  name?: string;

  /**  */
  saasVersion?: string;

  /**  */
  status?: string;

  /**  */
  version?: string;
}

/** SyncPolicyObjectModel */
export interface SyncPolicyObjectModel {
  /**  */
  action?: EnumSyncPolicyObjectModelAction;

  /**  */
  objectName?: string;

  /**  */
  objectType?: EnumSyncPolicyObjectModelObjectType;

  /**  */
  tagKeyValue?: string;
}

/** Table */
export interface Table {
  /**  */
  catalogId?: string;

  /**  */
  createTime?: Date;

  /**  */
  createdBy?: string;

  /**  */
  databaseName?: string;

  /**  */
  description?: string;

  /**  */
  isRegisteredWithLakeFormation?: boolean;

  /**  */
  lastAccessTime?: Date;

  /**  */
  lastAnalyzedTime?: Date;

  /**  */
  name?: string;

  /**  */
  owner?: string;

  /**  */
  parameters?: object;

  /**  */
  partitionKeys?: Column[];

  /**  */
  registeredWithLakeFormation?: boolean;

  /**  */
  retention?: number;

  /**  */
  storageDescriptor?: StorageDescriptor;

  /**  */
  tableType?: string;

  /**  */
  targetTable?: TableIdentifier;

  /**  */
  updateTime?: Date;

  /**  */
  versionId?: string;

  /**  */
  viewExpandedText?: string;

  /**  */
  viewOriginalText?: string;
}

/** TableIdentifier */
export interface TableIdentifier {
  /**  */
  catalogId?: string;

  /**  */
  databaseName?: string;

  /**  */
  name?: string;
}

/** TableMappingEntry */
export interface TableMappingEntry {
  /**  */
  account_id?: string;

  /**  */
  catalog_name?: string;

  /**  */
  id?: string;

  /**  */
  platform?: string;

  /**  */
  schema_name?: string;

  /**  */
  table_name?: string;

  /**  */
  tenant_id?: string;
}

/** TableMetadata */
export interface TableMetadata {
  /**  */
  databaseName?: string;

  /**  */
  fullyQualifiedName?: string;

  /**  */
  name?: string;

  /**  */
  platformFullyQualifiedName?: string[];

  /**  */
  schemaName?: string;

  /**  */
  semanticModel?: string[];

  /**  */
  serverName?: string;

  /**  */
  sourceServers?: string[];

  /**  */
  tableOwner?: string;

  /**  */
  tableType?: string;

  /**  */
  type?: string;
}

/** Tag */
export interface Tag {
  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;

  /**  */
  type?: string;
}

/** TagMetadata */
export interface TagMetadata {
  /**  */
  databaseName?: string;

  /**  */
  fullTagName?: string;

  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  schemaName?: string;

  /**  */
  values?: string[];
}

/** TagModel */
export interface TagModel {
  /**  */
  description?: string;

  /**  */
  name?: string;
}

/** TagObjectAuditModel */
export interface TagObjectAuditModel {
  /**  */
  action?: string;

  /**  */
  objectName?: string;

  /**  */
  objectType?: string;

  /**  */
  tagKeyValue?: string;
}

/** TagObjectMetadata */
export interface TagObjectMetadata {
  /**  */
  columnType?: string;

  /**  */
  fqTableViewName?: string;

  /**  */
  fullTagValue?: string;

  /**  */
  fullyQualifiedName?: string;

  /**  */
  name?: string;

  /**  */
  owner?: string;

  /**  */
  tableType?: string;

  /**  */
  tagKey?: string;

  /**  */
  tagName?: string;

  /**  */
  tagValue?: string;

  /**  */
  type?: string;
}

/** TagsModel */
export interface TagsModel {
  /**  */
  accountId?: string;

  /**  */
  tags?: string[];

  /**  */
  tenantId?: string;
}

/** TargetDatasourceModel */
export interface TargetDatasourceModel {
  /**  */
  accountId?: string;

  /**  */
  dataProduct?: string;
}

/** TenantAuditLogs */
export interface TenantAuditLogs {
  /**  */
  accountId?: string;

  /**  */
  action?: string;

  /**  */
  applicationId?: string;

  /**  */
  cascadedFrom?: string;

  /**  */
  comments?: string;

  /**  */
  createdDate?: Date;

  /**  */
  httpMethod?: string;

  /**  */
  id?: string;

  /**  */
  queryText?: string;

  /**  */
  resourceId?: string;

  /**  */
  resourceName?: string;

  /**  */
  resourceType?: string;

  /**  */
  result?: string;

  /**  */
  tenantId?: string;

  /**  */
  updateOpDetails?: string;

  /**  */
  userId?: string;

  /**  */
  userLoginIP?: string;
}

/** TenantAuditLogsModel */
export interface TenantAuditLogsModel {
  /**  */
  accountId?: string;

  /**  */
  action?: string;

  /**  */
  comments?: string;

  /**  */
  httpMethod?: string;

  /**  */
  resourceId?: string;

  /**  */
  resourceName?: string;

  /**  */
  resourceType?: string;

  /**  */
  result?: string;

  /**  */
  tenantId?: string;

  /**  */
  updateOpDetails?: string;

  /**  */
  userId?: string;

  /**  */
  userLoginIP?: string;
}

/** TenantConfigurationFeatureModel */
export interface TenantConfigurationFeatureModel {
  /**  */
  configurationKey?: string;

  /**  */
  value?: object;
}

/** TenantConfigurationModel */
export interface TenantConfigurationModel {
  /**  */
  accountId?: string;

  /**  */
  configurationKey?: string;

  /**  */
  tenantId?: string;

  /**  */
  value?: string;
}

/** TenantFeatureModel */
export interface TenantFeatureModel {
  /**  */
  canToggle?: boolean;

  /**  */
  configurationKey?: string;

  /**  */
  displayName?: string;

  /**  */
  enable?: boolean;

  /**  */
  infoMessage?: string;

  /**  */
  requiredParams?: AttributeParamModel[];
}

/** TenantModel */
export interface TenantModel {
  /**  */
  address?: string;

  /**  */
  configParameters?: string;

  /**  */
  description?: string;

  /**  */
  name?: string;

  /**  */
  templatePolicySupported?: boolean;

  /**  */
  useExternalSSM?: boolean;
}

/** TenantProfile */
export interface TenantProfile {
  /**  */
  address?: string;

  /**  */
  configParameters?: string;

  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  federated?: boolean;

  /**  */
  groupUserMappingTableSchemaName?: string;

  /**  */
  id?: string;

  /**  */
  kmsKey?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  lockoutTimeInMin?: number;

  /**  */
  managementTenant?: boolean;

  /**  */
  maxFailedAttempts?: number;

  /**  */
  name?: string;

  /**  */
  provisioningSource?: string;

  /**  */
  status?: string;

  /**  */
  templatePolicySupported?: boolean;

  /**  */
  trialEndDate?: Date;

  /**  */
  trialStartDate?: Date;

  /**  */
  useExternalSSM?: boolean;
}

/** TenantUser */
export interface TenantUser {
  /**  */
  accessType?: string;

  /**  */
  accountNonLocked?: boolean;

  /**  */
  applicationAttributeMapping?: EntityMappingModel[];

  /**  */
  attributeMapping?: EntityMappingModel[];

  /**  */
  configParameters?: string;

  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  email?: string;

  /**  */
  failedAttempt?: number;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  lockTime?: Date;

  /**  */
  loggedIn?: boolean;

  /**  */
  loginId?: string;

  /**  */
  mfaEnableDate?: Date;

  /**  */
  mfaEnabled?: boolean;

  /**  */
  name?: string;

  /**  */
  phone?: string;

  /**  */
  roleIds?: string[];

  /**  */
  roles?: Role[];

  /**  */
  skipSso?: boolean;

  /**  */
  tenantId?: string;

  /**  */
  userType?: string;
}

/** TlxAlertResponseModel */
export interface TlxAlertResponseModel {
  /**  */
  items?: AlertRecordModelRes[];

  /**  */
  pageNo?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;
}

/** TlxApplicationUserEntitlementAttributeColumnResponseModel */
export interface TlxApplicationUserEntitlementAttributeColumnResponseModel {
  /**  */
  items?: ApplicationUserEntitlementAttributeColumnModel[];

  /**  */
  pageNo?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;
}

/** TlxColumnMaskingPatterns */
export interface TlxColumnMaskingPatterns {
  /**  */
  allowedValues?: string;

  /**  */
  deleted?: boolean;

  /**  */
  hints?: string;

  /**  */
  id?: string;

  /**  */
  inputType?: string;

  /**  */
  maskingPatternParameterDetails?: MaskingPatternParameterDetails;

  /**  */
  name?: string;
}

/** TlxExternalIntegrationTypeMetadata */
export interface TlxExternalIntegrationTypeMetadata {
  /**  */
  displayName?: string;

  /**  */
  id?: string;

  /**  */
  integrationDisplayName?: string;

  /**  */
  integrationType?: string;

  /**  */
  metadata?: string;

  /**  */
  type?: string;
}

/** TlxGenericNameIdModel */
export interface TlxGenericNameIdModel {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  type?: string;

  /**  */
  valueTypes?: object;

  /**  */
  values?: string[];
}

/** TlxHttpResponse */
export interface TlxHttpResponse {
  /**  */
  code?: number;

  /**  */
  data?: object;

  /**  */
  message?: string;
}

/** TlxObjectActionMappingModel */
export interface TlxObjectActionMappingModel {
  /**  */
  actionDisplayName?: string;

  /**  */
  actionName?: string;

  /**  */
  disabled?: boolean;

  /**  */
  id?: string;
}

/** TlxPaginatedResponseModel */
export interface TlxPaginatedResponseModel {
  /**  */
  items?: object[];

  /**  */
  pageNo?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;
}

/** TlxPaginatedResponseModel_AccessPolicyUserDefinedFunctionModel */
export interface TlxPaginatedResponseModel_AccessPolicyUserDefinedFunctionModel {
  /**  */
  items?: AccessPolicyUserDefinedFunctionModel[];

  /**  */
  pageNo?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;
}

/** TlxPaginatedResponseModel_AccountModel */
export interface TlxPaginatedResponseModel_AccountModel {
  /**  */
  items?: AccountModel[];

  /**  */
  pageNo?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;
}

/** TlxPaginatedResponseModel_AgentPolicyItemModel */
export interface TlxPaginatedResponseModel_AgentPolicyItemModel {
  /**  */
  items?: AgentPolicyItemModel[];

  /**  */
  pageNo?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;
}

/** TlxPaginatedResponseModel_Application */
export interface TlxPaginatedResponseModel_Application {
  /**  */
  items?: Application[];

  /**  */
  pageNo?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;
}

/** TlxPaginatedResponseModel_AttributeDataResponseModel */
export interface TlxPaginatedResponseModel_AttributeDataResponseModel {
  /**  */
  items?: AttributeDataResponseModel[];

  /**  */
  pageNo?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;
}

/** TlxPaginatedResponseModel_CatalogMasterDataModel */
export interface TlxPaginatedResponseModel_CatalogMasterDataModel {
  /**  */
  items?: CatalogMasterDataModel[];

  /**  */
  pageNo?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;
}

/** TlxPaginatedResponseModel_CatalogResponseModel */
export interface TlxPaginatedResponseModel_CatalogResponseModel {
  /**  */
  items?: CatalogResponseModel[];

  /**  */
  pageNo?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;
}

/** TlxPaginatedResponseModel_DataAccessPolicyWithoutUDFModel */
export interface TlxPaginatedResponseModel_DataAccessPolicyWithoutUDFModel {
  /**  */
  items?: DataAccessPolicyWithoutUDFModel[];

  /**  */
  pageNo?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;
}

/** TlxPaginatedResponseModel_DataDomainPaginatedModel */
export interface TlxPaginatedResponseModel_DataDomainPaginatedModel {
  /**  */
  items?: DataDomainPaginatedModel[];

  /**  */
  pageNo?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;
}

/** TlxPaginatedResponseModel_EnterprisePolicyResponse */
export interface TlxPaginatedResponseModel_EnterprisePolicyResponse {
  /**  */
  items?: EnterprisePolicyResponse[];

  /**  */
  pageNo?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;
}

/** TlxPaginatedResponseModel_EstateAgentModel */
export interface TlxPaginatedResponseModel_EstateAgentModel {
  /**  */
  items?: EstateAgentModel[];

  /**  */
  pageNo?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;
}

/** TlxPaginatedResponseModel_Item */
export interface TlxPaginatedResponseModel_Item {
  /**  */
  items?: Item[];

  /**  */
  pageNo?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;
}

/** TlxPaginatedResponseModel_MonitoringPolicyResponseModelV1 */
export interface TlxPaginatedResponseModel_MonitoringPolicyResponseModelV1 {
  /**  */
  items?: MonitoringPolicyResponseModelV1[];

  /**  */
  pageNo?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;
}

/** TlxPaginatedResponseModel_OpaPolicyEvaluationAuditLogModel */
export interface TlxPaginatedResponseModel_OpaPolicyEvaluationAuditLogModel {
  /**  */
  items?: OpaPolicyEvaluationAuditLogModel[];

  /**  */
  pageNo?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;
}

/** TlxPaginatedResponseModel_PolicyResourceRequestModel */
export interface TlxPaginatedResponseModel_PolicyResourceRequestModel {
  /**  */
  items?: PolicyResourceRequestModel[];

  /**  */
  pageNo?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;
}

/** TlxPaginatedResponseModel_PolicyResourceTypeRequestModel */
export interface TlxPaginatedResponseModel_PolicyResourceTypeRequestModel {
  /**  */
  items?: PolicyResourceTypeRequestModel[];

  /**  */
  pageNo?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;
}

/** TlxPaginatedResponseModel_PrivilegeTemplateModel */
export interface TlxPaginatedResponseModel_PrivilegeTemplateModel {
  /**  */
  items?: PrivilegeTemplateModel[];

  /**  */
  pageNo?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;
}

/** TlxPaginatedResponseModel_RoleMappingListResponseModel */
export interface TlxPaginatedResponseModel_RoleMappingListResponseModel {
  /**  */
  items?: RoleMappingListResponseModel[];

  /**  */
  pageNo?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;
}

/** TlxPaginatedResponseModel_TrustAiFabricErrorLogModel */
export interface TlxPaginatedResponseModel_TrustAiFabricErrorLogModel {
  /**  */
  items?: TrustAiFabricErrorLogModel[];

  /**  */
  pageNo?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;
}

/** TlxPaginatedResponseModel_UnifiedIcebergInventoryModel */
export interface TlxPaginatedResponseModel_UnifiedIcebergInventoryModel {
  /**  */
  items?: UnifiedIcebergInventoryModel[];

  /**  */
  pageNo?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;
}

/** TlxPaginatedResponseModel_UnifiedLakeHousePolicyListItemResponse */
export interface TlxPaginatedResponseModel_UnifiedLakeHousePolicyListItemResponse {
  /**  */
  items?: UnifiedLakeHousePolicyListItemResponse[];

  /**  */
  pageNo?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;
}

/** TlxSyncServiceResponseModel */
export interface TlxSyncServiceResponseModel {
  /**  */
  accountId?: string;

  /**  */
  failedMessage?: string;

  /**  */
  status?: string;
}

/** TlxUserEntitlementAttributeColumnResponseModel */
export interface TlxUserEntitlementAttributeColumnResponseModel {
  /**  */
  items?: UserEntitlementAttributeColumnModel[];

  /**  */
  pageNo?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;
}

/** TlxUserEntitlementAttributeValueResponseModel */
export interface TlxUserEntitlementAttributeValueResponseModel {
  /**  */
  columns?: UserAttributeValueColumn[];

  /**  */
  data?: UserEntitlementAttributeValueModel[];

  /**  */
  pageNo?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;
}

/** TokenRefreshRequest */
export interface TokenRefreshRequest {
  /**  */
  refreshToken: string;
}

/** Tool */
export interface Tool {
  /**  */
  allowedTools?: string[];

  /**  */
  isGatewayProtected?: boolean;

  /**  */
  name?: string;

  /**  */
  serverUrl?: string;

  /**  */
  sourceConfig?: ToolSourceConfig;
}

/** ToolSourceConfig */
export interface ToolSourceConfig {
  /**  */
  projectConnectionId?: string;

  /**  */
  requireApproval?: object;
}

/** TrustAiFabricErrorLogModel */
export interface TrustAiFabricErrorLogModel {
  /**  */
  context?: string;

  /**  */
  createdDate?: Date;

  /**  */
  errorCode?: string;

  /**  */
  errorMessage?: string;

  /**  */
  errorType?: EnumTrustAiFabricErrorLogModelErrorType;

  /**  */
  id?: string;

  /**  */
  mcpServerId?: string;

  /**  */
  requestId?: string;

  /**  */
  tenantId?: string;
}

/** TrustAiFabricErrorLogRequest */
export interface TrustAiFabricErrorLogRequest {
  /**  */
  context?: string;

  /**  */
  errorCode?: string;

  /**  */
  errorMessage?: string;

  /**  */
  errorType: EnumTrustAiFabricErrorLogRequestErrorType;

  /**  */
  mcpServerId?: string;

  /**  */
  requestId?: string;

  /**  */
  tenantId: string;
}

/** TrustDspmChatQueryTracker */
export interface TrustDspmChatQueryTracker {
  /**  */
  accountId?: string;

  /**  */
  accountName?: string;

  /**  */
  accountType?: string;

  /**  */
  facet?: string;

  /**  */
  id?: string;

  /**  */
  isDeleted?: boolean;

  /**  */
  messageId?: string;

  /**  */
  queryId?: string;

  /**  */
  sessionId?: string;

  /**  */
  storeType?: string;

  /**  */
  tenantId?: string;
}

/** UnifiedIcebergInventoryModel */
export interface UnifiedIcebergInventoryModel {
  /**  */
  accountId?: string;

  /**  */
  canonicalMappingId?: string;

  /**  */
  catalogName?: string;

  /**  */
  catalogType?: string;

  /**  */
  createdBy?: string;

  /**  */
  createdDate?: string;

  /**  */
  description?: string;

  /**  */
  discoveredAt?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedDate?: string;

  /**  */
  metadataLocation?: string;

  /**  */
  modifiedBy?: string;

  /**  */
  name?: string;

  /**  */
  namespace?: string;

  /**  */
  objectType?: string;

  /**  */
  platform?: string;

  /**  */
  projectId?: string;

  /**  */
  storageLocation?: string;

  /**  */
  syncRunId?: string;

  /**  */
  tableFormat?: string;

  /**  */
  tableId?: string;

  /**  */
  tableName?: string;

  /**  */
  targetTableName?: string;

  /**  */
  tenantId?: string;
}

/** UnifiedLakeHouseAccessPolicyDeployRequest */
export interface UnifiedLakeHouseAccessPolicyDeployRequest {
  /**  */
  deployments?: DeploymentItem[];
}

/** UnifiedLakeHousePolicyListItemResponse */
export interface UnifiedLakeHousePolicyListItemResponse {
  /**  */
  canonicalObject?: string;

  /**  */
  coverageStatus?: string;

  /**  */
  dataSourceIds?: string[];

  /**  */
  databaseObjects?: DatabaseObject[];

  /**  */
  description?: string;

  /**  */
  draftPolicyId?: string;

  /**  */
  id?: string;

  /**  */
  lakehousePolicyTypeDetails?: LakehousePolicyTypeDetail;

  /**  */
  lastUpdated?: string;

  /**  */
  name?: string;

  /**  */
  nativePreviews?: NativePreview[];

  /**  */
  owner?: string;

  /**  */
  platformCoverage?: PlatformCoverage[];

  /**  */
  policyActions?: TlxObjectActionMappingModel[];

  /**  */
  policyDataTypeId?: string;

  /**  */
  privilegeList?: PrivilegeDetail[];

  /**  */
  rule?: string;

  /**  */
  rules?: RuleDetail[];

  /**  */
  status?: string;

  /**  */
  target?: string;
}

/** UnifiedLakeHouseRoleModel */
export interface UnifiedLakeHouseRoleModel {
  /**  */
  account_id: string;

  /**  */
  action?: string;

  /**  */
  additional_metadata?: object;

  /**  */
  created_at?: Date;

  /**  */
  deleted_at_source?: Date;

  /**  */
  detected_on?: Date;

  /**  */
  id?: string;

  /**  */
  inserted_at?: Date;

  /**  */
  is_deleted?: boolean;

  /**  */
  owner?: string;

  /**  */
  platform: string;

  /**  */
  role_id?: string;

  /**  */
  role_name: string;

  /**  */
  role_type?: string;

  /**  */
  updated_at?: Date;
}

/** UnifiedLakeHouseTableMappingResponseModel */
export interface UnifiedLakeHouseTableMappingResponseModel {
  /**  */
  storage_location?: string;

  /**  */
  tables?: TableMappingEntry[];
}

/** UnifiedLakeHouseTableModel */
export interface UnifiedLakeHouseTableModel {
  /**  */
  account_id: string;

  /**  */
  action?: string;

  /**  */
  additional_metadata?: object;

  /**  */
  catalog_name: string;

  /**  */
  created_at?: Date;

  /**  */
  detected_on?: Date;

  /**  */
  id?: string;

  /**  */
  inserted_at?: Date;

  /**  */
  is_deleted?: boolean;

  /**  */
  last_modified_at?: Date;

  /**  */
  metadata_location?: string;

  /**  */
  platform: string;

  /**  */
  row_count?: number;

  /**  */
  schema_name: string;

  /**  */
  size_bytes?: number;

  /**  */
  storage_location?: string;

  /**  */
  table_format?: string;

  /**  */
  table_name: string;

  /**  */
  table_owner?: string;

  /**  */
  table_type?: string;

  /**  */
  updated_at?: Date;
}

/** UnifiedLakeHouseTableResponseModel */
export interface UnifiedLakeHouseTableResponseModel {
  /**  */
  account_id?: string;

  /**  */
  additional_metadata?: object;

  /**  */
  catalog_name?: string;

  /**  */
  created_at?: Date;

  /**  */
  detected_on?: Date;

  /**  */
  id?: string;

  /**  */
  inserted_at?: Date;

  /**  */
  last_modified_at?: Date;

  /**  */
  metadata_location?: string;

  /**  */
  platform?: string;

  /**  */
  row_count?: number;

  /**  */
  schema_name?: string;

  /**  */
  size_bytes?: number;

  /**  */
  storage_location?: string;

  /**  */
  table_format?: string;

  /**  */
  table_name?: string;

  /**  */
  table_owner?: string;

  /**  */
  table_type?: string;

  /**  */
  tenant_id?: string;

  /**  */
  updated_at?: Date;
}

/** UnifiedLakeHouseUserModel */
export interface UnifiedLakeHouseUserModel {
  /**  */
  account_id: string;

  /**  */
  action?: string;

  /**  */
  additional_metadata?: object;

  /**  */
  created_at?: Date;

  /**  */
  deleted_at_source?: Date;

  /**  */
  detected_on?: Date;

  /**  */
  display_name?: string;

  /**  */
  email?: string;

  /**  */
  first_name?: string;

  /**  */
  id?: string;

  /**  */
  inserted_at?: Date;

  /**  */
  is_active?: boolean;

  /**  */
  is_deleted?: boolean;

  /**  */
  is_disabled?: boolean;

  /**  */
  last_name?: string;

  /**  */
  platform: string;

  /**  */
  updated_at?: Date;

  /**  */
  user_id?: string;

  /**  */
  user_name: string;
}

/** UnifiedLakeHouseUserResponseModel */
export interface UnifiedLakeHouseUserResponseModel {
  /**  */
  account_id?: string;

  /**  */
  additional_metadata?: object;

  /**  */
  created_at?: Date;

  /**  */
  deleted_at_source?: Date;

  /**  */
  detected_on?: Date;

  /**  */
  display_name?: string;

  /**  */
  email?: string;

  /**  */
  first_name?: string;

  /**  */
  id?: string;

  /**  */
  inserted_at?: Date;

  /**  */
  is_active?: boolean;

  /**  */
  is_disabled?: boolean;

  /**  */
  last_name?: string;

  /**  */
  platform?: string;

  /**  */
  tenant_id?: string;

  /**  */
  updated_at?: Date;

  /**  */
  user_id?: string;

  /**  */
  user_name?: string;
}

/** UnifiedReleaseResponse */
export interface UnifiedReleaseResponse {
  /**  */
  components?: ComponentDetail[];

  /**  */
  date?: string;

  /**  */
  id?: string;

  /**  */
  releaseLink?: string;
}

/** UnifiedReleasesWrapper */
export interface UnifiedReleasesWrapper {
  /**  */
  releases?: UnifiedReleaseResponse[];

  /**  */
  versions?: UnifiedReleaseResponse[];
}

/** UnitsModel */
export interface UnitsModel {
  /**  */
  generatedChanges?: number;

  /**  */
  mcpServerRecords?: number;

  /**  */
  mcpToolRecords?: number;

  /**  */
  nativeControls?: number;

  /**  */
  recommendedDefinitions?: number;

  /**  */
  targetedAgents?: number;

  /**  */
  trustlogixRecords?: number;
}

/** UpdateRequest */
export interface UpdateRequest {
  /**  */
  action: EnumUpdateRequestAction;

  /**  */
  actor?: string;

  /**  */
  agentId?: string;

  /**  */
  environmentId?: string;

  /**  */
  mission?: MissionInput;
}

/** UpdateResult */
export interface UpdateResult {
  /**  */
  action?: EnumUpdateResultAction;

  /**  */
  agentId?: string;

  /**  */
  mission?: AgentMissionModel;
}

/** UrlConfigurationResponse */
export interface UrlConfigurationResponse {
  /**  */
  mcpProxyUrl?: string;
}

/** UserAttributeAccountDattaProductResponseModel */
export interface UserAttributeAccountDattaProductResponseModel {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  type?: string;
}

/** UserAttributeConfigurationModel */
export interface UserAttributeConfigurationModel {
  /**  */
  configType?: string;

  /**  */
  configTypeId?: string;

  /**  */
  configurationName?: string;

  /**  */
  id?: string;

  /**  */
  parameters?: UserAttributeConfigurationParameterModel[];

  /**  */
  status?: EnumUserAttributeConfigurationModelStatus;
}

/** UserAttributeConfigurationParameterModel */
export interface UserAttributeConfigurationParameterModel {
  /**  */
  displayName?: string;

  /**  */
  order?: number;

  /**  */
  parameterName?: string;

  /**  */
  parameterType?: string;

  /**  */
  parameterValue?: string;

  /**  */
  required?: boolean;
}

/** UserAttributeConfigurationTypeModel */
export interface UserAttributeConfigurationTypeModel {
  /**  */
  configType?: string;

  /**  */
  datasourceType?: string;

  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  parameters?: UserAttributeConfigurationParameterModel[];

  /**  */
  userAttributeColumnConfigurationMetadata?: string;
}

/** UserAttributeDataTypeModel */
export interface UserAttributeDataTypeModel {
  /**  */
  displayName?: string;

  /**  */
  value?: string;
}

/** UserAttributeImportMetadataModel */
export interface UserAttributeImportMetadataModel {
  /**  */
  attributes?: UserEntitlementAttributeColumnModel[];

  /**  */
  externalIntegrationId?: string;

  /**  */
  targetDatasource?: TargetDatasourceModel[];
}

/** UserAttributeRecordCountClassificationResponse */
export interface UserAttributeRecordCountClassificationResponse {
  /**  */
  usersWithMultipleRecords?: string[];

  /**  */
  usersWithOneRecord?: string[];

  /**  */
  usersWithZeroRecord?: string[];
}

/** UserAttributeSourceModel */
export interface UserAttributeSourceModel {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  sourceType?: string;

  /**  */
  type?: string;
}

/** UserAttributeSyncJobRunDetailsModel */
export interface UserAttributeSyncJobRunDetailsModel {
  /**  */
  accountId?: string;

  /**  */
  attributes?: string;

  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  dataProduct?: string;

  /**  */
  deltaLink?: string;

  /**  */
  failMessage?: string;

  /**  */
  groupDeltaLink?: string;

  /**  */
  groupFailMessage?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  lastSyncDate?: Date;

  /**  */
  nextDeltaLink?: string;

  /**  */
  nextGroupDeltaLink?: string;

  /**  */
  status?: string;

  /**  */
  userAttributeConfigurationId?: string;
}

/** UserAttributeUDFResponseModel */
export interface UserAttributeUDFResponseModel {
  /**  */
  arguments?: string;

  /**  */
  description?: string;

  /**  */
  failMessage?: string;

  /**  */
  returnType?: string;

  /**  */
  sampleUsage?: string;

  /**  */
  status?: string;

  /**  */
  udfDefinition?: string;

  /**  */
  udfName?: string;
}

/** UserAttributeValueColumn */
export interface UserAttributeValueColumn {
  /**  */
  actualDataType?: string;

  /**  */
  attributeGroupName?: string;

  /**  */
  attributeType?: string;

  /**  */
  configurationValue?: string;

  /**  */
  dataProduct?: string;

  /**  */
  deriveType?: EnumUserAttributeValueColumnDeriveType;

  /**  */
  description?: string;

  /**  */
  displayName?: string;

  /**  */
  id?: string;

  /**  */
  isMultiValue?: boolean;

  /**  */
  isReferenceAttribute?: boolean;

  /**  */
  isSessionUser?: boolean;

  /**  */
  name?: string;

  /**  */
  parentAttributeRef?: string;

  /**  */
  readOnly?: boolean;

  /**  */
  required?: boolean;

  /**  */
  sourceAttributeName?: string;

  /**  */
  status?: string;

  /**  */
  type?: string;

  /**  */
  userAttributeConfigurationId?: string;
}

/** UserAuth */
export interface UserAuth {
  /**  */
  loginId?: string;

  /**  */
  password?: string;

  /**  */
  totp?: string;
}

/** UserEntitlementAttributeColumnModel */
export interface UserEntitlementAttributeColumnModel {
  /**  */
  accountId?: string;

  /**  */
  actualDataType?: string;

  /**  */
  attributeGroupName?: string;

  /**  */
  attributeLevelUdf?: UserAttributeUDFResponseModel[];

  /**  */
  configurationValue?: string;

  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  dataProduct?: string;

  /** false */
  deleted?: boolean;

  /**  */
  deriveType?: EnumUserEntitlementAttributeColumnModelDeriveType;

  /**  */
  description?: string;

  /**  */
  displayName?: string;

  /**  */
  elementType?: string;

  /**  */
  failMessage?: string;

  /**  */
  id?: string;

  /**  */
  identityType?: string;

  /** false */
  isMultiValue?: boolean;

  /** false */
  isReferenceAttribute?: boolean;

  /** false */
  isSessionUser?: boolean;

  /** false */
  isVirtual?: boolean;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;

  /**  */
  parentAttributeRef?: string;

  /** false */
  required?: boolean;

  /**  */
  size?: string;

  /**  */
  sourceAttributeName?: string;

  /**  */
  status?: string;

  /**  */
  tenantId?: string;

  /**  */
  type?: string;

  /**  */
  userAttributeConfigurationId?: string;
}

/** UserEntitlementAttributeModel */
export interface UserEntitlementAttributeModel {
  /**  */
  entitlementColumns?: UserEntitlementAttributeColumnModel[];

  /**  */
  entitlementTable?: string;

  /**  */
  id?: string;

  /**  */
  status?: string;

  /**  */
  statusDetails?: string;
}

/** UserEntitlementAttributeValueModel */
export interface UserEntitlementAttributeValueModel {
  /**  */
  applyToAllReportees?: boolean;

  /**  */
  cascaded?: boolean;

  /**  */
  cascadedFrom?: string;

  /**  */
  dataProduct?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  status?: string;

  /**  */
  sync?: boolean;

  /**  */
  values?: object;
}

/** UserModel */
export interface UserModel {
  /**  */
  accessType?: EnumUserModelAccessType;

  /**  */
  applicationAttributeMapping?: EntityMappingModel[];

  /**  */
  attributeMapping?: EntityMappingModel[];

  /**  */
  description?: string;

  /**  */
  email?: string;

  /**  */
  loginId?: string;

  /**  */
  name?: string;

  /**  */
  roleIds?: string[];

  /** false */
  skipSso?: boolean;
}

/** UserPolicy */
export interface UserPolicy {
  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  dataSourceType?: string;

  /**  */
  databaseName?: string;

  /**  */
  deleted?: boolean;

  /**  */
  grantedBy?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  objectName?: string;

  /**  */
  objectPrivileges?: string;

  /**  */
  objectType?: string;

  /**  */
  roleName?: string;

  /**  */
  schemaName?: string;

  /**  */
  userName?: string;
}

/** UserPolicyModel */
export interface UserPolicyModel {
  /**  */
  databaseName?: string;

  /**  */
  grantedBy?: string;

  /**  */
  objectName?: string;

  /**  */
  objectPrivileges?: string;

  /**  */
  objectType?: string;

  /**  */
  roleName?: string;

  /**  */
  schemaName?: string;

  /**  */
  userName?: string;
}

/** UserPolicyResponse */
export interface UserPolicyResponse {
  /**  */
  pageNo?: number;

  /**  */
  pageSize?: number;

  /**  */
  total?: number;

  /**  */
  userPolicies?: UserPolicy[];
}

/** Request body to upsert a single user preference */
export interface UserPreferenceRequest {
  /** Arbitrary JSON object to store for this preference type */
  value: object;
}

/** UserResourceContextRequest */
export interface UserResourceContextRequest {
  /**  */
  resourceKey: string;

  /**  */
  resourceValue: string;
}

/** UsersToRole */
export interface UsersToRole {
  /**  */
  createdBy?: string;

  /**  */
  createdDate?: Date;

  /**  */
  dbinstance?: string;

  /**  */
  dbtype?: string;

  /**  */
  deleted?: boolean;

  /**  */
  description?: string;

  /**  */
  id?: string;

  /**  */
  lastModifiedBy?: string;

  /**  */
  lastModifiedDate?: Date;

  /**  */
  name?: string;

  /**  */
  noOfUsers?: number;

  /**  */
  role?: string;

  /**  */
  tenantId?: string;

  /**  */
  users?: string;
}

/** UsersToRoleModel */
export interface UsersToRoleModel {
  /**  */
  usersToRole?: UsersToRole[];
}

/** UtilityScriptResponse */
export interface UtilityScriptResponse {
  /**  */
  description?: string;

  /**  */
  lastUpdatedDate?: string;

  /**  */
  scriptDescriptorName?: string;

  /**  */
  title?: string;

  /**  */
  version?: string;
}

/** VerifiedOutcomes */
export interface VerifiedOutcomes {
  /**  */
  agentsBlockedCrossRegionCopy?: number;

  /**  */
  agentsProtectedByIntentAuth?: number;

  /**  */
  agentsRestrictedEmbargoed?: number;

  /**  */
  agentsRoutedThroughIbac?: number;

  /**  */
  issuesRemediated?: number;

  /**  */
  percentEuActionsLogged?: number;

  /**  */
  proofPanel?: ProofPanel;
}

/** WatermarkTimestampModel */
export interface WatermarkTimestampModel {
  /**  */
  syncServiceRunTimestamp?: Date;

  /**  */
  type?: EnumWatermarkTimestampModelType;

  /**  */
  watermarkTimestamp?: string;

  /**  */
  workspaceName?: string;
}

/** WhatsChanged */
export interface WhatsChanged {
  /**  */
  items?: WhatsChangedItem[];
}

/** WhatsChangedItem */
export interface WhatsChangedItem {
  /**  */
  delta?: number;

  /**  */
  id?: string;

  /**  */
  tone?: string;
}

/** enpriseUserAttributes */
export interface enpriseUserAttributes {
  /**  */
  costCenter?: string;

  /**  */
  department?: string;

  /**  */
  division?: string;

  /**  */
  employeeNumber?: string;

  /**  */
  organization?: string;

  /**  */
  territory?: string;
}
export enum EnumAccountTagAssociationEditDeleteModelDomain {
  'COLUMN' = 'COLUMN',
  'DATABASE' = 'DATABASE',
  'RBAC_TAG_OBJECTS' = 'RBAC_TAG_OBJECTS',
  'SCHEMA' = 'SCHEMA',
  'SENSITIVITY_LABEL' = 'SENSITIVITY_LABEL',
  'TABLE' = 'TABLE',
  'VIEW' = 'VIEW'
}
export enum EnumAccountTagAssociationModelDomain {
  'COLUMN' = 'COLUMN',
  'DATABASE' = 'DATABASE',
  'RBAC_TAG_OBJECTS' = 'RBAC_TAG_OBJECTS',
  'SCHEMA' = 'SCHEMA',
  'SENSITIVITY_LABEL' = 'SENSITIVITY_LABEL',
  'TABLE' = 'TABLE',
  'VIEW' = 'VIEW'
}
export enum EnumAccountTagReferenceModelDomain {
  'COLUMN' = 'COLUMN',
  'DATABASE' = 'DATABASE',
  'RBAC_TAG_OBJECTS' = 'RBAC_TAG_OBJECTS',
  'SCHEMA' = 'SCHEMA',
  'SENSITIVITY_LABEL' = 'SENSITIVITY_LABEL',
  'TABLE' = 'TABLE',
  'VIEW' = 'VIEW'
}
export enum EnumAgentDefinitionPlatformModelName {
  'AWS_AGENTCORE' = 'AWS_AGENTCORE',
  'DATABRICKS' = 'DATABRICKS',
  'GITHUB' = 'GITHUB',
  'MICROSOFT_365' = 'MICROSOFT_365',
  'MICROSOFT_FOUNDRY' = 'MICROSOFT_FOUNDRY',
  'OPENAI' = 'OPENAI',
  'SNOWFLAKE' = 'SNOWFLAKE'
}
export enum EnumAgentEnforcementPathModelKind {
  'mcpConnection' = 'mcpConnection',
  'routing' = 'routing'
}
export enum EnumAgentEnforcementPathModelReason {
  'directMcp' = 'directMcp',
  'gatewayUnhealthy' = 'gatewayUnhealthy',
  'mcpConnectionFailed' = 'mcpConnectionFailed',
  'mcpConnectionMissing' = 'mcpConnectionMissing',
  'noEnvironment' = 'noEnvironment',
  'notRouted' = 'notRouted',
  'unverifiable' = 'unverifiable'
}
export enum EnumAgentEnforcementPathModelState {
  'CONFIGURED' = 'CONFIGURED',
  'NOT_APPLICABLE' = 'NOT_APPLICABLE',
  'SETUP_REQUIRED' = 'SETUP_REQUIRED',
  'UNKNOWN' = 'UNKNOWN'
}
export enum EnumAgentEnforcementReadinessModelMethod {
  'MCP_GATEWAY' = 'MCP_GATEWAY',
  'NONE' = 'NONE',
  'OTHER' = 'OTHER',
  'PLUGIN' = 'PLUGIN'
}
export enum EnumAgentEnforcementReadinessModelReason {
  'directMcp' = 'directMcp',
  'gatewayUnhealthy' = 'gatewayUnhealthy',
  'mcpConnectionFailed' = 'mcpConnectionFailed',
  'mcpConnectionMissing' = 'mcpConnectionMissing',
  'noEnvironment' = 'noEnvironment',
  'notRouted' = 'notRouted',
  'unverifiable' = 'unverifiable'
}
export enum EnumAgentEnforcementReadinessModelStatus {
  'ATTENTION_REQUIRED' = 'ATTENTION_REQUIRED',
  'READY' = 'READY',
  'SETUP_REQUIRED' = 'SETUP_REQUIRED',
  'UNKNOWN' = 'UNKNOWN'
}
export enum EnumAgentEnvironmentModelHealth {
  'DISABLED' = 'DISABLED',
  'HEALTHY' = 'HEALTHY',
  'WARNING' = 'WARNING'
}
export enum EnumAgentEnvironmentModelIdentityProvider {
  'AWS_IAM' = 'AWS_IAM',
  'CONFIGURE_LATER' = 'CONFIGURE_LATER',
  'MICROSOFT_ENTRA_ID' = 'MICROSOFT_ENTRA_ID',
  'OKTA' = 'OKTA',
  'OTHER' = 'OTHER'
}
export enum EnumAgentEnvironmentModelPlatform {
  'AWS_AGENTCORE' = 'AWS_AGENTCORE',
  'DATABRICKS' = 'DATABRICKS',
  'GITHUB' = 'GITHUB',
  'MICROSOFT_365' = 'MICROSOFT_365',
  'MICROSOFT_FOUNDRY' = 'MICROSOFT_FOUNDRY',
  'OPENAI' = 'OPENAI',
  'SNOWFLAKE' = 'SNOWFLAKE'
}
export enum EnumAgentIntentGenerationModelIntentType {
  'CUSTOM' = 'CUSTOM',
  'STANDARD' = 'STANDARD'
}
export enum EnumAgentIntentGenerationModelStatus {
  'ACTIVE' = 'ACTIVE',
  'PENDING_APPROVAL' = 'PENDING_APPROVAL',
  'SKIPPED_NO_BINDINGS' = 'SKIPPED_NO_BINDINGS',
  'SKIPPED_NO_POLICY_RULES' = 'SKIPPED_NO_POLICY_RULES',
  'SKIPPED_NO_PROMPT' = 'SKIPPED_NO_PROMPT',
  'SUPERSEDED' = 'SUPERSEDED'
}
export enum EnumAgentInventorySource {
  'MANUAL' = 'MANUAL',
  'MIXED' = 'MIXED',
  'REGISTRY' = 'REGISTRY',
  'UNKNOWN' = 'UNKNOWN'
}
export enum EnumAgentMcpServerBindingModelEffect {
  'ALLOW' = 'ALLOW',
  'CONDITIONAL' = 'CONDITIONAL',
  'DENY' = 'DENY'
}
export enum EnumAgentMcpServerBindingModelScope {
  'APPLICATION' = 'APPLICATION',
  'DATA_OBJECT' = 'DATA_OBJECT',
  'DATA_PRODUCT' = 'DATA_PRODUCT',
  'DATA_SOURCE' = 'DATA_SOURCE',
  'RESOURCE' = 'RESOURCE',
  'SENSITIVITY_LABELS' = 'SENSITIVITY_LABELS'
}
export enum EnumAgentMcpServerBindingModelStatus {
  'DISABLED' = 'DISABLED',
  'ENABLED' = 'ENABLED'
}
export enum EnumAgentMissionModelPurposeCategory {
  'ANALYTICS' = 'ANALYTICS',
  'CONTENT_CREATION' = 'CONTENT_CREATION',
  'CUSTOMER_SUPPORT' = 'CUSTOMER_SUPPORT',
  'ENGINEERING' = 'ENGINEERING',
  'FINANCE' = 'FINANCE',
  'HR' = 'HR',
  'RESEARCH' = 'RESEARCH'
}
export enum EnumAgentMissionModelSource {
  'ADMINISTRATOR' = 'ADMINISTRATOR',
  'ADMINISTRATOR_OVERRIDE' = 'ADMINISTRATOR_OVERRIDE',
  'IMPORTED' = 'IMPORTED',
  'TRUSTAI_INFERRED' = 'TRUSTAI_INFERRED'
}
export enum EnumAgentMissionModelStatus {
  'ADMINISTRATOR_DEFINED' = 'ADMINISTRATOR_DEFINED',
  'CONFIRMED' = 'CONFIRMED',
  'INFERRED_NEEDS_REVIEW' = 'INFERRED_NEEDS_REVIEW',
  'NEEDS_MORE_CONTEXT' = 'NEEDS_MORE_CONTEXT',
  'OVERRIDDEN' = 'OVERRIDDEN',
  'REVIEW_RECOMMENDED' = 'REVIEW_RECOMMENDED'
}
export enum EnumAgentNativePolicyLogicModelEffect {
  'ALLOW' = 'ALLOW',
  'BLOCK' = 'BLOCK',
  'MASK' = 'MASK',
  'REQUIRE_APPROVAL' = 'REQUIRE_APPROVAL'
}
export enum EnumAgentNativePolicyModelSource {
  'GENERATED' = 'GENERATED',
  'MANUALLY_MODIFIED' = 'MANUALLY_MODIFIED'
}
export enum EnumAgentNativePolicyModelState {
  'CREATING' = 'CREATING',
  'DEPLOYED' = 'DEPLOYED',
  'DEPLOYING' = 'DEPLOYING',
  'FAILED' = 'FAILED',
  'QUEUED' = 'QUEUED'
}
export enum EnumAgentNativePolicyModelTarget {
  'DATA_PLATFORM' = 'DATA_PLATFORM',
  'MCP_SERVER' = 'MCP_SERVER',
  'MCP_TOOL' = 'MCP_TOOL'
}
export enum EnumAgentPolicyAgentModelApplicability {
  'APPLICABLE' = 'APPLICABLE',
  'NOT_APPLICABLE' = 'NOT_APPLICABLE',
  'RECOMMENDED' = 'RECOMMENDED'
}
export enum EnumAgentPolicyAgentModelReason {
  'ALREADY_ASSIGNED' = 'ALREADY_ASSIGNED',
  'NOT_APPLICABLE' = 'NOT_APPLICABLE',
  'UNRESOLVED' = 'UNRESOLVED'
}
export enum EnumAgentPolicyAgentModelStatus {
  'CONFLICT_DETECTED' = 'CONFLICT_DETECTED',
  'ENFORCED' = 'ENFORCED',
  'NOT_ENFORCED' = 'NOT_ENFORCED',
  'NOT_MAPPED' = 'NOT_MAPPED',
  'PARTIALLY_ENFORCED' = 'PARTIALLY_ENFORCED'
}
export enum EnumAgentPolicyAgentModelStatusAfter {
  'NOT_EVALUATED' = 'NOT_EVALUATED',
  'NOT_SECURE' = 'NOT_SECURE',
  'SECURE' = 'SECURE'
}
export enum EnumAgentPolicyAgentModelStatusBefore {
  'NOT_EVALUATED' = 'NOT_EVALUATED',
  'NOT_SECURE' = 'NOT_SECURE',
  'SECURE' = 'SECURE'
}
export enum EnumAgentPolicyCatalogItemModelApplicability {
  'APPLICABLE' = 'APPLICABLE',
  'NOT_APPLICABLE' = 'NOT_APPLICABLE',
  'RECOMMENDED' = 'RECOMMENDED'
}
export enum EnumAgentPolicyCatalogItemModelRecommendationStrength {
  'RECOMMENDED' = 'RECOMMENDED',
  'STRONGLY_RECOMMENDED' = 'STRONGLY_RECOMMENDED'
}
export enum EnumAgentPolicyContextModelType {
  'accessPath' = 'accessPath',
  'agent' = 'agent',
  'group' = 'group',
  'policy' = 'policy'
}
export enum EnumAgentPolicyControlModelSense {
  'ALLOW' = 'ALLOW',
  'BLOCK' = 'BLOCK',
  'MASK' = 'MASK',
  'REQUIRE_APPROVAL' = 'REQUIRE_APPROVAL'
}
export enum EnumAgentPolicyDataControlModelStatus {
  'CONFLICT_DETECTED' = 'CONFLICT_DETECTED',
  'ENFORCED' = 'ENFORCED',
  'NOT_ENFORCED' = 'NOT_ENFORCED',
  'NOT_MAPPED' = 'NOT_MAPPED',
  'PARTIALLY_ENFORCED' = 'PARTIALLY_ENFORCED'
}
export enum EnumAgentPolicyDataEnforcementModelStatus {
  'CONFLICT_DETECTED' = 'CONFLICT_DETECTED',
  'ENFORCED' = 'ENFORCED',
  'NOT_ENFORCED' = 'NOT_ENFORCED',
  'NOT_MAPPED' = 'NOT_MAPPED',
  'PARTIALLY_ENFORCED' = 'PARTIALLY_ENFORCED'
}
export enum EnumAgentPolicyEffectiveEnforcementModelStatus {
  'CONFLICT_DETECTED' = 'CONFLICT_DETECTED',
  'ENFORCED' = 'ENFORCED',
  'NOT_ENFORCED' = 'NOT_ENFORCED',
  'NOT_MAPPED' = 'NOT_MAPPED',
  'PARTIALLY_ENFORCED' = 'PARTIALLY_ENFORCED'
}
export enum EnumAgentPolicyFindingModelLayer {
  'AGENT' = 'AGENT',
  'DATA' = 'DATA',
  'SERVER' = 'SERVER',
  'TOOL' = 'TOOL'
}
export enum EnumAgentPolicyFindingModelStatus {
  'CONFLICT_DETECTED' = 'CONFLICT_DETECTED',
  'ENFORCED' = 'ENFORCED',
  'NOT_ENFORCED' = 'NOT_ENFORCED',
  'NOT_MAPPED' = 'NOT_MAPPED',
  'PARTIALLY_ENFORCED' = 'PARTIALLY_ENFORCED'
}
export enum EnumAgentPolicyHistoryEventModelKind {
  'APPLIED' = 'APPLIED',
  'DEPLOYMENT_FAILED' = 'DEPLOYMENT_FAILED',
  'MODIFIED' = 'MODIFIED',
  'PLATFORM_DEPLOYED' = 'PLATFORM_DEPLOYED',
  'REAPPLIED' = 'REAPPLIED',
  'RETRIED' = 'RETRIED',
  'TLX_DEPLOYED' = 'TLX_DEPLOYED',
  'VERIFIED' = 'VERIFIED'
}
export enum EnumAgentPolicyImplementationGroupModelState {
  'CREATING' = 'CREATING',
  'DEPLOYED' = 'DEPLOYED',
  'DEPLOYING' = 'DEPLOYING',
  'FAILED' = 'FAILED',
  'NOT_CREATED' = 'NOT_CREATED',
  'PARTIALLY_DEPLOYED' = 'PARTIALLY_DEPLOYED'
}
export enum EnumAgentPolicyImplementationModelAlignment {
  'MATCHES_DEFINITION' = 'MATCHES_DEFINITION',
  'MODIFIED' = 'MODIFIED',
  'UNKNOWN' = 'UNKNOWN'
}
export enum EnumAgentPolicyImplementationModelDefinitionState {
  'APPLIED' = 'APPLIED',
  'APPLYING' = 'APPLYING',
  'FAILED' = 'FAILED',
  'RECOMMENDED' = 'RECOMMENDED'
}
export enum EnumAgentPolicyImplementationModelImplementationState {
  'CREATING' = 'CREATING',
  'DEPLOYED' = 'DEPLOYED',
  'DEPLOYING' = 'DEPLOYING',
  'FAILED' = 'FAILED',
  'NOT_CREATED' = 'NOT_CREATED',
  'PARTIALLY_DEPLOYED' = 'PARTIALLY_DEPLOYED'
}
export enum EnumAgentPolicyItemModelApplicability {
  'APPLICABLE' = 'APPLICABLE',
  'NOT_APPLICABLE' = 'NOT_APPLICABLE',
  'RECOMMENDED' = 'RECOMMENDED'
}
export enum EnumAgentPolicyItemModelDefinitionState {
  'APPLIED' = 'APPLIED',
  'APPLYING' = 'APPLYING',
  'FAILED' = 'FAILED',
  'RECOMMENDED' = 'RECOMMENDED'
}
export enum EnumAgentPolicyItemModelEffect {
  'ALLOW' = 'ALLOW',
  'CONDITIONAL' = 'CONDITIONAL',
  'DENY' = 'DENY'
}
export enum EnumAgentPolicyItemModelPolicyState {
  'APPLIED' = 'APPLIED',
  'NOT_APPLIED' = 'NOT_APPLIED',
  'PARTIALLY_APPLIED' = 'PARTIALLY_APPLIED'
}
export enum EnumAgentPolicyMcpEnforcementModelStatus {
  'CONFLICT_DETECTED' = 'CONFLICT_DETECTED',
  'ENFORCED' = 'ENFORCED',
  'NOT_ENFORCED' = 'NOT_ENFORCED',
  'NOT_MAPPED' = 'NOT_MAPPED',
  'PARTIALLY_ENFORCED' = 'PARTIALLY_ENFORCED'
}
export enum EnumAgentPolicyRecommendationModelStrength {
  'RECOMMENDED' = 'RECOMMENDED',
  'STRONGLY_RECOMMENDED' = 'STRONGLY_RECOMMENDED'
}
export enum EnumAgentPolicyRequestModelEffect {
  'ALLOW' = 'ALLOW',
  'CONDITIONAL' = 'CONDITIONAL',
  'DENY' = 'DENY'
}
export enum EnumAgentPolicyResponseModelEffect {
  'ALLOW' = 'ALLOW',
  'CONDITIONAL' = 'CONDITIONAL',
  'DENY' = 'DENY'
}
export enum EnumAgentPolicyReviewRecommendationModelStrength {
  'RECOMMENDED' = 'RECOMMENDED',
  'STRONGLY_RECOMMENDED' = 'STRONGLY_RECOMMENDED'
}
export enum EnumAgentPolicyRuleModelEffect {
  'ALLOW' = 'ALLOW',
  'CONDITIONAL' = 'CONDITIONAL',
  'DENY' = 'DENY'
}
export enum EnumAgentPolicyRunModelKind {
  'APPLY' = 'APPLY',
  'REAPPLY' = 'REAPPLY',
  'RETRY' = 'RETRY'
}
export enum EnumAgentPolicyRunModelState {
  'CREATING' = 'CREATING',
  'DEPLOYED' = 'DEPLOYED',
  'DEPLOYING' = 'DEPLOYING',
  'FAILED' = 'FAILED',
  'NOT_CREATED' = 'NOT_CREATED',
  'PARTIALLY_DEPLOYED' = 'PARTIALLY_DEPLOYED'
}
export enum EnumAgentPolicyScopeModelDimension {
  'BUSINESS_UNIT' = 'BUSINESS_UNIT',
  'CONNECTED_RESOURCE' = 'CONNECTED_RESOURCE',
  'ENVIRONMENT' = 'ENVIRONMENT',
  'NONE' = 'NONE',
  'PLATFORM' = 'PLATFORM',
  'PROJECT' = 'PROJECT',
  'PURPOSE' = 'PURPOSE',
  'SECURITY_STATUS' = 'SECURITY_STATUS'
}
export enum EnumAgentPolicyScopeModelKind {
  'AGENTS' = 'AGENTS',
  'ALL' = 'ALL',
  'FILTER' = 'FILTER',
  'GROUP' = 'GROUP'
}
export enum EnumAgentPolicyStepModelKey {
  'CREATE_TLX' = 'CREATE_TLX',
  'DEPLOY_PLATFORM' = 'DEPLOY_PLATFORM',
  'DEPLOY_TLX' = 'DEPLOY_TLX',
  'VERIFY' = 'VERIFY'
}
export enum EnumAgentPolicyStepModelStatus {
  'ACTIVE' = 'ACTIVE',
  'DONE' = 'DONE',
  'FAILED' = 'FAILED',
  'PENDING' = 'PENDING'
}
export enum EnumAgentPolicyToolEnforcementModelStatus {
  'CONFLICT_DETECTED' = 'CONFLICT_DETECTED',
  'ENFORCED' = 'ENFORCED',
  'NOT_ENFORCED' = 'NOT_ENFORCED',
  'NOT_MAPPED' = 'NOT_MAPPED',
  'PARTIALLY_ENFORCED' = 'PARTIALLY_ENFORCED'
}
export enum EnumAgentPromptModelPromptType {
  'SYSTEM' = 'SYSTEM',
  'USER' = 'USER'
}
export enum EnumAgentRegistryRequestModelTarget {
  'CONNECTION' = 'CONNECTION',
  'CONNECTION_AND_IDENTITY' = 'CONNECTION_AND_IDENTITY',
  'IDENTITY' = 'IDENTITY'
}
export enum EnumAuthoredAgentPolicyModelOrigin {
  'AGENT' = 'AGENT',
  'TOOL_CUSTOMIZATION' = 'TOOL_CUSTOMIZATION'
}
export enum EnumAuthoredAgentPolicyModelStatus {
  'APPLIED' = 'APPLIED',
  'DRAFT' = 'DRAFT'
}
export enum EnumBulkPolicyImportJobModelStatus {
  'COMPLETED' = 'COMPLETED',
  'FAILED' = 'FAILED',
  'PARTIAL_COMPLETED' = 'PARTIAL_COMPLETED',
  'PROCESSING' = 'PROCESSING'
}
export enum EnumBulkPolicyImportJobRowModelStatus {
  'FAILED' = 'FAILED',
  'INITIALIZED' = 'INITIALIZED',
  'PROCESSING' = 'PROCESSING',
  'SUCCESS' = 'SUCCESS'
}
export enum EnumCohortModelEntry {
  'MULTI_AGENT' = 'MULTI_AGENT',
  'SINGLE_AGENT' = 'SINGLE_AGENT'
}
export enum EnumCredentialsConfigModelExchangeType {
  'DELEGATION' = 'DELEGATION',
  'IMPERSONATION' = 'IMPERSONATION'
}
export enum EnumCredentialsConfigModelGrantType {
  'CLIENT_CREDENTIALS' = 'CLIENT_CREDENTIALS',
  'TOKEN_EXCHANGE' = 'TOKEN_EXCHANGE'
}
export enum EnumCredentialsConfigModelServiceIdentity {
  'AGENT' = 'AGENT',
  'CUSTOM' = 'CUSTOM',
  'GATEWAY' = 'GATEWAY'
}
export enum EnumDataAccessPolicyResourceSourceType {
  'APPLICATION' = 'APPLICATION',
  'DATA_OBJECT' = 'DATA_OBJECT',
  'DATA_PRODUCT' = 'DATA_PRODUCT',
  'DATA_SOURCE' = 'DATA_SOURCE',
  'RESOURCE' = 'RESOURCE',
  'SENSITIVITY_LABELS' = 'SENSITIVITY_LABELS'
}
export enum EnumDataAccessPolicyModelPolicySubtype {
  'COLUMN_NAMES' = 'COLUMN_NAMES',
  'COLUMN_TAGGED_AS' = 'COLUMN_TAGGED_AS',
  'ENTERPRISE' = 'ENTERPRISE',
  'OBJECTS_TAGGED_AS' = 'OBJECTS_TAGGED_AS',
  'OBJECT_NAMES' = 'OBJECT_NAMES',
  'SENSITIVITY_LABELS' = 'SENSITIVITY_LABELS'
}
export enum EnumDataAccessPolicyModelResourceSourceType {
  'APPLICATION' = 'APPLICATION',
  'DATA_OBJECT' = 'DATA_OBJECT',
  'DATA_PRODUCT' = 'DATA_PRODUCT',
  'DATA_SOURCE' = 'DATA_SOURCE',
  'RESOURCE' = 'RESOURCE',
  'SENSITIVITY_LABELS' = 'SENSITIVITY_LABELS'
}
export enum EnumDataAccessPolicyResourceDetailsResourceSourceType {
  'APPLICATION' = 'APPLICATION',
  'DATA_OBJECT' = 'DATA_OBJECT',
  'DATA_PRODUCT' = 'DATA_PRODUCT',
  'DATA_SOURCE' = 'DATA_SOURCE',
  'RESOURCE' = 'RESOURCE',
  'SENSITIVITY_LABELS' = 'SENSITIVITY_LABELS'
}
export enum EnumDataAccessPolicyWithoutUDFModelResourceSourceType {
  'APPLICATION' = 'APPLICATION',
  'DATA_OBJECT' = 'DATA_OBJECT',
  'DATA_PRODUCT' = 'DATA_PRODUCT',
  'DATA_SOURCE' = 'DATA_SOURCE',
  'RESOURCE' = 'RESOURCE',
  'SENSITIVITY_LABELS' = 'SENSITIVITY_LABELS'
}
export enum EnumEnforcementEnvironmentStatus {
  'ATTENTION_REQUIRED' = 'ATTENTION_REQUIRED',
  'CONFIGURATION_REQUIRED' = 'CONFIGURATION_REQUIRED',
  'ENABLED' = 'ENABLED',
  'NOT_ENABLED' = 'NOT_ENABLED',
  'UNKNOWN' = 'UNKNOWN'
}
export enum EnumEstateAgentDetailModelIdentityProvider {
  'AWS_IAM' = 'AWS_IAM',
  'CONFIGURE_LATER' = 'CONFIGURE_LATER',
  'MICROSOFT_ENTRA_ID' = 'MICROSOFT_ENTRA_ID',
  'OKTA' = 'OKTA',
  'OTHER' = 'OTHER'
}
export enum EnumEstateAgentDetailModelPlatform {
  'AWS_AGENTCORE' = 'AWS_AGENTCORE',
  'DATABRICKS' = 'DATABRICKS',
  'GITHUB' = 'GITHUB',
  'MICROSOFT_365' = 'MICROSOFT_365',
  'MICROSOFT_FOUNDRY' = 'MICROSOFT_FOUNDRY',
  'OPENAI' = 'OPENAI',
  'SNOWFLAKE' = 'SNOWFLAKE'
}
export enum EnumEstateAgentDetailModelSecurityStatus {
  'NOT_EVALUATED' = 'NOT_EVALUATED',
  'NOT_SECURE' = 'NOT_SECURE',
  'SECURE' = 'SECURE'
}
export enum EnumEstateAgentModelIdentityProvider {
  'AWS_IAM' = 'AWS_IAM',
  'CONFIGURE_LATER' = 'CONFIGURE_LATER',
  'MICROSOFT_ENTRA_ID' = 'MICROSOFT_ENTRA_ID',
  'OKTA' = 'OKTA',
  'OTHER' = 'OTHER'
}
export enum EnumEstateAgentModelPlatform {
  'AWS_AGENTCORE' = 'AWS_AGENTCORE',
  'DATABRICKS' = 'DATABRICKS',
  'GITHUB' = 'GITHUB',
  'MICROSOFT_365' = 'MICROSOFT_365',
  'MICROSOFT_FOUNDRY' = 'MICROSOFT_FOUNDRY',
  'OPENAI' = 'OPENAI',
  'SNOWFLAKE' = 'SNOWFLAKE'
}
export enum EnumEstateAgentModelSecurityStatus {
  'NOT_EVALUATED' = 'NOT_EVALUATED',
  'NOT_SECURE' = 'NOT_SECURE',
  'SECURE' = 'SECURE'
}
export enum EnumEstateSearchGroupModelType {
  'AI_AGENT' = 'AI_AGENT',
  'DATA_SOURCE' = 'DATA_SOURCE',
  'MCP_SERVER' = 'MCP_SERVER'
}
export enum EnumEstateSearchItemModelType {
  'AI_AGENT' = 'AI_AGENT',
  'DATA_SOURCE' = 'DATA_SOURCE',
  'MCP_SERVER' = 'MCP_SERVER'
}
export enum EnumExternalIntegrationSourceDetailsSyncMode {
  'FULL_SYNC' = 'FULL_SYNC',
  'UI_IMPORT' = 'UI_IMPORT'
}
export enum EnumGlobalPolicyEffect {
  'Deny' = 'Deny',
  'NotApplicable' = 'NotApplicable',
  'Permit' = 'Permit'
}
export enum EnumItemType {
  'ALL_GRANTED_ROLE' = 'ALL_GRANTED_ROLE',
  'ALL_GRANTED_TO_ROLE' = 'ALL_GRANTED_TO_ROLE',
  'COLUMN' = 'COLUMN',
  'DATABASE' = 'DATABASE',
  'DIRECT_ROLE' = 'DIRECT_ROLE',
  'FUNCTION' = 'FUNCTION',
  'GRANTED_ROLE' = 'GRANTED_ROLE',
  'GRANTED_TO_ROLE' = 'GRANTED_TO_ROLE',
  'GRANTED_USER' = 'GRANTED_USER',
  'GROUP' = 'GROUP',
  'INDIRECT_ROLE' = 'INDIRECT_ROLE',
  'OBJECT' = 'OBJECT',
  'PRIVILEGE' = 'PRIVILEGE',
  'PROCEDURE' = 'PROCEDURE',
  'PROXY' = 'PROXY',
  'ROLE' = 'ROLE',
  'SCHEMA' = 'SCHEMA',
  'TABLE' = 'TABLE',
  'UNASSIGNED_ROLE' = 'UNASSIGNED_ROLE',
  'UNASSIGNED_ROLE_TO_ROLE' = 'UNASSIGNED_ROLE_TO_ROLE',
  'UNASSIGNED_USER' = 'UNASSIGNED_USER',
  'USER' = 'USER',
  'WAREHOUSE' = 'WAREHOUSE'
}
export enum EnumJsonNodeNodeType {
  'ARRAY' = 'ARRAY',
  'BINARY' = 'BINARY',
  'BOOLEAN' = 'BOOLEAN',
  'MISSING' = 'MISSING',
  'NULL' = 'NULL',
  'NUMBER' = 'NUMBER',
  'OBJECT' = 'OBJECT',
  'POJO' = 'POJO',
  'STRING' = 'STRING'
}
export enum EnumMcpServiceModelProtectionStatus {
  'NEEDS_POLICY' = 'NEEDS_POLICY',
  'PROTECTED' = 'PROTECTED'
}
export enum EnumMcpToolModelAccess {
  'ALLOWED' = 'ALLOWED',
  'DENIED' = 'DENIED',
  'RESTRICTED' = 'RESTRICTED'
}
export enum EnumMcpToolModelProtectionStatus {
  'NEEDS_POLICY' = 'NEEDS_POLICY',
  'PROTECTED' = 'PROTECTED'
}
export enum EnumMcpUserModelEnforcementMode {
  'INTERCEPTOR' = 'INTERCEPTOR',
  'MCP' = 'MCP',
  'MIDDLEWARE' = 'MIDDLEWARE',
  'PROXY' = 'PROXY'
}
export enum EnumMissionInputPurposeCategory {
  'ANALYTICS' = 'ANALYTICS',
  'CONTENT_CREATION' = 'CONTENT_CREATION',
  'CUSTOMER_SUPPORT' = 'CUSTOMER_SUPPORT',
  'ENGINEERING' = 'ENGINEERING',
  'FINANCE' = 'FINANCE',
  'HR' = 'HR',
  'RESEARCH' = 'RESEARCH'
}
export enum EnumNotTargetedModelReason {
  'ALREADY_ASSIGNED' = 'ALREADY_ASSIGNED',
  'NOT_APPLICABLE' = 'NOT_APPLICABLE'
}
export enum EnumOnboardingRunRequestModelPlatformId {
  'AWS_AGENTCORE' = 'AWS_AGENTCORE',
  'DATABRICKS' = 'DATABRICKS',
  'GITHUB' = 'GITHUB',
  'MICROSOFT_365' = 'MICROSOFT_365',
  'MICROSOFT_FOUNDRY' = 'MICROSOFT_FOUNDRY',
  'OPENAI' = 'OPENAI',
  'SNOWFLAKE' = 'SNOWFLAKE'
}
export enum EnumOpaPolicyEvaluationAuditLogModelAuditType {
  'DECISION' = 'DECISION',
  'ENFORCEMENT' = 'ENFORCEMENT'
}
export enum EnumOpaPolicyEvaluationAuditLogRequestAuditType {
  'DECISION' = 'DECISION',
  'ENFORCEMENT' = 'ENFORCEMENT'
}
export enum EnumPlanRecordModelDestination {
  'DATA_PLATFORM' = 'DATA_PLATFORM',
  'MCP_SERVER' = 'MCP_SERVER',
  'MCP_TOOL' = 'MCP_TOOL'
}
export enum EnumPlanRecordModelOperation {
  'CREATE' = 'CREATE',
  'PENDING_CLASSIFICATION' = 'PENDING_CLASSIFICATION',
  'SKIPPED_OVERRIDE' = 'SKIPPED_OVERRIDE',
  'UNCHANGED' = 'UNCHANGED',
  'UPDATE' = 'UPDATE'
}
export enum EnumPolicyResourceResourceSourceType {
  'APPLICATION' = 'APPLICATION',
  'DATA_OBJECT' = 'DATA_OBJECT',
  'DATA_PRODUCT' = 'DATA_PRODUCT',
  'DATA_SOURCE' = 'DATA_SOURCE',
  'RESOURCE' = 'RESOURCE',
  'SENSITIVITY_LABELS' = 'SENSITIVITY_LABELS'
}
export enum EnumPrincipalType {
  'Group' = 'Group',
  'Role' = 'Role',
  'User' = 'User'
}
export enum EnumPurviewDocumentSensitivityLabelsResponseLabelStatus {
  'LABELED' = 'LABELED',
  'UNLABELED' = 'UNLABELED',
  'UNSUPPORTED_MEDIA' = 'UNSUPPORTED_MEDIA'
}
export enum EnumPurviewSensitivityLabelAssignmentMethod {
  'auto' = 'auto',
  'privileged' = 'privileged',
  'standard' = 'standard'
}
export enum EnumReadinessDiscoveryStatus {
  'COMPLETED' = 'COMPLETED',
  'NOT_STARTED' = 'NOT_STARTED',
  'RUNNING' = 'RUNNING'
}
export enum EnumReadinessEvaluationStatus {
  'COMPLETED' = 'COMPLETED',
  'NOT_STARTED' = 'NOT_STARTED',
  'RUNNING' = 'RUNNING'
}
export enum EnumRecentReportModelCategory {
  'ENTITLEMENT_REPORTS' = 'ENTITLEMENT_REPORTS',
  'RISK_REPORTS' = 'RISK_REPORTS',
  'TRUSTLOGIX_REPORTS' = 'TRUSTLOGIX_REPORTS',
  'USAGE_REPORTS' = 'USAGE_REPORTS'
}
export enum EnumRemediationDataAccessPolicyModelPrincipalType {
  'GROUP' = 'GROUP',
  'PBI_GROUP' = 'PBI_GROUP',
  'ROLE' = 'ROLE',
  'SERVICE_PRINCIPAL' = 'SERVICE_PRINCIPAL',
  'USER' = 'USER'
}
export enum EnumRoleProvisioningModelAction {
  'GRANT' = 'GRANT',
  'REVOKE' = 'REVOKE'
}
export enum EnumRoleProvisioningModelType {
  'FROM_ROLE' = 'FROM_ROLE',
  'TO_ROLE' = 'TO_ROLE',
  'TO_USER' = 'TO_USER'
}
export enum EnumRuleConjunction {
  'AND' = 'AND',
  'OR' = 'OR'
}
export enum EnumRuleEffect {
  'ALLOW' = 'ALLOW',
  'ALLOW_ONLY_WHEN' = 'ALLOW_ONLY_WHEN',
  'DENY' = 'DENY'
}
export enum EnumSyncPolicyObjectModelAction {
  'CREATE_OBJECT' = 'CREATE_OBJECT',
  'SET_TAG' = 'SET_TAG',
  'UNSET_TAG' = 'UNSET_TAG'
}
export enum EnumSyncPolicyObjectModelObjectType {
  'COLUMN' = 'COLUMN',
  'TABLE' = 'TABLE'
}
export enum EnumTrustAiFabricErrorLogModelErrorType {
  'GW' = 'GW',
  'PDP' = 'PDP'
}
export enum EnumTrustAiFabricErrorLogRequestErrorType {
  'GW' = 'GW',
  'PDP' = 'PDP'
}
export enum EnumUpdateRequestAction {
  'ACCEPT_SUGGESTED' = 'ACCEPT_SUGGESTED',
  'CONFIRM' = 'CONFIRM',
  'KEEP_CURRENT' = 'KEEP_CURRENT',
  'NEEDS_MORE_CONTEXT' = 'NEEDS_MORE_CONTEXT',
  'OVERRIDE' = 'OVERRIDE'
}
export enum EnumUpdateResultAction {
  'ACCEPT_SUGGESTED' = 'ACCEPT_SUGGESTED',
  'CONFIRM' = 'CONFIRM',
  'KEEP_CURRENT' = 'KEEP_CURRENT',
  'NEEDS_MORE_CONTEXT' = 'NEEDS_MORE_CONTEXT',
  'OVERRIDE' = 'OVERRIDE'
}
export enum EnumUserAttributeConfigurationModelStatus {
  'FAILED' = 'FAILED',
  'SUCCESS' = 'SUCCESS'
}
export enum EnumUserAttributeValueColumnDeriveType {
  'DERIVE' = 'DERIVE',
  'HIERARCHICAL' = 'HIERARCHICAL',
  'HIERARCHICAL_RECURSIVE' = 'HIERARCHICAL_RECURSIVE',
  'NOT_DERIVE' = 'NOT_DERIVE'
}
export enum EnumUserEntitlementAttributeColumnModelDeriveType {
  'DERIVE' = 'DERIVE',
  'HIERARCHICAL' = 'HIERARCHICAL',
  'HIERARCHICAL_RECURSIVE' = 'HIERARCHICAL_RECURSIVE',
  'NOT_DERIVE' = 'NOT_DERIVE'
}
export enum EnumUserModelAccessType {
  'DATA_SOURCE' = 'DATA_SOURCE',
  'DOMAIN' = 'DOMAIN'
}
export enum EnumWatermarkTimestampModelType {
  'DATABRICKS_AUDIT_LOG_TIMESTAMP' = 'DATABRICKS_AUDIT_LOG_TIMESTAMP',
  'DATABRICKS_TABLE_AUDIT_TIMESTAMP' = 'DATABRICKS_TABLE_AUDIT_TIMESTAMP',
  'DREMIO_TABLE_AUDIT_TIMESTAMP' = 'DREMIO_TABLE_AUDIT_TIMESTAMP',
  'ON_DEMAND_SYNC_SERVICE_START' = 'ON_DEMAND_SYNC_SERVICE_START',
  'SNOWFLAKE_QUERY_HISTORY_AUDIT_TIMESTAMP' = 'SNOWFLAKE_QUERY_HISTORY_AUDIT_TIMESTAMP',
  'SNOWFLAKE_TABLE_AUDIT_TIMESTAMP' = 'SNOWFLAKE_TABLE_AUDIT_TIMESTAMP',
  'ULH_CP_MAPPING_CHECKPOINT' = 'ULH_CP_MAPPING_CHECKPOINT',
  'UNPROCESSED_POLICY_LIST' = 'UNPROCESSED_POLICY_LIST'
}
